/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends, __generator, __values } from "tslib";
import { Control } from "igniteui-react-core";
import { INotifyPropertyChanged_$type, Base, Type, EventArgs, PropertyChangedEventArgs, IEnumerable_$type, callStaticConstructors, Point_$type, runOn, delegateCombine, delegateRemove, fromEnum, fromEn, typeCast, enumGetBox, EnumUtil, Boolean_$type, Number_$type, typeGetValue, toEnum, String_$type, markType, markDep, PointUtil, TypeRegistrar, Delegate_$type, Array_$type } from "igniteui-react-core";
import { ILegendOwner_$type } from "igniteui-react-core";
import { IInternalLegendOwner_$type } from "igniteui-react-core";
import { IDataLegendTarget_$type } from "igniteui-react-core";
import { IToolbarTarget_$type } from "igniteui-react-core";
import { SRProvider } from "igniteui-react-core";
import { DVContainer } from "igniteui-react-core";
import { SeriesPlotAreaMarginHorizontalMode_$type } from "./SeriesPlotAreaMarginHorizontalMode";
import { SeriesPlotAreaMarginVerticalMode_$type } from "./SeriesPlotAreaMarginVerticalMode";
import { SeriesViewerScrollbarMode_$type } from "./SeriesViewerScrollbarMode";
import { DoubleAnimator } from "igniteui-react-core";
import { BrushCollection } from "igniteui-react-core";
import { DependencyProperty } from "igniteui-react-core";
import { DependencyObject } from "igniteui-react-core";
import { MarkerAutomaticBehavior_$type } from "./MarkerAutomaticBehavior";
import { IChartLegend_$type } from "igniteui-react-core";
import { SeriesHighlightingMode_$type } from "./SeriesHighlightingMode";
import { SeriesViewerHorizontalScrollbarPosition_$type } from "./SeriesViewerHorizontalScrollbarPosition";
import { SeriesViewerVerticalScrollbarPosition_$type } from "./SeriesViewerVerticalScrollbarPosition";
import { Brush } from "igniteui-react-core";
import { SeriesHighlightingBehavior_$type } from "./SeriesHighlightingBehavior";
import { LegendHighlightingMode_$type } from "./LegendHighlightingMode";
import { LegendItemBadgeShape_$type } from "igniteui-react-core";
import { LegendItemBadgeMode_$type } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { ChartHitTestMode_$type } from "./ChartHitTestMode";
import { InteractionState_$type } from "igniteui-react-core";
import { WindowResponse_$type } from "./WindowResponse";
import { Visibility_$type } from "igniteui-react-core";
import { SeriesViewerComponentsFromView } from "./SeriesViewerComponentsFromView";
import { ZoomCoercionMode_$type } from "./ZoomCoercionMode";
import { ModifierKeys_$type } from "igniteui-react-core";
import { DataTemplate } from "igniteui-react-core";
import { HorizontalAlignment_$type } from "igniteui-react-core";
import { CanvasRenderScheduler } from "igniteui-react-core";
import { SyncSettings } from "./SyncSettings";
import { PropertyMetadata } from "igniteui-react-core";
import { ICommandStateChangedListener_$type } from "igniteui-react-core";
import { List$1 } from "igniteui-react-core";
import { SeriesViewerComponentsForView } from "./SeriesViewerComponentsForView";
import { Dictionary$2 } from "igniteui-react-core";
import { IDataLegend_$type } from "igniteui-react-core";
import { PropertyUpdatedEventArgs } from "igniteui-react-core";
import { NotifyCollectionChangedEventArgs } from "igniteui-react-core";
import { ObservableCollection$1 } from "igniteui-react-core";
import { Size } from "igniteui-react-core";
import { FrameworkElement } from "igniteui-react-core";
import { MouseEventArgs } from "igniteui-react-core";
import { MouseButtonEventArgs } from "igniteui-react-core";
import { Tuple$2 } from "igniteui-react-core";
import { ScalerParams } from "./ScalerParams";
import { SeriesViewerManipulationEventArgs } from "./SeriesViewerManipulationEventArgs";
import { RectChangedEventArgs } from "igniteui-react-core";
import { MathUtil } from "igniteui-react-core";
import { DeviceUtils } from "igniteui-react-core";
import { RefreshCompletedEventArgs } from "./RefreshCompletedEventArgs";
import { Thickness } from "igniteui-react-core";
import { AxisTitlePosition_$type } from "./AxisTitlePosition";
import { IFastItemsSource_$type } from "igniteui-react-core";
import { CoercionInfo } from "./CoercionInfo";
import { FastItemsSource } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { IDataLegendSeries_$type } from "igniteui-react-core";
import { CaptureImageSettings } from "igniteui-react-core";
import { ImageCapturedEventArgs } from "igniteui-react-core";
import { ChartContentType_$type } from "./ChartContentType";
import { defaultDVDateParse, dateNow } from "igniteui-react-core";
import { isNaN_, isInfinity, logBase, log10, truncate } from "igniteui-react-core";
import { stringIsNullOrEmpty, stringEmpty, stringIsNullOrWhiteSpace } from "igniteui-react-core";
import { ISchedulableRender_$type } from "igniteui-react-core";
import { Rectangle } from "igniteui-react-core";
import { Path } from "igniteui-react-core";
import { Line } from "igniteui-react-core";
import { RenderingContext } from "igniteui-react-core";
import { TextBlock } from "igniteui-react-core";
import { ITileZoomTile_$type } from "./ITileZoomTile";
import { DOMExecutionContext } from "igniteui-react-core";
import { RenderSurface } from "./RenderSurface";
import { PathFigureCollection } from "igniteui-react-core";
import { PathFigure } from "igniteui-react-core";
import { LineSegment } from "igniteui-react-core";
import { PathGeometry } from "igniteui-react-core";
import { GeometryGroup } from "igniteui-react-core";
import { DataContext } from "igniteui-react-core";
import { LabelPanelsArrangeState } from "./LabelPanelsArrangeState";
import { MarkerTemplates } from "./MarkerTemplates";
import { DataTemplateRenderInfo } from "igniteui-react-core";
import { DataTemplateMeasureInfo } from "igniteui-react-core";
import { AxisLabelsLocation_$type } from "./AxisLabelsLocation";
import { IProvidesViewport_$type } from "./IProvidesViewport";
import { ArgumentNullException } from "igniteui-react-core";
import { ActualLegendItemBadgeShape_$type } from "./ActualLegendItemBadgeShape";
import { CanvasViewRenderer } from "igniteui-react-core";
import { Defaults } from "./Defaults";
import { EllipseGeometry } from "igniteui-react-core";
import { DataTemplatePassInfo } from "igniteui-react-core";
import { BrushUtil } from "igniteui-react-core";
import { LegendItemHelper } from "igniteui-react-core";
import { DomWrapper_$type } from "igniteui-react-core";
import { PointerTooltipStyle } from "./PointerTooltipStyle";
import { DefaultPaletteInfo } from "./DefaultPaletteInfo";
import { CssGradientUtil } from "igniteui-react-core";
import { AxisDefaults } from "./AxisDefaults";
import { BrushUtilCore } from "igniteui-react-core";
import { AxisRange } from "./AxisRange";
import { LinearNumericSnapper } from "./LinearNumericSnapper";
import { AxisAnnotationCollection } from "./AxisAnnotationCollection";
import { VerticalAlignment_$type } from "igniteui-react-core";
import { Canvas } from "igniteui-react-core";
import { IFastItemsSourceProvider_$type } from "igniteui-react-core";
import { DoubleCollection } from "igniteui-react-core";
import { LabelPosition } from "./LabelPosition";
import { BindingFormatter } from "igniteui-react-core";
import { LabelFontHeuristics } from "./LabelFontHeuristics";
import { Pool$1 } from "igniteui-react-core";
import { AxisComponentsFromView } from "./AxisComponentsFromView";
import { FastReflectionHelper } from "igniteui-react-core";
import { AxisRangeChangedEventArgs } from "./AxisRangeChangedEventArgs";
import { RectangleGeometry } from "igniteui-react-core";
import { PathRenderingInfo } from "./PathRenderingInfo";
import { LineGeometry } from "igniteui-react-core";
import { RenderRequestedEventArgs } from "./RenderRequestedEventArgs";
import { CategoryMode_$type } from "./CategoryMode";
import { GridMode_$type } from "./GridMode";
import { Panel } from "igniteui-react-core";
import { RectUtil } from "igniteui-react-core";
import { TickmarkValues } from "./TickmarkValues";
import { TransformGroup } from "igniteui-react-core";
import { RotateTransform } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { AngleSimplifier } from "igniteui-react-core";
import { TransformMatrixHelpler } from "igniteui-react-core";
import { ICategoryScaler_$type } from "./ICategoryScaler";
import { AxisRangeBufferMode_$type } from "./AxisRangeBufferMode";
import { NumericAxisRenderingParameters } from "./NumericAxisRenderingParameters";
import { LogarithmicTickmarkValues } from "./LogarithmicTickmarkValues";
import { LinearTickmarkValues } from "./LinearTickmarkValues";
import { TickmarkValuesInitializationParameters } from "./TickmarkValuesInitializationParameters";
import { CategoryAxisRenderingParameters } from "./CategoryAxisRenderingParameters";
import { NumberAbbreviatorFactory } from "./NumberAbbreviatorFactory";
import { AutomaticSeriesPurpose_$type } from "./AutomaticSeriesPurpose";
import { HashSet$1 } from "igniteui-react-core";
import { HighlightingState } from "./HighlightingState";
import { Marker } from "./Marker";
import { ContentControl } from "igniteui-react-core";
import { AutoMarginsAndAngleUpdateMode_$type } from "./AutoMarginsAndAngleUpdateMode";
import { ComputedPlotAreaMarginMode_$type } from "./ComputedPlotAreaMarginMode";
import { PolygonUtil } from "igniteui-react-core";
import { ILegendSeries_$type } from "igniteui-react-core";
import { ILegendSeriesInternal_$type } from "igniteui-react-core";
import { ILegendTemplateProvider_$type } from "igniteui-react-core";
import { PenLineJoin_$type } from "igniteui-react-core";
import { PenLineCap_$type } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { SeriesVisibleRangeMode_$type } from "./SeriesVisibleRangeMode";
import { SeriesOutlineMode_$type } from "./SeriesOutlineMode";
import { TransitionInSpeedType_$type } from "./TransitionInSpeedType";
import { SeriesHitTestMode_$type } from "./SeriesHitTestMode";
import { Binding } from "igniteui-react-core";
import { SeriesComponentsForView } from "./SeriesComponentsForView";
import { MarkerOutlineMode_$type } from "./MarkerOutlineMode";
import { MarkerFillMode_$type } from "./MarkerFillMode";
import { FastItemColumn } from "igniteui-react-core";
import { SeriesComponentsFromView } from "./SeriesComponentsFromView";
import { DataLegendSeriesValueInfo } from "igniteui-react-core";
import { DataLegendSeriesContext } from "igniteui-react-core";
import { MarkerType_$type } from "./MarkerType";
import { Style } from "igniteui-react-core";
import { FastItemsSourceReference } from "igniteui-react-core";
import { stringFormat } from "igniteui-react-core";
import { EasingFunctions } from "igniteui-react-core";
/**
 * @hidden
 */
var SeriesViewer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesViewer, _super);
    function SeriesViewer() {
        var _this = _super.call(this) || this;
        _this._widget = null;
        _this.cu = null;
        _this.c7 = null;
        _this.an = null;
        _this.fo = new List$1(ICommandStateChangedListener_$type, 0);
        _this._commandCompleted = null;
        _this._invalidateActions = null;
        _this.a5 = null;
        _this.a8 = null;
        _this.cm = null;
        _this.bp = new SeriesCollection();
        _this.bw = 0;
        _this.by = 0;
        _this._skipDataCleanup = false;
        _this.cv = null;
        _this.cw = null;
        _this.ar = null;
        _this.s9 = null;
        _this.plotAreaMouseLeftButtonDown = null;
        _this.plotAreaMouseLeftButtonUp = null;
        _this.plotAreaClicked = null;
        _this.plotAreaMouseEnter = null;
        _this.plotAreaMouseLeave = null;
        _this.plotAreaMouseOver = null;
        _this.b3 = 0;
        _this.b4 = 0;
        _this.br = 1;
        _this.propertyChanged = null;
        _this.propertyUpdated = null;
        _this.dh = false;
        _this.seriesCursorMouseMove = null;
        _this.seriesMouseLeftButtonDown = null;
        _this.seriesMouseLeftButtonUp = null;
        _this.seriesMouseMove = null;
        _this.seriesMouseEnter = null;
        _this.seriesMouseLeave = null;
        _this.dc = false;
        _this.ti = Rect.empty;
        _this.tg = Rect.empty;
        _this.da = true;
        _this.tf = null;
        _this.dq = false;
        _this.hs = 30;
        _this.ex = false;
        _this.ds = false;
        _this.b0 = new SeriesViewerComponentsForView();
        _this.df = false;
        _this.at = 0;
        _this.as = 1;
        _this.seriesAnimating = null;
        _this.dd = false;
        _this.ch = 0;
        _this.dj = false;
        _this.d0 = false;
        _this.db = false;
        _this.ku = null;
        _this.viewerManipulationStarting = null;
        _this.viewerManipulationEnding = null;
        _this.dn = false;
        _this.dk = false;
        _this.windowRectChanged = null;
        _this.sizeChanged = null;
        _this.d9 = false;
        _this.actualWindowRectChanged = null;
        _this.gridAreaRectChanged = null;
        _this.d2 = false;
        _this.fx = 0.0001;
        _this.fw = 0.0001;
        _this._syncChannel = null;
        _this.b8 = null;
        _this.ff = false;
        _this.dm = false;
        _this.d8 = false;
        _this.fi = false;
        _this.cc = 1;
        _this.t0 = null;
        _this.hu = 0;
        _this.bo = null;
        _this.dl = false;
        _this.fg = false;
        _this.th = Rect.empty;
        _this.fr = new Date();
        _this.fl = false;
        _this.refreshCompleted = null;
        _this.h6 = null;
        _this.h5 = null;
        _this.sm = null;
        _this.sl = null;
        _this.gc = NaN;
        _this.ga = NaN;
        _this.gb = NaN;
        _this.f9 = NaN;
        _this.f8 = NaN;
        _this.f6 = NaN;
        _this.f7 = NaN;
        _this.f5 = NaN;
        _this.h3 = null;
        _this.al = null;
        _this.am = null;
        _this.ak = null;
        _this.di = false;
        _this.c9 = false;
        _this._syncSettings = null;
        _this.destroyed = false;
        _this.h1 = null;
        _this.fm = new Dictionary$2(String_$type, Base.$, 0);
        _this.ev = false;
        _this.gd = NaN;
        _this.f2 = NaN;
        _this.f4 = NaN;
        _this.f0 = NaN;
        _this.fz = 30;
        _this.fy = NaN;
        _this.de = true;
        _this.f3 = NaN;
        _this.f1 = NaN;
        _this.h4 = null;
        _this.ft = 1;
        _this.fs = NaN;
        _this.te = null;
        _this.d7 = false;
        _this.fu = 0;
        _this.fv = 0;
        _this.p5 = null;
        _this.ax = null;
        _this.ec = false;
        _this.ed = false;
        _this.ea = false;
        _this.dg = false;
        _this.ht = 0;
        _this.dy = false;
        _this.eg = false;
        _this.seriesDataUpdated = null;
        _this.fp = new List$1(IDataLegend_$type, 0);
        _this.fq = null;
        _this.imageCaptured = null;
        DVContainer.instance.registerIfLoaded("AnnotationFactoryManager");
        DVContainer.instance.registerIfLoaded("InteractivityFactoryManager");
        DVContainer.instance.registerIfLoaded("DataChartToolbarFactoryManager");
        DVContainer.instance.registerIfLoaded("VisualDataFactoryManager");
        _this.te = Rect.empty;
        _this.s9 = { $type: Point_$type, x: NaN, y: NaN };
        _this.fr = dateNow();
        _this.ec = false;
        _this.ed = false;
        _this.al = new CanvasRenderScheduler();
        _this.al.a = runOn(_this, _this.lu);
        _this.am = new CanvasRenderScheduler();
        _this.ak = new CanvasRenderScheduler();
        SeriesViewer.tv = new Rect(0, 0, 0, 1, 1);
        _this.syncSettings = ((function () {
            var $ret = new SyncSettings();
            $ret.synchronizeHorizontally = true;
            $ret.synchronizeVertically = true;
            return $ret;
        })());
        _this.cu = _this.ct();
        _this.n1(_this.cu);
        _this.cu.c4();
        _this.pf();
        _this.l9();
        _this.actualSyncLink = new SyncLink();
        _this.pn(null, _this.actualSyncLink);
        _this.ar = new ChartContentManager(_this);
        _this.propertyUpdated = delegateCombine(_this.propertyUpdated, function (a, b) { return _this.od(a, b.propertyName, b.oldValue, b.newValue); });
        var a = _this.series;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.o4));
        var b = _this.series;
        b.collectionResetting = delegateCombine(b.collectionResetting, runOn(_this, _this.o5));
        _this.cw = new DoubleAnimator(0, 1, _this.hz);
        _this.cv = new DoubleAnimator(0, 1, _this.hy);
        var c = _this.cv;
        c.propertyChanged = delegateCombine(c.propertyChanged, runOn(_this, _this.l8));
        _this.cu.bx();
        _this.mb();
        _this.ma();
        return _this;
    }
    Object.defineProperty(SeriesViewer.prototype, "widget", {
        get: function () {
            return this._widget;
        },
        set: function (a) {
            this._widget = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.staticInit = function () {
        SeriesViewer.tv = new Rect(0, 0, 0, 1, 1);
    };
    Object.defineProperty(SeriesViewer.prototype, "c8", {
        get: function () {
            if (this.c7 == null) {
                this.c7 = new SRProvider(this.cu.j.ae);
            }
            return this.c7;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ao = function (a) {
        if (this.an == null) {
            this.an = new AutomaticSeriesManager(this);
        }
        return this.an;
    };
    SeriesViewer.prototype.getDesiredToolbarActions = function () {
        if (!this.ep) {
            return null;
        }
        return this.a6.getDesiredToolbarActions();
    };
    SeriesViewer.prototype.onToolCommandExecuting = function (a) {
        if (!this.ep) {
            return 1;
        }
        return this.a6.onToolCommandExecuting(this, a);
    };
    SeriesViewer.prototype.addCommandAvailabilityListener = function (a) {
    };
    SeriesViewer.prototype.removeCommandAvailabilityListener = function (a) {
    };
    SeriesViewer.prototype.addCommandStateChangedListener = function (a) {
        if (!this.fo.contains(a)) {
            this.fo.add(a);
        }
    };
    SeriesViewer.prototype.removeCommandStateChangedListener = function (a) {
        if (this.fo.contains(a)) {
            this.fo.remove(a);
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "commandCompleted", {
        get: function () {
            return this._commandCompleted;
        },
        set: function (a) {
            this._commandCompleted = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "invalidateActions", {
        get: function () {
            return this._invalidateActions;
        },
        set: function (a) {
            this._invalidateActions = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.me = function () {
        if (this.invalidateActions != null) {
            this.invalidateActions();
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "a6", {
        get: function () {
            var _this = this;
            if (this.a5 == null) {
                this.a5 = DVContainer.instance.createInstance(IDataChartToolbarProvider_$type, function () { return _this.c8.n; });
                this.a5.container = this.cu.bi;
            }
            return this.a5;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ep", {
        get: function () {
            return DVContainer.instance.checkLoaded("DataChartToolbarFactoryManager");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "a9", {
        get: function () {
            var _this = this;
            if (this.a8 == null) {
                this.a8 = DVContainer.instance.createInstance(ISeriesViewerInteractionManager_$type, function () { return _this.c8.n; });
            }
            return this.a8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ei", {
        get: function () {
            return DVContainer.instance.checkLoaded("InteractivityFactoryManager");
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.l9 = function () {
        if (this.cm != null && this.cn == null) {
            var a = this.cn;
            a.thumbnailSizeChanged = delegateRemove(a.thumbnailSizeChanged, runOn(this, this.n9));
        }
        if (this.cn != null) {
            var b = this.cn;
            b.thumbnailSizeChanged = delegateCombine(b.thumbnailSizeChanged, runOn(this, this.n9));
        }
        if (this.h4 != null) {
            this.cn.backgroundImageUri = this.h4;
        }
        if (this.cn != null) {
            this.cn.initializeScalingRatio(this.gf);
        }
        if (this.cm == null && this.cn != null) {
            this.ms();
        }
        this.cm = this.cn;
    };
    SeriesViewer.prototype.n9 = function (a, b) {
        var e_1, _a;
        this.cn.surfaceIsDirty = true;
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.e3 = true;
            }
        }
        catch (e_1_1) {
            e_1 = { error: e_1_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_1)
                    throw e_1.error;
            }
        }
    };
    SeriesViewer.prototype.get_e0 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "e0", {
        get: function () {
            return this.get_e0();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.get_ez = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "ez", {
        get: function () {
            return this.get_ez();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ma = function () {
        this.cu.co();
        if (this.cn != null) {
            this.cn.initializeScalingRatio(this.gf);
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "series", {
        get: function () {
            return this.bp;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.o4 = function (a, b) {
        var e_2, _a, e_3, _b;
        this.dy = this.d4();
        if (b.oldItems != null) {
            try {
                for (var _c = __values(fromEn(b.oldItems)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    c.b9 = null;
                    c.ce = null;
                    this.oy(c);
                    this.cu.dy(c);
                }
            }
            catch (e_2_1) {
                e_2 = { error: e_2_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_2)
                        throw e_2.error;
                }
            }
        }
        if (b.newItems != null) {
            try {
                for (var _e = __values(fromEn(b.newItems)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var d = _f.value;
                    if (!this.cu.aq(d)) {
                        this.pg(d);
                        this.cu.bp(d);
                        d.ce = this;
                        d.b9 = this.actualSyncLink;
                        d.m9();
                    }
                }
            }
            catch (e_3_1) {
                e_3 = { error: e_3_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_3)
                        throw e_3.error;
                }
            }
        }
        this.mr();
        this.my();
        this.nd();
        this.ml();
    };
    Object.defineProperty(SeriesViewer.prototype, "bx", {
        get: function () {
            return this.bw;
        },
        set: function (a) {
            this.bw = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bz", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            this.by = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.mc = function () {
        this.my();
    };
    SeriesViewer.prototype.my = function () {
    };
    Object.defineProperty(SeriesViewer.prototype, "skipDataCleanup", {
        get: function () {
            return this._skipDataCleanup;
        },
        set: function (a) {
            this._skipDataCleanup = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.oy = function (a) {
        if (!this.skipDataCleanup) {
            if (typeCast(Series.$, a) !== null) {
                a.itemsSource = null;
            }
            else if (typeCast(CategoryAxisBase.$, a) !== null) {
                a.itemsSource = null;
            }
        }
        this.o0(a.name, true);
    };
    SeriesViewer.prototype.o5 = function (a, b) {
        var e_4, _a;
        this.dy = this.d4();
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.b9 = null;
                c.ce = null;
                this.oy(c);
                this.cu.dy(c);
            }
        }
        catch (e_4_1) {
            e_4 = { error: e_4_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_4)
                    throw e_4.error;
            }
        }
        this.ml();
    };
    SeriesViewer.prototype.mg = function (a, b, c, d) {
        var e = this.ty;
        var f = e.width;
        var g = e.height;
        var h = f / g;
        var i = a / b;
        if (isNaN_(h)) {
            return {
                p0: a,
                p1: b
            };
        }
        if (isNaN_(i) || c || d || Math.abs(h - i) > 0.0001) {
            if (c && d) {
                if (a > b) {
                    b = a / h;
                }
                else {
                    a = b * h;
                }
            }
            else if (c) {
                b = a / h;
            }
            else {
                a = b * h;
            }
        }
        if (b > 1) {
            var j = 1 / b;
            b = 1;
            a = a * j;
        }
        if (a > 1) {
            var k = 1 / a;
            a = 1;
            b = b * k;
        }
        return {
            p0: a,
            p1: b
        };
    };
    SeriesViewer.prototype.d4 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "fc", {
        get: function () {
            return this.eq;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ee", {
        get: function () {
            return this.a8 != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "dx", {
        get: function () {
            return this.a8 != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "dw", {
        get: function () {
            return this.b3 != 0 || this.b4 != 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "dv", {
        get: function () {
            return this.dx && this.dw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "a7", {
        get: function () {
            var a = this.a9.f$b;
            if (a.executionContext == null) {
                a.executionContext = this.cu.l();
            }
            if (a.ensureAnimator == null) {
                a.ensureAnimator = runOn(this, this.l3);
            }
            return a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ba", {
        get: function () {
            var a = this.a9.f$c;
            if (a.executionContext == null) {
                a.executionContext = this.cu.l();
            }
            if (a.animator == null) {
                a.animator = this.cw;
                a.owner = this;
            }
            return a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.l3 = function () {
        {
            var a = this.cv;
            if (!a.f() && a.r > 0) {
                a.v();
            }
            if (a.r == 0) {
                this.pi(1);
            }
        }
    };
    SeriesViewer.prototype.l8 = function (a, b) {
        this.pi(this.cv.o);
    };
    SeriesViewer.prototype.pi = function (a) {
        var b = this.a7.tick(a);
        if (a == 1 && b && this.cv.r > 0) {
            this.cv.v();
        }
        var c = this.a7.dirtySeries;
        if (this.a7.allDirty) {
            var d = this.series;
            for (var e = 0; e < d.count; e++) {
                var f = d._inner[e];
                f.l7();
            }
        }
        else {
            for (var g = 0; g < c.count; g++) {
                var h = c._inner[g];
                h.l7();
            }
        }
        if (!b) {
            this.cv.w();
        }
    };
    SeriesViewer.prototype.l7 = function () {
        this.cu.ck();
        this.l6();
        for (var a = 0; a < this.series.count; a++) {
            if (this.series._inner[a].dd) {
                this.series._inner[a].li();
            }
        }
    };
    SeriesViewer.prototype.sq = function (a) {
        return this.sp(this.ag, a);
    };
    SeriesViewer.prototype.sw = function (a) {
        return this.sp(this.aj, a);
    };
    SeriesViewer.prototype.su = function (a) {
        return this.sp(this.ah, a);
    };
    SeriesViewer.prototype.sv = function (a) {
        return this.sp(this.ai, a);
    };
    SeriesViewer.prototype.sp = function (a, b) {
        if (a == null || a.count == 0) {
            return null;
        }
        else {
            return a.item(b % a.count);
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "ta", {
        get: function () {
            return this.s9;
        },
        set: function (a) {
            if (PointUtil.notEquals(this.s9, a)) {
                var b = this.s9;
                this.s9 = a;
                this.oi("CrosshairPoint", b, this.s9);
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ou = function () {
    };
    Object.defineProperty(SeriesViewer.prototype, "eh", {
        get: function () {
            return this.cl == 1 || this.cl == 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "legend", {
        get: function () {
            return this.c(SeriesViewer.q2);
        },
        set: function (a) {
            this.h(SeriesViewer.q2, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "dt", {
        get: function () {
            return this.c(SeriesViewer.p7);
        },
        set: function (a) {
            this.h(SeriesViewer.p7, a);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.no = function (a, b) {
        this.dh = false;
        var c = false;
        c = false;
        if (this.cu.k.al) {
            return;
        }
        if (this.plotAreaMouseLeftButtonDown != null) {
            var d = this.bf(a, b, c);
            this.plotAreaMouseLeftButtonDown(this, d);
        }
    };
    SeriesViewer.prototype.bf = function (a, b, c) {
        var d = { $type: Point_$type, x: a.x, y: a.y };
        var e = { $type: Point_$type, x: a.x, y: a.y };
        if (!this.ty.isEmpty) {
            if (c) {
                e.x -= this.ty.left;
                e.y -= this.ty.top;
            }
            else {
                d.x += this.ty.left;
                d.y += this.ty.top;
            }
        }
        var f = new PlotAreaMouseButtonEventArgs(this, d, e);
        f.manipulationOccurred = this.dh;
        return f;
    };
    SeriesViewer.prototype.bj = function (a, b, c) {
        var d = { $type: Point_$type, x: a.x, y: a.y };
        var e = { $type: Point_$type, x: a.x, y: a.y };
        if (!this.ty.isEmpty) {
            if (c) {
                e.x -= this.ty.left;
                e.y -= this.ty.top;
            }
            else {
                d.x += this.ty.left;
                d.y += this.ty.top;
            }
        }
        var f = new PlotAreaMouseEventArgs(this, d, e);
        return f;
    };
    SeriesViewer.prototype.np = function (a, b, c) {
        var d = false;
        d = false;
        if (this.cu.k.al) {
            return;
        }
        if (this.plotAreaMouseLeftButtonUp != null) {
            var e = this.bf(a, b, d);
            this.plotAreaMouseLeftButtonUp(this, e);
        }
        if (!this.dh && !c) {
            if (this.plotAreaClicked != null) {
                var f = this.bf(a, b, d);
                this.plotAreaClicked(this, f);
            }
        }
        this.dh = false;
    };
    Object.defineProperty(SeriesViewer.prototype, "eq", {
        get: function () {
            return this.c(SeriesViewer.qy);
        },
        set: function (a) {
            this.h(SeriesViewer.qy, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "fb", {
        get: function () {
            return this.c(SeriesViewer.rl);
        },
        set: function (a) {
            this.h(SeriesViewer.rl, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bv", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesHighlightingMode_$type, this.c(SeriesViewer.qh));
        },
        set: function (a) {
            this.h(SeriesViewer.qh, enumGetBox(SeriesHighlightingMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "b5", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesViewerScrollbarMode_$type, this.c(SeriesViewer.qp));
        },
        set: function (a) {
            this.h(SeriesViewer.qp, enumGetBox(SeriesViewerScrollbarMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "b6", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesViewerScrollbarMode_$type, this.c(SeriesViewer.rz));
        },
        set: function (a) {
            this.h(SeriesViewer.rz, enumGetBox(SeriesViewerScrollbarMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "b2", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesViewerHorizontalScrollbarPosition_$type, this.c(SeriesViewer.qr));
        },
        set: function (a) {
            this.h(SeriesViewer.qr, enumGetBox(SeriesViewerHorizontalScrollbarPosition_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "b7", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesViewerVerticalScrollbarPosition_$type, this.c(SeriesViewer.r1));
        },
        set: function (a) {
            this.h(SeriesViewer.r1, enumGetBox(SeriesViewerVerticalScrollbarPosition_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "sy", {
        get: function () {
            return this.c(SeriesViewer.ql);
        },
        set: function (a) {
            this.h(SeriesViewer.ql, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "sz", {
        get: function () {
            return this.c(SeriesViewer.qq);
        },
        set: function (a) {
            this.h(SeriesViewer.qq, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gv", {
        get: function () {
            return this.c(SeriesViewer.qt);
        },
        set: function (a) {
            this.h(SeriesViewer.qt, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gu", {
        get: function () {
            return this.c(SeriesViewer.qo);
        },
        set: function (a) {
            this.h(SeriesViewer.qo, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gr", {
        get: function () {
            return this.c(SeriesViewer.qk);
        },
        set: function (a) {
            this.h(SeriesViewer.qk, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gs", {
        get: function () {
            return this.c(SeriesViewer.qm);
        },
        set: function (a) {
            this.h(SeriesViewer.qm, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gt", {
        get: function () {
            return this.c(SeriesViewer.qn);
        },
        set: function (a) {
            this.h(SeriesViewer.qn, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gx", {
        get: function () {
            return this.c(SeriesViewer.qv);
        },
        set: function (a) {
            this.h(SeriesViewer.qv, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gw", {
        get: function () {
            return this.c(SeriesViewer.qu);
        },
        set: function (a) {
            this.h(SeriesViewer.qu, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "d6", {
        get: function () {
            return this.c(SeriesViewer.qs);
        },
        set: function (a) {
            this.h(SeriesViewer.qs, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "s7", {
        get: function () {
            return this.c(SeriesViewer.rw);
        },
        set: function (a) {
            this.h(SeriesViewer.rw, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "s8", {
        get: function () {
            return this.c(SeriesViewer.r0);
        },
        set: function (a) {
            this.h(SeriesViewer.r0, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hh", {
        get: function () {
            return this.c(SeriesViewer.r3);
        },
        set: function (a) {
            this.h(SeriesViewer.r3, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hg", {
        get: function () {
            return this.c(SeriesViewer.ry);
        },
        set: function (a) {
            this.h(SeriesViewer.ry, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "he", {
        get: function () {
            return this.c(SeriesViewer.rv);
        },
        set: function (a) {
            this.h(SeriesViewer.rv, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hk", {
        get: function () {
            return this.c(SeriesViewer.r6);
        },
        set: function (a) {
            this.h(SeriesViewer.r6, a);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.lu = function () {
        if (!this.al.g && !this.al.f && !this.cu.a.g && !this.cu.a.f) {
            this.nr();
        }
    };
    SeriesViewer.prototype.nr = function () {
        this.ls();
    };
    Object.defineProperty(SeriesViewer.prototype, "hf", {
        get: function () {
            return this.c(SeriesViewer.rx);
        },
        set: function (a) {
            this.h(SeriesViewer.rx, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hj", {
        get: function () {
            return this.c(SeriesViewer.r5);
        },
        set: function (a) {
            this.h(SeriesViewer.r5, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hi", {
        get: function () {
            return this.c(SeriesViewer.r4);
        },
        set: function (a) {
            this.h(SeriesViewer.r4, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "fk", {
        get: function () {
            return this.c(SeriesViewer.r2);
        },
        set: function (a) {
            this.h(SeriesViewer.r2, a);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.bu = function () {
        if (this.bt == 0) {
            return 1;
        }
        if (this.bv == 3 || this.bv == 5) {
            if (this.bt == 2) {
                return 4;
            }
        }
        return this.bt;
    };
    Object.defineProperty(SeriesViewer.prototype, "bs", {
        get: function () {
            return this.br;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bt", {
        get: function () {
            return EnumUtil.getEnumValue(SeriesHighlightingBehavior_$type, this.c(SeriesViewer.qg));
        },
        set: function (a) {
            this.h(SeriesViewer.qg, enumGetBox(SeriesHighlightingBehavior_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bb", {
        get: function () {
            return EnumUtil.getEnumValue(LegendHighlightingMode_$type, this.c(SeriesViewer.qz));
        },
        set: function (a) {
            this.h(SeriesViewer.qz, enumGetBox(LegendHighlightingMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bd", {
        get: function () {
            return EnumUtil.getEnumValue(LegendItemBadgeShape_$type, this.c(SeriesViewer.q1));
        },
        set: function (a) {
            this.h(SeriesViewer.q1, enumGetBox(LegendItemBadgeShape_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "bc", {
        get: function () {
            return EnumUtil.getEnumValue(LegendItemBadgeMode_$type, this.c(SeriesViewer.q0));
        },
        set: function (a) {
            this.h(SeriesViewer.q0, enumGetBox(LegendItemBadgeMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.oi = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        if (this.propertyUpdated != null) {
            this.propertyUpdated(this, new PropertyUpdatedEventArgs(a, b, c));
        }
    };
    SeriesViewer.prototype.nf = function () {
        this.ng(this.series);
    };
    SeriesViewer.prototype.ng = function (a) {
        var e_5, _a;
        try {
            for (var _b = __values(fromEn(a)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                var c = b.a2;
                if (c == null) {
                    continue;
                }
                var d = b.ne;
                if (d == null) {
                    continue;
                }
                if (c.containsChild(d)) {
                    c.removeChild(d);
                }
                if (!c.containsChild(d) && b.qb != 1) {
                    c.addChildInOrder(d, b);
                }
            }
        }
        catch (e_5_1) {
            e_5 = { error: e_5_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_5)
                    throw e_5.error;
            }
        }
    };
    SeriesViewer.prototype.ns = function (a, b, c) {
        this.on(a, b, typeCast(MouseEventArgs.$, c));
    };
    SeriesViewer.prototype.nw = function (a, b, c) {
        this.or(a, b, typeCast(MouseEventArgs.$, c));
    };
    SeriesViewer.prototype.nt = function (a, b, c) {
        this.oo(a, b, typeCast(MouseEventArgs.$, c));
    };
    SeriesViewer.prototype.nu = function (a, b, c) {
        this.op(a, b, typeCast(MouseButtonEventArgs.$, c));
    };
    SeriesViewer.prototype.nv = function (a, b, c) {
        var d = typeCast(MouseButtonEventArgs.$, c);
        if (d != null) {
            this.oq(a, b, typeCast(MouseButtonEventArgs.$, c));
        }
    };
    SeriesViewer.prototype.ll = function (a, b) {
        return null;
    };
    Object.defineProperty(SeriesViewer.prototype, "ew", {
        get: function () {
            return this.dh;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.mx = function () {
        if (!this.dc) {
            this.dc = true;
            this.dh = true;
            if (this.viewerManipulationStarting != null) {
                var a = new SeriesViewerManipulationEventArgs();
                a.isDragZoom = true;
                this.viewerManipulationStarting(this, a);
            }
        }
    };
    SeriesViewer.prototype.nx = function (a, b, c) {
    };
    SeriesViewer.prototype.ny = function (a, b, c) {
    };
    SeriesViewer.prototype.ol = function (a, b) {
        if (this.seriesCursorMouseMove != null && this.d0) {
            this.seriesCursorMouseMove(this, new ChartCursorEventArgs(this, a, b));
        }
    };
    SeriesViewer.prototype.op = function (a, b, c) {
        if (this.seriesMouseLeftButtonDown != null) {
            this.seriesMouseLeftButtonDown(this, new DataChartMouseButtonEventArgs(this, a, b, c));
        }
    };
    SeriesViewer.prototype.oq = function (a, b, c) {
        if (this.seriesMouseLeftButtonUp != null) {
            this.seriesMouseLeftButtonUp(this, new DataChartMouseButtonEventArgs(this, a, b, c));
        }
    };
    SeriesViewer.prototype.o9 = function (a) {
        this.a9.f$ao(this, a);
    };
    SeriesViewer.prototype.pa = function (a) {
        a = { $type: Point_$type, x: a.x - this.ty.left, y: a.y - this.ty.top };
        var b = this.td(a);
        if (this.fb) {
            this.lx(b);
        }
        else {
            var c = this.bs;
            var d = c == 2 || c == 3 || c == 4;
            if (d) {
                this.pj(b);
                for (var e = 0; e < this.series.count; e++) {
                    var f = this.series._inner[e];
                    f.m8(b);
                    if (f.isStacked) {
                        f.lf(function (g) {
                            g.m8(b);
                            return true;
                        });
                    }
                }
            }
        }
    };
    SeriesViewer.prototype.or = function (a, b, c) {
        if (this.seriesMouseMove != null) {
            this.seriesMouseMove(this, new ChartMouseEventArgs(this, a, b, c));
        }
    };
    SeriesViewer.prototype.on = function (a, b, c) {
        if (this.seriesMouseEnter != null) {
            this.seriesMouseEnter(this, new ChartMouseEventArgs(this, a, b, c));
        }
    };
    SeriesViewer.prototype.oo = function (a, b, c) {
        if (this.seriesMouseLeave != null) {
            this.seriesMouseLeave(this, new ChartMouseEventArgs(this, a, b, c));
        }
    };
    SeriesViewer.prototype.mw = function () {
        if (this.dc) {
            this.dc = false;
            if (this.viewerManipulationEnding != null) {
                var a = new SeriesViewerManipulationEventArgs();
                a.isDragZoom = true;
                this.viewerManipulationEnding(this, a);
            }
        }
    };
    SeriesViewer.prototype.get_ty = function () {
        return this.ti;
    };
    Object.defineProperty(SeriesViewer.prototype, "ty", {
        get: function () {
            return this.get_ty();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "tn", {
        get: function () {
            return this.tg;
        },
        set: function (a) {
            this.tg = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.get_d5 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "d5", {
        get: function () {
            return this.get_d5();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ts = function (a, b, c) {
        if (c.isEmpty) {
            return c;
        }
        var d = c;
        var e = b;
        var f = (d.left - e.left) / e.width;
        var g = (d.top - e.top) / e.height;
        var h = (d.right - e.left) / e.width;
        var i = (d.bottom - e.top) / e.height;
        f = a.left + f * a.width;
        g = a.top + g * a.height;
        h = a.left + h * a.width;
        i = a.top + i * a.height;
        return new Rect(0, f, g, h - f, i - g);
    };
    SeriesViewer.prototype.get_tm = function () {
        if (this.da) {
            this.da = false;
            var a = this.tq(this.ty, this.tn, this.tj);
            this.tf = a;
        }
        return this.tf;
    };
    Object.defineProperty(SeriesViewer.prototype, "tm", {
        get: function () {
            return this.get_tm();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.tq = function (a, b, c) {
        var d = b;
        var e = c;
        var f = a;
        if (f.isEmpty) {
            return Rect.empty;
        }
        if (d.isEmpty) {
            return a;
        }
        var g = (d.left - f.left) / f.width;
        var h = (d.right - f.left) / f.width;
        var i = (d.top - f.top) / f.height;
        var j = (d.bottom - f.top) / f.height;
        g = f.left + (g - e.left) / e.width * f.width;
        h = f.left + (h - e.left) / e.width * f.width;
        i = f.top + (i - e.top) / e.height * f.height;
        j = f.top + (j - e.top) / e.height * f.height;
        var k = new Rect(0, g, i, h - g, j - i);
        k.intersect(f);
        return k;
    };
    SeriesViewer.prototype.tl = function (a) {
        this.da = true;
        return Rect.empty;
    };
    SeriesViewer.prototype.tr = function () {
        return this.ty;
    };
    SeriesViewer.prototype.pe = function (a) {
        a.kd = this.ty;
    };
    Object.defineProperty(SeriesViewer.prototype, "hv", {
        get: function () {
            return this.hs;
        },
        set: function (a) {
            this.hs = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.oc = function (a, b) {
        if (!b.isEmpty) {
            this.ti = b;
            this.tg = this.tl(this.ti);
            this.cu.eq(this.ti);
        }
        if (this.d4()) {
            if (this.actualSyncLink != null) {
                this.pr(this.tj, false);
            }
        }
        this.nq(a, b);
        if (this.dv) {
            this.ba.updateScrollbars(this, this.tj, this.tj, a, b);
        }
    };
    SeriesViewer.prototype.b1 = function () {
        return this.b0;
    };
    SeriesViewer.prototype.lt = function (a, b) {
        var c = false;
        c = true;
        if (this.ty.containsPoint(a)) {
            if (!this.df) {
                this.df = true;
                if (this.plotAreaMouseEnter != null) {
                    var d = this.bj(a, false, c);
                    d.isDuringManipulation = b;
                    this.plotAreaMouseEnter(this, d);
                }
            }
            else {
                this.df = true;
                if (this.plotAreaMouseOver != null) {
                    var e = this.bj(a, false, c);
                    e.isDuringManipulation = b;
                    this.plotAreaMouseOver(this, e);
                }
            }
        }
        else {
            if (this.df) {
                this.df = false;
                if (this.plotAreaMouseLeave != null) {
                    var f = this.bj(a, false, c);
                    f.isDuringManipulation = b;
                    this.plotAreaMouseLeave(this, f);
                }
            }
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "av", {
        get: function () {
            return this.at;
        },
        set: function (a) {
            var b = this.at;
            this.at = a;
            if (b != this.at) {
                this.oi("ContentHitTestMode", enumGetBox(ChartHitTestMode_$type, b), enumGetBox(ChartHitTestMode_$type, this.at));
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ot = function () {
        this.au = this.aw();
    };
    SeriesViewer.prototype.aw = function () {
        if (!this.ei) {
            return 1;
        }
        return this.a9.f$a(this);
    };
    Object.defineProperty(SeriesViewer.prototype, "au", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            this.as = a;
            if (b != this.as) {
                this.oi("ActualContentHitTestMode", enumGetBox(ChartHitTestMode_$type, b), enumGetBox(ChartHitTestMode_$type, this.as));
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ok = function (a) {
        if (this.seriesAnimating != null) {
            this.seriesAnimating(a);
        }
    };
    SeriesViewer.prototype.er = function () {
        return this.es() || this.et();
    };
    SeriesViewer.prototype.onDetachedFromUI = function () {
        this.cu.c2();
        SyncManager.e(this);
    };
    SeriesViewer.prototype.onAttachedToUI = function () {
        this.cu.cw();
        SyncManager.c(this);
    };
    Object.defineProperty(SeriesViewer.prototype, "cl", {
        get: function () {
            return this.ch;
        },
        set: function (a) {
            if (this.cl != a) {
                var b = this.ch;
                this.ch = a;
                if (this.ei) {
                    this.a9.f$ag(this);
                }
                if (b == 1 && this.ch != 1) {
                    this.mw();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ni = function (a) {
        this.lx(this.td(a));
    };
    SeriesViewer.prototype.nj = function (a, b) {
        var c = false;
        c = false;
        this.lx({ $type: Point_$type, x: NaN, y: NaN });
        if (this.df) {
            this.df = false;
            if (this.plotAreaMouseLeave != null) {
                var d = this.bj(a, false, c);
                d.isDuringManipulation = b;
                this.plotAreaMouseLeave(this, d);
            }
        }
    };
    SeriesViewer.prototype.e4 = function (a, b) {
        return this.a9.f$f(this, a, b);
    };
    SeriesViewer.prototype.m8 = function (a) {
        this.a9.f$o(this, a);
    };
    SeriesViewer.prototype.e3 = function (a) {
        return this.a9.f$e(this, a);
    };
    Object.defineProperty(SeriesViewer.prototype, "du", {
        get: function () {
            return this.db;
        },
        set: function (a) {
            this.db = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.get_ej = function () {
        return this.dy || this.fh();
    };
    Object.defineProperty(SeriesViewer.prototype, "ej", {
        get: function () {
            return this.get_ej();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.na = function (a) {
        this.a9.f$q(this, a);
    };
    Object.defineProperty(SeriesViewer.prototype, "d3", {
        get: function () {
            return this.db;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.nn = function (a) {
        this.a9.f$ae(this, a);
    };
    SeriesViewer.prototype.nb = function (a, b) {
        this.a9.f$r(this, a, b);
    };
    SeriesViewer.prototype.m9 = function (a) {
        this.a9.f$p(this, a);
    };
    Object.defineProperty(SeriesViewer.prototype, "e5", {
        get: function () {
            return this.dj;
        },
        set: function (a) {
            this.dj = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.n7 = function () {
        this.a9.f$al(this);
    };
    SeriesViewer.prototype.nm = function (a) {
        this.a9.f$ad(this, a);
    };
    SeriesViewer.prototype.n8 = function (a, b, c, d) {
        this.a9.f$am(this, a, b, c, d);
    };
    SeriesViewer.prototype.nl = function (a) {
        this.a9.f$ac(this, a);
    };
    SeriesViewer.prototype.n4 = function (a, b, c, d) {
        this.a9.f$ai(this, a, b, c, d);
    };
    SeriesViewer.prototype.nh = function (a) {
        this.a9.f$z(this, a);
    };
    SeriesViewer.prototype.nk = function (a) {
        this.a9.f$ab(this, a);
    };
    SeriesViewer.prototype.nc = function (a) {
        this.a9.f$s(this, a);
    };
    SeriesViewer.prototype.n3 = function (a, b, c, d) {
        this.a9.f$ah(this, a, b, c, d);
    };
    SeriesViewer.prototype.n0 = function () {
        this.dh = false;
    };
    SeriesViewer.prototype.ne = function (a) {
        this.cu.ej(a.height);
    };
    SeriesViewer.prototype.l6 = function () {
        if (this.db) {
            this.lx({ $type: Point_$type, x: NaN, y: NaN });
            this.cu.ch();
        }
        this.db = false;
    };
    SeriesViewer.prototype.m1 = function (a, b) {
        this.a9.f$n(this, a, b);
    };
    SeriesViewer.prototype.cj = function (a) {
        var b = this.cu.k != null && this.cu.k.al ? this.ck : this.ci;
        if (b != 3) {
            return b;
        }
        return this.cu.m(a);
    };
    SeriesViewer.prototype.n6 = function () {
        this.dm = false;
        if (!this.dn) {
            this.dn = true;
            this.dh = true;
            if (this.viewerManipulationStarting != null) {
                var a = new SeriesViewerManipulationEventArgs();
                a.isZoomPan = true;
                this.viewerManipulationStarting(this, a);
            }
        }
        this.a9.f$ak(this);
    };
    SeriesViewer.prototype.n5 = function () {
        if (this.dn) {
            this.dn = false;
            if (this.viewerManipulationEnding != null) {
                var a = new SeriesViewerManipulationEventArgs();
                a.isZoomPan = true;
                this.viewerManipulationEnding(this, a);
            }
        }
        this.a9.f$aj(this);
    };
    SeriesViewer.prototype.pb = function () {
        this.a9.f$ap(this);
    };
    SeriesViewer.prototype.l1 = function () {
        if (this.dm) {
            this.m5();
        }
        this.a9.f$k(this);
    };
    SeriesViewer.prototype.lw = function () {
        this.lv();
    };
    SeriesViewer.prototype.lv = function () {
        if (this.ei) {
            this.a9.f$h(this);
        }
    };
    SeriesViewer.prototype.oa = function () {
    };
    SeriesViewer.prototype.ox = function () {
    };
    SeriesViewer.prototype.ov = function () {
        for (var a = 0; a < this.series.count; a++) {
            this.series._inner[a].mn(false);
        }
        this.l5(false, false, true);
    };
    SeriesViewer.prototype.m0 = function (a, b) {
        this.a9.f$m(this, a, b);
    };
    SeriesViewer.prototype.e9 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "fe", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            this.dk = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.mz = function (a, b, c) {
        this.a9.f$l(this, a, b, c);
    };
    SeriesViewer.prototype.po = function (a, b) {
        if (b.propertyName == SyncSettings.$$p[0]) {
            SyncManager.b(this, b.oldValue, b.newValue);
        }
    };
    SeriesViewer.prototype.pn = function (a, b) {
        var e_6, _a;
        if (a != null) {
            a.as(this);
            a.propertyUpdated = delegateRemove(a.propertyUpdated, this.propertyUpdated);
        }
        if (b != null) {
            b.al(this);
            b.propertyUpdated = delegateCombine(b.propertyUpdated, this.propertyUpdated);
        }
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.b9 = this.actualSyncLink;
                c.ce = this;
            }
        }
        catch (e_6_1) {
            e_6 = { error: e_6_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_6)
                    throw e_6.error;
            }
        }
    };
    SeriesViewer.prototype.lx = function (a) {
        if (this.dv) {
            this.ba.onCrosshairMoved(this.tb(a));
        }
        this.actualSyncLink.an(this, a);
    };
    SeriesViewer.prototype.pr = function (a, b) {
        this.ps(a, b, !b);
    };
    SeriesViewer.prototype.ps = function (a, b, c) {
        if (!b) {
            this.actualSyncLink.au(this, a, c);
        }
        else {
            if (!this.es() && !this.et()) {
                return;
            }
            var d = !a.isEmpty && !isNaN_(a.x) && !isNaN_(a.y) && !isNaN_(a.width) && !isNaN_(a.height);
            var e = a;
            if (d && !this.fa) {
                if (e.width < this.gj) {
                    return;
                }
                else if (e.height < this.gi) {
                    return;
                }
            }
            if (d && !this.es()) {
                e = new Rect(0, 0, a.y, 1, a.height);
            }
            if (d && !this.et()) {
                e = new Rect(0, a.x, 0, a.width, 1);
            }
            this.actualSyncLink.at(this, e);
        }
    };
    SeriesViewer.prototype.ob = function (a, b) {
        if (!b) {
            this.actualSyncLink.ap(this, a);
        }
        else {
            if (!this.es() && !this.et()) {
                return;
            }
            var c = !a.isEmpty && !isNaN_(a.x) && !isNaN_(a.y) && !isNaN_(a.width) && !isNaN_(a.height);
            var d = a;
            if (c && !this.es()) {
                d = new Rect(0, 0, a.y, 1, a.height);
            }
            if (c && !this.et()) {
                d = new Rect(0, a.x, 0, a.width, 1);
            }
            this.actualSyncLink.ap(this, d);
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "en", {
        get: function () {
            return this.actualSyncLink != null;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype._fn = function () {
        var _a, _b, a, e_7_1;
        var e_7, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (this.actualSyncLink == null) {
                        return [2 /*return*/, undefined];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 6, 7, 8]);
                    _a = __values(fromEnum(this.actualSyncLink.ai)), _b = _a.next();
                    _d.label = 2;
                case 2:
                    if (!!_b.done)
                        return [3 /*break*/, 5];
                    a = _b.value;
                    return [4 /*yield*/, a];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_7_1 = _d.sent();
                    e_7 = { error: e_7_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_c = _a.return))
                            _c.call(_a);
                    }
                    finally {
                        if (e_7)
                            throw e_7.error;
                    }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    };
    SeriesViewer.prototype.fn = function () {
        var _this = this;
        return toEnum(function () { return _this._fn(); });
    };
    SeriesViewer.prototype.td = function (a) {
        a = { $type: Point_$type, x: a.x + this.ty.left, y: a.y + this.ty.top };
        var b = this.tm;
        var c = this.tj.left + this.tj.width * (a.x - b.left) / b.width;
        var d = this.tj.top + this.tj.height * (a.y - b.top) / b.height;
        return { $type: Point_$type, x: c, y: d };
    };
    SeriesViewer.prototype.tb = function (a) {
        var b = this.tm;
        var c = (a.x - this.tj.left) * b.width / this.tj.width + b.left;
        var d = (a.y - this.tj.top) * b.height / this.tj.height + b.top;
        a = { $type: Point_$type, x: a.x - this.ty.left, y: a.y - this.ty.top };
        return { $type: Point_$type, x: c, y: d };
    };
    SeriesViewer.prototype.tx = function (a) {
        a = new Rect(0, a.left + this.ty.left, a.top + this.ty.top, a.width, a.height);
        var b = this.tm;
        var c = this.tj.left + this.tj.width * (a.left - b.left) / b.width;
        var d = this.tj.top + this.tj.height * (a.top - b.top) / b.height;
        var e = this.tj.left + this.tj.width * (a.right - b.left) / b.width;
        var f = this.tj.top + this.tj.height * (a.bottom - b.top) / b.height;
        return new Rect(0, c, d, e - c, f - d);
    };
    SeriesViewer.prototype.os = function (a, b) {
        if (this.windowRectChanged != null && Rect.l_op_Inequality(a, b)) {
            this.windowRectChanged(this, new RectChangedEventArgs(a, b));
        }
    };
    SeriesViewer.prototype.n2 = function (a, b) {
        this.os(a, b);
    };
    SeriesViewer.prototype.nz = function (a, b) {
        if (this.sizeChanged != null && Size.l_op_Inequality(a, b)) {
            this.sizeChanged(this, new RectChangedEventArgs(new Rect(1, 0, 0, a), new Rect(1, 0, 0, b)));
        }
    };
    SeriesViewer.prototype.e7 = function (a, b) {
        if (a.width != b.width || a.height != b.height || a.x != b.x || a.y != b.y) {
            return true;
        }
        return false;
    };
    SeriesViewer.prototype.of = function (a, b) {
        if (this.actualWindowRectChanged != null && this.e7(a, b)) {
            this.actualWindowRectChanged(this, new RectChangedEventArgs(a, b));
        }
    };
    SeriesViewer.prototype.pt = function (a) {
        if (isNaN_(a) || isInfinity(a)) {
            a = 0.05;
        }
        var b = this.gp() - a;
        var c = this.gp() - a;
        var d = this.gg + (a / 2);
        var e = this.gh + (a / 2);
        this.tz = new Rect(0, d, e, b, c);
    };
    SeriesViewer.prototype.pu = function (a) {
        this.pt(a * -1);
    };
    SeriesViewer.prototype.o3 = function () {
        this.cu.d2();
    };
    SeriesViewer.prototype.og = function (a, b) {
        if (this.gridAreaRectChanged != null && Rect.l_op_Inequality(a, b)) {
            this.gridAreaRectChanged(this, new RectChangedEventArgs(a, b));
        }
    };
    SeriesViewer.prototype.get_ek = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "ek", {
        get: function () {
            return this.get_ek();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.nq = function (a, b) {
        this.og(a, b);
        if (this.ei) {
            this.a9.f$an(this);
        }
        if (this.ek && (Rect.l_op_Equality(a, null) || a.isEmpty || a.width == 0 || a.height == 0)) {
            this.pr(this.tz, false);
        }
        else {
            this.mb();
        }
        if (a.isEmpty || a.width == 0 || a.height == 0) {
            this.ml();
        }
    };
    SeriesViewer.prototype.mf = function () {
        this.mb();
    };
    Object.defineProperty(SeriesViewer.prototype, "gj", {
        get: function () {
            return this.fx;
        },
        set: function (a) {
            var b = this.fx;
            this.fx = a;
            this.oi("ActualWindowRectMinWidth", b, this.fx);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gi", {
        get: function () {
            return this.fw;
        },
        set: function (a) {
            var b = this.fw;
            this.fw = a;
            this.oi("ActualWindowRectMinHeight", b, this.fw);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "syncChannel", {
        get: function () {
            return this._syncChannel;
        },
        set: function (a) {
            this._syncChannel = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "actualSyncLink", {
        get: function () {
            return this.b8;
        },
        set: function (a) {
            var b = this.b8;
            this.b8 = a;
            this.oi("ActualSyncLink", b, this.b8);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.md = function () {
        this.cu.d3();
    };
    SeriesViewer.prototype.m6 = function () {
        this.dm = true;
    };
    SeriesViewer.prototype.m4 = function () {
        this.dm = false;
    };
    SeriesViewer.prototype.m5 = function () {
        if (this.dm) {
            if (this.dn) {
                this.dn = false;
                if (this.viewerManipulationEnding != null) {
                    var a = new SeriesViewerManipulationEventArgs();
                    a.isZoomPan = true;
                    this.viewerManipulationEnding(this, a);
                }
                this.dh = false;
            }
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "cn", {
        get: function () {
            return this.cu.i().a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.pk = function (a) {
        if (this.cn != null) {
            this.cn.mobileMode = a;
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "cd", {
        get: function () {
            return this.cc;
        },
        set: function (a) {
            this.cc = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ce = function () {
        if (this.cf == 0) {
            return 1;
        }
        return this.cf;
    };
    SeriesViewer.prototype.dz = function () {
        return this.cl == 0 && !this.dj && !this.dk;
    };
    SeriesViewer.prototype.dr = function () {
        if (this.actualSyncLink != null && this.actualSyncLink.ai.count > 0) {
            var a = true;
            a = this.dz();
            if (!a) {
                return false;
            }
            for (var b = 0; b < this.actualSyncLink.ai.count; b++) {
                if (!this.actualSyncLink.ai.item(b).dz()) {
                    return false;
                }
            }
            return true;
        }
        else {
            return this.dz();
        }
    };
    SeriesViewer.prototype.lq = function () {
        if (this.cl == 2) {
            this.cu.bt();
            this.cl = 0;
            this.n5();
            this.ob(Rect.empty, true);
            if (this.cb == 1) {
                this.pr(this.t0, true);
            }
        }
        if (this.cl == 1) {
            this.cu.bt();
            this.cl = 0;
            this.n5();
            this.cu.cf();
            this.ob(Rect.empty, true);
        }
    };
    SeriesViewer.prototype.notifyCrosshairUpdate = function () {
    };
    SeriesViewer.prototype.pp = function (a, b) {
        var c = this.gj;
        var d = this.gi;
        this.tz = new Rect(0, this.gg, this.gh, MathUtil.d(a, c, 1), MathUtil.d(b, d, 1));
    };
    SeriesViewer.prototype.pq = function (a, b, c, d) {
        if (!MathUtil.a(a) || a < 0 || a >= 1) {
            a = this.gg;
        }
        if (!MathUtil.a(b) || b < 0 || b >= 1) {
            b = this.gh;
        }
        if (!MathUtil.a(d)) {
            d = this.gq();
        }
        if (!MathUtil.a(c)) {
            c = this.gp();
        }
        this.tz = new Rect(0, a, b, MathUtil.d(c, this.gj, 1), MathUtil.d(d, this.gi, 1));
    };
    SeriesViewer.prototype.gp = function () {
        return 1;
    };
    SeriesViewer.prototype.gq = function () {
        return 1;
    };
    SeriesViewer.prototype.g3 = function () {
        if (this.ho > 0) {
            return this.ho;
        }
        var a = Rect.l_op_Inequality(this.ty, null) && !this.ty.isEmpty && MathUtil.a(this.ty.width);
        var b = MathUtil.a(this.hq);
        if (b && a) {
            var c = this.hq / this.ty.width;
            if (c <= 0 || c >= 1) {
                c = 0.0001;
            }
            return c;
        }
        return 0.0001;
    };
    SeriesViewer.prototype.g2 = function () {
        if (this.hn > 0) {
            return this.hn;
        }
        var a = Rect.l_op_Inequality(this.ty, null) && !this.ty.isEmpty && MathUtil.a(this.ty.height);
        var b = MathUtil.a(this.hp);
        if (b && a) {
            var c = this.hp / this.ty.height;
            if (c <= 0 || c >= 1) {
                c = 0.0001;
            }
            return c;
        }
        return 0.0001;
    };
    SeriesViewer.prototype.od = function (a, b, c, d) {
        var e_8, _a, e_9, _b, e_10, _c;
        switch (b) {
            case SeriesViewer.$$p[36]:
                this.cu.dj();
                break;
            case SeriesViewer.$$p[33]:
                this.cu.dj();
                break;
            case SeriesViewer.$$p[48]:
                this.cd = this.ce();
                break;
            case "HorizontalViewScrollbarMode":
                this.b3 = this.b5;
                if (this.dx || this.ei) {
                    this.ba.onHorizontalScrollbarModeChanged(this.b3);
                }
                break;
            case "VerticalViewScrollbarMode":
                this.b4 = this.b6;
                if (this.dx || this.ei) {
                    this.ba.onVerticalScrollbarModeChanged(this.b4);
                }
                break;
            case "ActualContentHitTestMode":
                this.mt();
                break;
            case "ContentHitTestMode":
                this.ot();
                break;
            case SeriesViewer.$$p[35]:
                this.cu.dh(c, d);
                this.cu.dj();
                break;
            case SeriesViewer.$$p[32]:
                this.cu.dd(c, d);
                this.cu.dj();
                break;
            case "TitleTextStyle":
            case "TitleTextColor":
            case "SubtitleTextStyle":
            case "SubtitleTextColor":
            case "TitleTopMargin":
            case "TitleLeftMargin":
            case "TitleRightMargin":
            case "TitleBottomMargin":
            case "SubtitleTopMargin":
            case "SubtitleLeftMargin":
            case "SubtitleRightMargin":
            case "SubtitleBottomMargin":
                this.cu.dj();
                break;
            case SeriesViewer.$$p[24]:
            case SeriesViewer.$$p[25]:
            case SeriesViewer.$$p[26]:
                this.cu.db();
                break;
            case "PixelScalingRatio":
                if (isNaN_(DeviceUtils.a(this.g0))) {
                    this.ma();
                }
                else {
                    this.gf = DeviceUtils.a(this.g0);
                }
                break;
            case "InteractionPixelScalingRatio":
                this.ge = this.gy;
                break;
            case "ActualPixelScalingRatio":
                this.cu.dq();
                break;
            case SeriesViewer.$$p[11]:
                this.cu.cp();
                break;
            case "ActualSyncLink":
                this.pn(typeCast(SyncLink.$, c), typeCast(SyncLink.$, d));
                break;
            case SeriesViewer.$$p[3]:
                if (!this.d8) {
                    this.fi = true;
                }
                if (this.t3 == 0) {
                    this.d0 = true;
                }
                else {
                    this.d0 = this.dp;
                }
                if (this.ei) {
                    this.a9.f$an(this);
                }
                break;
            case "CrosshairPoint":
                if (this.ei) {
                    if (this.e2) {
                        this.pj(this.ta);
                    }
                    this.a9.f$an(this);
                }
                this.notifyCrosshairUpdate();
                break;
            case SeriesViewer.$$p[44]:
                if (this.actualSyncLink != null) {
                    this.hu++;
                    this.pr(d, false);
                    this.hu--;
                }
                if (!this.tz.equals1(c) && this.hu == 0) {
                    this.n2(c, this.tz);
                }
                this.mb();
                break;
            case SeriesViewer.$$p[40]:
                this.gg = this.hl;
                break;
            case SeriesViewer.$$p[41]:
                this.gh = this.hm;
                break;
            case "ActualWindowPositionVertical":
            case "ActualWindowPositionHorizontal":
                if (!this.fg) {
                    this.pp(this.gp(), this.gq());
                }
                break;
            case SeriesViewer.$$p[43]:
            case SeriesViewer.$$p[47]:
                this.gj = this.g3();
                break;
            case SeriesViewer.$$p[42]:
            case SeriesViewer.$$p[46]:
                this.gi = this.g2();
                break;
            case SeriesViewer.$$p[12]:
                this.cu.c5();
                break;
            case SeriesViewer.$$p[9]:
                this.cv.r = this.hy;
                break;
            case SeriesViewer.$$p[17]:
                this.pm();
                break;
            case "ActualWindowRect":
                this.da = true;
                if (this.e7(c, d)) {
                    this.lm(c, d);
                }
                if (d.width == 1 && d.height == 1 && c.isEmpty) {
                    this.fl = true;
                }
                this.of(c, d);
                break;
            case SeriesViewer.$$p[21]:
                this.cu.da(d);
                break;
            case SeriesViewer.$$p[38]:
                this.dq = this.fj;
                break;
            case SeriesViewer.$$p[49]:
                this.hv = this.h0;
                this.lv();
                break;
            case SeriesViewer.$$p[23]:
                this.a9.f$af(this);
                break;
            case "HighlightingMode":
            case "HighlightingBehavior":
                this.br = this.bu();
                if (this.ei) {
                    var e = this.a7;
                    e.highlightingBehavior = this.bs;
                }
                break;
            case "LegendItemBadgeShape":
                try {
                    for (var _d = __values(fromEnum(this.series)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var f = _e.value;
                        f.legendItemBadgeShape = this.bd;
                    }
                }
                catch (e_8_1) {
                    e_8 = { error: e_8_1 };
                }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return))
                            _a.call(_d);
                    }
                    finally {
                        if (e_8)
                            throw e_8.error;
                    }
                }
                break;
            case "LegendItemBadgeMode":
                try {
                    for (var _f = __values(fromEnum(this.series)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var g = _g.value;
                        g.ba = this.bc;
                    }
                }
                catch (e_9_1) {
                    e_9 = { error: e_9_1 };
                }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return))
                            _b.call(_f);
                    }
                    finally {
                        if (e_9)
                            throw e_9.error;
                    }
                }
                break;
            case SeriesViewer.$$p[1]:
            case SeriesViewer.$$p[16]:
            case SeriesViewer.$$p[14]:
            case SeriesViewer.$$p[15]:
            case SeriesViewer.$$p[13]:
                try {
                    for (var _h = __values(fromEnum(this.series)), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var h = _j.value;
                        h.lp();
                    }
                }
                catch (e_10_1) {
                    e_10 = { error: e_10_1 };
                }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return))
                            _c.call(_h);
                    }
                    finally {
                        if (e_10)
                            throw e_10.error;
                    }
                }
                break;
            case "HorizontalViewScrollbarCornerRadius":
            case "HorizontalViewScrollbarFill":
            case "HorizontalViewScrollbarMaxOpacity":
            case "HorizontalViewScrollbarOutline":
            case "HorizontalViewScrollbarStrokeThickness":
            case "VerticalViewScrollbarCornerRadius":
            case "VerticalViewScrollbarFill":
            case "VerticalViewScrollbarMaxOpacity":
            case "VerticalViewScrollbarOutline":
            case "VerticalViewScrollbarStrokeThickness":
                if (this.ei) {
                    this.ba.updateBarAppearance(this, this.sy, this.s7, this.sz, this.s8, this.gv, this.hh, this.gu, this.hg);
                }
                break;
            case "HorizontalViewScrollbarHeight":
            case "HorizontalViewScrollbarInset":
            case SeriesViewer.i8:
            case "HorizontalViewScrollbarTrackStartInset":
            case "HorizontalViewScrollbarTrackEndInset":
                if (this.ei) {
                    this.ba.updateBarDimensions(this, this.gs, this.gr, this.gt, this.d6, this.gx, this.gw, this.hk, this.he, this.hf, this.fk, this.hj, this.hi);
                }
                break;
            case "VerticalViewScrollbarPosition":
                if (this.ei) {
                    this.ba.updateVerticalScrollbarPosition(this.b7);
                }
                break;
            case "HorizontalViewScrollbarPosition":
                if (this.ei) {
                    this.ba.updateHorizontalScrollbarPosition(this.b2);
                }
                break;
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "ef", {
        get: function () {
            return this.bs == 2 || this.bs == 3 || this.bs == 4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "e2", {
        get: function () {
            return this.bs == 2 || this.bs == 3 || this.bs == 4;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.pj = function (a) {
        var _this = this;
        var b = 1.7976931348623157E+308;
        var c = null;
        for (var d = 0; d < this.series.count; d++) {
            var e = this.series._inner[d];
            if (e.dd) {
                continue;
            }
            if (e.c3 && e.c6) {
                continue;
            }
            if (e.isStacked) {
                e.lf(function (f) {
                    var g = _this.lk(f, b, c, a);
                    if (g == null) {
                        return true;
                    }
                    b = g.c;
                    c = g.d;
                    return true;
                });
            }
            var f = this.lk(e, b, c, a);
            if (f == null) {
                continue;
            }
            b = f.c;
            c = f.d;
        }
        this.bo = c;
    };
    SeriesViewer.prototype.lk = function (a, b, c, d) {
        var e = a.pn(d);
        var f = a.ps(d, true, true);
        if (isNaN_(f.x) || isNaN_(f.y)) {
            return null;
        }
        var g = (e.x - f.x) * (e.x - f.x) + (e.y - f.y) * (e.y - f.y);
        if (g < b) {
            b = g;
            c = a;
        }
        return new Tuple$2(Number_$type, Series.$, b, c);
    };
    SeriesViewer.prototype.pm = function () {
        this.dl = this.t4 == 0;
        this.cu.dp();
        this.pl();
        this.cu.em();
        this.md();
        this.mr();
    };
    SeriesViewer.prototype.mt = function () {
        this.cu.cv();
    };
    SeriesViewer.prototype.pl = function () {
        if (this.cn == null) {
            return;
        }
        this.cn.visibility = this.t4;
        this.cn.isZoomable = this.er();
    };
    Object.defineProperty(SeriesViewer.prototype, "tt", {
        get: function () {
            return this.th;
        },
        set: function (a) {
            var b = this.th;
            this.th = a;
            if (this.th.isEmpty) {
                this.cu.cj();
            }
            else {
                this.cu.en(this.ty, this.tw(this.tt));
                this.cu.ec();
                this.oi("PreviewRect", b, this.th);
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.pd = function () {
        this.gg = this.tj.x;
        this.gh = this.tj.y;
    };
    SeriesViewer.prototype.lm = function (a, b) {
        this.fl = false;
        this.fr = dateNow();
        if (this.ee) {
            for (var c = 0; c < this.series.count; c++) {
                this.series._inner[c].k0();
            }
            this.a7.clear();
        }
        if (this.cv.f()) {
            this.cv.w();
        }
        var d = this.fg;
        this.fg = true;
        this.pd();
        this.fg = d;
        this.cu.ck();
        this.cu.ep(this.tj);
        if (this.dv) {
            this.ba.updateScrollbars(this, a, this.tj, this.ty, this.ty);
        }
        this.mu(a, b);
    };
    SeriesViewer.prototype.mu = function (a, b) {
    };
    SeriesViewer.prototype.tw = function (a) {
        if (this.ty.isEmpty) {
            return Rect.empty;
        }
        var b = this.ty;
        var c = b.left + (b.width * (a.left - this.tj.left) / this.tj.width);
        var d = b.top + (b.height * (a.top - this.tj.top) / this.tj.height);
        var e = b.left + (b.width * (a.right - this.tj.left) / this.tj.width);
        var f = b.top + (b.height * (a.bottom - this.tj.top) / this.tj.height);
        return new Rect(0, c, d, e - c, f - d);
    };
    SeriesViewer.prototype.oj = function () {
        if (this.refreshCompleted != null && !this.destroyed) {
            this.refreshCompleted(this, new RefreshCompletedEventArgs());
        }
    };
    SeriesViewer.prototype.n1 = function (a) {
        this.pl();
    };
    Object.defineProperty(SeriesViewer.prototype, "kr", {
        get: function () {
            return this.h6;
        },
        set: function (a) {
            var b = this.h6;
            this.h6 = a;
            this.oi("TitleTextStyle", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "kf", {
        get: function () {
            return this.h5;
        },
        set: function (a) {
            var b = this.h5;
            this.h5 = a;
            this.oi("SubtitleTextStyle", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "s5", {
        get: function () {
            return this.sm;
        },
        set: function (a) {
            var b = this.sm;
            this.sm = a;
            this.oi("TitleTextColor", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "s4", {
        get: function () {
            return this.sl;
        },
        set: function (a) {
            var b = this.sl;
            this.sl = a;
            this.oi("SubtitleTextColor", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hc", {
        get: function () {
            return this.gc;
        },
        set: function (a) {
            var b = this.gc;
            this.gc = a;
            this.oi("TitleTopMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ha", {
        get: function () {
            return this.ga;
        },
        set: function (a) {
            var b = this.ga;
            this.ga = a;
            this.oi("TitleLeftMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "hb", {
        get: function () {
            return this.gb;
        },
        set: function (a) {
            var b = this.gb;
            this.gb = a;
            this.oi("TitleRightMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g9", {
        get: function () {
            return this.f9;
        },
        set: function (a) {
            var b = this.f9;
            this.f9 = a;
            this.oi("TitleBottomMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g8", {
        get: function () {
            return this.f8;
        },
        set: function (a) {
            var b = this.f8;
            this.f8 = a;
            this.oi("SubtitleTopMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g6", {
        get: function () {
            return this.f6;
        },
        set: function (a) {
            var b = this.f6;
            this.f6 = a;
            this.oi("SubtitleLeftMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g7", {
        get: function () {
            return this.f7;
        },
        set: function (a) {
            var b = this.f7;
            this.f7 = a;
            this.oi("SubtitleRightMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g5", {
        get: function () {
            return this.f5;
        },
        set: function (a) {
            var b = this.f5;
            this.f5 = a;
            this.oi("SubtitleBottomMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.t1 = function () {
        return this.cu.fj();
    };
    SeriesViewer.prototype.t2 = function () {
        return this.cu.fk();
    };
    SeriesViewer.prototype.ap = function (a) {
        return this.cu.c(a);
    };
    SeriesViewer.prototype.aq = function (a) {
        return this.cu.d(a);
    };
    SeriesViewer.prototype.getFontHeight = function () {
        return this.cu.a9;
    };
    SeriesViewer.prototype.get_e1 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "e1", {
        get: function () {
            return this.get_e1();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.m3 = function () {
    };
    SeriesViewer.prototype.provideContainer = function (a) {
        this.cu.c0(a);
    };
    SeriesViewer.prototype.m2 = function (a, b) {
        this.cu.c1(a, b);
    };
    SeriesViewer.prototype.notifyContainerResized = function () {
        this.cu.cu();
        this.m3();
    };
    SeriesViewer.prototype.to = function () {
        return this.cu.fb();
    };
    SeriesViewer.prototype.l2 = function () {
        this.cu.b5();
    };
    SeriesViewer.prototype.tc = function () {
        return this.cu.e8();
    };
    SeriesViewer.prototype.cy = function () {
        return this.cu.t();
    };
    SeriesViewer.prototype.cx = function () {
        return this.cu.q();
    };
    SeriesViewer.prototype.sr = function () {
        return this.cu.e0();
    };
    SeriesViewer.prototype.ss = function () {
        return this.cu.e3();
    };
    SeriesViewer.prototype.lo = function (a) {
        this.cu.bp(a);
    };
    SeriesViewer.prototype.oz = function (a) {
        this.cu.dy(a);
    };
    Object.defineProperty(SeriesViewer.prototype, "ey", {
        get: function () {
            return this.di;
        },
        set: function (a) {
            var b = this.di;
            this.di = a;
            if (b != this.di) {
                this.cu.cr(this.di);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "dp", {
        get: function () {
            return this.c9;
        },
        set: function (a) {
            var b = this.c9;
            this.c9 = a;
            if (b != this.c9) {
                this.cu.bk(this.c9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "syncSettings", {
        get: function () {
            return this._syncSettings;
        },
        set: function (a) {
            this._syncSettings = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ln = function (a) {
        this.cu.bn(a);
    };
    SeriesViewer.prototype.o1 = function (a) {
        this.cu.dz(a);
    };
    SeriesViewer.prototype.mq = function (source_, a, b, c) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        var d = this.actualSyncLink.ag(source_);
        if (d == null) {
            return;
        }
        d.handleCollectionChanged(new NotifyCollectionChangedEventArgs(2, 2, c, b, a));
    };
    SeriesViewer.prototype.mh = function (source_) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        var a = this.actualSyncLink.ag(source_);
        if (a == null) {
            return;
        }
        a.handleCollectionChanged(new NotifyCollectionChangedEventArgs(0, 4));
    };
    SeriesViewer.prototype.mo = function (source_, a, b) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        var c = this.actualSyncLink.ag(source_);
        if (c == null) {
            return;
        }
        c.handleCollectionChanged(new NotifyCollectionChangedEventArgs(1, 0, b, a));
    };
    SeriesViewer.prototype.mp = function (source_, a, b) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        var c = this.actualSyncLink.ag(source_);
        if (c == null) {
            return;
        }
        c.handleCollectionChanged(new NotifyCollectionChangedEventArgs(1, 1, b, a));
    };
    SeriesViewer.prototype.destroy = function () {
        this.destroyed = true;
        var a = new List$1(Series.$, 0);
        for (var b = 0; b < this.series.count; b++) {
            a.add(this.series._inner[b]);
        }
        for (var c = 0; c < a.count; c++) {
            if (a._inner[c].b1 != null) {
                a._inner[c].b1.aj();
            }
            this.series.remove(a._inner[c]);
            this.o0(a._inner[c].name, true);
            a._inner[c].itemsSource = null;
            a._inner[c].ma(null, null);
        }
        this.l0();
        this.o2();
        this.onDetachedFromUI();
        this.cu.c0(null);
    };
    SeriesViewer.prototype.l0 = function () {
    };
    SeriesViewer.prototype.o8 = function (source_) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        this.h1 = source_;
        this.ph();
    };
    SeriesViewer.prototype.o2 = function () {
        this.h1 = null;
        this.ph();
    };
    SeriesViewer.prototype.o7 = function (a, source_) {
        if (source_.dataView && source_.dataSource) {
            source_ = source_.dataView();
        }
        ;
        if (stringIsNullOrEmpty(a) == false) {
            if (!this.fm.containsKey(a)) {
                this.fm.addItem(a, source_);
            }
            else {
                this.fm.item(a, source_);
            }
        }
        this.ph();
    };
    SeriesViewer.prototype.o0 = function (a, b) {
        if (stringIsNullOrEmpty(a) == false) {
            if (this.fm.containsKey(a)) {
                this.fm.removeItem(a);
            }
        }
        if (!b) {
            this.ph();
        }
    };
    SeriesViewer.prototype.o6 = function (a, b) {
        if (a.itemsSource != b) {
            a.itemsSource = b;
        }
    };
    SeriesViewer.prototype.pg = function (a) {
        if (!this.ev) {
            return;
        }
        if (typeCast(Series.$, a) !== null) {
            var b = a;
            if (this.fm.containsKey(b.name)) {
                var c = this.fm.item(b.name);
                this.o6(b, c);
            }
            else {
                this.o6(b, this.h1);
            }
        }
        if (typeCast(CategoryAxisBase.$, a) !== null) {
            var d = a;
            if (this.fm.containsKey(d.name)) {
                var e = this.fm.item(d.name);
                if (d.itemsSource != e) {
                    d.itemsSource = e;
                }
            }
            else {
                if (d.itemsSource != this.h1) {
                    d.itemsSource = this.h1;
                }
            }
        }
    };
    SeriesViewer.prototype.ph = function () {
        var e_11, _a;
        if (!this.ev) {
            return;
        }
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                this.pg(a);
            }
        }
        catch (e_11_1) {
            e_11 = { error: e_11_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_11)
                    throw e_11.error;
            }
        }
    };
    Object.defineProperty(SeriesViewer.prototype, "hd", {
        get: function () {
            return this.gd;
        },
        set: function (a) {
            this.gd = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gz", {
        get: function () {
            return this.f2;
        },
        set: function (a) {
            this.f2 = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g4", {
        get: function () {
            return this.f4;
        },
        set: function (a) {
            this.f4 = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gm", {
        get: function () {
            return this.f0;
        },
        set: function (a) {
            this.f0 = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gl", {
        get: function () {
            return this.fz;
        },
        set: function (a) {
            this.fz = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gk", {
        get: function () {
            return this.fy;
        },
        set: function (a) {
            this.fy = a;
            this.md();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.e8 = function () {
        return false;
    };
    Object.defineProperty(SeriesViewer.prototype, "eb", {
        get: function () {
            return this.de;
        },
        set: function (a) {
            var b = this.de;
            this.de = a;
            this.oi("IsAntiAliasingEnabledDuringInteraction", b, this.de);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "g0", {
        get: function () {
            return this.f3;
        },
        set: function (a) {
            var b = this.f3;
            this.f3 = a;
            this.oi("PixelScalingRatio", b, this.f3);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gy", {
        get: function () {
            return this.f1;
        },
        set: function (a) {
            var b = this.f1;
            this.f1 = a;
            this.oi("InteractionPixelScalingRatio", b, this.f1);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.cg = function (a, b) {
        var c = new CoercionInfo();
        c.b = a;
        c.a = null;
        var d = FastItemsSource.f(a);
        if (d.d == null) {
            return c;
        }
        if (b != null) {
            var methods_ = b;
            var key_ = d.d;
            var val_ = null;
            if (typeof methods_[key_] != 'undefined') {
                val_ = methods_[key_];
            }
            ;
            c.b = d.c;
            c.a = val_;
        }
        else if (d.d == "defaultDateParse") {
            var e = defaultDVDateParse;
            c.b = d.c;
            c.a = e;
        }
        return c;
    };
    Object.defineProperty(SeriesViewer.prototype, "jp", {
        get: function () {
            return this.h4;
        },
        set: function (a) {
            this.h4 = a;
            if (this.cn == null) {
                return;
            }
            this.cn.backgroundImageUri = this.h4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gf", {
        get: function () {
            return this.ft;
        },
        set: function (a) {
            var b = this.ft;
            this.ft = a;
            this.oi("ActualPixelScalingRatio", b, this.ft);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "ge", {
        get: function () {
            return this.fs;
        },
        set: function (a) {
            var b = this.fs;
            this.fs = a;
            this.oi("ActualInteractionPixelScalingRatio", b, this.fs);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "tj", {
        get: function () {
            return this.te;
        },
        set: function (a) {
            var b = Rect.l_op_Inequality(this.te, a);
            if (b) {
                var c = this.te;
                this.te = a;
                this.oi("ActualWindowRect", c, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.tp = function () {
        return this.tj;
    };
    SeriesViewer.prototype.mb = function () {
        if (this.d7) {
            return;
        }
        this.tj = this.tk();
    };
    SeriesViewer.prototype.tu = function () {
        return Rect.empty;
    };
    SeriesViewer.prototype.tk = function () {
        var a = this.tz.left;
        var b = this.tz.top;
        var c = this.tz.width;
        var d = this.tz.height;
        if (this.cd == 1) {
            a = Math.min(1, Math.max(0, this.tz.left));
            c = Math.min(1, Math.max(0, this.tz.width));
        }
        if (this.cd == 1) {
            b = Math.min(1, Math.max(0, this.tz.top));
            d = Math.min(1, Math.max(0, this.tz.height));
        }
        return new Rect(0, a, b, c, d);
    };
    SeriesViewer.prototype.h2 = function (a, b) {
        return this.cu.bj(a, b, this.gf);
    };
    Object.defineProperty(SeriesViewer.prototype, "gg", {
        get: function () {
            return this.fu;
        },
        set: function (a) {
            var b = this.fu;
            this.fu = a;
            this.oi("ActualWindowPositionHorizontal", b, this.fu);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewer.prototype, "gh", {
        get: function () {
            return this.fv;
        },
        set: function (a) {
            var b = this.fv;
            this.fv = a;
            this.oi("ActualWindowPositionVertical", b, this.fv);
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.ms = function () {
        if (this.dl && this.cn != null) {
            this.cn.surfaceIsDirty = true;
            this.cn.doRefresh(false);
        }
        this.lw();
        this.mm();
    };
    SeriesViewer.prototype.mr = function () {
        if (this.dl && this.cn != null) {
            this.cn.surfaceIsDirty = true;
            this.cn.doRefresh(false);
        }
        this.lw();
    };
    SeriesViewer.prototype.flush = function () {
        this.l5(true, true, true);
    };
    SeriesViewer.prototype.l5 = function (a, b, c) {
        this.ar.y();
        if (a) {
            this.cu.b7();
            this.ar.y();
        }
        if (c) {
            this.al.l();
        }
        if (b) {
            this.cu.a.l();
        }
        this.fl = true;
    };
    SeriesViewer.prototype.fh = function () {
        return false;
    };
    SeriesViewer.prototype.ow = function (a, b) {
        if (this.p5 != null) {
            this.pc(this.p5);
            this.p5 = null;
            this.ax = null;
        }
        this.p5 = a;
        this.ax = this.ar.k(2, a, b);
    };
    SeriesViewer.prototype.pc = function (a) {
        this.ar.ad(2, a);
        this.p5 = null;
        this.ax = null;
    };
    SeriesViewer.prototype.ly = function () {
        this.ar.ac(2, this.p5, this.ax, false);
    };
    SeriesViewer.prototype.nd = function () {
        var a = false;
        var b = false;
        var c = false;
        for (var d = 0; d < this.series.count; d++) {
            var e = this.series._inner[d];
            if (e.dm) {
                a = true;
            }
            if (e.dn) {
                b = true;
            }
            if (e.dd) {
                c = true;
            }
        }
        this.ec = a;
        this.ed = b;
        this.ea = c;
    };
    Object.defineProperty(SeriesViewer.prototype, "eo", {
        get: function () {
            return this.dl;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewer.prototype.lp = function () {
        this.cu.bq();
        for (var a = 0; a < this.series.count; a++) {
            this.series._inner[a].lx();
        }
    };
    SeriesViewer.prototype.eu = function () {
        return this.cu.am();
    };
    SeriesViewer.prototype.hx = function () {
        var a = this.ht;
        this.ht++;
        return a;
    };
    SeriesViewer.prototype.c1 = function () {
        if (this.kr == null || this.cu.j.ae == null) {
            return null;
        }
        return FontUtil.toFontInfo(this.cu.j.ae, this.kr);
    };
    SeriesViewer.prototype.c0 = function () {
        if (this.kf == null || this.cu.j.ae == null) {
            return null;
        }
        return FontUtil.toFontInfo(this.cu.j.ae, this.kf);
    };
    SeriesViewer.prototype.pf = function () {
        var a = false;
        a = this.dp;
        this.d8 = true;
        this.d0 = (a && !this.fi) || this.t3 == 0;
        this.d8 = false;
    };
    SeriesViewer.prototype.om = function () {
        if (this.seriesDataUpdated != null) {
            this.seriesDataUpdated(this, EventArgs.empty);
        }
    };
    SeriesViewer.prototype.ml = function () {
        for (var a = 0; a < this.fp.count; a++) {
            this.fp._inner[a].notifySeriesCollectionChanged();
        }
    };
    SeriesViewer.prototype.mm = function () {
        for (var a = 0; a < this.fp.count; a++) {
            this.fp._inner[a].notifySeriesDataChanged();
        }
    };
    SeriesViewer.prototype.mn = function (a) {
        for (var b = 0; b < this.fp.count; b++) {
            this.fp._inner[b].notifyVisualPropertiesChanged(a);
        }
    };
    SeriesViewer.prototype.mk = function (a) {
        for (var b = 0; b < this.fp.count; b++) {
            this.fp._inner[b].notifyCursorPositionChanged(a);
        }
    };
    SeriesViewer.prototype.attachDataLegend = function (a) {
        this.fp.add(a);
    };
    SeriesViewer.prototype.detachDataLegend = function (a) {
        this.fp.remove(a);
    };
    SeriesViewer.prototype.getDataLegendSeries = function () {
        var a = 0;
        for (var b = 0; b < this.series.count; b++) {
            if (this.series._inner[b].isStacked) {
                this.series._inner[b].lf(function (c) {
                    if (c.isUsableInLegend) {
                        a++;
                    }
                    return true;
                });
            }
            else {
                if (this.series._inner[b].isUsableInLegend) {
                    a++;
                }
            }
        }
        var c = new Array(a);
        var d = 0;
        for (var e = 0; e < this.series.count; e++) {
            if (this.series._inner[e].isStacked) {
                this.series._inner[e].lf(function (f) {
                    if (f.isUsableInLegend) {
                        c[d] = f;
                        d++;
                    }
                    return true;
                });
            }
            else {
                if (this.series._inner[e].isUsableInLegend) {
                    c[d] = this.series._inner[e];
                    d++;
                }
            }
        }
        return c;
    };
    SeriesViewer.prototype.lr = function (a) {
        if (this.fq == null) {
            this.fq = new List$1(CaptureImageSettings.$, 0);
        }
        this.fq.add(a);
        this.ar.z();
    };
    SeriesViewer.prototype.ls = function () {
        var _this = this;
        if (this.fq != null && this.fq.count > 0) {
            var a = this.fq.toArray();
            this.fq.clear();
            var _loop_1 = function (c) {
                var b = a[c];
                this_1.ik(b, function (d, e) {
                    if (d != null) {
                        _this.oh(b, d, e);
                    }
                });
            };
            var this_1 = this;
            for (var c = 0; c < a.length; c++) {
                _loop_1(c);
            }
        }
    };
    SeriesViewer.prototype.ik = function (a, b) {
        var c = "image/png";
        switch (a.a) {
            case 0:
                c = "image/png";
                break;
            case 1:
                c = "image/jpeg";
                break;
            default: return null;
        }
        var d = null;
        d = this.cu.j.at(this.cu.a8, this.cu.a7, this.gf, c, function (e, f) {
            var _a;
            if (a.b) {
                var b_ = f;
                if ((window.ClipboardItem)) {
                    navigator.clipboard.write([new window.ClipboardItem((_a = {}, _a[b_.type] = b_, _a))]);
                }
            }
            if (b != null) {
                b(e, f);
            }
        });
        return d;
    };
    SeriesViewer.prototype.oh = function (a, b, c) {
        if (c === void 0) {
            c = null;
        }
        if (this.imageCaptured != null) {
            var d = new ImageCapturedEventArgs(b, c, a);
            this.imageCaptured(this, d);
        }
    };
    SeriesViewer.$t = markType(SeriesViewer, 'SeriesViewer', Control.$, [INotifyPropertyChanged_$type, ILegendOwner_$type, IInternalLegendOwner_$type, IDataLegendTarget_$type, IToolbarTarget_$type]);
    SeriesViewer.q2 = DependencyProperty.i("Legend", IChartLegend_$type, SeriesViewer.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("Legend", b.oldValue, b.newValue);
    }));
    SeriesViewer.p7 = DependencyProperty.i("AnimateSeriesWhenAxisRangeChanges", Boolean_$type, SeriesViewer.$, new PropertyMetadata(2, false, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("AnimateSeriesWhenAxisRangeChanges", b.oldValue, b.newValue);
    }));
    SeriesViewer.qy = DependencyProperty.i("IsWindowSyncedToVisibleRange", Boolean_$type, SeriesViewer.$, new PropertyMetadata(2, false, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("IsWindowSyncedToVisibleRange", b.oldValue, b.newValue);
    }));
    SeriesViewer.rl = DependencyProperty.i("ShouldSimulateHoverMoveCrosshairPoint", Boolean_$type, SeriesViewer.$, new PropertyMetadata(2, false, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("ShouldSimulateHoverMoveCrosshairPoint", b.oldValue, b.newValue);
    }));
    SeriesViewer.qh = DependencyProperty.i("HighlightingMode", SeriesHighlightingMode_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesHighlightingMode_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HighlightingMode", b.oldValue, b.newValue);
    }));
    SeriesViewer.qp = DependencyProperty.i("HorizontalViewScrollbarMode", SeriesViewerScrollbarMode_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesViewerScrollbarMode_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarMode", b.oldValue, b.newValue);
    }));
    SeriesViewer.rz = DependencyProperty.i("VerticalViewScrollbarMode", SeriesViewerScrollbarMode_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesViewerScrollbarMode_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarMode", b.oldValue, b.newValue);
    }));
    SeriesViewer.qr = DependencyProperty.i("HorizontalViewScrollbarPosition", SeriesViewerHorizontalScrollbarPosition_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesViewerHorizontalScrollbarPosition_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarPosition", b.oldValue, b.newValue);
    }));
    SeriesViewer.r1 = DependencyProperty.i("VerticalViewScrollbarPosition", SeriesViewerVerticalScrollbarPosition_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesViewerVerticalScrollbarPosition_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarPosition", b.oldValue, b.newValue);
    }));
    SeriesViewer.ql = DependencyProperty.i("HorizontalViewScrollbarFill", Brush.$, SeriesViewer.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarFill", b.oldValue, b.newValue);
    }));
    SeriesViewer.qq = DependencyProperty.i("HorizontalViewScrollbarOutline", Brush.$, SeriesViewer.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarOutline", b.oldValue, b.newValue);
    }));
    SeriesViewer.qt = DependencyProperty.i("HorizontalViewScrollbarStrokeThickness", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarStrokeThickness", b.oldValue, b.newValue);
    }));
    SeriesViewer.qo = DependencyProperty.i("HorizontalViewScrollbarMaxOpacity", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarMaxOpacity", b.oldValue, b.newValue);
    }));
    SeriesViewer.qk = DependencyProperty.i("HorizontalViewScrollbarCornerRadius", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarCornerRadius", b.oldValue, b.newValue);
    }));
    SeriesViewer.qm = DependencyProperty.i("HorizontalViewScrollbarHeight", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarHeight", b.oldValue, b.newValue);
    }));
    SeriesViewer.qn = DependencyProperty.i("HorizontalViewScrollbarInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.qv = DependencyProperty.i("HorizontalViewScrollbarTrackStartInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarTrackStartInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.qu = DependencyProperty.i("HorizontalViewScrollbarTrackEndInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HorizontalViewScrollbarTrackEndInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.i8 = "HorizontalViewScrollbarShouldAddAutoTrackInsets";
    SeriesViewer.qs = DependencyProperty.i(SeriesViewer.i8, Boolean_$type, SeriesViewer.$, new PropertyMetadata(2, true, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi(SeriesViewer.i8, b.oldValue, b.newValue);
    }));
    SeriesViewer.rw = DependencyProperty.i("VerticalViewScrollbarFill", Brush.$, SeriesViewer.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarFill", b.oldValue, b.newValue);
    }));
    SeriesViewer.r0 = DependencyProperty.i("VerticalViewScrollbarOutline", Brush.$, SeriesViewer.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarOutline", b.oldValue, b.newValue);
    }));
    SeriesViewer.r3 = DependencyProperty.i("VerticalViewScrollbarStrokeThickness", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarStrokeThickness", b.oldValue, b.newValue);
    }));
    SeriesViewer.ry = DependencyProperty.i("VerticalViewScrollbarMaxOpacity", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarMaxOpacity", b.oldValue, b.newValue);
    }));
    SeriesViewer.rv = DependencyProperty.i("VerticalViewScrollbarCornerRadius", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarCornerRadius", b.oldValue, b.newValue);
    }));
    SeriesViewer.r6 = DependencyProperty.i("VerticalViewScrollbarWidth", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarWidth", b.oldValue, b.newValue);
    }));
    SeriesViewer.rx = DependencyProperty.i("VerticalViewScrollbarInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.r5 = DependencyProperty.i("VerticalViewScrollbarTrackStartInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarTrackStartInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.r4 = DependencyProperty.i("VerticalViewScrollbarTrackEndInset", Number_$type, SeriesViewer.$, new PropertyMetadata(2, NaN, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("VerticalViewScrollbarTrackEndInset", b.oldValue, b.newValue);
    }));
    SeriesViewer.k5 = "VerticalViewScrollbarShouldAddAutoTrackInsets";
    SeriesViewer.r2 = DependencyProperty.i(SeriesViewer.k5, Boolean_$type, SeriesViewer.$, new PropertyMetadata(2, true, function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi(SeriesViewer.k5, b.oldValue, b.newValue);
    }));
    SeriesViewer.qg = DependencyProperty.i("HighlightingBehavior", SeriesHighlightingBehavior_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(SeriesHighlightingBehavior_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("HighlightingBehavior", b.oldValue, b.newValue);
    }));
    SeriesViewer.qz = DependencyProperty.i("LegendHighlightingMode", LegendHighlightingMode_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(LegendHighlightingMode_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("LegendHighlightingMode", b.oldValue, b.newValue);
    }));
    SeriesViewer.q1 = DependencyProperty.i("LegendItemBadgeShape", LegendItemBadgeShape_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(LegendItemBadgeShape_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("LegendItemBadgeShape", b.oldValue, b.newValue);
    }));
    SeriesViewer.q0 = DependencyProperty.i("LegendItemBadgeMode", LegendItemBadgeMode_$type, SeriesViewer.$, new PropertyMetadata(2, enumGetBox(LegendItemBadgeMode_$type, 0), function (a, b) {
        var c = typeCast(SeriesViewer.$, a);
        c.oi("LegendItemBadgeMode", b.oldValue, b.newValue);
    }));
    SeriesViewer.tv = Rect.empty;
    SeriesViewer.$$p = markDep(DependencyProperty, PropertyMetadata, SeriesViewer, 'oi', ['ActualPlotAreaBorderBrush:sn:p6', [Brush.$, null], 'Brushes:ag:p8', [BrushCollection.$, null], 'CircleMarkerTemplate:pv:p9', [DataTemplate.$, null], 'CrosshairVisibility:t3:qa', [Visibility_$type, enumGetBox(Visibility_$type, 0)], 'DefaultInteraction:ci:qb', [InteractionState_$type, enumGetBox(InteractionState_$type, 3)], 'DiamondMarkerTemplate:pw:qc', [DataTemplate.$, null], 'DragModifier:sj:qd', [ModifierKeys_$type, enumGetBox(ModifierKeys_$type, 2)], 'HexagonMarkerTemplate:px:qe', [DataTemplate.$, null], 'HexagramMarkerTemplate:py:qf', [DataTemplate.$, null], 'HighlightingTransitionDuration:hy:qi', [1, 300], 'HorizontalCrosshairBrush:sx:qj', [Brush.$, null], 'IsPagePanningAllowed:el:qw', [0, true], 'IsSurfaceInteractionDisabled:em:qx', [0, false], 'MarkerAutomaticBehavior:be:q3', [MarkerAutomaticBehavior_$type, enumGetBox(MarkerAutomaticBehavior_$type, 4)], 'MarkerBrushes:ah:q4', [BrushCollection.$, null], 'MarkerOutlines:ai:q5', [BrushCollection.$, null], 'Outlines:aj:q6', [BrushCollection.$, null], 'OverviewPlusDetailPaneVisibility:t4:q7', [Visibility_$type, enumGetBox(Visibility_$type, 1)], 'PanModifier:sk:q8', [ModifierKeys_$type, enumGetBox(ModifierKeys_$type, 4)], 'PentagonMarkerTemplate:pz:q9', [DataTemplate.$, null], 'PentagramMarkerTemplate:p0:ra', [DataTemplate.$, null], 'PlotAreaBackground:s0:rb', [Brush.$, null], 'PlotAreaBorderBrush:s1:rc', [Brush.$, null], 'PreferHigherResolutionTiles:e6:rd', [0, false], 'PreviewPathFill:s2:re', [Brush.$, null], 'PreviewPathOpacity:g1:rf', [1, NaN], 'PreviewPathStroke:s3:rg', [Brush.$, null], 'PyramidMarkerTemplate:p1:rh', [DataTemplate.$, null], 'RightButtonDefaultInteraction:ck:ri', [InteractionState_$type, enumGetBox(InteractionState_$type, 3)], 'ScrollbarsAnimationDuration:hz:rj', [1, 300], 'ShouldPanOnMaximumZoom:fa:rk', [0, true], 'SquareMarkerTemplate:p2:rm', [DataTemplate.$, null], 'SubtitleHorizontalAlignment:sh:rn', [HorizontalAlignment_$type, enumGetBox(HorizontalAlignment_$type, 1)], 'Subtitle:j8:ro', [2, null], 'TetragramMarkerTemplate:p3:rp', [DataTemplate.$, null], 'TitleHorizontalAlignment:si:rq', [HorizontalAlignment_$type, enumGetBox(HorizontalAlignment_$type, 1)], 'Title:kk:rr', [2, null], 'TriangleMarkerTemplate:p4:rs', [DataTemplate.$, null], 'UseTiledZooming:fj:rt', [0, false], 'VerticalCrosshairBrush:s6:ru', [Brush.$, null], 'WindowPositionHorizontal:hl:r7', [1, NaN], 'WindowPositionVertical:hm:r8', [1, NaN], 'WindowRectMinHeight:hn:r9', [1, NaN], 'WindowRectMinWidth:ho:sa', [1, NaN], 'WindowRect:tz:sb', [Rect.$, new Rect(0, 0, 0, 1, 1)], 'WindowResponse:cb:sc', [WindowResponse_$type, enumGetBox(WindowResponse_$type, 1)], 'WindowSizeMinHeight:hp:sd', [1, NaN], 'WindowSizeMinWidth:hq:se', [1, NaN], 'ZoomCoercionMode:cf:sf', [ZoomCoercionMode_$type, enumGetBox(ZoomCoercionMode_$type, 0)], 'ZoomTileCacheSize:h0:sg', [1, 30]]);
    return SeriesViewer;
}(Control));
export { SeriesViewer };
/**
 * @hidden
 */
var SeriesViewerView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesViewerView, _super);
    function SeriesViewerView(a) {
        var _this = _super.call(this) || this;
        _this.p = null;
        _this.a = null;
        _this.n = null;
        _this.o = null;
        _this.g = null;
        _this.b = null;
        _this.ai = false;
        _this.fi = null;
        _this.ff = null;
        _this.fe = null;
        _this.fd = null;
        _this.h = new SeriesViewerComponentsFromView();
        _this.j = null;
        _this.w = null;
        _this.z = null;
        _this.y = null;
        _this.x = null;
        _this.an = false;
        _this.ao = false;
        _this.bi = null;
        _this.k = null;
        _this.a9 = 0;
        _this.a8 = 0;
        _this.a7 = 0;
        _this.e9 = Rect.empty;
        _this.aj = false;
        _this.fg = null;
        _this.fh = null;
        _this.a1 = 0;
        _this.az = 0;
        _this.a0 = 0;
        _this.ay = 0;
        _this.ak = true;
        _this.aa = false;
        _this.a2 = NaN;
        _this.fa = Rect.empty;
        _this.ab = false;
        _this.af = false;
        _this.ae = false;
        _this.av = false;
        _this.et = null;
        _this.es = null;
        _this.ad = false;
        _this.ac = false;
        _this.ag = true;
        _this.ax = null;
        _this.ar = false;
        _this.bg = 0;
        _this.ah = true;
        _this.a8 = 0;
        _this.a7 = 0;
        _this.p = a;
        _this.p.ta = { $type: Point_$type, x: NaN, y: NaN };
        _this.p.cb = 1;
        _this.j = new SeriesViewerViewManager(_this);
        _this.fd = ((function () {
            var $ret = new Line();
            $ret.visibility = 1;
            return $ret;
        })());
        _this.fe = ((function () {
            var $ret = new Line();
            $ret.visibility = 1;
            return $ret;
        })());
        return _this;
    }
    SeriesViewerView.prototype.l = function () {
        return new DOMExecutionContext(this.j.ae);
    };
    SeriesViewerView.prototype.co = function () {
        this.j.ba();
    };
    SeriesViewerView.prototype.c4 = function () {
        this.p.d8 = true;
        this.p.t3 = 1;
        this.p.d8 = false;
        this.ff = new Path();
        this.fi = new Rectangle();
        this.fi._visibility = 1;
        this.d6();
        this.g = new SeriesCollection();
        this.b = new AxisCollection();
        this.a = new CanvasRenderScheduler();
        this.a.o(this);
        this.a.h.add(this.p.am);
        if (this.p.t4 == 0) {
            this.cn();
        }
        var a = this.p;
        a.windowRectChanged = delegateCombine(a.windowRectChanged, runOn(this, this.ct));
        var b = this.p;
        b.gridAreaRectChanged = delegateCombine(b.gridAreaRectChanged, runOn(this, this.cs));
        this.o = new OverviewPlusDetailViewportHost(this);
        this.dp();
    };
    SeriesViewerView.prototype.e = function () {
        for (var a = 0; a < this.g.count; a++) {
            if (this.g._inner[a].a7.a$c) {
                return this.g._inner[a];
            }
        }
        return null;
    };
    SeriesViewerView.prototype.cn = function () {
        if (this.n == null) {
            this.n = this.j.g();
        }
        this.p.cn.provideContext(this.z);
        this.p.cn.provideContainer(this.bi);
        this.p.cn.provideEventSource(this.k);
        this.n.world = new Rect(0, 0, 0, 1, 1);
        this.n.window = this.p.tz;
        this.n.surfaceViewer = TypeRegistrar.create("SeriesViewerSurfaceViewer", this.p, this);
        this.n.viewScheduler = this.a;
        this.em();
        var a = this.n;
        a.windowChanging = delegateCombine(a.windowChanging, runOn(this, this.dn));
        var b = this.n;
        b.windowChanged = delegateCombine(b.windowChanged, runOn(this, this.dm));
    };
    SeriesViewerView.prototype.dn = function (a, b) {
        var c = b.newValue;
        if (this.n != null) {
            c = this.n.changeRect(b.oldValue, b.newValue, this.p.es(), this.p.et(), this.n.world);
        }
        if (c.isEmpty) {
            this.n.window = b.oldValue;
        }
        else if (!c.equals1(b.newValue)) {
            this.n.window = c;
        }
        if (this.p.cb == 1) {
            var d = this.p.ty.width / this.p.ty.height;
            c = new Rect(0, c.left / d, c.top, c.width / d, c.height);
            this.p.tz = c;
        }
    };
    SeriesViewerView.prototype.dm = function (a, b) {
        var c = b.newValue;
        if (this.n != null) {
            c = this.n.changeRect(b.oldValue, b.newValue, this.p.es(), this.p.et(), this.n.world);
        }
        if (c.isEmpty) {
            c = b.oldValue;
        }
        else if (!c.equals1(b.newValue)) {
            this.n.window = c;
        }
        var d = this.p.ty.width / this.p.ty.height;
        c = new Rect(0, c.left / d, c.top, c.width / d, c.height);
        this.p.tz = c;
    };
    SeriesViewerView.prototype.em = function () {
        if (this.n == null) {
            return;
        }
        if (this.p.t4 != 0) {
            return;
        }
        var a = 1;
        if (this.p.ty.isEmpty == false) {
            a = this.p.ty.width / this.p.ty.height;
        }
        var b = this.n.world;
        var c = new Rect(0, 0, 0, a, 1);
        this.n.world = c;
        if (b.width != c.width || b.height != c.height || b.x != c.x || b.y != c.y) {
            this.n.surfaceViewer.isDirty = true;
        }
        this.n.window = new Rect(0, this.p.tz.left * a, this.p.tz.top, this.p.tz.width * a, this.p.tz.height);
    };
    SeriesViewerView.prototype.ct = function (a, b) {
        this.em();
    };
    SeriesViewerView.prototype.cs = function (a, b) {
        this.em();
    };
    SeriesViewerView.prototype.cb = function (a, b, c) {
        var e_12, _a;
        var d = true;
        try {
            for (var _b = __values(fromEnum(this.p.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var e = _c.value;
                if (d && e.e3) {
                    d = false;
                    if (!c.a.e) {
                        c.a.l(0, 0, a, b);
                    }
                }
                e.mp(new Rect(0, 0, 0, a, b), c);
            }
        }
        catch (e_12_1) {
            e_12 = { error: e_12_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_12)
                    throw e_12.error;
            }
        }
    };
    SeriesViewerView.prototype.d5 = function () {
        this.j.bm();
    };
    SeriesViewerView.prototype.cd = function () {
    };
    SeriesViewerView.prototype.d7 = function () {
        this.j.bn();
    };
    SeriesViewerView.prototype.ck = function () {
        for (var a = 0; a < this.p.series.count; a++) {
            this.p.series._inner[a].b1.ap();
        }
    };
    SeriesViewerView.prototype.cc = function () {
    };
    SeriesViewerView.prototype.ce = function () {
    };
    SeriesViewerView.prototype.dy = function (a) {
        var _this = this;
        var b = this.g.indexOf(a);
        if (b >= 0) {
            this.g.removeAt(b);
        }
        if (a.isStacked) {
            a.lf(function (c) {
                c.ce = null;
                b = _this.g.indexOf(c);
                if (b >= 0) {
                    _this.g.removeAt(b);
                }
                return true;
            });
        }
        this.p.ot();
        a.ma(null, null);
        this.dc();
    };
    SeriesViewerView.prototype.dc = function () {
        if (this.p.destroyed) {
            return;
        }
        if (this.g.count == 0) {
            if (this.y != null && Rect.l_op_Inequality(this.p.ty, null) && !this.p.ty.isEmpty) {
                this.er();
            }
        }
        this.p.al.r(this.y, this.x);
    };
    SeriesViewerView.prototype.er = function () {
        if (this.g.count > 0) {
            return;
        }
        if (this.y != null && Rect.l_op_Inequality(this.p.ty, null) && !this.p.ty.isEmpty) {
            if (this.p.gf != 1) {
                this.y.aa();
                this.y.ab(this.p.gf, this.p.gf);
            }
            if (!this.y.e) {
                this.y.l(this.p.ty.left, this.p.ty.top, this.p.ty.width, this.p.ty.height);
            }
            if (this.p.gf != 1) {
                this.y.z();
            }
        }
    };
    SeriesViewerView.prototype.aq = function (a) {
        a.l5(a.b1.bu, this.e9);
        return this.g.contains(a);
    };
    Object.defineProperty(SeriesViewerView.prototype, "au", {
        get: function () {
            return this.ai;
        },
        set: function (a) {
            this.ai = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.bp = function (a) {
        var _this = this;
        if (!this.g.contains(a)) {
            this.g.add(a);
            if (a.isStacked) {
                a.lf(function (b) {
                    _this.g.add(b);
                    return true;
                });
            }
            this.p.ot();
        }
        a.ma(this.y, this.x);
        this.p.md();
    };
    SeriesViewerView.prototype.dt = function (a) {
        this.x = a;
        for (var b = 0; b < this.g.count; b++) {
            this.g._inner[b].ma(this.y, this.x);
        }
        for (var c = 0; c < this.b.count; c++) {
            this.b._inner[c].hx(this.y, this.x);
        }
    };
    SeriesViewerView.prototype.bx = function () {
    };
    SeriesViewerView.prototype.bt = function () {
        this.cf();
        this.ck();
    };
    SeriesViewerView.prototype.cf = function () {
        this.fi._visibility = 1;
        this.cq();
    };
    SeriesViewerView.prototype.ca = function () {
    };
    SeriesViewerView.prototype.dr = function () {
    };
    SeriesViewerView.prototype.d8 = function () {
        this.fi._visibility = 0;
        this.cq();
    };
    SeriesViewerView.prototype.eg = function (a) {
        this.fi.o = a.top + this.p.ty.top;
        this.fi.n = a.left + this.p.ty.left;
        this.fi.width = a.width;
        this.fi.height = a.height;
        this.db();
        this.fi._fill = null;
        this.fi.ad = 0.5;
        this.cq();
    };
    SeriesViewerView.prototype.bw = function () {
    };
    SeriesViewerView.prototype.df = function () {
    };
    SeriesViewerView.prototype.eo = function (a, b, c, d) {
        this.fe.an = a;
        this.fe.ap = b;
        this.fe.ao = c;
        this.fe.aq = d;
        this.cq();
    };
    SeriesViewerView.prototype.ed = function () {
        this.fe._visibility = 0;
        this.cq();
    };
    SeriesViewerView.prototype.cl = function () {
        if (this.fe._visibility == 0) {
            this.fe._visibility = 1;
            this.cq();
        }
    };
    SeriesViewerView.prototype.eh = function (a, b, c, d) {
        this.fd.an = a;
        this.fd.ap = b;
        this.fd.ao = c;
        this.fd.aq = d;
        this.cq();
    };
    SeriesViewerView.prototype.d9 = function () {
        this.fd._visibility = 0;
        this.cq();
    };
    SeriesViewerView.prototype.cg = function () {
        if (this.fd._visibility == 0) {
            this.fd._visibility = 1;
            this.cq();
        }
    };
    SeriesViewerView.prototype.cj = function () {
        this.ff._visibility = 1;
        this.cq();
    };
    SeriesViewerView.prototype.e6 = function (a) {
        var b = new PathFigureCollection();
        var c = new PathFigure();
        c._isClosed = true;
        c._startPoint = { $type: Point_$type, x: a.left, y: a.top };
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.left, y: a.bottom }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.right, y: a.bottom }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.right, y: a.top }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.left, y: a.top }));
        b.add(c);
        return b;
    };
    SeriesViewerView.prototype.e7 = function (a) {
        var b = new PathFigureCollection();
        var c = new PathFigure();
        c._isClosed = true;
        c._startPoint = { $type: Point_$type, x: a.left, y: a.top };
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.right, y: a.top }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.right, y: a.bottom }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.left, y: a.bottom }));
        c._segments.add(new LineSegment(0, { $type: Point_$type, x: a.left, y: a.top }));
        b.add(c);
        return b;
    };
    SeriesViewerView.prototype.en = function (a, b) {
        b.intersect(a);
        var c = new PathGeometry();
        c.c = this.e7(a);
        var d = new PathGeometry();
        d.c = this.e6(b);
        var e = new GeometryGroup();
        e.d.add(c);
        e.d.add(d);
        this.ff.an = e;
        this.db();
        this.cq();
    };
    SeriesViewerView.prototype.ec = function () {
        this.ff._visibility = 0;
        this.cq();
    };
    SeriesViewerView.prototype.ep = function (a) {
    };
    SeriesViewerView.prototype.dw = function (a) {
        var b = this.b.indexOf(a);
        this.b.removeAt(b);
        a.hx(null, null);
        this.d3();
        this.p.o0(a.name, true);
    };
    SeriesViewerView.prototype.dx = function (a) {
    };
    SeriesViewerView.prototype.bo = function (a) {
        if (!this.b.contains(a)) {
            this.b.add(a);
        }
        a.hx(this.y, this.x);
        this.d3();
    };
    SeriesViewerView.prototype.bl = function (a) {
    };
    SeriesViewerView.prototype.i = function () {
        this.h.a = this.n;
        return this.h;
    };
    SeriesViewerView.aw = function (a) {
        var b = a.ce.series;
        var c = new List$1(Series.$, 0);
        for (var d = 0; d < b.count; d++) {
            c.add(b._inner[d]);
            if (b._inner[d].isStacked) {
                b._inner[d].lf(function (e) {
                    c.add(e);
                    return true;
                });
            }
        }
        return c;
    };
    SeriesViewerView.prototype.d2 = function () {
        this.p.tz = new Rect(0, 0, 0, 1, 1);
    };
    SeriesViewerView.prototype.c0 = function (a) {
        var e_13, _a, e_14, _b;
        var _this = this;
        if (a == this.bi) {
            return;
        }
        if (a == null) {
            if (this.k != null) {
                this.k.av();
            }
            this.j.bg(null);
            this.w = null;
            this.z = null;
            this.y = null;
            this.x = null;
            this.k = null;
            if (this.p.cn != null) {
                this.p.cn.provideContext(null);
                this.p.cn.provideContainer(null);
                this.p.cn.provideEventSource(null);
            }
            return;
        }
        this.bi = a;
        if (this.au) {
            this.a.h.add(this.p.al);
        }
        this.j.bg(a);
        this.w = this.j.t;
        this.z = this.j.w;
        this.y = this.j.v;
        this.x = this.j.u;
        this.an = false;
        try {
            this.an = (window.navigator.msPointerEnabled && window.MSGesture !== undefined);
        }
        catch (b) {
        }
        this.ao = false;
        try {
            this.ao = (window.PointerEvent !== undefined);
        }
        catch (c) {
        }
        if (this.an || this.ao) {
            this.av = true;
        }
        this.k = this.j.f;
        if (this.k != null) {
            this.k.bl = this.p.ty;
            this.k.ao = runOn(this, this.as);
            var d = this.k;
            d.onContactCompleted = delegateCombine(d.onContactCompleted, function (d, e) { return _this.cx(d, e, _this.k.am); });
            var e = this.k;
            e.onContactMoved = delegateCombine(e.onContactMoved, runOn(this, this.cy));
            var f = this.k;
            f.onContactStarted = delegateCombine(f.onContactStarted, runOn(this, this.cz));
            var g = this.k;
            g.onDragCompleted = delegateCombine(g.onDragCompleted, runOn(this.p, this.p.m9));
            var h = this.k;
            h.onFlingStarted = delegateCombine(h.onFlingStarted, runOn(this, this.al));
            var i = this.k;
            i.onDragDelta = delegateCombine(i.onDragDelta, function (i) { return _this.p.na(i); });
            var j = this.k;
            j.onDragStarted = delegateCombine(j.onDragStarted, function (j) { return _this.p.nb(j, true); });
            var k = this.k;
            k.onKeyDown = delegateCombine(k.onKeyDown, runOn(this.p, this.p.e3));
            var l = this.k;
            l.onMouseDown = delegateCombine(l.onMouseDown, runOn(this, this.c6));
            var m = this.k;
            m.onMouseLeave = delegateCombine(m.onMouseLeave, runOn(this, this.c7));
            var n = this.k;
            n.onMouseOver = delegateCombine(n.onMouseOver, runOn(this, this.c8));
            var o = this.k;
            o.onMouseUp = delegateCombine(o.onMouseUp, runOn(this, this.c9));
            var p = this.k;
            p.onMouseWheel = delegateCombine(p.onMouseWheel, runOn(this.p, this.p.e4));
            if (this.k.an) {
                var q = this.k;
                q.onZoomDelta = delegateCombine(q.onZoomDelta, function (q, r, s, t) { return _this.p.n4(q, r, s, t); });
                var r = this.k;
                r.onZoomStarted = delegateCombine(r.onZoomStarted, function (r, s, t, u) { return _this.p.n8(r, s, t, u); });
                var s = this.k;
                s.onZoomCompleted = delegateCombine(s.onZoomCompleted, function (s, t, u, v) {
                    if (_this.k.af) {
                        _this.p.n0();
                    }
                    _this.p.n3(s, t, u, v);
                });
            }
            else {
                var t = this.k;
                t.onPinchDelta = delegateCombine(t.onPinchDelta, function (t, u) { return _this.p.nl(u); });
                var u = this.k;
                u.onPinchStarted = delegateCombine(u.onPinchStarted, function (u, v) { return _this.p.nm(u); });
                var v = this.k;
                v.onGestureCompleted = delegateCombine(v.onGestureCompleted, function (v, w) { return _this.p.nc(v); });
            }
            var w = this.k;
            w.onDoubleTap = delegateCombine(w.onDoubleTap, function (w) { return _this.p.m8(w); });
            var x = this.k;
            x.onHold = delegateCombine(x.onHold, runOn(this, this.c3));
        }
        if (this.p.cn != null) {
            this.p.cn.provideContext(this.z);
            this.p.cn.provideContainer(a);
            this.p.cn.provideEventSource(this.k);
        }
        try {
            for (var _c = __values(fromEnum(this.b)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var y = _d.value;
                y.a5.az();
                this.bo(y);
            }
        }
        catch (e_13_1) {
            e_13 = { error: e_13_1 };
        }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return))
                    _a.call(_c);
            }
            finally {
                if (e_13)
                    throw e_13.error;
            }
        }
        try {
            for (var _e = __values(fromEnum(this.g)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var z = _f.value;
                this.bp(z);
            }
        }
        catch (e_14_1) {
            e_14 = { error: e_14_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_14)
                    throw e_14.error;
            }
        }
    };
    SeriesViewerView.prototype.al = function (a, b, c) {
        if (this.p.du) {
            return false;
        }
        return true;
    };
    SeriesViewerView.prototype.cy = function (a, b) {
        this.p.m0(a, b);
    };
    SeriesViewerView.prototype.cz = function (a, b) {
        this.p.a9.f$t(this.p, a, b);
    };
    SeriesViewerView.prototype.c3 = function (a) {
        this.p.nn(a);
    };
    SeriesViewerView.prototype.cx = function (a, b, c) {
        this.p.mz(a, b, c);
    };
    SeriesViewerView.prototype.du = function (a) {
    };
    SeriesViewerView.prototype.get_ap = function () {
        return false;
    };
    Object.defineProperty(SeriesViewerView.prototype, "ap", {
        get: function () {
            return this.get_ap();
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.ef = function () {
        this.a9 = FontUtil.getCurrentFontHeight(this.j.ae, this.p.getFontInfo());
    };
    SeriesViewerView.prototype.f = function (a, b, c, d) {
        var _this = this;
        return {
            ret: ((function () { var e = _this.p.a9.f$d(_this.p, _this.g, _this.x, a, b, c, d); c = e.p5; return e.ret; })()),
            p2: c
        };
    };
    SeriesViewerView.prototype.bd = function () {
        return this.a8;
    };
    SeriesViewerView.prototype.bc = function () {
        return this.a7;
    };
    SeriesViewerView.prototype.cu = function () {
        this.j.bd();
    };
    SeriesViewerView.prototype.c1 = function (a, b) {
        var c = this.a8;
        var d = this.a7;
        if (this.a8 != a) {
            this.aj = true;
        }
        this.a8 = a;
        if (this.a7 != b) {
            this.aj = true;
        }
        this.a7 = b;
        if (this.aj) {
            var e = new Size(1, c, d);
            var f = new Size(1, a, b);
            this.p.nz(e, f);
        }
        this.dj();
        this.d3();
        this.p.al.r(this.y, this.x);
    };
    SeriesViewerView.prototype.b6 = function (a) {
        this.fg = a;
    };
    SeriesViewerView.prototype.b9 = function (a) {
        this.fh = a;
    };
    SeriesViewerView.prototype.b8 = function () {
        this.a.r(this.z, null);
    };
    SeriesViewerView.prototype.d3 = function () {
        this.ag = true;
        this.p.ar.z();
    };
    SeriesViewerView.prototype.b2 = function () {
        var e_15, _a, e_16, _b, e_17, _c, e_18, _d;
        var _this = this;
        if (this.a8 == 0 || this.a7 == 0) {
            return;
        }
        this.ag = false;
        this.aa = false;
        if (this.ak) {
            this.di();
            this.de();
            this.ak = false;
            this.cq();
        }
        var a = this.a8;
        var b = this.a7;
        var c = this.p.gz;
        var d = this.p.g4;
        var e = this.p.gm;
        var f = this.p.hd;
        var g = this.p.gk;
        var h = this.p.gl;
        if (isNaN_(g)) {
            g = this.a9 / 2;
        }
        if (isNaN_(h)) {
            h = 0;
        }
        var i = this.p.e8();
        var j = new List$1(AxisLabelPanelBase.$, 0);
        try {
            for (var _e = __values(fromEnum(this.b)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var k = _f.value;
                if (k.aw != null) {
                    j.add(k.aw);
                    k.aw.bx = function () { return _this.aj; };
                }
            }
        }
        catch (e_15_1) {
            e_15 = { error: e_15_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return))
                    _a.call(_e);
            }
            finally {
                if (e_15)
                    throw e_15.error;
            }
        }
        if (i) {
            var l = false;
            var m = false;
            var n = false;
            var o = false;
            try {
                for (var _g = __values(fromEnum(j)), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var p = _h.value;
                    if (LabelPanelArranger.b(p) == 2 && (p.ad.az == null || p.ad.az.visibility == 0)) {
                        l = true;
                    }
                    if (LabelPanelArranger.b(p) == 3 && (p.ad.az == null || p.ad.az.visibility == 0)) {
                        m = true;
                    }
                    if (LabelPanelArranger.b(p) == 0 && (p.ad.az == null || p.ad.az.visibility == 0)) {
                        n = true;
                    }
                    if (LabelPanelArranger.b(p) == 1 && (p.ad.az == null || p.ad.az.visibility == 0)) {
                        o = true;
                    }
                    if (p.ad != null && p.ad.az != null) {
                        p.ad.az.c = p.ad.az.location;
                    }
                }
            }
            catch (e_16_1) {
                e_16 = { error: e_16_1 };
            }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return))
                        _b.call(_g);
                }
                finally {
                    if (e_16)
                        throw e_16.error;
                }
            }
            if (l || m) {
                if (!n && isNaN_(f)) {
                    f = g;
                }
                if (!o && isNaN_(e)) {
                    e = g;
                }
            }
            if (o || n) {
                if (!l && isNaN_(c)) {
                    c = h;
                }
                if (!m && isNaN_(d)) {
                    d = h;
                }
            }
        }
        if (isNaN_(f)) {
            f = 0;
        }
        if (isNaN_(c)) {
            c = 0;
        }
        if (isNaN_(d)) {
            d = 0;
        }
        if (isNaN_(e)) {
            e = 0;
        }
        var q = this.bf();
        f += q;
        var r = this.be();
        f += r;
        var s = new Rect(0, c, f, a - (c + d), b - (f + e));
        s = LabelPanelArranger.e(j, s);
        var t = new Size(1, Math.max(0, a - (c + d)), Math.max(0, b - (f + e)));
        if (this.p.d4() && s.width != s.height) {
            if (s.width < s.height) {
                f += (s.height - s.width) / 2;
                s.top = s.top + ((s.height - s.width) / 2);
                t.height = t.height - (s.height - s.width);
                s.height = s.width;
            }
            else {
                c += (s.width - s.height) / 2;
                s.left = s.left + ((s.width - s.height) / 2);
                t.width = t.width - (s.width - s.height);
                s.width = s.height;
            }
        }
        this.a1 = f - (q + r);
        this.az = c;
        this.a0 = d;
        this.ay = e;
        this.e9 = s;
        var u = ((function () {
            var $ret = new LabelPanelsArrangeState();
            $ret.f = c;
            $ret.c = c;
            $ret.a = f + t.height;
            $ret.b = f + t.height;
            $ret.g = c + t.width;
            $ret.d = c + t.width;
            $ret.h = f;
            $ret.e = f;
            return $ret;
        })());
        LabelPanelArranger.d(j, u, this.e9, function (v, w) {
            if (!v.c1.equals1(w)) {
                if (v.ad != null) {
                    v.ad.cr = true;
                }
                v.c1 = w;
                v.ad.a5.ag();
            }
        });
        var v = false;
        if (this.aj) {
            this.aj = false;
            v = true;
        }
        this.p.oc(this.p.ty, this.e9);
        try {
            for (var _j = __values(fromEnum(this.b)), _k = _j.next(); !_k.done; _k = _j.next()) {
                var w = _k.value;
                if (Rect.l_op_Equality(w.kd, null) || w.kd.isEmpty) {
                    this.aa = true;
                }
                if (w.kd.equals1(this.e9) && !this.j.y()) {
                    continue;
                }
                w.hp(w.kd, this.e9);
            }
        }
        catch (e_17_1) {
            e_17 = { error: e_17_1 };
        }
        finally {
            try {
                if (_k && !_k.done && (_c = _j.return))
                    _c.call(_j);
            }
            finally {
                if (e_17)
                    throw e_17.error;
            }
        }
        try {
            for (var _l = __values(fromEnum(this.g)), _m = _l.next(); !_m.done; _m = _l.next()) {
                var x = _m.value;
                if (Rect.l_op_Equality(x.b1.bu, null) || x.b1.bu.isEmpty) {
                    this.aa = true;
                }
                if (x.b1.bu.equals1(this.e9) && !this.j.y()) {
                    continue;
                }
                x.l5(x.b1.bu, this.e9);
            }
        }
        catch (e_18_1) {
            e_18 = { error: e_18_1 };
        }
        finally {
            try {
                if (_m && !_m.done && (_d = _l.return))
                    _d.call(_l);
            }
            finally {
                if (e_18)
                    throw e_18.error;
            }
        }
        this.ek();
        this.dv(this.e9);
        this.j.bc(false);
    };
    SeriesViewerView.prototype.ek = function () {
        if (this.p.cn != null && !this.e9.isEmpty) {
            var a = this.p.cn;
            var b = (this.p.dp) ? this.e9.width : Number.POSITIVE_INFINITY;
            var c = (this.p.dp) ? this.e9.height : Number.POSITIVE_INFINITY;
            var d = a.getDesiredSize(new Size(1, b, c));
            this.p.cn.arrange(new Rect(0, this.e9.right - d.width, this.e9.bottom - d.height, d.width, d.height));
            this.em();
        }
    };
    SeriesViewerView.prototype.v = function () {
        var a = this.p.getFontInfo();
        var b = this.s();
        if (this.p.c1() != null) {
            a = this.p.c1();
        }
        else if (b != null) {
            a = b;
        }
        return a;
    };
    SeriesViewerView.prototype.u = function () {
        var a = this.p.getFontInfo();
        var b = this.r();
        if (this.p.c0() != null) {
            a = this.p.c0();
        }
        else if (b != null) {
            a = b;
        }
        return a;
    };
    SeriesViewerView.prototype.e5 = function () {
        var a = this.p.getFontBrush();
        var b = this.e2();
        if (this.p.s5 != null) {
            a = this.p.s5;
        }
        else if (b != null) {
            a = b;
        }
        return a;
    };
    SeriesViewerView.prototype.e4 = function () {
        var a = this.p.getFontBrush();
        var b = this.e1();
        if (this.p.s4 != null) {
            a = this.p.s4;
        }
        else if (b != null) {
            a = b;
        }
        return a;
    };
    SeriesViewerView.prototype.bf = function () {
        if (this.p.kk == null || !(typeCast(XamDataChart.$, this.p) !== null)) {
            return 0;
        }
        var a = this.v();
        var b = 0;
        b = FontUtil.getCurrentFontHeight(this.j.ae, a);
        var c = this.fm();
        b += c.top + c.bottom;
        return b;
    };
    SeriesViewerView.prototype.be = function () {
        if (this.p.j8 == null || !(typeCast(XamDataChart.$, this.p) !== null)) {
            return 0;
        }
        if (!isNaN_(this.a2)) {
            return this.a2;
        }
        var a = this.u();
        this.a2 = FontUtil.getCurrentFontHeight(this.j.ae, a);
        var b = this.fl();
        this.a2 += b.top + b.bottom;
        return this.a2;
    };
    SeriesViewerView.prototype.fm = function () {
        var a = this.j.ce();
        var b = isNaN_(this.p.hc) ? a.top : this.p.hc;
        var c = isNaN_(this.p.ha) ? a.left : this.p.ha;
        var d = isNaN_(this.p.hb) ? a.right : this.p.hb;
        var e = isNaN_(this.p.g9) ? a.bottom : this.p.g9;
        return new Thickness(1, c, b, d, e);
    };
    SeriesViewerView.prototype.fl = function () {
        var a = this.j.cd();
        var b = isNaN_(this.p.g8) ? a.top : this.p.g8;
        var c = isNaN_(this.p.g6) ? a.left : this.p.g6;
        var d = isNaN_(this.p.g7) ? a.right : this.p.g7;
        var e = isNaN_(this.p.g5) ? a.bottom : this.p.g5;
        return new Thickness(1, c, b, d, e);
    };
    SeriesViewerView.prototype.dv = function (a) {
    };
    SeriesViewerView.prototype.cq = function () {
        if (!this.af) {
            if (this.z != null) {
                this.af = true;
                this.a.r(this.z, null);
            }
        }
    };
    SeriesViewerView.prototype.d0 = function () {
        if (this.z == null) {
            return;
        }
        if (this.z.d) {
            if (this.p.gf != 1) {
                this.z.aa();
                this.z.ab(this.p.gf, this.p.gf);
            }
            if (!this.fa.isEmpty) {
                if (!this.au) {
                    if (!this.z.e) {
                        this.z.l(this.fa.left, this.fa.top, this.fa.width, this.fa.height);
                    }
                }
            }
        }
        this.d1();
        if (this.z.d) {
            if (this.p.gf != 1) {
                this.z.z();
            }
        }
    };
    SeriesViewerView.prototype.isValid = function () {
        return true;
    };
    SeriesViewerView.prototype.preRender = function () {
        this.j.a6(this.a8, this.a7);
        this.ds();
    };
    SeriesViewerView.prototype.ds = function () {
    };
    SeriesViewerView.prototype.d1 = function () {
        if (this.z.d) {
            this.fa = new Rect(0, 0, 0, this.a8, this.a7);
            if (this.ax != null && this.ax.count > 0) {
                this.ci();
                this.z.aa();
                this.z.af(this.p.ty);
                if (!this.au) {
                    if (!this.z.e) {
                        this.z.l(this.p.ty.left, this.p.ty.top, this.p.ty.width, this.p.ty.height);
                    }
                }
            }
            this.z.s(this.fd);
            this.z.s(this.fe);
            this.z.t(this.ff);
            this.z.w(this.fi);
            this.z.ad(this.v());
            if (this.et != null) {
                this.et.ao = this.e5();
                this.z.x(this.et);
            }
            this.z.ad(this.u());
            if (this.es != null) {
                this.es.ao = this.e4();
                this.z.x(this.es);
            }
            if (this.ax != null && this.ax.count > 0) {
                this.j.bl(this.ax);
                this.z.z();
            }
            if (this.ar) {
                this.eb();
                this.ar = false;
                this.ax.clear();
                this.p.a9.f$i(this.p);
                this.cq();
            }
            if (this.p.dv) {
                if (this.fh != null) {
                    this.z.w(this.fh);
                }
                if (this.fg != null) {
                    this.z.w(this.fg);
                }
            }
        }
    };
    SeriesViewerView.prototype.c2 = function () {
        this.j.bh();
    };
    SeriesViewerView.prototype.cw = function () {
        this.j.bf();
    };
    SeriesViewerView.prototype.fb = function () {
        return new Rect(0, 0, 0, this.a8, this.a7);
    };
    SeriesViewerView.prototype.e8 = function () {
        return this.j.b8();
    };
    SeriesViewerView.prototype.d6 = function () {
        this.p.pv = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.d;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.p4 = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.m;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.p1 = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.j;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.p2 = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.k;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.pw = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.e;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.pz = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.h;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.px = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.f;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.p3 = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.l;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.p0 = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.i;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
        this.p.py = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.g;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
    };
    SeriesViewerView.prototype.ee = function () {
        this.j.bp();
        this.d4();
        var a = this.a9;
        this.ef();
        if (a != this.a9) {
            this.p.md();
        }
    };
    SeriesViewerView.prototype.dp = function () {
        if (this.p.t4 == 0) {
            this.cn();
            this.p.l9();
        }
        if (this.p.cn != null) {
            var a = this.p.t4;
            this.p.cn.visibility = a;
            this.p.cn.doRefresh(false);
        }
    };
    SeriesViewerView.prototype.as = function (a) {
        return this.p.a9.f$g(this.p, a);
    };
    SeriesViewerView.prototype.c8 = function (a, b, c) {
        this.p.a9.f$w(this.p, this.g, this.x, a, b, c);
        this.p.lt(a, this.p.cl != 0 || this.p.ew);
    };
    SeriesViewerView.prototype.c7 = function (a) {
        this.p.a9.f$v(this.p, a);
    };
    SeriesViewerView.prototype.c6 = function (a) {
        this.p.a9.f$u(this.p, this.k, a);
    };
    SeriesViewerView.prototype.c9 = function (a) {
        this.p.a9.f$x(this.p, this.k, a);
    };
    SeriesViewerView.prototype.d4 = function () {
    };
    Object.defineProperty(SeriesViewerView.prototype, "ez", {
        get: function () {
            return this.k.bi;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.eq = function (a) {
        if (this.k != null) {
            this.k.bl = this.p.ty;
        }
    };
    SeriesViewerView.prototype.cr = function (a) {
        this.p.a9.f$aa(this.p, a);
        this.p.dp = a;
    };
    SeriesViewerView.prototype.bk = function (a) {
        this.p.pf();
        this.j.bw(a);
        if (this.p.cn != null) {
            this.p.cn.mobileMode = a;
        }
        this.el();
    };
    SeriesViewerView.prototype.el = function () {
        this.p.pm();
    };
    Object.defineProperty(SeriesViewerView.prototype, "isDirty", {
        get: function () {
            return this.af;
        },
        set: function (a) {
            this.af = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.undirty = function (a) {
        this.af = false;
        this.d0();
    };
    Object.defineProperty(SeriesViewerView.prototype, "index", {
        get: function () {
            return 10;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.postRender = function () {
    };
    SeriesViewerView.prototype.b7 = function () {
        this.d3();
    };
    SeriesViewerView.prototype.ch = function () {
        this.j.a9();
    };
    SeriesViewerView.prototype.ea = function () {
        this.j.bo();
    };
    SeriesViewerView.prototype.bv = function (a) {
        this.j.ay();
    };
    SeriesViewerView.prototype.bm = function (a) {
        this.j.au(a);
    };
    SeriesViewerView.prototype.ei = function (a) {
        this.j.bu(a);
    };
    SeriesViewerView.prototype.ej = function (a) {
        this.j.bv(a);
    };
    SeriesViewerView.prototype.bn = function (a) {
        this.j.av(a);
    };
    SeriesViewerView.prototype.dz = function (a) {
        this.j.bk(a);
    };
    SeriesViewerView.prototype.da = function (a) {
        this.p.al.r(this.y, this.z);
    };
    SeriesViewerView.prototype.bu = function (a) {
    };
    SeriesViewerView.prototype.m = function (a) {
        if (this.p.dp) {
            return 2;
        }
        else {
            return 1;
        }
    };
    SeriesViewerView.prototype.c5 = function () {
        if (this.k != null) {
            this.k.ae = this.p.em;
        }
        if (this.n != null) {
            this.n.isSurfaceInteractionDisabled = this.p.em;
        }
    };
    SeriesViewerView.prototype.bb = function (a, b) {
        if (a == null || this.z == null) {
            return 0;
        }
        this.z.ad(b);
        return this.z.f(a);
    };
    SeriesViewerView.prototype.ba = function (a, b) {
        if (a == null) {
            return 0;
        }
        var c = 0;
        c = FontUtil.getCurrentFontHeight(this.j.ae, b);
        return c;
    };
    SeriesViewerView.prototype.dj = function () {
        this.ak = true;
        this.d3();
        this.cq();
    };
    SeriesViewerView.prototype.eu = function (a, b, c, d) {
        if (a == null) {
            return null;
        }
        var e = ((function () {
            var $ret = new TextBlock();
            $ret.al = a;
            $ret.o = b.top;
            return $ret;
        })());
        var f = this.bb(e, c);
        e.o = b.top;
        var g = this.ba(a, c);
        e.m = f;
        e.l = g;
        switch (d) {
            case 0:
                e.n = b.left;
                break;
            case 2:
                e.n = Math.max((this.a8 - b.right) - f, b.left);
                break;
            case 1:
            case 3:
            default:
                var h = (this.a8 / 2) - (f / 2);
                h += b.left;
                h -= b.right;
                e.n = h;
                break;
        }
        return e;
    };
    SeriesViewerView.prototype.di = function () {
        this.et = typeCast(XamDataChart.$, this.p) !== null ? this.eu(this.p.kk, this.fm(), this.v(), this.ey()) : null;
    };
    SeriesViewerView.prototype.de = function () {
        this.a2 = NaN;
        this.es = typeCast(XamDataChart.$, this.p) !== null ? this.eu(this.p.j8, this.fl(), this.u(), this.ex()) : null;
        if (this.es != null) {
            this.es.o += this.bf();
        }
    };
    SeriesViewerView.prototype.c = function (a) {
        var b = this.j.c();
        if (b == 0) {
            var c = LabelPanelArranger.b(a.aw);
            if (a.aj == null) {
                if (c == 4) {
                    return 4;
                }
                if (c == 5) {
                    return 3;
                }
            }
            else {
                if (c == 4) {
                    return 3;
                }
                if (c == 5) {
                    return 4;
                }
            }
            if (c == 0) {
                return 3;
            }
            return 4;
        }
        return b;
    };
    SeriesViewerView.prototype.d = function (a) {
        var b = this.j.d();
        if (b == 0) {
            var c = LabelPanelArranger.b(a.aw);
            if (a.aj == null) {
                if (c == 7) {
                    return 1;
                }
                if (c == 6) {
                    return 2;
                }
            }
            else {
                if (c == 7) {
                    return 2;
                }
                if (c == 6) {
                    return 1;
                }
            }
            if (c == 3) {
                return 2;
            }
            return 1;
        }
        return b;
    };
    SeriesViewerView.prototype.dk = function () {
        if (!isNaN_(this.p.ge)) {
            if (!isNaN_(DeviceUtils.a(this.p.g0))) {
                this.p.gf = DeviceUtils.a(this.p.g0);
            }
            else {
                this.co();
            }
        }
        if (!this.p.eb) {
            this.j.a5();
        }
    };
    SeriesViewerView.prototype.dl = function () {
        if (!isNaN_(DeviceUtils.a(this.p.ge))) {
            this.p.gf = DeviceUtils.a(this.p.ge);
        }
        if (!this.p.eb) {
            this.j.a4();
        }
    };
    SeriesViewerView.prototype.t = function () {
        return this.j.r();
    };
    SeriesViewerView.prototype.e3 = function () {
        return this.j.b7();
    };
    SeriesViewerView.prototype.q = function () {
        return this.j.q();
    };
    SeriesViewerView.prototype.e0 = function () {
        return this.j.b6();
    };
    SeriesViewerView.prototype.s = function () {
        return this.j.p();
    };
    SeriesViewerView.prototype.r = function () {
        return this.j.o();
    };
    SeriesViewerView.prototype.e2 = function () {
        return this.j.b5();
    };
    SeriesViewerView.prototype.e1 = function () {
        return this.j.b4();
    };
    Object.defineProperty(SeriesViewerView.prototype, "a4", {
        get: function () {
            return this.az;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerView.prototype, "a5", {
        get: function () {
            return this.a0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerView.prototype, "a6", {
        get: function () {
            return this.a1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerView.prototype, "a3", {
        get: function () {
            return this.ay;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerView.prototype, "ew", {
        get: function () {
            return this.et;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesViewerView.prototype, "ev", {
        get: function () {
            return this.es;
        },
        enumerable: false,
        configurable: true
    });
    SeriesViewerView.prototype.fc = function () {
        return new Rect(0, 0, 0, this.a8, this.a7);
    };
    SeriesViewerView.prototype.fk = function () {
        return this.j.cg();
    };
    SeriesViewerView.prototype.fj = function () {
        return this.j.cf();
    };
    SeriesViewerView.prototype.dd = function (a, b) {
        this.ac = true;
    };
    SeriesViewerView.prototype.dh = function (a, b) {
        this.ad = true;
    };
    SeriesViewerView.prototype.ey = function () {
        if (this.ad) {
            return this.p.si;
        }
        else {
            var a = 1;
            switch (this.j.as()) {
                case "left":
                    a = 0;
                    break;
                case "right":
                    a = 2;
                    break;
            }
            return a;
        }
    };
    SeriesViewerView.prototype.ex = function () {
        if (this.ac) {
            return this.p.sh;
        }
        else {
            var a = 1;
            switch (this.j.ar()) {
                case "left":
                    a = 0;
                    break;
                case "right":
                    a = 2;
                    break;
            }
            return a;
        }
    };
    SeriesViewerView.prototype.bq = function () {
        if (this.ag) {
            this.b2();
            if (this.aa) {
                this.p.ar.y();
            }
            if (this.ag) {
                this.b2();
            }
        }
    };
    SeriesViewerView.prototype.am = function () {
        if (this.p.fl) {
            return false;
        }
        if ((dateNow().getTime() - this.p.fr.getTime()) < 300) {
            return true;
        }
        return false;
    };
    SeriesViewerView.prototype.b5 = function () {
        this.j.a6(this.a8, this.a7);
    };
    SeriesViewerView.prototype.cp = function () {
        this.j.bb(this.p.el);
    };
    SeriesViewerView.prototype.at = function (a) {
        var b = this.p.tj;
        var c = b.top > 0;
        var d = b.left > 0;
        var e = b.right < 1;
        var f = b.bottom < 1;
        var g = a.y < 0;
        var h = a.y > 0;
        var i = a.x < 0;
        var j = a.x > 0;
        if (c && g) {
            return true;
        }
        if (d && i) {
            return true;
        }
        if (f && h) {
            return true;
        }
        if (j && e) {
            return true;
        }
        return false;
    };
    SeriesViewerView.prototype.dq = function () {
        this.j.bj();
        this.p.al.r(this.y, this.x);
        this.p.am.r(this.y, null);
        this.p.ak.r(this.y, this.x);
        this.a.r(this.z, null);
    };
    SeriesViewerView.prototype.b3 = function (a, b, c) {
        this.ar = false;
        if (this.ax == null) {
            this.ax = new List$1(ITileZoomTile_$type, 0);
        }
        for (var d = 0; d < this.ax.count; d++) {
            while (d < this.ax.count && !a.containsKey(this.ax._inner[d].content)) {
                this.ax.removeAt(d);
            }
        }
        for (var e = 0; e < b.count; e++) {
            this.ax.add(b._inner[e]);
        }
        this.cq();
    };
    SeriesViewerView.prototype.bh = function (a, b, c) {
        return this.j.an(a, b, c);
    };
    SeriesViewerView.prototype.b0 = function () {
        this.j.a2();
    };
    SeriesViewerView.prototype.b1 = function (a) {
        this.j.a3(a);
    };
    SeriesViewerView.prototype.cm = function () {
        if (this.ax == null) {
            return;
        }
        this.ar = true;
        this.cq();
    };
    SeriesViewerView.prototype.by = function () {
        this.j.a0();
    };
    SeriesViewerView.prototype.br = function () {
        this.j.aw();
    };
    SeriesViewerView.prototype.bz = function (a) {
        this.j.a1(a);
        this.p.m6();
    };
    SeriesViewerView.prototype.bs = function () {
        this.j.ax();
        this.p.m4();
    };
    SeriesViewerView.prototype.ci = function () {
        if (this.ah) {
            this.ah = false;
            if (!this.y.e) {
                this.y.l(this.p.ty.left, this.p.ty.top, this.p.ty.width, this.p.ty.height);
            }
            this.p.al.e = true;
        }
    };
    SeriesViewerView.prototype.eb = function () {
        if (!this.ah) {
            this.ah = true;
            this.p.al.e = false;
            this.p.al.r(this.y, this.x);
        }
    };
    SeriesViewerView.prototype.dg = function () {
    };
    SeriesViewerView.prototype.cv = function () {
        this.j.be();
    };
    SeriesViewerView.prototype.db = function () {
        this.ff._fill = this.p.s2 == null ? this.j.b3() : this.p.s2;
        this.ff._opacity = isNaN_(this.p.g1) ? 0.1 : this.p.g1;
        this.fi._stroke = this.p.s3 == null ? this.j.b3() : this.p.s3;
    };
    SeriesViewerView.prototype.b4 = function (a) {
        if (this.j.ae == null) {
            this.p.provideContainer(a);
        }
    };
    SeriesViewerView.prototype.bj = function (a, b, c) {
        return this.j.ao(a, b, c);
    };
    SeriesViewerView.$t = markType(SeriesViewerView, 'SeriesViewerView', Base.$, [ISchedulableRender_$type]);
    return SeriesViewerView;
}(Base));
export { SeriesViewerView };
/**
 * @hidden
 */
var OverviewPlusDetailViewportHost = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(OverviewPlusDetailViewportHost, _super);
    function OverviewPlusDetailViewportHost(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        if (a == null) {
            throw new ArgumentNullException(0, "view");
        }
        _this.a = a;
        return _this;
    }
    OverviewPlusDetailViewportHost.prototype.getViewInfo = function (a, b) {
        a = new Rect(0, 0, 0, this.a.n.worldRectViewport.width, this.a.n.worldRectViewport.height);
        b = SeriesViewer.tv;
        return {
            p0: a,
            p1: b
        };
    };
    OverviewPlusDetailViewportHost.prototype.getEffectiveViewport = function () {
        if (!this.a.p.ek) {
            if (this.a.p.tn.isEmpty) {
                return this.a.p.tn;
            }
            return this.a.p.ts(this.a.n.previewViewportdRect, this.a.p.ty, this.a.p.tn);
        }
        return Rect.empty;
    };
    OverviewPlusDetailViewportHost.prototype.getMainContentViewport = function () {
        if (!this.a.p.ek) {
            if (this.a.p.tm.isEmpty) {
                return this.a.p.tm;
            }
            return Rect.empty;
        }
        return Rect.empty;
    };
    OverviewPlusDetailViewportHost.$t = markType(OverviewPlusDetailViewportHost, 'OverviewPlusDetailViewportHost', Base.$, [IProvidesViewport_$type]);
    return OverviewPlusDetailViewportHost;
}(Base));
export { OverviewPlusDetailViewportHost };
/**
 * @hidden
 */
var LegendTemplates = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(LegendTemplates, _super);
    function LegendTemplates() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LegendTemplates.af = function (a) {
        var b = a.an();
        switch (b) {
            case 3: return LegendTemplates.y;
            case 4: return LegendTemplates.aa;
            case 0: return LegendTemplates.z;
            case 8: return LegendTemplates.ae;
            case 9: return LegendTemplates.ac;
            case 5: return LegendTemplates.ah;
            case 1:
            case 2: return LegendTemplates.ad;
            case 6:
            case 7: return LegendTemplates.ab;
        }
        return LegendTemplates.ah;
    };
    LegendTemplates.a = function (a) {
        return new RenderingContext(new CanvasViewRenderer(), a.context);
    };
    LegendTemplates.v = function (a) {
        var b = typeCast(Series.$, a.series);
        if (b == null || b.ba == 0) {
            a.thickness = Defaults.v;
        }
        else {
            a.thickness = b.fy;
        }
        if (b == null) {
            a.actualItemBrush = a.itemBrush;
        }
        else {
            a.actualItemBrush = b.o6;
        }
        if (b == null) {
            a.outline = a.actualItemBrush;
        }
        else {
            a.outline = b.o7;
        }
    };
    LegendTemplates.b = function (a, b, c) {
        var d = (c - b) / 2;
        return a + d;
    };
    LegendTemplates.c = function (a, b, c) {
        var d = (c - b) / 2;
        return a + d;
    };
    LegendTemplates.u = function (a, b, c, d, e, f, g, h) {
        var i = DeviceUtils.g(Defaults.w);
        var j = DeviceUtils.g(Defaults.u);
        var k = LegendTemplates.c(f, j, a.availableHeight);
        var l = LegendTemplates.c(h, j, a.availableHeight);
        var m = LegendTemplates.b(e, i, a.availableWidth);
        var n = LegendTemplates.b(g, i, a.availableWidth);
        var o = ((function () {
            var $ret = new PathFigure();
            $ret.isClosed = true;
            $ret.isFilled = true;
            return $ret;
        })());
        o._startPoint = { $type: Point_$type, x: m, y: l };
        o._segments.add(new LineSegment(0, { $type: Point_$type, x: m, y: l }));
        o._segments.add(new LineSegment(0, { $type: Point_$type, x: n, y: l }));
        o._segments.add(new LineSegment(0, { $type: Point_$type, x: n, y: k }));
        o._segments.add(new LineSegment(0, { $type: Point_$type, x: m, y: k }));
        var p = new PathGeometry();
        p.c.add(o);
        var q = new Path();
        q.an = p;
        q.ad = b;
        q._stroke = c;
        q._fill = d;
        var r = LegendTemplates.a(a);
        r.t(q);
    };
    LegendTemplates.s = function (a) {
        var b = a.data;
        var c = b.series;
        LegendTemplates.v(b);
        var d = DeviceUtils.g(Defaults.w);
        var e = DeviceUtils.g(Defaults.u);
        var f = new Line();
        f.an = LegendTemplates.b(0, d, a.availableWidth);
        f.ap = a.availableHeight / 2;
        f.ao = LegendTemplates.b(d, d, a.availableWidth);
        f.aq = a.availableHeight / 2;
        f._stroke = b.actualItemBrush;
        if (c.ba == 0) {
            f.ad = Defaults.v;
        }
        else {
            f.ad = c.fy;
            f.al = c.pk;
            f.ak = c.pk;
            f.ai = c.pi;
            f.ac = c.gw;
            f.am = c.pl;
        }
        var g = LegendTemplates.a(a);
        g.s(f);
    };
    LegendTemplates.r = function (a, b, c) {
        var d = a.data;
        LegendTemplates.v(d);
        var e = DeviceUtils.g(Defaults.w);
        var f = DeviceUtils.g(Defaults.u);
        var g = e / 2;
        var h = f / 2;
        var i = LegendTemplates.b(g, e, a.availableWidth);
        var j = LegendTemplates.c(h, f, a.availableHeight);
        var k = new EllipseGeometry();
        k.e = { $type: Point_$type, x: i, y: j };
        k.c = g;
        k.d = h;
        var l = new Path();
        l.an = k;
        l.ad = d.thickness;
        l._stroke = d.outline;
        l._fill = d.actualItemBrush;
        var m = LegendTemplates.a(a);
        m.t(l);
    };
    LegendTemplates.t = function (a, b) {
        if (b === void 0) {
            b = 0;
        }
        var c = a.data;
        var d = DeviceUtils.g(Defaults.w - b);
        var e = DeviceUtils.g(Defaults.u - b);
        var f = new DataTemplateMeasureInfo();
        f.passInfo = a.passInfo;
        f.width = d;
        f.height = e;
        f.data = a.data;
        f.context = a.context;
        f.renderContext = a.renderContext;
        var g = c.actualItemBrush;
        var h = c.itemBrush;
        var i = c.series;
        var j = i.nj();
        c.actualItemBrush = i.pc();
        c.outline = i.pd();
        if (i.ba == 1) {
            c.thickness = i.f6();
        }
        else {
            c.thickness = Defaults.ab;
        }
        if (j != null && j.measure != null && j.render != null) {
            var k = new DataTemplateRenderInfo();
            k.passInfo = a.passInfo;
            k.availableWidth = f.width;
            k.availableHeight = f.height;
            k.xPosition = (a.availableWidth / 2);
            k.yPosition = (a.availableHeight / 2);
            k.data = a.data;
            k.context = a.context;
            k.renderContext = a.renderContext;
            j.render(k);
        }
        c.itemBrush = h;
        c.actualItemBrush = g;
    };
    LegendTemplates.j = function (a) {
        var b = a.data;
        LegendTemplates.v(b);
        LegendTemplates.r(a, Defaults.w, Defaults.u);
    };
    LegendTemplates.n = function (a) {
        var b = a.data;
        var c = b.series;
        LegendTemplates.s(a);
        if (c.ba == 1) {
            LegendTemplates.t(a, Defaults.t);
        }
    };
    LegendTemplates.o = function (a) {
        LegendTemplates.t(a, 0);
    };
    LegendTemplates.q = function (a) {
        var b = a.data;
        LegendTemplates.v(b);
        LegendTemplates.u(a, b.thickness, b.outline, b.actualItemBrush, 0, 0, Defaults.w, Defaults.u);
    };
    LegendTemplates.p = function (a) {
        var b = a.data;
        var c = b.series;
        LegendTemplates.v(b);
        if (c.ba == 0) {
            var d = Defaults.v;
            var e = b.actualItemBrush;
            var f = c.o7;
            var g = Defaults.w;
            var h = Defaults.u;
            LegendTemplates.u(a, d, f, e, 0, 0, g, h);
        }
        else {
            var i = Defaults.v;
            var j = b.actualItemBrush;
            var k = c.pf();
            var l = Defaults.w / 2;
            var m = Defaults.w;
            var n = Defaults.u;
            LegendTemplates.u(a, i, j, j, 0, 0, l, n);
            LegendTemplates.u(a, i, k, k, l, 0, m, n);
        }
    };
    LegendTemplates.i = function (a) {
        var b = a.data;
        LegendTemplates.v(b);
        var c = 0;
        var d = Defaults.w;
        var e = (Defaults.u * 0.25);
        var f = (Defaults.u * 0.75);
        LegendTemplates.u(a, b.thickness, b.outline, b.actualItemBrush, c, e, d, f);
    };
    LegendTemplates.l = function (a) {
        var b = a.data;
        LegendTemplates.v(b);
        var c = (Defaults.w * 0.25);
        var d = (Defaults.w * 0.75);
        var e = Defaults.u;
        var f = 0;
        LegendTemplates.u(a, b.thickness, b.outline, b.actualItemBrush, c, f, d, e);
    };
    LegendTemplates.m = function (a) {
        var b = a.data;
        var c = BrushUtil.g(0, 0, 0, 0);
        var d = BrushUtil.g(0, 0, 0, 0);
        LegendTemplates.u(a, Defaults.v, c, d, 0, 0, Defaults.w, Defaults.u);
    };
    LegendTemplates.k = function (a) {
    };
    LegendTemplates.g = function (a) {
        var b = a.data;
        var c = b.series;
        var d = c.legendItemBadgeTemplate;
        if (d == null) {
            d = LegendTemplates.af(c);
        }
        var e = c.title;
        if (e == null) {
            e = "Series Title";
        }
        LegendItemHelper.d(a.context, a.xPosition, a.yPosition, a.availableWidth, a.availableHeight, a.data, e.toString(), d, a.passInfo, c.a2 != null && c.a2.isFinancial, c.f5, c.gx);
    };
    LegendTemplates.resolveLegendItemTemplate = function (a) {
        switch (a) {
            case 0: return LegendTemplates.w;
            case 1: return LegendTemplates.x;
        }
        return LegendTemplates.w;
    };
    LegendTemplates.e = function (a) {
        var b = a.data;
        var c = b.series;
        var d = c.legendItemBadgeTemplate;
        if (d == null) {
            d = LegendTemplates.af(c);
        }
        var e = b.itemLabel;
        if (e == null) {
            e = "Series Item";
        }
        LegendItemHelper.c(a.context, a.xPosition, a.yPosition, a.availableWidth, a.availableHeight, a.data, e.toString(), d, a.passInfo);
    };
    LegendTemplates.f = function (a) {
    };
    LegendTemplates.d = function (a) {
    };
    LegendTemplates.h = function (a) {
    };
    LegendTemplates.$t = markType(LegendTemplates, 'LegendTemplates');
    LegendTemplates.z = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.j;
        return $ret;
    })());
    LegendTemplates.ae = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.o;
        return $ret;
    })());
    LegendTemplates.ad = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.n;
        return $ret;
    })());
    LegendTemplates.ah = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.q;
        return $ret;
    })());
    LegendTemplates.ab = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.p;
        return $ret;
    })());
    LegendTemplates.y = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.i;
        return $ret;
    })());
    LegendTemplates.aa = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.l;
        return $ret;
    })());
    LegendTemplates.ac = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.m;
        return $ret;
    })());
    LegendTemplates.w = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.f;
        $ret.render = LegendTemplates.g;
        return $ret;
    })());
    LegendTemplates.x = ((function () {
        var $ret = new DataTemplate();
        $ret.measure = LegendTemplates.d;
        $ret.render = LegendTemplates.e;
        return $ret;
    })());
    return LegendTemplates;
}(Base));
export { LegendTemplates };
/**
 * @hidden
 */
var SeriesViewerViewManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesViewerViewManager, _super);
    function SeriesViewerViewManager(a) {
        var _this = _super.call(this) || this;
        _this.ae = null;
        _this.af = null;
        _this.aj = null;
        _this.ai = null;
        _this.ag = null;
        _this.ak = null;
        _this.t = null;
        _this.w = null;
        _this.v = null;
        _this.u = null;
        _this.x = null;
        _this.f = null;
        _this.j = null;
        _this.ah = null;
        _this.ab = 0;
        _this.aa = 0;
        _this.ac = 1;
        _this.ad = 0;
        _this.l = null;
        _this.ca = new Thickness(0, 0);
        _this.aq = null;
        _this.ap = stringEmpty();
        _this.b9 = new Thickness(0, 0);
        _this.b0 = null;
        _this.bz = null;
        _this.k = null;
        _this.a = 0;
        _this.b = 0;
        _this.n = null;
        _this.b2 = null;
        _this.m = null;
        _this.b1 = null;
        _this.cb = new Thickness(0, 0);
        _this.cc = new Thickness(0, 0);
        _this.h = null;
        _this.z = new Dictionary$2(String_$type, Tuple$2.$.specialize(DomWrapper_$type, RenderingContext.$), 0);
        _this.al = -1;
        _this.am = -1;
        _this.s = null;
        _this.j = a;
        return _this;
    }
    SeriesViewerViewManager.prototype.bj = function () {
    };
    SeriesViewerViewManager.prototype.bg = function (a) {
        if (a == null) {
            if (this.f != null) {
                this.f.av();
            }
            this.ae = null;
            if (this.af != null) {
                this.af.remove();
            }
            this.af = null;
            if (this.aj != null) {
                this.aj.remove();
            }
            this.aj = null;
            if (this.ai != null) {
                this.ai.remove();
            }
            this.ai = null;
            if (this.ag != null) {
                this.ag.remove();
            }
            this.ag = null;
            if (this.ak != null) {
                this.ak.remove();
            }
            this.ak = null;
            this.t = null;
            this.w = null;
            this.v = null;
            this.u = null;
            if (this.ah != null) {
                this.ah.remove();
            }
            this.ah = null;
            this.f = null;
            this.j.p.cv.u(null);
            this.j.p.cw.u(null);
            this.j.p.al.m(null);
            this.j.p.am.m(null);
            this.j.p.ak.m(null);
            this.j.a.m(null);
            return;
        }
        this.ae = a;
        this.j.p.cv.u(this.ae);
        this.j.p.cw.u(this.ae);
        this.j.p.al.m(this.ae);
        this.j.p.am.m(this.ae);
        this.j.p.ak.m(this.ae);
        this.j.a.m(this.ae);
        this.j.p.ar.aa(this.ae);
        this.bi();
        this.ae.rootWrapper.setStyleProperty("position", "relative");
        this.af = this.ae.createElement("canvas");
        this.af.setStyleProperty("position", "absolute");
        this.af.setStyleProperty("top", "0px");
        this.af.setStyleProperty("left", "0px");
        this.aj = this.ae.createElement("canvas");
        this.aj.setStyleProperty("position", "absolute");
        this.aj.setStyleProperty("top", "0px");
        this.aj.setStyleProperty("left", "0px");
        this.ai = this.ae.createElement("canvas");
        this.ai.setStyleProperty("position", "absolute");
        this.ai.setStyleProperty("top", "0px");
        this.ai.setStyleProperty("left", "0px");
        this.ag = this.ae.createElement("canvas");
        this.ag.setStyleProperty("position", "absolute");
        this.ag.setStyleProperty("top", "0px");
        this.ag.setStyleProperty("left", "0px");
        this.ak = this.ae.createElement("canvas");
        this.ak.setStyleProperty("position", "absolute");
        this.ak.setStyleProperty("top", "0px");
        this.ak.setStyleProperty("left", "0px");
        this.ae.append(this.af);
        this.ae.append(this.ai);
        this.ae.append(this.aj);
        this.t = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.af));
        this.w = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.aj));
        this.v = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.ai));
        if (this.j.p.au != 1) {
            this.u = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.ag));
            this.s = this.u;
        }
        else {
            this.u = new RenderingContext(null, null);
        }
        this.x = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.ak));
        this.j.du(this.t);
        this.j.c1(this.ae.rootWrapper.width(), this.ae.rootWrapper.height());
        {
            if ((TypeRegistrar.isRegistered('CanvasGestureDOMEventProxy'))) {
                var overlayCanvas_ = this.aj;
                var container_ = this.ae;
                this.f = (TypeRegistrar.create('CanvasGestureDOMEventProxy', overlayCanvas_, container_, false));
            }
            else {
                this.f = null;
            }
            if (this.f != null) {
                this.f.ap = runOn(this.j, this.j.at);
            }
        }
        this.ah = this.ae.createElement("div");
        this.ah.hide();
        this.ah.setStyleProperty("position", "absolute");
        this.ah.setStyleProperty("z-index", "10000");
        this.ah.addClass(this.j.p.ku);
        this.ae.append(this.ah);
    };
    SeriesViewerViewManager.by = function (a, b) {
        b();
        return;
    };
    SeriesViewerViewManager.prototype.bi = function () {
        this.j.d4();
        this.j.ef();
        this.bp();
    };
    SeriesViewerViewManager.prototype.ba = function () {
        var a = this.j.p.g0;
        var b = this.j.p.gf;
        if (!isNaN_(a) && a != 0) {
            return;
        }
        if (window.devicePixelRatio != undefined && window.devicePixelRatio != b) {
            this.j.p.gf = window.devicePixelRatio;
        }
    };
    SeriesViewerViewManager.prototype.g = function () {
        if ((TypeRegistrar.isRegistered('XamOverviewPlusDetailPane'))) {
            var overlayCanvas_ = this.aj;
            var container_ = this.ae;
            return (TypeRegistrar.create('XamOverviewPlusDetailPane'));
        }
        return null;
    };
    SeriesViewerViewManager.prototype.bm = function () {
        this.aj.setStyleProperty("cursor", "default");
    };
    SeriesViewerViewManager.prototype.bn = function () {
        this.aj.setStyleProperty("cursor", "pointer");
    };
    SeriesViewerViewManager.prototype.b3 = function () {
        return ((function () {
            var $ret = new Brush();
            $ret.fill = "#000000";
            return $ret;
        })());
    };
    SeriesViewerViewManager.prototype.az = function (a, b, c) {
        this.ab = a;
        this.aa = b;
        this.ac = c;
        var d = a;
        var e = b;
        if (c != 1) {
            d = Math.round(a * c);
            e = Math.round(b * c);
        }
        if (this.af != null) {
            this.af.setAttribute("width", d.toString());
            this.af.setAttribute("height", e.toString());
            this.af.setStyleProperty("width", a.toString() + "px");
            this.af.setStyleProperty("height", b.toString() + "px");
        }
        if (this.aj != null) {
            this.aj.setAttribute("width", d.toString());
            this.aj.setAttribute("height", e.toString());
            this.aj.setStyleProperty("width", a.toString() + "px");
            this.aj.setStyleProperty("height", b.toString() + "px");
            this.aj.setAttribute("tabindex", "0");
            this.aj.setStyleProperty("outline", "0");
        }
        if (this.ai != null) {
            this.ai.setAttribute("width", d.toString());
            this.ai.setAttribute("height", e.toString());
            this.ai.setStyleProperty("width", a.toString() + "px");
            this.ai.setStyleProperty("height", b.toString() + "px");
        }
        if (this.ag != null) {
            this.ag.setAttribute("width", d.toString());
            this.ag.setAttribute("height", e.toString());
            this.ag.setStyleProperty("width", a.toString() + "px");
            this.ag.setStyleProperty("height", b.toString() + "px");
        }
        if (this.ak != null) {
            this.ak.setAttribute("width", d.toString());
            this.ak.setAttribute("height", e.toString());
            this.ak.setStyleProperty("width", a.toString() + "px");
            this.ak.setStyleProperty("height", b.toString() + "px");
        }
        this.j.p.al.q();
        this.j.p.am.q();
        this.j.p.ak.q();
    };
    SeriesViewerViewManager.prototype.b8 = function () {
        if (this.f == null) {
            return { $type: Point_$type, x: 0, y: 0 };
        }
        var a = this.f.bk(this.ae.rootWrapper);
        return { $type: Point_$type, x: a.left, y: a.top };
    };
    SeriesViewerViewManager.prototype.y = function () {
        return false;
    };
    SeriesViewerViewManager.prototype.bc = function (a) {
    };
    SeriesViewerViewManager.prototype.a8 = function (a, b, c, d, e) {
        var f = this.e();
        a = f.a;
        b = f.f;
        c = f.k;
        d = f.h;
        e = f.i;
        return {
            p0: a,
            p1: b,
            p2: c,
            p3: d,
            p4: e
        };
    };
    SeriesViewerViewManager.prototype.e = function () {
        var e_19, _a;
        var a = new DefaultPaletteInfo();
        a.a = new BrushCollection();
        a.f = new BrushCollection();
        a.b = new BrushCollection();
        a.c = new BrushCollection();
        var b = new List$1(String_$type, 0);
        b.add("background-image");
        this.ae.startCSSQuery();
        var c = this.ae.getCssDefaultValuesForClassCollection("ui-chart-fill-palette-", b.toArray());
        var d = c.length;
        var e = this.ae.getCssDefaultValuesForClassCollection("ui-chart-outline-palette-", b.toArray());
        var f = e.length;
        var g = this.ae.getCssDefaultValuesForClassCollection("ui-chart-marker-fill-palette-", b.toArray());
        var h = g.length;
        var i = this.ae.getCssDefaultValuesForClassCollection("ui-chart-marker-outline-palette-", b.toArray());
        var j = i.length;
        for (var k = 0; k < d; k++) {
            a.a.add(CssGradientUtil.brushFromGradientString(c[k][0]));
        }
        for (var l = 0; l < f; l++) {
            a.f.add(CssGradientUtil.brushFromGradientString(e[l][0]));
        }
        for (var m = 0; m < h; m++) {
            a.b.add(CssGradientUtil.brushFromGradientString(g[m][0]));
        }
        for (var n = 0; n < j; n++) {
            a.c.add(CssGradientUtil.brushFromGradientString(i[n][0]));
        }
        b.clear();
        var o = 0;
        var p = 0;
        var q = Math.min(d, f);
        var r = null;
        if (d == 0) {
            b.add("background-color");
        }
        if (f == 0) {
            b.add("border-top-color");
            p = d == 0 ? 1 : 0;
        }
        if (b.count > 0) {
            r = this.ae.getCssDefaultValuesForClassCollection("ui-chart-palette-", b.toArray());
            q = r.length;
        }
        if (d == 0) {
            if (q > 0) {
                for (var s = 0; s < q; s++) {
                    var t = new Brush();
                    t._fill = r[s][o];
                    a.a.add(t);
                }
            }
            else {
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#8BDC5C";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#8961A9";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#6DB1FF";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#82E9D9";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#EA3C63";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#735656";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#F8CE4F";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#A8A8B7";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#E051A9";
                    return $ret;
                })()));
                a.a.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#FF903B";
                    return $ret;
                })()));
            }
        }
        if (f == 0) {
            if (q > 0) {
                for (var u = 0; u < q; u++) {
                    var v = new Brush();
                    v._fill = r[u][p];
                    a.f.add(v);
                }
            }
            else {
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#8BDC5C";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#8961A9";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#6DB1FF";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#82E9D9";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#EA3C63";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#735656";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#F8CE4F";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#A8A8B7";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#E051A9";
                    return $ret;
                })()));
                a.f.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#FF903B";
                    return $ret;
                })()));
            }
        }
        b.clear();
        var w = Math.min(h, j);
        if (h == 0) {
            b.add("background-color");
        }
        if (j == 0) {
            b.add("border-top-color");
            p = h == 0 ? 1 : 0;
        }
        if (b.count > 0) {
            r = this.ae.getCssDefaultValuesForClassCollection("ui-chart-marker-palette-", b.toArray());
            w = r.length;
        }
        if (h == 0) {
            if (w > 0) {
                var _loop_2 = function (x) {
                    var y = ((function () {
                        var $ret = new Brush();
                        $ret.fill = r[x][o];
                        return $ret;
                    })());
                    a.b.add(y);
                };
                for (var x = 0; x < w; x++) {
                    _loop_2(x);
                }
            }
            else {
                a.b.add(((function () {
                    var $ret = new Brush();
                    $ret.fill = "#FFFFFF";
                    return $ret;
                })()));
            }
        }
        if (j == 0) {
            if (w > 0) {
                var _loop_3 = function (z) {
                    var aa = ((function () {
                        var $ret = new Brush();
                        $ret.fill = r[z][p];
                        return $ret;
                    })());
                    a.c.add(aa);
                };
                for (var z = 0; z < w; z++) {
                    _loop_3(z);
                }
            }
            else {
                try {
                    for (var _b = __values(fromEnum(a.a)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var ab = _c.value;
                        a.c.add(ab);
                    }
                }
                catch (e_19_1) {
                    e_19 = { error: e_19_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_19)
                            throw e_19.error;
                    }
                }
            }
        }
        var ac = this.ae.getCssDefaultPropertyValue("ui-chart-axis", "border-top-color");
        if (ac != null) {
            a.i = new Brush();
            a.i._fill = ac;
        }
        else {
            a.i = AxisDefaults.g;
        }
        a.k = new Brush();
        a.k._fill = this.ae.getCssDefaultPropertyValue("", "color");
        a.j = Defaults.ae;
        var ad = this.ae.getCssDefaultPropertyValue("ui-chart-crosshair", "border-top-color");
        if (ad != null) {
            a.j = new Brush();
            a.j._fill = ad;
        }
        this.ae.endCSSQuery();
        a.h = FontUtil.getFont(this.ae);
        var ae = ((function () {
            var $ret = new Brush();
            $ret.fill = "#ee5879";
            return $ret;
        })());
        a.d = new BrushCollection();
        a.d.add(ae);
        a.e = new BrushCollection();
        a.e.add(ae);
        return a;
    };
    SeriesViewerViewManager.prototype.a7 = function (a, b, c, d, e, f) {
        this.ae.startCSSQuery();
        var g = this.ae.getCssDefaultPropertyValue("ui-chart-area-fill-opacity", "opacity");
        a = g != null ? parseFloat(g) : 1;
        b = new Array(4);
        var h = this.ae.getCssDefaultPropertyValue("ui-chart-render-margins", "margin-top");
        var i = this.ae.getCssDefaultPropertyValue("ui-chart-render-margins", "margin-right");
        var j = this.ae.getCssDefaultPropertyValue("ui-chart-render-margins", "margin-bottom");
        var k = this.ae.getCssDefaultPropertyValue("ui-chart-render-margins", "margin-left");
        b[0] = h != null ? parseFloat(h) : NaN;
        b[1] = i != null ? parseFloat(i) : NaN;
        b[2] = j != null ? parseFloat(j) : NaN;
        b[3] = k != null ? parseFloat(k) : NaN;
        c = d = null;
        var l = this.ae.getCssDefaultPropertyValue("ui-chart-axis-stroke", "border-top-color");
        if (l != null) {
            var m = new Brush();
            m._fill = l;
            c = m;
        }
        var n = this.ae.getCssDefaultPropertyValue("ui-chart-axis-major-line", "border-top-color");
        if (n != null) {
            var o = new Brush();
            o._fill = n;
            d = o;
        }
        var p = this.ae.getCssDefaultPropertyValue("ui-chart-aligned-gridlines", "visibility");
        f = p != null && p == "visible";
        var q = this.ae.getCssDefaultPropertyValue("ui-chart-category-axis-tick", "height");
        if (q != null) {
            e = parseFloat(q);
            if (Math.abs(e) > 4000) {
                e = 0;
            }
        }
        else {
            q = this.ae.getCssDefaultPropertyValue("ui-chart-category-axis-tick", "width");
            e = q != null ? parseFloat(q) : 0;
        }
        this.ae.endCSSQuery();
        return {
            p0: a,
            p1: b,
            p2: c,
            p3: d,
            p4: e,
            p5: f
        };
    };
    SeriesViewerViewManager.prototype.ay = function () {
        this.ah.removeChildren();
    };
    SeriesViewerViewManager.prototype.bu = function (x_) {
        var box_ = this.ah;
        var offset_ = this.f.bk(this.ah);
        var a = this.b8();
        x_ = a.x + this.j.p.ty.left + x_;
        box_.setOffset(x_, this.j.p.ty.top + this.ad + a.y);
    };
    SeriesViewerViewManager.prototype.bv = function (y_) {
        this.ad = y_;
        var box_ = this.ah;
        var offset_ = this.ah.getOffset();
        var a = this.b8();
        y_ = this.j.p.ty.top + this.ad + a.y;
        box_.setOffset(offset_.left, y_);
    };
    SeriesViewerViewManager.prototype.au = function (a) {
        var b = a;
        b.show();
        this.ah.append(b);
    };
    SeriesViewerViewManager.prototype.a9 = function () {
        this.ah.hide();
    };
    SeriesViewerViewManager.prototype.bo = function () {
        this.ah.show();
    };
    SeriesViewerViewManager.prototype.av = function (a) {
        this.ae.appendToBody(a);
    };
    SeriesViewerViewManager.prototype.bk = function (a) {
        a.remove();
    };
    SeriesViewerViewManager.prototype.bd = function () {
        if (this.ae == null) {
            return;
        }
        this.ba();
        this.j.c1(this.ae.rootWrapper.width(), this.ae.rootWrapper.height());
    };
    SeriesViewerViewManager.prototype.p = function () {
        return this.l;
    };
    SeriesViewerViewManager.prototype.ce = function () {
        return this.ca;
    };
    SeriesViewerViewManager.prototype.as = function () {
        return this.aq;
    };
    SeriesViewerViewManager.prototype.ar = function () {
        return this.ap;
    };
    SeriesViewerViewManager.prototype.cd = function () {
        return this.b9;
    };
    SeriesViewerViewManager.prototype.b5 = function () {
        return this.b0;
    };
    SeriesViewerViewManager.prototype.b4 = function () {
        return this.bz;
    };
    SeriesViewerViewManager.prototype.o = function () {
        return this.k;
    };
    SeriesViewerViewManager.prototype.c = function () {
        return this.a;
    };
    SeriesViewerViewManager.prototype.d = function () {
        return this.b;
    };
    SeriesViewerViewManager.prototype.r = function () {
        return this.n;
    };
    SeriesViewerViewManager.prototype.b7 = function () {
        return this.b2;
    };
    SeriesViewerViewManager.prototype.q = function () {
        return this.m;
    };
    SeriesViewerViewManager.prototype.b6 = function () {
        return this.b1;
    };
    SeriesViewerViewManager.prototype.cf = function () {
        return this.cb;
    };
    SeriesViewerViewManager.prototype.cg = function () {
        return this.cc;
    };
    SeriesViewerViewManager.prototype.bp = function () {
        this.ae.startCSSQuery();
        this.br();
        this.bq();
        this.bt();
        this.bs();
        this.bx();
        this.ae.endCSSQuery();
    };
    SeriesViewerViewManager.prototype.bx = function () {
        var a = "ui-chart-pointer-tooltip";
        var b = this.ae.getCssDefaultPropertyValue(a, "background-color");
        var c = this.ae.getCssDefaultPropertyValue(a, "border-top-color");
        var d = this.ae.getCssDefaultPropertyValue(a, "border-top-left-radius");
        var e = this.ae.getCssDefaultPropertyValue(a, "border-top-width");
        var f = new PointerTooltipStyle();
        f.a = d != null ? parseFloat(d) : 0;
        f.c = b != null ? Brush.create(b) : ((function () {
            var $ret = new Brush();
            $ret.fill = "white";
            return $ret;
        })());
        f.d = c != null ? Brush.create(c) : ((function () {
            var $ret = new Brush();
            $ret.fill = "gray";
            return $ret;
        })());
        f.b = e != null ? parseFloat(e) : 0;
        this.h = f;
    };
    SeriesViewerViewManager.prototype.br = function () {
        var _this = this;
        var a = "ui-chart-title";
        this.l = FontUtil.getFontForClass(this.ae, a);
        this.b0 = ((function () {
            var $ret = new Brush();
            $ret.fill = _this.ae.getCssDefaultPropertyValue(a, "color");
            return $ret;
        })());
        this.aq = this.ae.getCssDefaultPropertyValue(a, "text-align");
        if (this.aq == null) {
            this.aq = "center";
        }
        var b = this.ae.getCssDefaultPropertyValue(a, "margin-top");
        var c = this.ae.getCssDefaultPropertyValue(a, "margin-bottom");
        var d = this.ae.getCssDefaultPropertyValue(a, "margin-left");
        var e = this.ae.getCssDefaultPropertyValue(a, "margin-right");
        var f = b != null ? parseFloat(b) : 0;
        var g = c != null ? parseFloat(c) : 0;
        var h = d != null ? parseFloat(d) : 0;
        var i = e != null ? parseFloat(e) : 0;
        this.ca = new Thickness(1, h, f, i, g);
    };
    SeriesViewerViewManager.prototype.bq = function () {
        var _this = this;
        var a = "ui-chart-subtitle";
        this.k = FontUtil.getFontForClass(this.ae, a);
        this.bz = ((function () {
            var $ret = new Brush();
            $ret.fill = _this.ae.getCssDefaultPropertyValue(a, "color");
            return $ret;
        })());
        this.ap = this.ae.getCssDefaultPropertyValue(a, "text-align");
        if (this.ap == null) {
            this.ap = "center";
        }
        var b = this.ae.getCssDefaultPropertyValue(a, "margin-top");
        var c = this.ae.getCssDefaultPropertyValue(a, "margin-bottom");
        var d = this.ae.getCssDefaultPropertyValue(a, "margin-left");
        var e = this.ae.getCssDefaultPropertyValue(a, "margin-right");
        var f = b != null ? parseFloat(b) : 0;
        var g = c != null ? parseFloat(c) : 0;
        var h = d != null ? parseFloat(d) : 0;
        var i = e != null ? parseFloat(e) : 0;
        this.b9 = new Thickness(1, h, f, i, g);
    };
    SeriesViewerViewManager.prototype.bs = function () {
        var _this = this;
        var a = "ui-chart-horizontal-axis-title";
        this.m = FontUtil.getFontForClass(this.ae, a);
        this.b1 = ((function () {
            var $ret = new Brush();
            $ret.fill = _this.ae.getCssDefaultPropertyValue(a, "color");
            return $ret;
        })());
        var b = this.ae.getCssDefaultPropertyValue(a, "vertical-align");
        if (b == null) {
            this.a = 0;
        }
        else if (b.toLowerCase() == "bottom") {
            this.a = 4;
        }
        else {
            this.a = 3;
        }
        var c = this.ae.getCssDefaultPropertyValue(a, "margin-top");
        var d = this.ae.getCssDefaultPropertyValue(a, "margin-bottom");
        var e = this.ae.getCssDefaultPropertyValue(a, "margin-left");
        var f = this.ae.getCssDefaultPropertyValue(a, "margin-right");
        var g = c != null ? parseFloat(c) : 2;
        var h = d != null ? parseFloat(d) : 2;
        var i = e != null ? parseFloat(e) : 2;
        var j = f != null ? parseFloat(f) : 2;
        this.cb = new Thickness(1, i, g, j, h);
    };
    SeriesViewerViewManager.prototype.bt = function () {
        var _this = this;
        var a = "ui-chart-vertical-axis-title";
        this.n = FontUtil.getFontForClass(this.ae, a);
        this.b2 = ((function () {
            var $ret = new Brush();
            $ret.fill = _this.ae.getCssDefaultPropertyValue(a, "color");
            return $ret;
        })());
        var b = this.ae.getCssDefaultPropertyValue(a, "text-align");
        if (b == null) {
            this.b = 0;
        }
        else if (b.toLowerCase() == "right") {
            this.b = 2;
        }
        else {
            this.b = 1;
        }
        var c = this.ae.getCssDefaultPropertyValue(a, "margin-top");
        var d = this.ae.getCssDefaultPropertyValue(a, "margin-bottom");
        var e = this.ae.getCssDefaultPropertyValue(a, "margin-left");
        var f = this.ae.getCssDefaultPropertyValue(a, "margin-right");
        var g = c != null ? parseFloat(c) : 0;
        var h = d != null ? parseFloat(d) : 0;
        var i = e != null ? parseFloat(e) : 0;
        var j = f != null ? parseFloat(f) : 0;
        this.cc = new Thickness(1, i, g, j, h);
    };
    SeriesViewerViewManager.prototype.a6 = function (a, b) {
        var c = this.j.p.gf;
        if (a != this.ab || b != this.aa || c != this.ac) {
            this.az(a, b, this.j.p.gf);
            this.j.p.al.l();
            this.j.a.l();
        }
    };
    SeriesViewerViewManager.prototype.i = function () {
        return this.h;
    };
    SeriesViewerViewManager.prototype.bb = function (a) {
        if (this.f == null) {
            return;
        }
        this.f.ab = a;
        this.f.ap = runOn(this.j, this.j.at);
    };
    SeriesViewerViewManager.prototype.an = function (a, b, c) {
        var _this = this;
        var d;
        if (!((function () { var e = _this.z.tryGetValue(b.iD.toString(), d); d = e.p1; return e.ret; })())) {
            var e = this.ae.createElement("canvas");
            e.setAttribute("width", c.toString());
            e.setAttribute("height", c.toString());
            e.setStyleProperty("width", c.toString() + "px");
            e.setStyleProperty("height", c.toString() + "px");
            var f = this.ae.get2DCanvasContext(e);
            var g = new RenderingContext(new CanvasViewRenderer(), f);
            var h = new Tuple$2(DomWrapper_$type, RenderingContext.$, e, g);
            d = h;
            this.z.addItem(b.iD.toString(), d);
        }
        var i = new Rect(0, 0, 0, c, c);
        var j = new RenderSurface();
        j.a = d.d;
        for (var k = 0; k < this.j.p.series.count; k++) {
            var l = this.j.p.series._inner[k];
            l.mm(i, a, j, "tile", 1);
        }
        this.j.p.ak.l();
        return d.c;
    };
    SeriesViewerViewManager.prototype.a3 = function (a) {
        this.z.removeItem(a.iD.toString());
    };
    SeriesViewerViewManager.prototype.a2 = function () {
        this.z.clear();
    };
    SeriesViewerViewManager.prototype.bl = function (a) {
        for (var b = 0; b < a.count; b++) {
            var c = a._inner[b];
            var d = c.content;
            this.j.z.n(d.getNativeElement(), 1, c.xPosition + this.j.p.ty.left, c.yPosition + this.j.p.ty.top, c.width, c.height);
        }
    };
    SeriesViewerViewManager.prototype.a0 = function () {
        var _this = this;
        if (this.al != -1) {
            this.aw();
        }
        if (this.ae != null) {
            this.al = this.ae.setTimeout(function () { return _this.j.p.a9.f$j(_this.j.p); }, 5000);
        }
        else {
            this.al = window.setTimeout(function () { return _this.j.p.a9.f$j(_this.j.p); }, 5000);
        }
    };
    SeriesViewerViewManager.prototype.aw = function () {
        if (this.al != -1) {
            if (this.ae != null) {
                this.ae.clearTimeout(this.al);
            }
            else {
                window.clearTimeout(this.al);
            }
            this.al = -1;
        }
    };
    SeriesViewerViewManager.prototype.a1 = function (a) {
        var _this = this;
        if (this.am != -1) {
            this.ax();
        }
        if (this.ae != null) {
            this.am = this.ae.setTimeout(function () { return _this.j.p.l1(); }, a);
        }
        else {
            this.am = window.setTimeout(function () { return _this.j.p.l1(); }, a);
        }
    };
    SeriesViewerViewManager.prototype.ax = function () {
        if (this.am != -1) {
            if (this.ae != null) {
                this.ae.clearTimeout(this.am);
            }
            else {
                window.clearTimeout(this.am);
            }
            this.am = -1;
        }
    };
    SeriesViewerViewManager.prototype.be = function () {
        if (this.j.p.au != 1) {
            if (this.s == null) {
                this.u = new RenderingContext(new CanvasViewRenderer(), this.ae.get2DCanvasContext(this.ag));
                this.s = this.u;
            }
            else {
                this.u = this.s;
            }
        }
        else {
            this.u = new RenderingContext(null, null);
        }
        this.j.dt(this.u);
    };
    SeriesViewerViewManager.prototype.bw = function (a) {
        if (this.ae != null) {
            var b = "igTouch";
            if (a) {
                this.ae.rootWrapper.addClass(b);
            }
            else {
                this.ae.rootWrapper.removeClass(b);
            }
        }
    };
    SeriesViewerViewManager.prototype.a4 = function () {
    };
    SeriesViewerViewManager.prototype.a5 = function () {
    };
    SeriesViewerViewManager.prototype.bh = function () {
        if (this.f != null) {
            this.f.bh(this.aj, "");
        }
    };
    SeriesViewerViewManager.prototype.bf = function () {
        this.ba();
        if (this.f != null) {
            this.f.at(this.aj, "");
        }
    };
    SeriesViewerViewManager.prototype.ao = function (a, b, c) {
        var d = this.ae.createElement("img");
        d.setProperty("src", this.at(a, b, c, "image/png"));
        return d.getNativeElement();
    };
    SeriesViewerViewManager.prototype.at = function (a, b, c, d, e) {
        var _this = this;
        if (e === void 0) {
            e = null;
        }
        var f = a * c;
        var g = b * c;
        var h = this.ae.createElement("canvas");
        h.setStyleProperty("width", a + "px");
        h.setStyleProperty("height", b + "px");
        h.setProperty("width", f);
        h.setProperty("height", g);
        var i = this.ae.get2DCanvasContext(h);
        var j = ((function () {
            var $ret = new Brush();
            $ret.fill = _this.ae.rootWrapper.getStyleProperty("background-color");
            return $ret;
        })());
        if (BrushUtilCore.a(j)) {
            j._fill = this.ae.rootWrapper.parent().getStyleProperty("background-color");
            if (BrushUtilCore.a(j)) {
                j._fill = "rgb(255, 255, 255)";
            }
        }
        if (c != 1) {
            i.save();
            i.scale(c, c);
        }
        i.fillStyle = j._fill;
        i.fillRect(0, 0, a, b);
        if (this.t != null && this.t != this.v) {
            i.drawImage(this.af.getNativeElement(), 0, 0, a, b);
        }
        if (this.v != null) {
            i.drawImage(this.ai.getNativeElement(), 0, 0, a, b);
        }
        if (this.w != null && this.w != this.v) {
            i.drawImage(this.aj.getNativeElement(), 0, 0, a, b);
        }
        if (c != 1) {
            i.restore();
        }
        var format_ = d;
        var sCanv_ = h.getNativeElement();
        var url_ = (sCanv_.toDataURL(format_));
        if (e != null) {
            var cb_1 = e;
            sCanv_.toBlob(function (blob) { cb_1(url_, blob); }, format_);
        }
        return url_;
    };
    SeriesViewerViewManager.$t = markType(SeriesViewerViewManager, 'SeriesViewerViewManager');
    return SeriesViewerViewManager;
}(Base));
export { SeriesViewerViewManager };
/**
 * @hidden
 */
var AutoRangeCalculator = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AutoRangeCalculator, _super);
    function AutoRangeCalculator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoRangeCalculator.a = function (a, b, c, d, e, f, g) {
        f = !isNaN_(b) && !isInfinity(b) ? b : Number.POSITIVE_INFINITY;
        g = !isNaN_(c) && !isInfinity(c) ? c : Number.NEGATIVE_INFINITY;
        var h = f;
        var i = g;
        if (isInfinity(h) || isInfinity(i)) {
            if (a != null) {
                var j = a.kr();
                if (j != null) {
                    h = Math.min(h, j.c);
                    i = Math.max(i, j.b);
                }
            }
        }
        if (!isInfinity(h) && !isInfinity(i)) {
            if (h == i && h != 0) {
                h *= h > 0 ? 0.9 : 1.1;
                i *= i > 0 ? 1.1 : 0.9;
            }
            if (h == i && h == 0) {
                i = 1;
            }
            if (b > c) {
                var k = c;
                c = b;
                b = k;
            }
            var l = isNaN_(b) || isInfinity(b) ? h : b;
            var m = isNaN_(c) || isInfinity(c) ? i : c;
            if (d) {
                if (l <= 0) {
                    if (m > 1) {
                        l = 1;
                    }
                    else {
                        l = Math.pow(e, Math.floor(logBase(m, e)));
                    }
                }
                if (isNaN_(b) || isInfinity(b)) {
                    var n = logBase(l, e);
                    h = Math.pow(e, Math.floor(n));
                }
                else {
                    h = l;
                }
                if (isNaN_(c) || isInfinity(c)) {
                    i = Math.pow(e, Math.ceil(logBase(m, e)));
                }
                else {
                    i = m;
                }
            }
            else {
                var o = Math.pow(10, Math.floor(log10(m - l)) - 1);
                var p = a.ei();
                if (a != null && p > 0 && (!a.lg && !a.lf)) {
                    var q = new LinearNumericSnapper(0, h, i, p, a.ey());
                    o = q.g;
                }
                else if (a.lc && p > 0 && (!a.lg || !a.lf)) {
                    var r = h;
                    var s = i;
                    if (a.lg) {
                        r = b;
                    }
                    if (a.lf) {
                        s = c;
                    }
                    var t = new LinearNumericSnapper(0, r, s, p, a.ey());
                    o = t.g;
                }
                if ((isNaN_(b) || isInfinity(b)) && !isNaN_(h) && !isNaN_(o) && o != 0) {
                    {
                        h = o * Math.floor(h / o);
                    }
                }
                else {
                    h = l;
                }
                if ((isNaN_(c) || isInfinity(c)) && !isNaN_(i) && !isNaN_(o) && o != 0) {
                    var u = Math.ceil(i / o);
                    {
                        i = o * u;
                    }
                }
                else {
                    i = m;
                }
                if (a.lc) {
                    if (a.lc && p > 0 && (!a.lg || !a.lf)) {
                        var v = new LinearNumericSnapper(0, h, i, p, a.ey());
                        var w = v.g;
                        if (w != o) {
                            o = w;
                            if ((isNaN_(b) || isInfinity(b)) && !isNaN_(h) && !isNaN_(o) && o != 0) {
                                {
                                    h = o * Math.floor(h / o);
                                }
                            }
                            else {
                                h = l;
                            }
                            if ((isNaN_(c) || isInfinity(c)) && !isNaN_(i) && !isNaN_(o) && o != 0) {
                                var x = Math.ceil(i / o);
                                {
                                    i = o * x;
                                }
                            }
                            else {
                                i = m;
                            }
                        }
                    }
                }
            }
        }
        f = h;
        g = i;
        return {
            p5: f,
            p6: g
        };
    };
    AutoRangeCalculator.$t = markType(AutoRangeCalculator, 'AutoRangeCalculator');
    return AutoRangeCalculator;
}(Base));
export { AutoRangeCalculator };
/**
 * @hidden
 */
export var IAxisAnnotationManager_$type = /*@__PURE__*/ new Type(null, 'IAxisAnnotationManager');
/**
 * @hidden
 */
var AxisLabelSettings = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisLabelSettings, _super);
    function AxisLabelSettings() {
        var _this = _super.call(this) || this;
        _this.ab = null;
        _this.ay = null;
        _this.b = 1;
        _this.a3 = 0;
        _this.i = true;
        _this.c = 0;
        _this.a = null;
        _this.n = 0;
        _this.p = NaN;
        _this.q = 2;
        _this.r = 2;
        _this.s = 2;
        _this.o = 2;
        _this.av = 0;
        _this.a0 = 1;
        _this.propertyChanged = null;
        _this.propertyUpdated = null;
        _this.f = null;
        _this.propertyUpdated = delegateCombine(_this.propertyUpdated, function (a, b) { return _this.ar(a, b.propertyName, b.oldValue, b.newValue); });
        return _this;
    }
    Object.defineProperty(AxisLabelSettings.prototype, "textStyle", {
        get: function () {
            return this.ab;
        },
        set: function (a) {
            var b = this.ab;
            this.ab = a;
            if (this.ab != b) {
                this.f = null;
                this.as("TextStyle", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "textColor", {
        get: function () {
            return this.ay;
        },
        set: function (a) {
            var b = this.ay;
            this.ay = a;
            this.as("TextColor", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "location", {
        get: function () {
            return this.b;
        },
        set: function (a) {
            var b = this.b;
            this.b = a;
            this.as("Location", enumGetBox(AxisLabelsLocation_$type, b), enumGetBox(AxisLabelsLocation_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "visibility", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            this.as("Visibility", enumGetBox(Visibility_$type, b), enumGetBox(Visibility_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "showFirstLabel", {
        get: function () {
            return this.i;
        },
        set: function (a) {
            var b = this.i;
            this.i = a;
            this.as("ShowFirstLabel", b, a);
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelSettings.prototype.registerAxis = function (a) {
        this.a = a;
    };
    AxisLabelSettings.prototype.unregisterAxis = function (a) {
        this.a = null;
    };
    Object.defineProperty(AxisLabelSettings.prototype, "angle", {
        get: function () {
            return this.n;
        },
        set: function (a) {
            var b = this.n;
            this.n = a;
            this.as("Angle", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "extent", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            this.as("Extent", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "margin", {
        set: function (a) {
            this.leftMargin = a;
            this.bottomMargin = a;
            this.rightMargin = a;
            this.topMargin = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "leftMargin", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            this.as("LeftMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "rightMargin", {
        get: function () {
            return this.r;
        },
        set: function (a) {
            var b = this.r;
            this.r = a;
            this.as("RightMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "topMargin", {
        get: function () {
            return this.s;
        },
        set: function (a) {
            var b = this.s;
            this.s = a;
            this.as("TopMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "bottomMargin", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            var b = this.o;
            this.o = a;
            this.as("BottomMargin", b, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "horizontalAlignment", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            var b = this.av;
            this.av = a;
            this.as("HorizontalAlignment", enumGetBox(HorizontalAlignment_$type, b), enumGetBox(HorizontalAlignment_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "verticalAlignment", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            var b = this.a0;
            this.a0 = a;
            this.as("VerticalAlignment", enumGetBox(VerticalAlignment_$type, b), enumGetBox(VerticalAlignment_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelSettings.prototype.as = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        if (this.propertyUpdated != null) {
            this.propertyUpdated(this, new PropertyUpdatedEventArgs(a, b, c));
        }
    };
    AxisLabelSettings.prototype.ar = function (a, b, c, d) {
        switch (b) {
            case "Location":
                this.c = this.location;
                break;
        }
        if (this.a == null || this.a.bg == null) {
            return;
        }
        switch (b) {
            case "Angle":
                this.a.cq = true;
                this.a.h7();
                break;
            case "TextStyle":
                this.f = null;
                this.a.cq = true;
                if (this.a.bi != null) {
                    this.a.bi.md();
                }
                this.a.h7();
                break;
            case "Location":
            case "Extent":
            case "Visibility":
            case "HorizontalAlignment":
            case "VerticalAlignment":
            case "TopMargin":
            case "RightMargin":
            case "BottomMargin":
            case "LeftMargin":
            case "ShowFirstLabel":
                this.a.cq = true;
                if (this.a.bi != null) {
                    this.a.bi.md();
                }
                this.a.h7();
                break;
            case "TextColor":
                this.a.h7();
                break;
        }
    };
    AxisLabelSettings.prototype.k = function () {
        return this.n != 0;
    };
    AxisLabelSettings.prototype.l = function () {
        return !isNaN_(this.p);
    };
    Object.defineProperty(AxisLabelSettings.prototype, "j", {
        get: function () {
            return this.textStyle != null || this.f != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelSettings.prototype, "g", {
        get: function () {
            return this.f;
        },
        set: function (a) {
            this.f = a;
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelSettings.prototype.h = function (a) {
        if (this.f == null) {
            this.f = FontUtil.toFontInfo(a, this.textStyle);
        }
        return this.f;
    };
    AxisLabelSettings.$t = markType(AxisLabelSettings, 'AxisLabelSettings', Base.$, [INotifyPropertyChanged_$type]);
    AxisLabelSettings.extentPropertyDefault = NaN;
    return AxisLabelSettings;
}(Base));
export { AxisLabelSettings };
/**
 * @hidden
 */
var TitleSettings = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(TitleSettings, _super);
    function TitleSettings() {
        var _this = _super.call(this) || this;
        _this.a5 = 0;
        _this.horizontalAlignment = 1;
        _this.leftMargin = NaN;
        _this.rightMargin = NaN;
        _this.topMargin = NaN;
        _this.bottomMargin = NaN;
        return _this;
    }
    Object.defineProperty(TitleSettings.prototype, "position", {
        get: function () {
            return this.a5;
        },
        set: function (a) {
            var b = this.a5;
            this.a5 = a;
            this.as("AxisTitlePosition", enumGetBox(AxisTitlePosition_$type, b), enumGetBox(AxisTitlePosition_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    TitleSettings.prototype.ar = function (a, b, c, d) {
        _super.prototype.ar.call(this, a, b, c, d);
        if (this.a == null || this.a.bi == null) {
            return;
        }
        switch (b) {
            case "AxisTitlePosition":
                this.a.cq = true;
                this.a.h7();
                break;
        }
    };
    TitleSettings.$t = markType(TitleSettings, 'TitleSettings', AxisLabelSettings.$);
    return TitleSettings;
}(AxisLabelSettings));
export { TitleSettings };
/**
 * @hidden
 */
var Axis = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(Axis, _super);
    function Axis() {
        var _this = _super.call(this) || this;
        _this.a5 = null;
        _this.bt = null;
        _this.a9 = null;
        _this.a7 = null;
        _this.ir = null;
        _this.bn = null;
        _this.bh = null;
        _this.bs = null;
        _this.by = false;
        _this.dl = NaN;
        _this.df = 50;
        _this.ds = 0;
        _this.dp = 150;
        _this.as = 0;
        _this.dk = NaN;
        _this.dw = 0;
        _this.dr = 0;
        _this.dn = 180;
        _this.bk = null;
        _this.bj = null;
        _this.f3 = "Verdana";
        _this.dm = NaN;
        _this.dy = 0;
        _this.dt = 8;
        _this.dq = 16;
        _this.fo = -1;
        _this.fn = 1;
        _this.fm = 3;
        _this.fp = 0;
        _this.kj = 0;
        _this.dv = 0;
        _this.du = 2;
        _this.is = null;
        _this.dz = 0;
        _this.ci = false;
        _this.bw = false;
        _this.dg = 0;
        _this.cv = false;
        _this.cx = false;
        _this.bz = false;
        _this.rangeChanged = null;
        _this.al = new AxisAnnotationCollection();
        _this.am = new AxisAnnotationCollection();
        _this.j6 = Rect.empty;
        _this.kc = null;
        _this.dc = null;
        _this.dd = null;
        _this.aw = null;
        _this.bx = false;
        _this.a6 = null;
        _this.fl = null;
        _this.ai = null;
        _this._coercionMethods = null;
        _this.bv = false;
        _this.cy = false;
        _this.c7 = false;
        _this.renderRequested = null;
        _this.bc = null;
        _this.cr = false;
        _this.di = NaN;
        _this.dj = -1;
        _this.cs = false;
        _this.propertyChanged = null;
        _this.propertyUpdated = null;
        _this.de = null;
        _this.da = new Dictionary$2(String_$type, String_$type, 0);
        _this.c9 = new Dictionary$2(String_$type, FastReflectionHelper.$, 0);
        _this.ki = new Size();
        _this.ap = new AxisComponentsForView();
        _this.d3 = 0;
        _this.dh = 0;
        _this.br = null;
        _this.bq = null;
        _this.bp = null;
        _this.ax = new AxisLabelSettings();
        _this.fk = null;
        DVContainer.instance.registerIfLoaded("VisualDataFactoryManager");
        DVContainer.instance.registerIfLoaded("AnnotationFactoryManager");
        _this.bz = true;
        _this.d3 = NaN;
        _this.a5 = _this.a4();
        _this.hs(_this.a5);
        _this.a5.aj();
        _this.br = ((function () {
            var $ret = new Pool$1(TextBlock.$);
            $ret.create = runOn(_this.a5, _this.a5.a0);
            $ret.activate = runOn(_this.a5, _this.a5.at);
            $ret.disactivate = runOn(_this.a5, _this.a5.av);
            $ret.destroy = runOn(_this.a5, _this.a5.au);
            return $ret;
        })());
        _this.bq = ((function () {
            var $ret = new Pool$1(TextBlock.$);
            $ret.create = runOn(_this.a5, _this.a5.a0);
            $ret.activate = runOn(_this.a5, _this.a5.at);
            $ret.disactivate = runOn(_this.a5, _this.a5.av);
            $ret.destroy = runOn(_this.a5, _this.a5.au);
            return $ret;
        })());
        _this.bp = ((function () {
            var $ret = new Pool$1(Rectangle.$);
            $ret.create = runOn(_this.a5, _this.a5.bf);
            $ret.activate = runOn(_this.a5, _this.a5.s);
            $ret.disactivate = runOn(_this.a5, _this.a5.u);
            $ret.destroy = runOn(_this.a5, _this.a5.t);
            return $ret;
        })());
        _this.kc = Rect.empty;
        _this.dc = new List$1(Base.$, 0);
        _this.dd = new List$1(LabelPosition.$, 0);
        _this.aw = _this.av();
        _this.aw.ag = _this.az;
        _this.aw.ad = _this;
        _this.de = new List$1(Series.$, 0);
        var a = _this.al;
        a.collectionResetting = delegateCombine(a.collectionResetting, runOn(_this, _this.hc));
        var b = _this.al;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.hb));
        var c = _this.am;
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.he));
        var d = _this.am;
        d.collectionChanged = delegateCombine(d.collectionChanged, runOn(_this, _this.hd));
        _this.ab = Axis.$;
        if (_this.az != null) {
            _this.ax = _this.az;
        }
        _this.propertyUpdated = delegateCombine(_this.propertyUpdated, function (e, f) { return _this.hw(e, f.propertyName, f.oldValue, f.newValue); });
        _this.bs = function (e, f) {
            if (_this.bi == null || !_this.bi.d9) {
                _this.iq(f.oldRect, f.newRect);
            }
        };
        _this.a5.y();
        return _this;
    }
    Axis.prototype.a4 = function () {
        return new AxisView(this);
    };
    Axis.prototype.hs = function (a) {
    };
    Axis.prototype.hf = function () {
        if (this.ca) {
            this.a8.onAddAnnotations(this);
        }
    };
    Object.defineProperty(Axis.prototype, "bu", {
        get: function () {
            if (this.bt == null) {
                this.bt = new SRProvider(this.fl);
            }
            if (this.bt.l == null) {
                this.bt.l = this.fl;
            }
            return this.bt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "ba", {
        get: function () {
            var _this = this;
            if (this.a9 == null) {
                this.a9 = DVContainer.instance.createInstance(IAxisVisualDataManager_$type, function () { return _this.bu.q; });
            }
            return this.a9;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ei = function () {
        return this.j7().width;
    };
    Axis.prototype.f2 = function () {
        return null;
    };
    Axis.prototype.f1 = function () {
        return null;
    };
    Axis.prototype.get_cb = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cb", {
        get: function () {
            return this.get_cb();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cj = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cj", {
        get: function () {
            return this.get_cj();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_b9 = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "b9", {
        get: function () {
            return this.get_b9();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cm = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cm", {
        get: function () {
            return this.get_cm();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cp = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cp", {
        get: function () {
            return this.get_cp();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cn = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cn", {
        get: function () {
            return this.get_cn();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_ce = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "ce", {
        get: function () {
            return this.get_ce();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_ck = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "ck", {
        get: function () {
            return this.get_ck();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cl = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cl", {
        get: function () {
            return this.get_cl();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cc = function () {
        return false;
    };
    Object.defineProperty(Axis.prototype, "cc", {
        get: function () {
            return this.get_cc();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_cd = function () {
        return true;
    };
    Object.defineProperty(Axis.prototype, "cd", {
        get: function () {
            return this.get_cd();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ak = function () {
        return this.aj;
    };
    Object.defineProperty(Axis.prototype, "a8", {
        get: function () {
            var _this = this;
            if (this.a7 == null) {
                this.a7 = DVContainer.instance.createInstance(IAxisAnnotationManager_$type, function () { return _this.bu.n; });
                this.a7.owner = this;
            }
            return this.a7;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "ca", {
        get: function () {
            return DVContainer.instance.checkLoaded("AnnotationFactoryManager");
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.hd = function (a, b) {
        if (!this.ca) {
            return;
        }
        this.a8.onAutoAnnotionsChanged(this, this.am, b);
    };
    Axis.prototype.he = function (a, b) {
        if (!this.ca) {
            return;
        }
        this.a8.onAutoAnnotionsReset(this, this.am, b);
    };
    Axis.prototype.hb = function (a, b) {
        if (!this.ca) {
            return;
        }
        this.a8.onAnnotionsChanged(this, this.al, b);
    };
    Axis.prototype.hc = function (a, b) {
        if (!this.ca) {
            return;
        }
        this.a8.onAnnotionsReset(this, this.al, b);
    };
    Axis.prototype.provideRenderer = function (a) {
        this.fl = a;
        this.hg();
        this.aw.ag = this.az;
    };
    Axis.prototype.hp = function (a, b) {
        if (!a.equals1(b)) {
            this.ip(a, b);
        }
    };
    Axis.prototype.ac = function () {
        _super.prototype.ac.call(this);
        this.a5.am();
    };
    Object.defineProperty(Axis.prototype, "bo", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            if (this.bo != a) {
                var b = this.bo;
                this.bn = a;
                this.h2("FastItemsSourceProvider", b, this.bn);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "bi", {
        get: function () {
            return this.bh;
        },
        set: function (a) {
            if (this.bi != a) {
                var b = this.bi;
                this.bh = a;
                this.h2("SeriesViewer", b, this.bh);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "bg", {
        get: function () {
            return typeCast(XamDataChart.$, this.bi);
        },
        set: function (a) {
            this.bi = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "c6", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            if (this.by == a) {
                return;
            }
            this.by = a;
            var b = null;
            if (this.aw != null && Rect.l_op_Inequality(this.aw.c1, null)) {
                b = this.aw.c1;
            }
            this.aw = this.av();
            this.aw.ad = this;
            this.aw.ag = this.az;
            if (Rect.l_op_Inequality(b, null)) {
                this.aw.c1 = b;
            }
            if (this.bi != null && this.bi.cu != null) {
                this.aw.af.al(this.bi.cu.y);
                this.h6(true);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "e6", {
        get: function () {
            return this.dl;
        },
        set: function (a) {
            var b = this.dl;
            if (b != a) {
                this.dl = a;
                this.dx = a;
                this.h6(true);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "dx", {
        get: function () {
            return this.df;
        },
        set: function (a) {
            this.df = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fc", {
        get: function () {
            return this.ds;
        },
        set: function (a) {
            this.ds = a;
            this.h6(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "e9", {
        get: function () {
            return this.dp;
        },
        set: function (a) {
            this.dp = a;
            this.h6(true);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "at", {
        get: function () {
            return this.as;
        },
        set: function (a) {
            var b = this.as;
            if (b != a) {
                this.as = a;
                this.h6(true);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "e5", {
        get: function () {
            return this.dk;
        },
        set: function (a) {
            this.dk = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fb", {
        get: function () {
            return this.dr;
        },
        set: function (a) {
            this.dr = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "e8", {
        get: function () {
            return this.dn;
        },
        set: function (a) {
            this.dn = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "bm", {
        get: function () {
            if (this.bk == null) {
                if (this.bj == null) {
                    this.bj = this.a5.i();
                }
                return this.bj;
            }
            return this.bk;
        },
        set: function (a) {
            this.bk = a;
            this.dm = FontUtil.getFontSize(this.bk);
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "gx", {
        get: function () {
            return this.f3;
        },
        set: function (a) {
            this.f3 = a;
            var b = this.dm;
            if (isNaN_(b)) {
                b = 12;
            }
            this.bm.n = a;
            this.bm.d = b;
            this.aw.b8();
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "e7", {
        get: function () {
            return this.dm;
        },
        set: function (a) {
            this.dm = a;
            this.bm = FontUtil.getFontWithNewFontSize(this.bm, this.dm);
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fd", {
        get: function () {
            return this.dt;
        },
        set: function (a) {
            this.dt = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fa", {
        get: function () {
            return this.dq;
        },
        set: function (a) {
            this.dq = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "ft", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            this.fo = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fs", {
        get: function () {
            return this.fn;
        },
        set: function (a) {
            this.fn = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fr", {
        get: function () {
            return this.fm;
        },
        set: function (a) {
            this.fm = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "km", {
        get: function () {
            return this.kj;
        },
        set: function (a) {
            this.kj = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "ff", {
        get: function () {
            return this.dv;
        },
        set: function (a) {
            this.dv = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "fe", {
        get: function () {
            return this.du;
        },
        set: function (a) {
            this.du = a;
            this.h5();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ih = function () {
        this.aw.cp();
    };
    Axis.prototype.h5 = function () {
        this.h6(false);
    };
    Axis.prototype.h6 = function (a) {
        if (a) {
            this.aw.co();
        }
        this.cq = true;
        this.h4();
    };
    Axis.prototype.ik = function () {
        if (this.fh > 0) {
            this.dz = this.fh;
            return;
        }
        var a = typeCast(XamDataChart.$, this.bi);
        if (a != null && isNaN_(this.fh) && this.cb && (this.cp || this.a2 == 0)) {
            this.dz = a.uj.fq;
            return;
        }
        this.dz = 0;
    };
    Object.defineProperty(Axis.prototype, "b4", {
        get: function () {
            return this.bw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "b7", {
        get: function () {
            return this.az != null && this.az.k();
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ig = function (a) {
        this.bw = true;
        if (this.dg != a) {
            this.dg = a;
            this.h8(false);
        }
    };
    Axis.prototype.ia = function () {
        this.bw = false;
        this.dg = 0;
        this.h8(false);
    };
    Axis.prototype.ef = function () {
        if (this.b4 && (!this.b7 || (this.b7 && this.az.angle == 0))) {
            return this.ew();
        }
        if (this.b7) {
            return this.az.angle;
        }
        return 0;
    };
    Axis.prototype.ew = function () {
        return this.dg;
    };
    Object.defineProperty(Axis.prototype, "c4", {
        get: function () {
            return this.c(Axis.jp);
        },
        set: function (a) {
            this.h(Axis.jp, a);
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.d5 = function () {
        return 0;
    };
    Axis.prototype.jr = function () {
        if (this.cp) {
            return 2;
        }
        return 0;
    };
    Axis.prototype.kk = function () {
        return 1;
    };
    Axis.prototype.js = function () {
        return 1;
    };
    Axis.prototype.kl = function () {
        return 1;
    };
    Axis.prototype.d7 = function () {
        if (this.cp) {
            return DeviceUtils.g(5);
        }
        return 0;
    };
    Axis.prototype.d9 = function () {
        if (!this.cp && !this.b9) {
            return DeviceUtils.g(5);
        }
        return 0;
    };
    Axis.prototype.d8 = function () {
        if (this.cp) {
            return DeviceUtils.g(5);
        }
        return 0;
    };
    Axis.prototype.d6 = function () {
        if (!this.cp && !this.b9) {
            return DeviceUtils.g(5);
        }
        return 0;
    };
    Axis.prototype.ec = function () {
        return NaN;
    };
    Axis.prototype.ee = function () {
        return NaN;
    };
    Axis.prototype.ed = function () {
        return NaN;
    };
    Axis.prototype.eb = function () {
        return NaN;
    };
    Axis.prototype.a0 = function () {
        if (this.cp) {
            return 2;
        }
        if (this.cm) {
            return 5;
        }
        return 1;
    };
    Axis.prototype.a1 = function () {
        return 1;
    };
    Axis.prototype.h3 = function (a) {
        if (this.rangeChanged != null) {
            this.rangeChanged(this, a);
        }
    };
    Axis.prototype.ea = function () {
        if (this.cp) {
            return -90;
        }
        return 0;
    };
    Axis.prototype.d4 = function () {
        return NaN;
    };
    Object.defineProperty(Axis.prototype, "an", {
        get: function () {
            return this.al;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "ao", {
        get: function () {
            return this.am;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "kd", {
        get: function () {
            if (this.kc.isEmpty) {
                return this.j6;
            }
            return this.kc;
        },
        set: function (a) {
            this.j6 = a;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.il = function () {
        var a = 0;
        var b = typeCast(XamDataChart.$, this.bi);
        if (b != null && b.ua == 0) {
            a = 1;
        }
        this.a5.ay(a);
    };
    Axis.prototype.c8 = function (a, b, c) {
        return this.bi != null;
    };
    Axis.prototype.co = function () {
        var a = Rect.empty;
        if (this.bi != null) {
            a = this.bi.tz;
        }
        return this.c8(this.kd, a, this.a5);
    };
    Axis.prototype.ip = function (a, b) {
        this.cr = false;
        this.kd = b;
        this.cq = true;
        this.c1();
        this.h8(false);
        if (this.bi != null) {
            this.bi.ar.ae(1, this, this.a6, b);
        }
    };
    Object.defineProperty(Axis.prototype, "cq", {
        get: function () {
            return this.bx;
        },
        set: function (a) {
            this.bx = a;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ka = function () {
        if (this.bi == null || this.bi.tn.isEmpty) {
            return Rect.empty;
        }
        var a = this.bi.tn;
        var b = this.kd;
        var c = (a.left - b.left) / b.width;
        var d = (a.top - b.top) / b.height;
        var e = (a.right - b.left) / b.width;
        var f = (a.bottom - b.top) / b.height;
        return new Rect(0, c, d, e - c, f - d);
    };
    Axis.prototype.iq = function (a, b) {
        this.cq = true;
        this.h8(true);
    };
    Axis.prototype.h4 = function () {
        this.h8(false);
    };
    Axis.prototype.hw = function (a, b, c, d) {
        var e_20, _a;
        switch (b) {
            case Axis.$$p[10]:
            case Axis.$$p[11]:
                if (this.gg != null) {
                    this.ai = new BindingFormatter();
                    this.ai.j = this.gg;
                    this.ai.d = this.ah;
                }
                else {
                    this.ai = null;
                }
                break;
            case "SeriesViewer":
                var e = typeCast(SeriesViewer.$, c);
                if (e != null) {
                    this.fl = null;
                    e.actualWindowRectChanged = delegateRemove(e.actualWindowRectChanged, this.bs);
                    e.ar.ad(1, this);
                    this.a5.ad(e);
                }
                var f = typeCast(SeriesViewer.$, d);
                if (f != null) {
                    this.fl = f.cu.j.ae;
                    f.actualWindowRectChanged = delegateCombine(f.actualWindowRectChanged, this.bs);
                    this.a6 = f.ar.k(1, this, runOn(this, this.hk));
                    if (this.az == null && this.fl != null) {
                        this.provideRenderer(this.fl);
                    }
                    this.a5.x(f);
                    if (this.cs && !this.a6.e) {
                        this.cs = false;
                        this.c1();
                    }
                    this.ij();
                    this.ik();
                }
                break;
            case Axis.$$p[8]:
                this.h8(false);
                break;
            case Axis.$$p[21]:
                this.cx = this.cw;
                this.h8(false);
                break;
            case Axis.$$p[20]:
                this.cv = this.cu;
                this.h8(false);
                break;
            case Axis.$$p[9]:
                this.ci = this.ch;
                var g = new AxisRangeChangedEventArgs(0, 0, 0, 1, 1);
                this.hj(g);
                try {
                    for (var _b = __values(fromEnum(this.de)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var h = _c.value;
                        h.lk();
                        if (h.ce != null) {
                            h.lu();
                        }
                    }
                }
                catch (e_20_1) {
                    e_20 = { error: e_20_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_20)
                            throw e_20.error;
                    }
                }
                break;
            case Axis.$$p[12]:
                this.a5.ak();
                if (typeCast(DataTemplate.$, d) !== null) {
                    this.c7 = true;
                }
                else {
                    this.c7 = false;
                }
                this.cq = true;
                this.ic();
                this.h8(false);
                break;
            case Axis.$$p[16]:
            case Axis.$$p[19]:
            case Axis.$$p[25]:
                this.h8(false);
                break;
            case Axis.$$p[13]:
                var i = typeCast(AxisLabelSettings.$, d);
                if (i != null) {
                    i.registerAxis(this);
                    this.ax = i;
                }
                else {
                    this.ax = new AxisLabelSettings();
                }
                if (this.aw != null) {
                    this.aw.ag = this.ax;
                }
                this.hu();
                this.cq = true;
                this.h8(false);
                break;
            case Axis.$$p[30]:
                this.a5.an();
                break;
            case Axis.$$p[31]:
                var j = typeCast(TitleSettings.$, d);
                if (j != null) {
                    j.registerAxis(this);
                }
                else {
                    j = new TitleSettings();
                }
                if (this.is != null) {
                    this.is.dataContext = j;
                }
                this.hv();
                this.h8(false);
                break;
            case Axis.$$p[26]:
                this.cq = true;
                this.ik();
                this.a5.ag();
                this.h8(false);
                break;
            case Axis.$$p[32]:
            case Axis.$$p[5]:
            case "UseEnhancedIntervalManagement":
            case Axis.$$p[6]:
                this.bz = this.c5;
                this.cq = true;
                this.h8(false);
                break;
            case Axis.$$p[3]:
                if (this.bi != null) {
                    this.bi.md();
                }
                break;
            case Axis.$$p[18]:
                this.ij();
                if (d != null) {
                    this.cy = true;
                    this.h8(false);
                }
                else {
                    this.cy = false;
                }
                break;
            case Axis.$$p[4]:
                if (this.aj != null) {
                    this.aj.h7();
                }
                break;
            case Axis.$$p[24]:
            case Axis.$$p[15]:
                this.ij();
                this.h8(false);
                break;
            case Axis.$$p[23]:
            case Axis.$$p[14]:
            case Axis.$$p[17]:
            case Axis.$$p[7]:
            case Axis.$$p[28]:
            case Axis.$$p[29]:
            case Axis.$$p[27]:
            case Axis.$$p[2]:
            case Axis.$$p[0]:
            case Axis.$$p[1]:
            case Axis.$$p[22]:
                this.h8(false);
                break;
            case "MinExtent":
                this.a5.ag();
                break;
        }
    };
    Axis.prototype.hu = function () {
        if (this.a5.o()) {
            this.a5.z(this.ax);
        }
    };
    Axis.prototype.hv = function () {
        this.a5.an();
    };
    Object.defineProperty(Axis.prototype, "coercionMethods", {
        get: function () {
            return this._coercionMethods;
        },
        set: function (a) {
            this._coercionMethods = a;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.get_expectFunctions = function () {
        return this.bv;
    };
    Axis.prototype.set_expectFunctions = function (a) {
        this.bv = a;
    };
    Object.defineProperty(Axis.prototype, "expectFunctions", {
        get: function () {
            return this.get_expectFunctions();
        },
        set: function (a) {
            this.set_expectFunctions(a);
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.ic = function () {
        this.br.count = 0;
        this.bq.count = 0;
        this.bp.count = 0;
        if (this.a5.o()) {
            this.a5.aq();
        }
    };
    Axis.prototype.hr = function (a, b, c, d) {
        var e = Math.min(b, c);
        var f = Math.max(b, c);
        if (e < d.bottom && f > d.top) {
            var g = new RectangleGeometry();
            g.e = new Rect(0, d.left, e, d.width, f - e);
            a.add(g);
        }
    };
    Axis.prototype.hq = function (a, b, c, d, e) {
        var f = b <= c.bottom && b >= c.top;
        if (!e && f) {
            f = !this.cg(b, d.c, c, false);
        }
        if (f) {
            if (d.a) {
                b = this.d0(b, c.top, c.bottom, d);
            }
            var g = new LineGeometry();
            g.d = { $type: Point_$type, x: c.left, y: b };
            g.c = { $type: Point_$type, x: c.right, y: b };
            a.add(g);
        }
    };
    Axis.prototype.io = function (a, b, c, d) {
        var e = Math.min(b, c);
        var f = Math.max(b, c);
        if (f > d.left && e < d.right) {
            var g = new RectangleGeometry();
            g.e = new Rect(0, e, d.top, f - e, d.height);
            a.add(g);
        }
    };
    Axis.prototype.im = function (a, b, c, d, e) {
        var f = b >= c.left && b <= c.right;
        if (!f) {
            var g = truncate(Math.round(b));
            var h = truncate(Math.round(c.left));
            var i = truncate(Math.round(c.right));
            if (g >= h && g <= i) {
                f = true;
            }
        }
        if (!e && f) {
            f = !this.cg(b, d.c, c, true);
        }
        if (f) {
            if (d.a) {
                b = this.d0(b, c.left, c.right, d);
            }
            var j = new LineGeometry();
            j.d = { $type: Point_$type, x: b, y: c.top };
            j.c = { $type: Point_$type, x: b, y: c.bottom };
            a.add(j);
        }
    };
    Axis.prototype.cg = function (a, b, c, d) {
        var e_21, _a;
        var e = false;
        var f = typeCast(XamDataChart.$, this.bi);
        if (f != null && (f.u1 || f.u2) && !c.isEmpty) {
            var g = this.bi.tj.width == 1 && this.bi.tj.height == 1;
            try {
                for (var _b = __values(fromEnum(f.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var h = _c.value;
                    if (h._visibility != 0 || h.fg < 1 || h.jv == null || BrushUtilCore.a(h.jv) || h.kd.isEmpty) {
                        continue;
                    }
                    if (h.aj != null && h.b5()) {
                        if (f.u1) {
                            var i = this.cp ? c.left : c.top;
                            var j = 0;
                            var k = h.ie(i, j, h.bi.tz, c, h.j8(), d ? c.left : c.top, d ? c.right : c.bottom);
                            i = k.p0;
                            j = k.p1;
                            var l = Rect.empty;
                            var m = Rect.empty;
                            if (d && h.cp) {
                                l = new Rect(0, i - (h.fg / 2), h.kd.top, h.fg, h.kd.height);
                                m = new Rect(0, a - (b / 2), c.top, b, c.height);
                            }
                            else if (!d && !h.cp) {
                                l = new Rect(0, h.kd.left, i - (h.fg / 2), h.kd.width, h.fg);
                                m = new Rect(0, c.left, a - (b / 2), c.width, b);
                            }
                            if (l.left <= m.right && m.left <= l.right && l.top <= m.bottom && m.top <= l.bottom) {
                                e = true;
                                break;
                            }
                        }
                    }
                    else {
                        var n = Rect.empty;
                        var o = Rect.empty;
                        if (d && h.cp) {
                            n = new Rect(0, h.kd.left, h.kd.top, h.fg, h.kd.height);
                            o = new Rect(0, a - (b / 2), c.top, b, c.height);
                        }
                        else if (!d && !h.cp) {
                            n = new Rect(0, h.kd.left, h.kd.bottom - (h.fg / 2), h.kd.width, h.fg);
                            o = new Rect(0, c.left, a - (b / 2), c.width, b);
                        }
                        if (n.left <= o.right && o.left <= n.right && n.top <= o.bottom && o.top <= n.bottom) {
                            e = true;
                            break;
                        }
                        if (g && f.u2) {
                            var p = f.vv;
                            if (isNaN_(p)) {
                                if (d && h.cp) {
                                    p = 0;
                                    p = Math.max(p, f.vn);
                                    p = Math.max(p, f.vk);
                                }
                                else if (!d && !h.cp) {
                                    p = 0;
                                    p = Math.max(p, f.vl);
                                    p = Math.max(p, f.vm);
                                }
                                p += 1;
                            }
                            p *= 2;
                            if (d && h.cp) {
                                n = new Rect(0, h.kd.left, h.kd.top, h.fg, h.kd.height);
                                o = new Rect(0, a - (p / 2), c.top, p, c.height);
                            }
                            else if (!d && !h.cp) {
                                n = new Rect(0, h.kd.left, h.kd.bottom - (h.fg / 2), h.kd.width, h.fg);
                                o = new Rect(0, c.left, a - (p / 2), c.width, p);
                            }
                            if (n.left <= o.right && o.left <= n.right && n.top <= o.bottom && o.top <= n.bottom) {
                                e = true;
                                break;
                            }
                        }
                    }
                }
            }
            catch (e_21_1) {
                e_21 = { error: e_21_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_21)
                        throw e_21.error;
                }
            }
        }
        return e;
    };
    Axis.prototype.ie = function (a, b, c, d, e, f, g) {
        var h = Math.abs(f - g);
        a = this.fv;
        a = this.aj.e4(a);
        var i = typeCast(CategoryAxisBase.$, this.aj);
        if (i != null && i.categoryMode == 2) {
            var j = 0.5 * i.getCategorySize(c, d, e);
            var k = i.a2 == 0;
            if (i.ch == k) {
                j = -j;
            }
            a = a + j;
        }
        b = a - f;
        if (a < f) {
            a = f;
        }
        else if (a > g) {
            a = g;
        }
        if (b < 0) {
            b = 0;
        }
        else if (b > h) {
            b = h;
        }
        return {
            p0: a,
            p1: b
        };
    };
    Axis.prototype.d0 = function (a, b, c, d) {
        var e = a;
        if (d != null && d.c > 0) {
            var f = d.c % 2;
            if (f == 0 || f == 1) {
                var g = 1;
                e = Math.floor(a);
                if (e + 0.5 < a) {
                    g = -1;
                    e = Math.ceil(a);
                }
                if (f == 1) {
                    e += 0.5 * g;
                }
                if (e >= c) {
                    e -= 1;
                }
                else if (e <= b) {
                    e += 1;
                }
            }
        }
        return e;
    };
    Axis.prototype.hi = function (a) {
        this.a5.ac(a);
    };
    Axis.prototype.hh = function () {
        this.br.count = 0;
        this.bq.count = 0;
        this.bp.count = 0;
        this.a5.aa();
        this.dc.clear();
        this.dd.clear();
    };
    Axis.prototype.h7 = function () {
        this.h8(false);
    };
    Axis.prototype.h8 = function (a) {
        if (this.bi != null) {
            this.bi.ar.ac(1, this, this.a6, a);
            if (this.renderRequested != null) {
                var b = new RenderRequestedEventArgs();
                b.animate = a;
                this.renderRequested(this, b);
                a = b.animate;
            }
        }
    };
    Axis.prototype.ez = function () {
        if (this.bc == null) {
            return -1;
        }
        if (isNaN_(this.bc.b)) {
            return -1;
        }
        if (this.ef() != 0) {
            return -1;
        }
        var a = this.bc.b;
        var b = this.e3();
        var c = this.e0();
        a = a + b + c;
        return Math.max(Axis.et, a);
    };
    Axis.prototype.e3 = function () {
        if (this.az == null) {
            return 0;
        }
        else {
            return this.az.topMargin;
        }
    };
    Axis.prototype.e1 = function () {
        if (this.az == null) {
            return 0;
        }
        else {
            return this.az.leftMargin;
        }
    };
    Axis.prototype.e2 = function () {
        if (this.az == null) {
            return 0;
        }
        else {
            return this.az.rightMargin;
        }
    };
    Axis.prototype.e0 = function () {
        if (this.az == null) {
            return 0;
        }
        else {
            return this.az.bottomMargin;
        }
    };
    Axis.prototype.ex = function () {
        if (this.bc == null) {
            return -1;
        }
        if (isNaN_(this.bc.d) && isNaN_(this.di)) {
            return -1;
        }
        if (this.az != null && (this.az.angle != 0)) {
            return -1;
        }
        var a = this.bc.d;
        if (!isNaN_(this.di) && this.fq == -1) {
            return this.di;
        }
        return Math.max(Axis.et, this.bc.d);
    };
    Axis.prototype.d2 = function (a, b, c, d, e) {
        if (a == 1) {
            return 1;
        }
        if (b) {
            return a;
        }
        var f = 0;
        var g = this.eq(a, b, c, d, e);
        if (!b && f < 10 && this.cz(g, c, d, e)) {
            a = g - 1;
            f += 1;
            while (!b && f < 10 && this.cz(a, c, d, e)) {
                a--;
                f += 1;
            }
        }
        return a;
    };
    Axis.prototype.eq = function (a, b, c, d, e) {
        var f = false;
        if (this.cp) {
            f = this.cb && this.b1 && this.bc != null;
        }
        else {
            f = this.cb && this.b1 && this.b6();
        }
        if (f) {
            var g = this.eg(a, c, d, e);
            if (isNaN_(g)) {
                return a;
            }
            var h = this.eh(a, c, d, e);
            if (g <= h) {
                return a;
            }
            var i = Math.ceil((h / g) * a) + 1;
            return i;
        }
        return a;
    };
    Axis.prototype.eh = function (a, b, c, d) {
        if (this.cp) {
            var e = this.bc.b;
            return e;
        }
        else {
            var f = this.di;
            if (this.bi != null && this.bi.e0) {
                f = this.bc.b;
            }
            return f;
        }
    };
    Axis.prototype.cz = function (a, b, c, d) {
        if (this.cp) {
            if (this.cb && this.b1 && this.bc != null) {
                var e = this.bc.b;
                if (a > 1) {
                    var f = a - 1;
                    if (f < 1) {
                        return false;
                    }
                    var g = this.eg(f, b, c, d);
                    if (isNaN_(g)) {
                        return false;
                    }
                    if (g > e) {
                        return true;
                    }
                }
            }
        }
        else {
            if (this.cb && this.b1 && this.b6()) {
                if (a > 1) {
                    var h = a - 1;
                    if (h < 1) {
                        return false;
                    }
                    var i = this.eg(h, b, c, d);
                    if (isNaN_(i)) {
                        return false;
                    }
                    var j = this.di;
                    if (this.bi != null && this.bi.e0) {
                        j = this.bc.b;
                    }
                    if (i > j) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    Axis.prototype.eg = function (a, b, c, d) {
        return NaN;
    };
    Axis.prototype.ey = function () {
        if (this.cp) {
            return this.ez();
        }
        else {
            return this.ex();
        }
    };
    Object.defineProperty(Axis.prototype, "c0", {
        get: function () {
            return this.fq == -1;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.hk = function (a) {
        if (this.a5.m()) {
            return;
        }
        var b = 0;
        var c = 0;
        if (this.dd != null && this.dd.count > 0) {
            b = this.dd._inner[this.dd.count - 1].c;
            c = this.dd.count;
        }
        if (this.cq && this.c4) {
            this.bc = this.bb();
        }
        this.h9(a);
        if (!this.cp && this.cq && this.c4 && this.c0) {
            if (this.b2()) {
                this.h9(a);
            }
        }
        var d = 1;
        var e = 0;
        if (this.dd != null && this.dd.count > 0) {
            d = this.dd._inner[this.dd.count - 1].c;
            e = this.dd.count;
        }
        if (this.c6) {
            this.cq = true;
        }
        var f = false;
        if (d != b || e != c || this.cq) {
            this.cq = false;
            if (this.a5.o()) {
                this.a5.ag();
                f = true;
            }
        }
        this.a5.af();
        if (!f) {
            this.hl();
        }
    };
    Axis.prototype.b2 = function () {
        if (!isNaN_(this.di) || this.dc == null || this.dc.count == 0) {
            return false;
        }
        var a = this.bl();
        if (a == null) {
            return false;
        }
        var b = -1.7976931348623157E+308;
        for (var c = 0; c < this.dc.count; c++) {
            var d = this.dc._inner[c];
            if (typeof d === 'string') {
                var e = FontUtil.measureStringWidth(d, a, this.a5.j);
                b = Math.max(e, b);
            }
        }
        b += 5;
        if (this.az != null) {
            b += this.az.leftMargin + this.az.rightMargin;
        }
        this.di = b;
        return true;
    };
    Axis.prototype.ib = function () {
        this.di = NaN;
        this.h8(false);
    };
    Axis.prototype.b6 = function () {
        return !isNaN_(this.di) && this.fq == -1;
    };
    Axis.prototype.d1 = function (a, b) {
        return a;
    };
    Axis.prototype.id = function () {
        this.di = NaN;
    };
    Axis.prototype.bb = function () {
        var a = this.bl();
        if (a == null) {
            return null;
        }
        var b = "W";
        if (this.a5.j == null) {
            return null;
        }
        var c = FontUtil.measureStringWidth(b, a, this.a5.j);
        if (this.dj != c || this.bc == null) {
            this.dj = c;
            var d = FontUtil.getCurrentFontHeight(this.bi.cu.j.ae, a);
            if (this.bc == null) {
                this.bc = new LabelFontHeuristics();
            }
            this.bc.b = d;
            this.bc.c = this.fq;
            this.bc.a = this.b1;
            this.bc.e = c;
            this.bc.d = this.bc.e * this.bc.c;
        }
        return this.bc;
    };
    Axis.prototype.bl = function () {
        var a = null;
        if (this.bi != null) {
            a = this.bi.getFontInfo();
        }
        if (this.az != null && this.az.j) {
            if (this.bi != null) {
                a = this.az.h(this.bi.cu.j.ae);
            }
        }
        return a;
    };
    Axis.prototype.hl = function () {
        if (!this.a5.o()) {
            return;
        }
        if (!this.b8()) {
            this.a5.ae();
        }
    };
    Axis.prototype.c1 = function () {
        return this.c2(false);
    };
    Axis.prototype.c2 = function (a) {
        if (a || this.bi == null) {
            var b = this.c3();
            if (b) {
                this.cq = true;
            }
            this.cs = false;
            return b;
        }
        if (!this.cs) {
            this.cs = true;
            this.bi.ar.ab(this, this.a6);
        }
        return false;
    };
    Axis.prototype.c3 = function () {
        return false;
    };
    Axis.prototype.h9 = function (a) {
        if (this.is != null) {
            if ((this.bf == null || this.bf.visibility == 0) && (this.az == null || this.az.visibility == 0) && this.g6 != null) {
                this.is._visibility = 0;
            }
            else {
                this.is._visibility = 1;
            }
        }
    };
    Axis.prototype.ij = function () {
        var e_22, _a, e_23, _b;
        var a = typeCast(XamDataChart.$, this.bi);
        if (a == null) {
            return;
        }
        var b = null, c = null, d = null;
        if (this.cb && !this.b9) {
            b = a.x6;
            try {
                for (var _c = __values(fromEnum(this.de)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var e = _d.value;
                    if (e.ef || e.ed || e.d9 || e.ed) {
                        c = a.x4;
                        d = a.x5;
                        break;
                    }
                }
            }
            catch (e_22_1) {
                e_22 = { error: e_22_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_22)
                        throw e_22.error;
                }
            }
        }
        else if (this.cj && !this.b9) {
            c = a.x4;
            d = a.x5;
            b = this.aj != null ? a.x6 : null;
            try {
                for (var _e = __values(fromEnum(this.de)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var f = _f.value;
                    if (f.ef || f.ed || f.d9 || f.ed) {
                        b = a.x6;
                        break;
                    }
                }
            }
            catch (e_23_1) {
                e_23 = { error: e_23_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_23)
                        throw e_23.error;
                }
            }
        }
        else if (this.b9 || this.a2 == 3) {
            b = a.x6;
            c = a.x4;
            d = a.x5;
        }
        this.jv = this.jz != null ? this.jz : b;
        this.jt = this.jw != null ? this.jw : c;
        this.ju = this.jx != null ? this.jx : d;
    };
    Axis.prototype.h2 = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        if (this.propertyUpdated != null) {
            this.propertyUpdated(this, new PropertyUpdatedEventArgs(a, b, c));
        }
    };
    Axis.prototype.ct = function (a) {
        var b = this.de.contains(a);
        if (!b) {
            this.de.add(a);
        }
        this.ij();
        return !b;
    };
    Axis.prototype.b0 = function (a) {
        var b = this.de.contains(a);
        if (b) {
            this.de.remove(a);
        }
        this.ij();
        return b;
    };
    Axis.prototype.fx = function (a, b) {
        var c = this.gs(b);
        if (c == Axis.$$p[12]) {
            return this.fy(a, b, this.f0);
        }
        return null;
    };
    Axis.prototype.gs = function (a) {
        if (!this.da.containsKey(a)) {
            var b = a.charAt(0).toUpperCase() + a.substr(1);
            this.da.addItem(a, b);
        }
        return this.da.item(a);
    };
    Axis.prototype.fy = function (a, b, c) {
        var d = null;
        if (!this.c9.containsKey(b)) {
            d = new FastReflectionHelper(false, c);
            this.c9.addItem(b, d);
        }
        else {
            d = this.c9.item(b);
        }
        d.propertyName = c;
        return d.getPropertyValue(a);
    };
    Axis.prototype.fz = function (a) {
        return this.a5.p(a);
    };
    Axis.prototype.gd = function (a) {
        return this.a5.r(a);
    };
    Axis.prototype.ev = function () {
        return NaN;
    };
    Axis.prototype.ej = function (a, b) {
        return 0;
    };
    Axis.prototype.ek = function (a, b, c) {
        return 0;
    };
    Axis.prototype.j9 = function (a) {
        if (this.bi == null) {
            return Rect.empty;
        }
        if (!a.equals1(this.kd)) {
            return Rect.empty;
        }
        return this.bi.tn;
    };
    Axis.prototype.j8 = function () {
        if (this.bi == null) {
            return Rect.empty;
        }
        return this.bi.tn;
    };
    Axis.prototype.j7 = function () {
        if (this.bi == null || this.bi.tm.isEmpty) {
            return this.kd;
        }
        return this.bi.tm;
    };
    Axis.prototype.kb = function (a, b) {
        if (b.isEmpty) {
            return a;
        }
        return b;
    };
    Axis.prototype.el = function (a, b, c) {
        var d = this.j9(c);
        var e = new ScalerParams(0, b, c, this.ch, d);
        return this.ej(a, e);
    };
    Axis.prototype.hn = function (a, b, c, d) {
    };
    Axis.prototype.hm = function (a, b, c, d, e) {
    };
    Axis.prototype.em = function (a, b) {
        return 0;
    };
    Axis.prototype.en = function (a, b, c) {
        return 0;
    };
    Axis.prototype.eo = function (a, b, c) {
        var d = this.j9(c);
        var e = new ScalerParams(0, b, c, this.ch, d);
        return this.em(a, e);
    };
    Axis.prototype.ho = function (a, b, c, d) {
    };
    Axis.prototype.e4 = function (a) {
        var b = this.j8();
        var c = new ScalerParams(0, this.bi.tj, this.kd, this.ch, b);
        return this.ej(a, c);
    };
    Axis.prototype.ht = function (a) {
        var b = false;
        if (this.ki.width == 0 || this.ki.height == 0) {
            this.kc = new Rect(0, 0, 0, a.width, a.height);
        }
        else {
            b = true;
            this.kc = new Rect(0, 0, 0, this.ki.width, this.ki.height);
        }
        if (b) {
            this.a6.c = true;
            this.cq = true;
            this.aw.ci();
            this.c2(true);
        }
    };
    Axis.prototype.ii = function () {
        this.kc = Rect.empty;
        this.aw.cq();
    };
    Axis.prototype.aq = function () {
        this.ap.a = this.aw;
        return this.ap;
    };
    Object.defineProperty(Axis.prototype, "es", {
        get: function () {
            return this.dh;
        },
        set: function (a) {
            var b = this.es;
            if (a != b) {
                this.dh = a;
                this.h2("MinExtent", b, this.es);
            }
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.b8 = function () {
        if (!isNaN_(this.d3)) {
            return true;
        }
        if (this.az == null) {
            return false;
        }
        else {
            return this.az.l();
        }
    };
    Axis.prototype.ep = function () {
        if (!isNaN_(this.d3)) {
            return this.d3;
        }
        if (this.az == null) {
            return 50;
        }
        return this.az.extent;
    };
    Axis.prototype.hg = function () {
        this.a5.w();
    };
    Axis.prototype.hj = function (a) {
        this.h3(a);
    };
    Object.defineProperty(Axis.prototype, "ke", {
        get: function () {
            return this.ar().a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "kf", {
        get: function () {
            return this.ar().b;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "kh", {
        get: function () {
            return this.a5.c().d;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Axis.prototype, "kg", {
        get: function () {
            return this.ar().c;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.be = function () {
        return SyncManager.a(this.bh);
    };
    Axis.prototype.ar = function () {
        return this.a5.c();
    };
    Object.defineProperty(Axis.prototype, "ay", {
        get: function () {
            return this.ax;
        },
        enumerable: false,
        configurable: true
    });
    Axis.prototype.hx = function (a, b) {
        if (this.aw != null) {
            this.aw.cj(a);
        }
        this.a5.ai(a, b);
    };
    Axis.prototype.b5 = function () {
        return this.fv != null;
    };
    Axis.prototype.fw = function () {
        return this.ba.exportVisualData(this);
    };
    Axis.prototype._db = function () {
        var a, b;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    a = 0;
                    _a.label = 1;
                case 1:
                    if (!(a < this.de.count))
                        return [3 /*break*/, 4];
                    b = this.de._inner[a];
                    return [4 /*yield*/, b];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    a++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Axis.prototype.db = function () {
        var _this = this;
        return toEnum(function () { return _this._db(); });
    };
    Axis.prototype.hy = function (a) {
    };
    Axis.prototype.h1 = function (a) {
    };
    Axis.prototype.h0 = function (a) {
    };
    Axis.prototype.j5 = function (a, b, c, d, e) {
        if (d === void 0) {
            d = null;
        }
        if (e === void 0) {
            e = null;
        }
        if (this.cp) {
            var f = new LineGeometry();
            f.d = { $type: Point_$type, x: c.left, y: a };
            f.c = { $type: Point_$type, x: c.right, y: a };
            return f;
        }
        else {
            var g = new LineGeometry();
            g.d = { $type: Point_$type, x: a, y: c.bottom };
            g.c = { $type: Point_$type, x: a, y: c.top };
            return g;
        }
    };
    Axis.$t = markType(Axis, 'Axis', Control.$, [INotifyPropertyChanged_$type]);
    Axis.jp = DependencyProperty.i("UseEnhancedIntervalManagement", Boolean_$type, Axis.$, new PropertyMetadata(2, false, function (a, b) { return a.h2("UseEnhancedIntervalManagement", b.oldValue, b.newValue); }));
    Axis.et = 7;
    Axis.$$p = markDep(DependencyProperty, PropertyMetadata, Axis, 'h2', ['ActualMajorStroke:jt:it', [Brush.$], 'ActualMinorStroke:ju:iu', [Brush.$], 'ActualStroke:jv:iv', [Brush.$], 'CrossingAxis:aj:iw', [Axis.$], 'CrossingValue:fv:ix', [4, null], 'EnhancedIntervalMinimumCharacters:fq:iy', [1, -1], 'EnhancedIntervalPreferMoreCategoryLabels:b1:iz', [0, false], 'FormatLabel:au:i0', [Delegate_$type], 'IsDisabled:cf:i1', [0, false], 'IsInverted:ch:i2', [0, false], 'LabelFormat:gg:i3', [2, null], 'LabelFormatSpecifiers:ah:i4', [Array_$type, null], 'Label:f0:i5', [4, null], 'LabelSettings:az:i6', [AxisLabelSettings.$, null], 'MajorStrokeDashArray:j1:i7', [DoubleCollection.$], 'MajorStroke:jw:i8', [Brush.$], 'MajorStrokeThickness:er:i9', [1, 1], 'MinorStrokeDashArray:j2:ja', [DoubleCollection.$], 'MinorStroke:jx:jb', [Brush.$], 'MinorStrokeThickness:eu:jc', [1, 1], 'ShouldAvoidAnnotationCollisions:cu:jd', [0, false], 'ShouldKeepAnnotationsInView:cw:je', [0, false], 'Strip:jy:jf', [Brush.$], 'StrokeDashArray:j3:jg', [DoubleCollection.$], 'Stroke:jz:jh', [Brush.$], 'StrokeThickness:fg:ji', [1, DeviceUtils.g(2)], 'TickLength:fh:jj', [1, NaN], 'TickStrokeDashArray:j4:jk', [DoubleCollection.$], 'TickStroke:j0:jl', [Brush.$], 'TickStrokeThickness:fi:jm', [1, DeviceUtils.g(2)], 'Title:g6:jn', [2], 'TitleSettings:bf:jo', [TitleSettings.$, null], 'UsePerLabelHeightMeasurement:c5:jq', [0, true]]);
    return Axis;
}(Control));
export { Axis };
/**
 * @hidden
 */
var AxisCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisCollection, _super);
    function AxisCollection() {
        var _this = _super.call(this, Axis.$, 0) || this;
        _this.collectionResetting = null;
        _this.propertyChanged = delegateCombine(_this.propertyChanged, function (a, b) {
            if (b.propertyName == "Name") {
                for (var c = 0; c < _this.count; ++c) {
                    if (_this._inner[c].name == b.propertyName) {
                        _this.ac(new NotifyCollectionChangedEventArgs(2, 2, _this._inner[c], _this._inner[c], c));
                    }
                }
            }
        });
        return _this;
    }
    AxisCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    AxisCollection.$t = markType(AxisCollection, 'AxisCollection', ObservableCollection$1.$.specialize(Axis.$));
    return AxisCollection;
}(ObservableCollection$1));
export { AxisCollection };
/**
 * @hidden
 */
var AxisLabelManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisLabelManager, _super);
    function AxisLabelManager() {
        var _this = _super.call(this) || this;
        _this.e = null;
        _this.f = null;
        _this.b = null;
        _this.a = null;
        _this.c = null;
        _this.c = function (a) {
        };
        return _this;
    }
    AxisLabelManager.prototype.n = function (a, b) {
        this.e.clear();
        this.f.clear();
        this.b.ad = this.a;
        this.b.c5 = a;
        this.b.c4 = b;
        if (b.isEmpty || a.isEmpty) {
            this.s(0);
            this.a.bq.count = 0;
            this.a.bp.count = 0;
        }
        if (this.a.br.count == 0 && this.a.bq.count == 0) {
            this.b.ab.clear();
        }
    };
    AxisLabelManager.prototype.i = function (a, b) {
        this.e.add1(a);
        this.f.add(b);
    };
    AxisLabelManager.prototype.t = function () {
        this.b.a9 = this.e;
        this.b.ba = this.f;
        this.b.cl();
    };
    AxisLabelManager.j = function (a, b) {
        AxisLabelManager.k(a, false, b);
    };
    AxisLabelManager.k = function (a, b, c) {
    };
    AxisLabelManager.l = function (a, b, c) {
    };
    AxisLabelManager.m = function (a, b) {
        AxisLabelManager.l(a, true, b);
    };
    AxisLabelManager.prototype.h = function (a) {
        this.b.ab.add(a);
    };
    AxisLabelManager.prototype.r = function (a) {
        this.b.bw = a;
    };
    AxisLabelManager.prototype.o = function (a) {
        this.c(a);
    };
    AxisLabelManager.prototype.u = function (a) {
        var b = this.a.br.item(a);
        return b;
    };
    AxisLabelManager.prototype.s = function (a) {
        if (this.a == null) {
            return;
        }
        this.a.br.count = a;
    };
    Object.defineProperty(AxisLabelManager.prototype, "d", {
        get: function () {
            if (this.a == null || this.a.az == null) {
                return false;
            }
            return this.a.az.visibility != 0;
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelManager.prototype.q = function () {
        this.a.br.count = 0;
        this.a.bq.count = 0;
        this.a.bp.count = 0;
        this.a.aw.bb.clear();
    };
    AxisLabelManager.prototype.p = function () {
        this.a.cq = true;
    };
    AxisLabelManager.prototype.g = function () {
        this.a.hf();
    };
    AxisLabelManager.$t = markType(AxisLabelManager, 'AxisLabelManager');
    return AxisLabelManager;
}(Base));
export { AxisLabelManager };
/**
 * @hidden
 */
var AxisLabelPanelBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisLabelPanelBase, _super);
    function AxisLabelPanelBase() {
        var _this = _super.call(this) || this;
        _this.cx = null;
        _this.bw = 0;
        _this.ad = null;
        _this.ak = false;
        _this.a3 = null;
        _this.ba = null;
        _this.c4 = null;
        _this.cw = Rect.empty;
        _this.cv = null;
        _this.c2 = null;
        _this.bc = 0;
        _this.bx = null;
        _this.bb = null;
        _this.a8 = null;
        _this.ag = null;
        _this.ao = false;
        _this.c3 = null;
        _this.ar = false;
        _this.av = false;
        _this.aw = false;
        _this.ax = false;
        _this.bz = null;
        _this.al = false;
        _this.bd = 50;
        _this.be = 0;
        _this.bf = 0;
        _this.c7 = new Size();
        _this.be = NaN;
        _this.c4 = Rect.empty;
        _this.c2 = Rect.empty;
        _this.c1 = Rect.empty;
        _this.af = _this.ae();
        _this.ch(_this.af);
        _this.af.an();
        _this.bb = new List$1(FrameworkElement.$, 0);
        _this.ba = new List$1(LabelPosition.$, 0);
        _this.a8 = new List$1(Rect.$, 0);
        _this.aw = false;
        _this.av = false;
        _this.ax = false;
        _this.ao = false;
        _this.ar = false;
        _this.c3 = Rect.empty;
        _this.ak = false;
        return _this;
    }
    AxisLabelPanelBase.prototype.ae = function () {
        return new AxisLabelPanelBaseView(this);
    };
    AxisLabelPanelBase.prototype.ch = function (a) {
    };
    AxisLabelPanelBase.prototype.b8 = function () {
    };
    AxisLabelPanelBase.prototype.cp = function () {
    };
    AxisLabelPanelBase.prototype.co = function () {
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "az", {
        get: function () {
            return this.ak;
        },
        set: function (a) {
            this.ak = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelPanelBase.prototype, "a9", {
        get: function () {
            return this.a3;
        },
        set: function (a) {
            var b = this.a3;
            this.a3 = a;
            if (b == null && b != a) {
                this.ce();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelPanelBase.prototype, "c5", {
        get: function () {
            return this.cw;
        },
        set: function (a) {
            var b = this.cw;
            this.cw = a;
            this.ct(b, this.cw);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelPanelBase.prototype, "c1", {
        get: function () {
            if (!this.c2.isEmpty) {
                return this.c2;
            }
            return this.cv;
        },
        set: function (a) {
            var b = this.cv;
            this.cv = a;
            this.cd(b, this.cv);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisLabelPanelBase.prototype, "bg", {
        get: function () {
            return this.bc;
        },
        set: function (a) {
            this.bc = a;
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.bn = function () {
        var a = 1.7976931348623157E+308;
        if (this.ba != null && this.ba.count > 1) {
            for (var b = 1; b < this.ba.count; b++) {
                var c = this.ba._inner[b];
                var d = this.ba._inner[b - 1];
                if (c.a || d.a) {
                    continue;
                }
                var e = Math.abs(c.c - d.c);
                if (e < a) {
                    a = e;
                }
            }
        }
        return a;
    };
    AxisLabelPanelBase.prototype.cl = function () {
        this.ar = false;
        this.c3 = Rect.empty;
    };
    AxisLabelPanelBase.prototype.an = function (a, b) {
        for (var c = 0; c < a.count - 1; c++) {
            if (b._inner[c]) {
                continue;
            }
            for (var d = c; d < a.count - 1; d++) {
                if (b._inner[d + 1]) {
                    continue;
                }
                if (a._inner[c].intersectsWith(a._inner[d + 1])) {
                    return true;
                }
            }
        }
        return false;
    };
    AxisLabelPanelBase.prototype.by = function (a, b, c) {
        return {
            ret: 0,
            p1: b
        };
    };
    AxisLabelPanelBase.prototype.a5 = function () {
        return null;
    };
    AxisLabelPanelBase.prototype.b6 = function () {
    };
    AxisLabelPanelBase.prototype.b2 = function (a) {
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "ap", {
        get: function () {
            return this.ag != null && this.ag.k();
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.bl = function () {
        if (this.ad.b4 && (!this.ap || (this.ap && this.ag.angle == 0))) {
            return this.ad.ew();
        }
        return this.ag != null ? this.ag.angle : 0;
    };
    AxisLabelPanelBase.prototype.bq = function () {
        return this.ad.bf != null ? this.ad.bf.angle : 0;
    };
    AxisLabelPanelBase.prototype.at = function (a, b) {
        if (a == 0 && !this.ad.b9 && this.ag != null) {
            if (this.ad.cp) {
                if (!this.ag.showFirstLabel && this.ad.bi.gq() == 1) {
                    return false;
                }
            }
            else {
                if (!this.ag.showFirstLabel && this.ad.bi.gp() == 1) {
                    return false;
                }
            }
        }
        return true;
    };
    AxisLabelPanelBase.prototype.bk = function (a) {
        return this.af.m(a);
    };
    AxisLabelPanelBase.prototype.bv = function (a) {
        return this.af.w(a);
    };
    AxisLabelPanelBase.prototype.bm = function (a) {
        return this.af.n(a);
    };
    AxisLabelPanelBase.prototype.bj = function (a) {
        return this.af.l(a);
    };
    AxisLabelPanelBase.prototype.aq = function () {
        return false;
    };
    AxisLabelPanelBase.prototype.ct = function (a, b) {
    };
    AxisLabelPanelBase.prototype.cd = function (a, b) {
    };
    AxisLabelPanelBase.prototype.a7 = function () {
        if (this.ab.count < 1 || this.ba.count == 0) {
            return new List$1(Rect.$, 0);
        }
        this.bb = new List$1(FrameworkElement.$, 0);
        this.a8 = new List$1(Rect.$, 0);
        this.b6();
        this.af.af();
        var a = this.bl();
        if (a % 360 == 0) {
            this.av = false;
        }
        if (this.bb.count == 0) {
            return new List$1(Rect.$, 0);
        }
        this.a8 = this.a5();
        this.a8 = this.a6(this.a8);
        this.ak = true;
        return this.a8;
    };
    AxisLabelPanelBase.prototype.a6 = function (a) {
        var _this = this;
        if (this.ad.cu || this.ad.cw) {
            var b = this.af.p();
            var c = this.af.r();
            var d = this.af.q();
            var e = this.af.o();
            var f = Math.max(b, Math.max(c, Math.max(d, e)));
            var g_1 = new Thickness(0, f);
            if (this.av) {
                g_1 = new Thickness(0, Math.sqrt((f * f) / 2));
            }
            var h = this.a4(a);
            var i = new List$1(Thickness.$, 0);
            if (h.count < 1) {
                return a;
            }
            h.aa(function (j, k) {
                var l = _this.cy(j, a._inner[j], g_1);
                var m = _this.cy(k, a._inner[k], g_1);
                var n = l.top;
                var o = m.top;
                if (n < o) {
                    return -1;
                }
                if (n > o) {
                    return 1;
                }
                return 0;
            });
            for (var j = 0; j < h.count; j++) {
                var k = h._inner[j];
                var l = a._inner[k];
                var m = this.cy(k, a._inner[k], g_1);
                var n = this.ad.bi.ty.top;
                if (this.ad.cw) {
                    if (l.top < (this.ad.bi.ty.top - n)) {
                        l = new Rect(0, l.left, l.top + ((this.ad.bi.ty.top - n) - l.top), l.width, l.height);
                        a._inner[k] = l;
                    }
                }
            }
            var o = this.as(a, h, g_1);
            if (o && (this.ad.cu)) {
                for (var p = 0; p < h.count - 1; p++) {
                    var q = h._inner[p];
                    var r = h._inner[p + 1];
                    var s = a._inner[q];
                    var t = a._inner[r];
                    var u = this.cy(q, a._inner[q], g_1);
                    var v = this.cy(r, a._inner[r], g_1);
                    if (u.intersectsWith(v) || u.top > v.bottom) {
                        var w = new Rect(0, t.left, u.bottom + 1 + (t.top - v.top), t.width, t.height);
                        a._inner[r] = w;
                    }
                }
            }
            for (var x = h.count - 1; x >= 0; x--) {
                var y = h._inner[x];
                var z = a._inner[y];
                var aa = this.cy(y, a._inner[y], g_1);
                var ab = this.ad.bi.cu.a3;
                if (this.ad.cw) {
                    if (aa.bottom > this.ad.bi.ty.bottom + ab) {
                        z = new Rect(0, z.left, z.top - (aa.bottom - (this.ad.bi.ty.bottom + ab)), z.width, z.height);
                        a._inner[y] = z;
                    }
                }
            }
            if (this.ad.cu) {
                for (var ac = h.count - 1; ac >= 1; ac--) {
                    var ad = h._inner[ac];
                    var ae = h._inner[ac - 1];
                    var af = a._inner[ad];
                    var ag = a._inner[ae];
                    var ah = this.cy(ad, a._inner[ad], g_1);
                    var ai = this.cy(ae, a._inner[ae], g_1);
                    if (ah.intersectsWith(ai) || ah.top < ai.bottom) {
                        var aj = new Rect(0, ag.left, ah.top - (ai.height + 1 + (ag.top - ai.top)), ag.width, ag.height);
                        a._inner[ae] = aj;
                    }
                }
            }
            return a;
        }
        else {
            return a;
        }
    };
    AxisLabelPanelBase.prototype.cy = function (a, b, c) {
        var d = this.ba._inner[a];
        var e = d.d;
        if (isNaN_(e.left) || isNaN_(e.top) || isNaN_(e.right) || isNaN_(e.bottom)) {
            e = c;
        }
        if (e.left > c.left || e.top > c.top || e.right > c.right || e.bottom > c.bottom) {
            e = c;
        }
        var f = new Rect(0, b.left - e.left, b.top - e.top, b.width + e.left + e.right, b.height + e.top + e.bottom);
        return f;
    };
    AxisLabelPanelBase.prototype.as = function (a, b, c) {
        if (b.count <= 1) {
            return false;
        }
        for (var d = 0; d < b.count - 1; d++) {
            var e = b._inner[d];
            var f = b._inner[d + 1];
            var g = a._inner[e];
            var h = a._inner[f];
            var i = this.cy(e, a._inner[e], c);
            var j = this.cy(f, a._inner[f], c);
            if (i.intersectsWith(j)) {
                return true;
            }
        }
        return false;
    };
    AxisLabelPanelBase.prototype.a4 = function (a) {
        var b = new List$1(Number_$type, 0);
        for (var c = 0; c < a.count; c++) {
            var d = this.ba._inner[c].a;
            if (d) {
                b.add(c);
            }
        }
        return b;
    };
    AxisLabelPanelBase.prototype.bp = function (a, b) {
        var c = a * (Math.PI / 180);
        var d = Math.abs(b.width * Math.cos(c)) + Math.abs(b.height * Math.sin(c));
        return d;
    };
    AxisLabelPanelBase.prototype.bo = function (a, b) {
        var c = a * (Math.PI / 180);
        var d = Math.abs(b.height * Math.cos(c)) + Math.abs(b.width * Math.sin(c));
        return d;
    };
    AxisLabelPanelBase.prototype.bt = function () {
        var a = this.af.k();
        return a;
    };
    AxisLabelPanelBase.prototype.br = function () {
        var a = this.af.j();
        return a;
    };
    AxisLabelPanelBase.prototype.bs = function () {
        if (this.ad.g6 == null || (this.ad.bf != null && this.ad.bf.visibility == 1)) {
            return 0;
        }
        var a = this.br();
        var b = this.bt();
        var c = new Rect(0, 0, 0, b, a);
        var d = this.bq();
        var e = RectUtil.w(c, d);
        return e.height + this.af.v() + this.af.s();
    };
    AxisLabelPanelBase.prototype.bu = function () {
        if (this.ad.g6 == null || (this.ad.bf != null && this.ad.bf.visibility == 1)) {
            return 0;
        }
        var a = this.br();
        var b = this.bt();
        var c = new Rect(0, 0, 0, b, a);
        var d = this.bq();
        var e = RectUtil.w(c, d);
        return e.width + this.af.t() + this.af.u();
    };
    AxisLabelPanelBase.prototype.c6 = function (a) {
        if (this.ad == null || this.ab.count == 0) {
            return a;
        }
        this.b5(a);
        this.b9();
        this.b4(a);
        this.a8 = this.a7();
        if (this.bb.count != this.a8.count) {
            return a;
        }
        var b = this.af.p();
        var c = this.af.r();
        var d = this.af.q();
        var e = this.af.o();
        if (this.av) {
            for (var f = 0; f < this.bb.count; f++) {
                if (this.at(f, this.a8._inner[f])) {
                    this.af.aa(this.bb._inner[f], this.a8._inner[f], b, c, d, e);
                }
                this.cm(this.bb._inner[f], this.bl());
            }
        }
        for (var g = 0; g < this.bb.count; g++) {
            if (!this.av) {
                this.af.ae(this.bb._inner[g]);
            }
            if (this.at(g, this.a8._inner[g])) {
                this.af.aa(this.bb._inner[g], this.a8._inner[g], b, c, d, e);
            }
            else {
                this.af.aa(this.bb._inner[g], new Rect(0, 0, 0, 0, 0), b, c, d, e);
            }
        }
        if (this.ad.bq.count > 0) {
            this.ad.a8.arrangeAnnotations(this.ad, this.af, this.bb, this.a8, this.av, this.bl(), b, c, d, e);
        }
        this.b2(a);
        if (this.aq() && this.am && this.ad != null && this.ad.bg != null && !this.ad.cr && this.ad.bg.uo && !this.ad.bg.uv && this.a8 != null && this.a8.count > 0) {
            var h = this.a8.count - 1;
            if (this.ad.bq.count > 0) {
                h -= this.ad.bq.count;
            }
            if (h < 0) {
                h = 0;
            }
            this.ad.bg.w9(this, this.c1, this.a8._inner[0], this.a8._inner[h]);
        }
        return a;
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "am", {
        get: function () {
            return this.ad.az != null && (this.ad.az.c != 5 && this.ad.az.c != 4);
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.c0 = function () {
        return Rect.empty;
    };
    AxisLabelPanelBase.prototype.b5 = function (a) {
        if (this.ad.is == null) {
            return;
        }
        this.af.ai(this.ad.is, new Size(1, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY));
        var b = Math.abs(this.bq() - 0) > 1E-06;
        var c = this.c0();
        var d = c.left + (c.width / 2);
        var e = c.top + (c.height / 2);
        var f = this.bt() + this.af.t() + this.af.u();
        var g = this.br() + this.af.v() + this.af.s();
        var h = f / 2;
        var i = g / 2;
        var j = new Rect(0, d - h, e - i, f, g);
        if (b) {
            this.cn(this.ad.is);
        }
        else {
            this.af.ae(this.ad.is);
        }
        this.af.aa(this.ad.is, j, this.af.t(), this.af.v(), this.af.u(), this.af.s());
        if ((this.ad.bf == null || this.ad.bf.visibility == 0) && (this.ad.az == null || this.ad.az.visibility == 0) && this.ad.g6 != null) {
            this.ad.is._visibility = 0;
        }
        else {
            this.ad.is._visibility = 1;
            this.af.aa(this.ad.is, new Rect(0, 0, 0, 0, 0), 0, 0, 0, 0);
        }
    };
    AxisLabelPanelBase.prototype.b4 = function (a) {
        this.af.ab(a);
    };
    AxisLabelPanelBase.prototype.b9 = function () {
    };
    AxisLabelPanelBase.prototype.a2 = function () {
        if (typeCast(CategoryAxisBase.$, this.ad) !== null) {
            return this.ad.ky;
        }
        if (typeCast(NumericAxisBase.$, this.ad) !== null) {
            var a = new List$1(Number_$type, 0);
            var d = this.ad.k5.j();
            for (var c = 0; c < d.length; c++) {
                var b = d[c];
                var e = this.ad.j8();
                var f = new ScalerParams(0, this.ad.bi.tz, this.ad.kd, this.ad.ci, e);
                a.add(this.ad.ej(b, f));
            }
            return a;
        }
        return null;
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "ah", {
        get: function () {
            var a = this.ag != null ? this.ag.c : this.ai();
            if (this.ad.aj == null) {
                if (a == 4) {
                    a = 5;
                }
                else if (a == 5) {
                    a = 4;
                }
                else if (a == 6) {
                    a = 7;
                }
                else if (a == 7) {
                    a = 6;
                }
            }
            return a;
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.cs = function (a, b, c, d, e, f) {
        var g = b;
        var h = b;
        if (f != null) {
            var i = f.c / 2;
            g -= i;
            h += i;
        }
        if (h >= e.left && g <= e.right) {
            if (f.a) {
                b = this.ad.d0(b, e.left, e.right, f);
            }
            var j = new LineGeometry();
            j.d = { $type: Point_$type, x: b, y: c };
            j.c = { $type: Point_$type, x: b, y: d };
            a.add(j);
        }
    };
    AxisLabelPanelBase.prototype.cc = function (a, b, c, d, e, f) {
        if (b <= e.bottom && b >= e.top) {
            if (f.a) {
                b = this.ad.d0(b, e.top, e.bottom, f);
            }
            var g = new LineGeometry();
            g.d = { $type: Point_$type, x: c, y: b };
            g.c = { $type: Point_$type, x: d, y: b };
            a.add(g);
        }
    };
    AxisLabelPanelBase.prototype.cm = function (a, b) {
        var c = this.bl();
        this.af.aj(a, c);
    };
    AxisLabelPanelBase.prototype.get_au = function () {
        return false;
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "au", {
        get: function () {
            return this.get_au();
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.ac = function (a, b) {
        var c = a.height;
        var d = a.width;
        var e = 0 + a.left;
        var f = (c / 2) + a.top;
        var g = new TransformGroup();
        var h = AngleSimplifier.a(b);
        var i = ((function () {
            var $ret = new RotateTransform();
            $ret.j = h;
            $ret.k = e;
            $ret.l = f;
            return $ret;
        })());
        var j = 0;
        var k = 0;
        if (h != 0 && h != 360) {
            if (h > 0 && h < 180) {
                j = -Math.sin(MathUtil.o(h)) * (c / 2);
            }
            else {
                i.k = d;
                k = -d;
                j = -Math.sin(MathUtil.o(h - 180)) * (c / 2);
            }
        }
        var l = ((function () {
            var $ret = new TranslateTransform();
            $ret.k = j;
            $ret.j = k;
            return $ret;
        })());
        g.j.add(i);
        g.j.add(l);
        var m = TransformMatrixHelpler.f(g);
        var n = RectUtil.n(a);
        var o = RectUtil.o(a);
        var p = RectUtil.k(a);
        var q = RectUtil.j(a);
        var r = TransformMatrixHelpler.i(m, n);
        var s = TransformMatrixHelpler.i(m, o);
        var t = TransformMatrixHelpler.i(m, p);
        var u = TransformMatrixHelpler.i(m, q);
        var v = new Array(4);
        v[0] = r;
        v[1] = s;
        v[2] = t;
        v[3] = u;
        return v;
    };
    AxisLabelPanelBase.prototype.cz = function (a, b) {
        var c = this.ac(a, b);
        var d = 1.7976931348623157E+308;
        var e = 1.7976931348623157E+308;
        var f = -1.7976931348623157E+308;
        var g = -1.7976931348623157E+308;
        for (var h = 0; h < c.length; h++) {
            d = c[h].x < d ? c[h].x : d;
            e = c[h].y < e ? c[h].y : e;
            f = c[h].x > f ? c[h].x : f;
            g = c[h].y > g ? c[h].y : g;
        }
        return new Rect(0, d, e, Math.max(f - d, 0), Math.max(g - e, 0));
    };
    AxisLabelPanelBase.prototype.cn = function (a) {
        var b = this.bq();
        this.cb(a, b);
    };
    AxisLabelPanelBase.prototype.cb = function (a, b) {
        var c = typeCast(FrameworkElement.$, a);
        var d = this.br();
        var e = this.bt();
        var f = 0.5 * e;
        var g = 0.5 * d;
        var h = ((function () {
            var $ret = new RotateTransform();
            $ret.j = b;
            $ret.k = f;
            $ret.l = g;
            return $ret;
        })());
        var i = new TransformGroup();
        i.j.add(h);
        c.j = i;
    };
    AxisLabelPanelBase.prototype.c8 = function (a) {
        var e_24, _a;
        if ((this.ab.contains(this.ad.is) == false) && this.ad.is != null) {
            this.ab.add(this.ad.is);
            AxisLabelManager.m(this.ad.is, this.ad.bf);
        }
        try {
            for (var _b = __values(fromEnum(this.ab)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                if (b != this.ad.is && b != this.af.aw) {
                    this.af.ah(b);
                }
            }
        }
        catch (e_24_1) {
            e_24 = { error: e_24_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_24)
                    throw e_24.error;
            }
        }
        var c = (this.ad == null || this.bd <= 0 || isNaN_(this.bd)) ? 50 : this.bd;
        if (this.ad != null && (this.ad.de == null || this.ad.de.count == 0)) {
            if (this.ad.b8()) {
                c = this.ad.ep();
            }
        }
        var d = this.aq();
        c = Math.min(c, d ? a.height : a.width);
        c = isInfinity(c) ? 50 : c;
        return d ? new Size(1, 50, c) : new Size(1, c, 50);
    };
    Object.defineProperty(AxisLabelPanelBase.prototype, "bh", {
        get: function () {
            return this.c(AxisLabelPanelBase.cu);
        },
        set: function (a) {
            this.h(AxisLabelPanelBase.cu, a);
        },
        enumerable: false,
        configurable: true
    });
    AxisLabelPanelBase.prototype.aj = function (a) {
        if (a == null) {
            return this.ad.bi.ap(this.ad);
        }
        if (a.position == 0) {
            if (this.ad != null && this.ad.bi != null) {
                return this.ad.bi.ap(this.ad);
            }
            return 4;
        }
        return a.position;
    };
    AxisLabelPanelBase.prototype.ai = function () {
        return 1;
    };
    AxisLabelPanelBase.prototype.ay = function (a) {
        return true;
    };
    AxisLabelPanelBase.prototype._a0 = function () {
        var _a, _b, a, e_25_1;
        var e_25, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, 6, 7]);
                    _a = __values(fromEnum(this.ab)), _b = _a.next();
                    _d.label = 1;
                case 1:
                    if (!!_b.done)
                        return [3 /*break*/, 4];
                    a = _b.value;
                    if (!(a != this.ad.is && a != this.af.aw))
                        return [3 /*break*/, 3];
                    return [4 /*yield*/, a];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_25_1 = _d.sent();
                    e_25 = { error: e_25_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_c = _a.return))
                            _c.call(_a);
                    }
                    finally {
                        if (e_25)
                            throw e_25.error;
                    }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    AxisLabelPanelBase.prototype.a0 = function () {
        var _this = this;
        return toEnum(function () { return _this._a0(); });
    };
    AxisLabelPanelBase.prototype.b1 = function (a, b, c, d, e) {
        var f = this.af.x(b, c, d, e);
        return f;
    };
    AxisLabelPanelBase.prototype.b7 = function (a) {
        if (this.bz == null || this.bk(this.bz) < this.bk(a)) {
            this.bz = a;
        }
    };
    AxisLabelPanelBase.prototype.cg = function (a) {
        this.bb.add(a);
    };
    AxisLabelPanelBase.prototype._a1 = function () {
        var a, b;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    a = 0;
                    _a.label = 1;
                case 1:
                    if (!(a < this.ad.br.count))
                        return [3 /*break*/, 4];
                    return [4 /*yield*/, this.ad.br.item(a)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    a++;
                    return [3 /*break*/, 1];
                case 4:
                    b = 0;
                    _a.label = 5;
                case 5:
                    if (!(b < this.ad.bq.count))
                        return [3 /*break*/, 8];
                    return [4 /*yield*/, this.ad.bq.item(b)];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7:
                    b++;
                    return [3 /*break*/, 5];
                case 8: return [2 /*return*/];
            }
        });
    };
    AxisLabelPanelBase.prototype.a1 = function () {
        var _this = this;
        return toEnum(function () { return _this._a1(); });
    };
    AxisLabelPanelBase.prototype.ca = function () {
        this.af.ag();
        this.cr();
    };
    AxisLabelPanelBase.prototype.cr = function () {
        this.a8 = this.a7();
    };
    AxisLabelPanelBase.prototype.ce = function () {
    };
    AxisLabelPanelBase.prototype.bi = function (a) {
        return this.bd;
    };
    AxisLabelPanelBase.prototype.ci = function () {
        this.c2 = new Rect(0, 0, 0, this.c7.width, this.c7.height);
    };
    AxisLabelPanelBase.prototype.cq = function () {
        this.c2 = Rect.empty;
    };
    AxisLabelPanelBase.prototype.cf = function () {
        this.af.ak();
    };
    AxisLabelPanelBase.prototype.cj = function (a) {
        this.af.al(a);
    };
    AxisLabelPanelBase.prototype.b3 = function () {
        this.af.y();
    };
    AxisLabelPanelBase.prototype.ck = function () {
        this.af.ao();
    };
    AxisLabelPanelBase.$t = markType(AxisLabelPanelBase, 'AxisLabelPanelBase', Panel.$);
    AxisLabelPanelBase.cu = DependencyProperty.i("Extent", Number_$type, AxisLabelPanelBase.$, new PropertyMetadata(2, 50, function (a, b) { return a.bd = b.newValue; }));
    return AxisLabelPanelBase;
}(Panel));
export { AxisLabelPanelBase };
/**
 * @hidden
 */
var CategoryAxisBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryAxisBase, _super);
    function CategoryAxisBase() {
        var _this = _super.call(this) || this;
        _this.ky = null;
        _this.kq = null;
        _this.ld = 0;
        _this.lf = 0;
        _this.ko = 0;
        _this.k0 = 1;
        _this.le = 0;
        _this.ks = false;
        _this.ky = new List$1(Number_$type, 0);
        return _this;
    }
    CategoryAxisBase.prototype.a4 = function () {
        return new CategoryAxisBaseView(this);
    };
    CategoryAxisBase.prototype.ag = function () {
        return [0, this.lg - 1];
    };
    CategoryAxisBase.prototype.get_cd = function () {
        return false;
    };
    CategoryAxisBase.prototype.hs = function (a) {
        _super.prototype.hs.call(this, a);
        this.kn = a;
    };
    CategoryAxisBase.prototype.eg = function (a, b, c, d) {
        var e = this.getCategorySize(b, c, d);
        var f = e * a;
        return f;
    };
    CategoryAxisBase.prototype.c8 = function (a, b, c) {
        var d = _super.prototype.c8.call(this, a, b, c);
        if (!d) {
            return false;
        }
        return this.itemsSource != null && this.lf > 0;
    };
    CategoryAxisBase.prototype.l1 = function () {
        if (this.kr != null && this.bo != null && this.itemsSource != null) {
            this.kr = this.bo.releaseFastItemsSource(this.itemsSource);
        }
    };
    CategoryAxisBase.prototype.l0 = function () {
        if (this.kr == null && this.bo != null && this.itemsSource != null) {
            this.kr = this.bo.getFastItemsSource(this.itemsSource);
        }
    };
    CategoryAxisBase.prototype.get_cb = function () {
        return true;
    };
    CategoryAxisBase.prototype.me = function (a, b, c) {
        if (this.b9) {
            return Rect.empty;
        }
        return this.mf(a, b, c, this.cp);
    };
    CategoryAxisBase.prototype.mf = function (a, b, c, d) {
        var e = 0;
        var f = a.x;
        var g = this.kd.left;
        var h = this.kd.right;
        if (d) {
            f = a.y;
            g = this.kd.top;
            h = this.kd.bottom;
        }
        var i = this.ky;
        if ((d && !this.ch) || (!d && this.ch)) {
            i = new List$1(Number_$type, 0);
            for (var j = this.ky.count - 1; j >= 0; j--) {
                i.add(this.ky._inner[j]);
            }
        }
        if (this.categoryMode == 0) {
            if (b) {
                var k = void 0;
                if (d) {
                    k = new Rect(0, this.kd.left, a.y - c / 2, this.kd.width, c);
                }
                else {
                    k = new Rect(0, a.x - c / 2, this.kd.top, c, this.kd.height);
                }
                k.intersect(this.kd);
                return k;
            }
            else {
                if (f > h) {
                    return Rect.empty;
                }
                if (f < g) {
                    return Rect.empty;
                }
                var l = 1.7976931348623157E+308;
                var m = -1;
                for (e = 0; e < i.count; e++) {
                    var n = Math.abs(i._inner[e] - f);
                    if (n < l) {
                        l = n;
                        m = e;
                    }
                }
                if (m == -1) {
                    return Rect.empty;
                }
                var o = i._inner[m];
                var p = void 0;
                if (d) {
                    p = new Rect(0, this.kd.left, o - c / 2, this.kd.width, c);
                }
                else {
                    p = new Rect(0, o - c / 2, this.kd.top, c, this.kd.height);
                }
                p.intersect(this.kd);
                return p;
            }
        }
        else {
            for (e = 0; e < i.count; e++) {
                if (i._inner[e] > f) {
                    break;
                }
            }
            if (e == 0) {
                return Rect.empty;
            }
            if (f > h) {
                return Rect.empty;
            }
            if (f < g) {
                return Rect.empty;
            }
            var q = this.kd.right;
            if (d) {
                q = this.kd.bottom;
            }
            if (e < i.count) {
                q = i._inner[e];
            }
            if (d) {
                return new Rect(0, this.kd.left, i._inner[e - 1], this.kd.width, q - i._inner[e - 1]);
            }
            else {
                return new Rect(0, i._inner[e - 1], this.kd.top, q - i._inner[e - 1], this.kd.height);
            }
        }
    };
    Object.defineProperty(CategoryAxisBase.prototype, "itemsSource", {
        get: function () {
            return this.c(CategoryAxisBase.l9);
        },
        set: function (a) {
            this.h(CategoryAxisBase.l9, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryAxisBase.prototype, "lg", {
        get: function () {
            return this.ld;
        },
        set: function (a) {
            this.ld = a;
            this.lf = this.ld;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryAxisBase.prototype, "categoryMode", {
        get: function () {
            return this.ko;
        },
        set: function (a) {
            if (this.ko != a) {
                var b = this.ko;
                this.ko = a;
                this.h2("CategoryMode", enumGetBox(CategoryMode_$type, b), enumGetBox(CategoryMode_$type, a));
            }
        },
        enumerable: false,
        configurable: true
    });
    CategoryAxisBase.prototype.lb = function (a, b, c) {
        var d = !isNaN_(this.k1) ? MathUtil.d(this.k1, 0, this.k0) : 0;
        if (!this.b9 && this.k9 > 0) {
            var e = this.getCategorySize(a, b, c);
            var f = 0.5 * d;
            var g = e * f;
            if (g < this.k9) {
                g = this.k9;
                f = g / e;
                d = f / 0.5;
                d = MathUtil.d(d, 0, this.k0);
            }
        }
        return d;
    };
    Object.defineProperty(CategoryAxisBase.prototype, "lh", {
        get: function () {
            return this.le;
        },
        set: function (a) {
            if (a != this.le) {
                var b = this.le;
                this.le = a;
                this.h2("GroupCount", b, this.le);
            }
        },
        enumerable: false,
        configurable: true
    });
    CategoryAxisBase.prototype.em = function (a, b) {
        return NaN;
    };
    CategoryAxisBase.prototype.getUnscaledValue3 = function (a, b, c, d) {
        return NaN;
    };
    CategoryAxisBase.prototype.getCategorySize = function (a, b, c) {
        return NaN;
    };
    CategoryAxisBase.prototype.k4 = function (a, b, c) {
        return NaN;
    };
    CategoryAxisBase.prototype.getGroupCenter = function (a, b, c, d) {
        return NaN;
    };
    CategoryAxisBase.prototype.lc = function (a) {
        var b = this.bi.tz;
        var c = this.kd;
        var d = this.j8();
        var e = new ScalerParams(0, b, c, this.ch, d);
        return this.em(a, e);
    };
    CategoryAxisBase.prototype._kx = function () {
        var _a, _b, a, e_26_1, _c, _d, b, _e, _f, c, e_27_1, e_28_1;
        var e_26, _g, e_28, _h, e_27, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 5, 6, 7]);
                    _a = __values(fromEnum(this.de)), _b = _a.next();
                    _k.label = 1;
                case 1:
                    if (!!_b.done)
                        return [3 /*break*/, 4];
                    a = _b.value;
                    return [4 /*yield*/, a];
                case 2:
                    _k.sent();
                    _k.label = 3;
                case 3:
                    _b = _a.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_26_1 = _k.sent();
                    e_26 = { error: e_26_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_b && !_b.done && (_g = _a.return))
                            _g.call(_a);
                    }
                    finally {
                        if (e_26)
                            throw e_26.error;
                    }
                    return [7 /*endfinally*/];
                case 7:
                    if (!(this.bi != null && this.bi.en && this.ku(this.bi)))
                        return [3 /*break*/, 21];
                    _k.label = 8;
                case 8:
                    _k.trys.push([8, 19, 20, 21]);
                    _c = __values(fromEnum(this.bi.fn())), _d = _c.next();
                    _k.label = 9;
                case 9:
                    if (!!_d.done)
                        return [3 /*break*/, 18];
                    b = _d.value;
                    if (!(b != this.bi))
                        return [3 /*break*/, 17];
                    _k.label = 10;
                case 10:
                    _k.trys.push([10, 15, 16, 17]);
                    _e = (e_27 = void 0, __values(fromEnum(b.series))), _f = _e.next();
                    _k.label = 11;
                case 11:
                    if (!!_f.done)
                        return [3 /*break*/, 14];
                    c = _f.value;
                    return [4 /*yield*/, c];
                case 12:
                    _k.sent();
                    _k.label = 13;
                case 13:
                    _f = _e.next();
                    return [3 /*break*/, 11];
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_27_1 = _k.sent();
                    e_27 = { error: e_27_1 };
                    return [3 /*break*/, 17];
                case 16:
                    try {
                        if (_f && !_f.done && (_j = _e.return))
                            _j.call(_e);
                    }
                    finally {
                        if (e_27)
                            throw e_27.error;
                    }
                    return [7 /*endfinally*/];
                case 17:
                    _d = _c.next();
                    return [3 /*break*/, 9];
                case 18: return [3 /*break*/, 21];
                case 19:
                    e_28_1 = _k.sent();
                    e_28 = { error: e_28_1 };
                    return [3 /*break*/, 21];
                case 20:
                    try {
                        if (_d && !_d.done && (_h = _c.return))
                            _h.call(_c);
                    }
                    finally {
                        if (e_28)
                            throw e_28.error;
                    }
                    return [7 /*endfinally*/];
                case 21: return [2 /*return*/];
            }
        });
    };
    CategoryAxisBase.prototype.kx = function () {
        var _this = this;
        return toEnum(function () { return _this._kx(); });
    };
    CategoryAxisBase.prototype.kt = function (a) {
        return this.de.contains(a);
    };
    CategoryAxisBase.prototype.ku = function (a) {
        return false;
    };
    CategoryAxisBase.prototype._kw = function () {
        var a, _a, _b, b, c, _c, _d, d, e_29_1, e_30_1;
        var e_30, _e, e_29, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    a = typeCast(XamDataChart.$, this.bi);
                    if (!(a != null && a.en && this.ku(a)))
                        return [3 /*break*/, 14];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 12, 13, 14]);
                    _a = __values(fromEnum(a.fn())), _b = _a.next();
                    _g.label = 2;
                case 2:
                    if (!!_b.done)
                        return [3 /*break*/, 11];
                    b = _b.value;
                    if (!(b != this.bi))
                        return [3 /*break*/, 10];
                    c = typeCast(XamDataChart.$, b);
                    if (!(c != null))
                        return [3 /*break*/, 10];
                    _g.label = 3;
                case 3:
                    _g.trys.push([3, 8, 9, 10]);
                    _c = (e_29 = void 0, __values(fromEnum(c.axes))), _d = _c.next();
                    _g.label = 4;
                case 4:
                    if (!!_d.done)
                        return [3 /*break*/, 7];
                    d = _d.value;
                    if (!(typeCast(CategoryAxisBase.$, d) !== null))
                        return [3 /*break*/, 6];
                    return [4 /*yield*/, typeCast(CategoryAxisBase.$, d)];
                case 5:
                    _g.sent();
                    _g.label = 6;
                case 6:
                    _d = _c.next();
                    return [3 /*break*/, 4];
                case 7: return [3 /*break*/, 10];
                case 8:
                    e_29_1 = _g.sent();
                    e_29 = { error: e_29_1 };
                    return [3 /*break*/, 10];
                case 9:
                    try {
                        if (_d && !_d.done && (_f = _c.return))
                            _f.call(_c);
                    }
                    finally {
                        if (e_29)
                            throw e_29.error;
                    }
                    return [7 /*endfinally*/];
                case 10:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 11: return [3 /*break*/, 14];
                case 12:
                    e_30_1 = _g.sent();
                    e_30 = { error: e_30_1 };
                    return [3 /*break*/, 14];
                case 13:
                    try {
                        if (_b && !_b.done && (_e = _a.return))
                            _e.call(_a);
                    }
                    finally {
                        if (e_30)
                            throw e_30.error;
                    }
                    return [7 /*endfinally*/];
                case 14: return [2 /*return*/];
            }
        });
    };
    CategoryAxisBase.prototype.kw = function () {
        var _this = this;
        return toEnum(function () { return _this._kw(); });
    };
    CategoryAxisBase.prototype.l5 = function (a) {
        var e_31, _a, e_32, _b;
        if (this.ks) {
            return;
        }
        try {
            this.ks = true;
            var b = 0;
            var c = 0;
            var d = false;
            try {
                for (var _c = __values(fromEnum(this.kx())), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var e = _d.value;
                    if (!e.dj && !e.ed && !e.ds) {
                        continue;
                    }
                    var f = e;
                    var g = f.preferredCategoryMode(this);
                    if (g == 2) {
                        b = 2;
                        d = true;
                        if (this.kt(e)) {
                            c++;
                        }
                    }
                    if (g == 1 && !d) {
                        b = 1;
                    }
                }
            }
            catch (e_31_1) {
                e_31 = { error: e_31_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_31)
                        throw e_31.error;
                }
            }
            var h = this.kv;
            try {
                for (var _e = __values(fromEnum(this.kw())), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var i = _f.value;
                    if (i.kv) {
                        h = true;
                    }
                    if (a) {
                        i.l5(false);
                    }
                }
            }
            catch (e_32_1) {
                e_32 = { error: e_32_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_32)
                        throw e_32.error;
                }
            }
            if (b == 0 && h) {
                b = 2;
                if (c == 0) {
                    c = 1;
                }
            }
            this.categoryMode = b;
            this.lh = c;
        }
        finally {
            this.ks = false;
        }
    };
    CategoryAxisBase.prototype.hw = function (a, b, c, d) {
        var e_33, _a, e_34, _b, e_35, _c;
        _super.prototype.hw.call(this, a, b, c, d);
        switch (b) {
            case "FastItemsSourceProvider":
                if ((typeCast(IFastItemsSourceProvider_$type, c)) != null) {
                    this.kr = c.releaseFastItemsSource(this.itemsSource);
                }
                if ((typeCast(IFastItemsSourceProvider_$type, d)) != null) {
                    this.kr = d.getFastItemsSource(this.itemsSource);
                }
                this.lg = 0;
                if (this.kr != null) {
                    this.lg = this.kr.count;
                }
                this.l5(true);
                break;
            case "ItemsSource":
                if (this.bo != null) {
                    this.kr = this.bo.getFastItemsSource(this.itemsSource);
                }
                break;
            case CategoryAxisBase.$$p[0]:
                var e = typeCast(IFastItemsSource_$type, c);
                this.ls();
                this.cq = true;
                if (e != null) {
                    e.event = delegateRemove(e.event, runOn(this, this.lv));
                }
                this.lg = 0;
                if (this.kr != null) {
                    this.lg = this.kr.count;
                }
                if (this.kr != null) {
                    var f = this.kr;
                    f.event = delegateCombine(f.event, runOn(this, this.lv));
                    this.h8(false);
                    try {
                        for (var _d = __values(fromEnum(this.db())), _e = _d.next(); !_e.done; _e = _d.next()) {
                            var g = _e.value;
                            g.mn(false);
                            if (g.ce != null) {
                                g.lu();
                            }
                        }
                    }
                    catch (e_33_1) {
                        e_33 = { error: e_33_1 };
                    }
                    finally {
                        try {
                            if (_e && !_e.done && (_a = _d.return))
                                _a.call(_d);
                        }
                        finally {
                            if (e_33)
                                throw e_33.error;
                        }
                    }
                    if (this.bi != null && this.bi.e1) {
                        this.bi.ou();
                    }
                }
                else {
                    this.hh();
                    try {
                        for (var _f = __values(fromEnum(this.db())), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var h = _g.value;
                            h.k2(true, h.b1);
                            if (h.ce != null) {
                                h.lu();
                            }
                        }
                    }
                    catch (e_34_1) {
                        e_34 = { error: e_34_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_34)
                                throw e_34.error;
                        }
                    }
                }
                break;
            case "ItemsCount":
                this.h3(new AxisRangeChangedEventArgs(0, 0, 0, typeGetValue((c)) - 1, typeGetValue((d)) - 1));
                this.h8(false);
                break;
            case CategoryAxisBase.$$p[5]:
                this.cq = true;
                this.l6();
                this.h8(false);
                this.lt();
                break;
            case "CategoryMode":
                this.cq = true;
                this.h8(false);
                this.l3();
                this.lt();
                break;
            case CategoryAxisBase.$$p[4]:
            case CategoryAxisBase.$$p[3]:
            case CategoryAxisBase.$$p[2]:
            case CategoryAxisBase.$$p[1]:
                this.k0 = this.k8;
                this.cq = true;
                try {
                    for (var _h = __values(fromEnum(this.db())), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var i = _j.value;
                        i.e3 = true;
                        var j = typeCast(IHasCategoryModePreference_$type, i);
                        if (j != null && j.preferredCategoryMode(this) == 2) {
                            i.mn(false);
                        }
                    }
                }
                catch (e_35_1) {
                    e_35 = { error: e_35_1 };
                }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return))
                            _c.call(_h);
                    }
                    finally {
                        if (e_35)
                            throw e_35.error;
                    }
                }
                this.h8(false);
                if (this.bi != null) {
                    this.bi.mr();
                }
                break;
            case Axis.$$p[4]:
            case Axis.$$p[3]:
                this.cq = true;
                this.h8(true);
                break;
        }
    };
    CategoryAxisBase.prototype.lt = function () {
        var e_36, _a;
        try {
            for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a.mn(false);
            }
        }
        catch (e_36_1) {
            e_36 = { error: e_36_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_36)
                    throw e_36.error;
            }
        }
    };
    CategoryAxisBase.prototype.lv = function (a, b) {
        this.l2(b);
    };
    CategoryAxisBase.prototype.l2 = function (a) {
        switch (a.action) {
            case 3:
            case 0:
            case 1:
            case 2:
            case 4:
                if (this.kr != null) {
                    this.lg = this.kr.count;
                }
                this.h8(false);
                break;
        }
        if (this.kr != null) {
            this.lg = this.kr.count;
        }
    };
    CategoryAxisBase.prototype.l6 = function () {
        var e_37, _a;
        var a = false, b = false;
        try {
            for (var _b = __values(fromEnum(this.de)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                var d = typeCast(IHasCategoryModePreference_$type, c);
                if (d == null) {
                    continue;
                }
                var e = d.preferredCategoryMode(this);
                a = a || e == 1;
                b = b || e == 2;
            }
        }
        catch (e_37_1) {
            e_37 = { error: e_37_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_37)
                    throw e_37.error;
            }
        }
        var f = b ? 2 : a ? 1 : 0;
        if (f == 0 && this.kv) {
            f = 1;
            if (this.lh == 0) {
                this.lh = 1;
            }
        }
        this.categoryMode = f;
    };
    CategoryAxisBase.prototype.ct = function (a) {
        var e_38, _a;
        var b = _super.prototype.ct.call(this, a);
        if (b) {
            this.l5(true);
            var c = typeCast(IHasCategoryModePreference_$type, a);
            if (c != null && c.preferredCategoryMode(this) == 2) {
                try {
                    for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var d = _c.value;
                        var e = typeCast(IHasCategoryModePreference_$type, d);
                        if (e != null && e != c && e.preferredCategoryMode(this) == 2) {
                            d.mn(false);
                        }
                    }
                }
                catch (e_38_1) {
                    e_38 = { error: e_38_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_38)
                            throw e_38.error;
                    }
                }
            }
            this.h8(false);
            this.c1();
        }
        return b;
    };
    CategoryAxisBase.prototype.b0 = function (a) {
        var e_39, _a;
        var b = _super.prototype.b0.call(this, a);
        if (b) {
            this.l5(true);
            var c = typeCast(IHasCategoryModePreference_$type, a);
            if (c != null && c.preferredCategoryMode(this) != 0) {
                try {
                    for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var d = _c.value;
                        var e = typeCast(IHasCategoryModePreference_$type, d);
                        if (e != null) {
                            d.mn(false);
                        }
                    }
                }
                catch (e_39_1) {
                    e_39 = { error: e_39_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_39)
                            throw e_39.error;
                    }
                }
            }
            this.h8(false);
        }
        return b;
    };
    CategoryAxisBase.prototype.l3 = function () {
        var e_40, _a;
        var a = null;
        try {
            for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                if (b.dj) {
                    var c = b.ao(this);
                    if (c != null && c.aj == this) {
                        a = c;
                    }
                }
            }
        }
        catch (e_40_1) {
            e_40 = { error: e_40_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_40)
                    throw e_40.error;
            }
        }
        if (a != null) {
            a.h7();
        }
    };
    CategoryAxisBase.prototype.ls = function () {
        this.kq = this.kr;
    };
    CategoryAxisBase.prototype.l4 = function () {
        var a = this.az;
        if (a == null) {
            a = new AxisLabelSettings();
        }
        if (a.visibility == 1) {
            this.br.count = 0;
            this.bq.count = 0;
            this.bp.count = 0;
        }
        else {
            var b = 0;
            b = this.kn.bi(this.dc);
            this.br.count = b;
        }
    };
    CategoryAxisBase.prototype.lu = function (a) {
        if (this.kr != null) {
            this.kr.handleCollectionChanged(a);
        }
    };
    CategoryAxisBase.prototype.lz = function (a, b, c) {
        this.lu(new NotifyCollectionChangedEventArgs(2, 2, c, b, a));
    };
    CategoryAxisBase.prototype.lw = function () {
        this.lu(new NotifyCollectionChangedEventArgs(0, 4));
    };
    CategoryAxisBase.prototype.lx = function (a, b) {
        this.lu(new NotifyCollectionChangedEventArgs(1, 0, b, a));
    };
    CategoryAxisBase.prototype.ly = function (a, b) {
        this.lu(new NotifyCollectionChangedEventArgs(1, 1, b, a));
    };
    CategoryAxisBase.prototype.k5 = function (a, b, c, d) {
        return this.k6(a, b, c, d, this.categoryMode);
    };
    CategoryAxisBase.prototype.k6 = function (a, b, c, d, e) {
        var f = 0;
        var g = e;
        if (g == 0 && this.categoryMode != 0) {
            g = 1;
        }
        switch (g) {
            case 0:
                f = 0;
                break;
            case 1:
                f = 0.5 * this.getCategorySize(a, b, c);
                break;
            case 2:
                f = this.getGroupCenter(d, a, b, c);
                break;
        }
        if (this.cp != this.ch) {
            f *= -1;
        }
        return f;
    };
    CategoryAxisBase.prototype.getSeriesOffset = function (a, b, c, d, e) {
        return this.k6(a, b, c, d, e);
    };
    Object.defineProperty(CategoryAxisBase.prototype, "isVertical", {
        get: function () {
            return this.cp;
        },
        enumerable: false,
        configurable: true
    });
    CategoryAxisBase.prototype.j$d = function (a, b) {
        return this.em.apply(this, arguments);
    };
    CategoryAxisBase.prototype.j$c = function (a, b) {
        return this.ej.apply(this, arguments);
    };
    CategoryAxisBase.prototype.j$e = function (a, b, c, d, e) {
        this.hm.apply(this, arguments);
    };
    CategoryAxisBase.prototype.j$f = function (a, b, c, d) {
        this.hn.apply(this, arguments);
    };
    CategoryAxisBase.prototype.j$g = function (a, b, c, d) {
        this.ho.apply(this, arguments);
    };
    Object.defineProperty(CategoryAxisBase.prototype, "j$b", {
        get: function () {
            return this.ch;
        },
        enumerable: false,
        configurable: true
    });
    CategoryAxisBase.prototype.j$a = function () {
        return this.ag.apply(this, arguments);
    };
    CategoryAxisBase.$t = markType(CategoryAxisBase, 'CategoryAxisBase', Axis.$, [ICategoryScaler_$type]);
    CategoryAxisBase.l9 = DependencyProperty.i("ItemsSource", IEnumerable_$type, CategoryAxisBase.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(CategoryAxisBase.$, a);
        if (c.bo != null) {
            c.bo.releaseFastItemsSource(b.oldValue);
        }
        a.h2("ItemsSource", b.oldValue, b.newValue);
    }));
    CategoryAxisBase.$$p = markDep(DependencyProperty, PropertyMetadata, CategoryAxisBase, 'h2', ['FastItemsSource:kr:l7', [IFastItemsSource_$type], 'Gap:k1:l8', [1, 0.2], 'MaximumGap:k8:ma', [1, 1], 'MinimumGapSize:k9:mb', [1, 0], 'Overlap:la:mc', [1, 0], 'UseClusteringMode:kv:md', [0, false]]);
    return CategoryAxisBase;
}(Axis));
export { CategoryAxisBase };
/**
 * @hidden
 */
var HorizontalAxisLabelPanelBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(HorizontalAxisLabelPanelBase, _super);
    function HorizontalAxisLabelPanelBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dl = 0;
        _this.di = 0;
        _this.dk = 0;
        _this.dj = 0;
        return _this;
    }
    HorizontalAxisLabelPanelBase.prototype.ae = function () {
        return new HorizontalAxisLabelPanelBaseView(this);
    };
    HorizontalAxisLabelPanelBase.prototype.ch = function (a) {
        _super.prototype.ch.call(this, a);
        this.c9 = a;
    };
    HorizontalAxisLabelPanelBase.prototype.b6 = function () {
        this.c9.a1();
    };
    HorizontalAxisLabelPanelBase.prototype.db = function () {
        return ((this.ag != null && this.ag.k()) || this.ad.b4) && this.bl() % 360 != 0;
    };
    HorizontalAxisLabelPanelBase.prototype.dc = function () {
        return this.ao && !this.av;
    };
    HorizontalAxisLabelPanelBase.prototype.aq = function () {
        return true;
    };
    HorizontalAxisLabelPanelBase.prototype.a5 = function () {
        var _this = this;
        var a = new List$1(Rect.$, 0);
        var b = new List$1(Boolean_$type, 0);
        this.aw = false;
        this.av = false;
        this.ax = false;
        var c = this.bl();
        var d = c * Math.PI / 180;
        if (this.db()) {
            this.av = true;
        }
        this.ao = false;
        this.dn(a, b, d);
        if (this.ad != null && this.ad.bi != null && (this.ad.bi.e0 || this.ad.bi.ez) && a != null) {
            for (var e = 0; e < a.count; e++) {
                var f = a._inner[e];
                if (this.c3.isEmpty) {
                    this.c3 = f;
                }
                else {
                    if (this.c3.width < f.width) {
                        this.c3 = f;
                    }
                }
            }
        }
        this.ao = this.ao || this.an(a, b);
        if (this.ao) {
            this.dq(a, b);
        }
        else {
            this.dr();
        }
        var g = this.ad.b8();
        if (!g) {
            this.dm(c);
        }
        else {
            this.af.ac();
        }
        if (this.av) {
            for (var h = 0; h < a.count; h++) {
                var i = a._inner[h];
                i.x = this.ba._inner[h].c;
                a._inner[h] = i;
            }
        }
        var j = 0;
        if (this.dc()) {
            j = ((function () { var k = _this.by(_this.di, a, b); a = k.p1; return k.ret; })());
        }
        if (this.ao && !this.aw) {
            if (j > 0) {
                if (this.c9.a0()) {
                    this.ax = true;
                }
            }
        }
        if (this.ao && this.da()) {
            this.ar = true;
            var k = this.c1.width;
            var l = this.dg();
            var m = this.df();
            var n = this.ba.count > 1 ? this.ba._inner[1].c - this.ba._inner[0].c : k;
            var o = Math.abs(n * 0.8);
            var p = 0;
            var q = Math.abs(Math.atan(this.di / n) * 180 / Math.PI);
            var r = this.af.p();
            var s = this.af.q();
            for (var t = 0; t < a.count; t++) {
                if (this.al) {
                    if (t > 0 && t < a.count - 1) {
                        var u = this.ba.count > 1 ? this.ba._inner[t].c - (a._inner[t - 1].x + a._inner[t - 1].width) : k;
                        var v = this.ba.count > 1 ? a._inner[t + 1].x - this.ba._inner[t].c : k;
                        o = Math.abs(Math.min(Math.abs(u * 2), Math.abs(v * 2)) * 0.8);
                    }
                    else {
                        if (t == 0) {
                            var w = this.ba.count > 1 ? a._inner[t + 1].x - this.ba._inner[t].c : k;
                            o = Math.abs((n * 2) * 0.8);
                        }
                        if (t == a.count - 1) {
                            var x = this.ba.count > 1 ? this.ba._inner[t].c - (a._inner[t - 1].x + a._inner[t - 1].width) : k;
                            o = Math.abs((x * 2) * 0.8);
                        }
                    }
                }
                var y = Math.min(a._inner[t].width, o);
                p = this.av ? this.ba._inner[t].c : this.ba._inner[t].c - y / 2;
                var z = AngleSimplifier.a(c);
                var aa = (z >= q && z <= 180 - q) || (z >= 180 + q && z <= 360 - q);
                var ab = a._inner[t];
                if (this.av && aa) {
                    var ac = this.bv(this.bb._inner[t]);
                    o = Math.min(l / Math.abs(Math.sin(d)), ac);
                }
                ab.x = p;
                ab.width = Math.min(o, ab.width);
                a._inner[t] = ab;
                if (!(typeCast(TextBlock.$, this.bb._inner[t]) !== null)) {
                    this.bb._inner[t].width = Math.min(o, ab.width);
                }
                var ad = typeCast(TextBlock.$, this.bb._inner[t]);
                if (ad != null) {
                    var ae = this.b1(t, ad, o, r, s);
                    if (this.ax) {
                        ad.height = m;
                    }
                    else if (!Base.equalsStatic(ad.al, ae)) {
                        ad.al = ae;
                        this.bb._inner[t].width = Math.min(o, this.bk(this.bb._inner[t]));
                        this.dk = Math.min(this.dk, this.bb._inner[t].width);
                    }
                }
            }
            if (!g) {
                this.dm(c);
            }
        }
        if (this.dd()) {
            this.dp(a);
        }
        return a;
    };
    HorizontalAxisLabelPanelBase.prototype.dn = function (a, b, c) {
        var d = this.bs();
        var e = this.dh();
        this.di = -1.7976931348623157E+308;
        this.dl = -1.7976931348623157E+308;
        this.dj = -1.7976931348623157E+308;
        this.dk = -1.7976931348623157E+308;
        var f = this.af.p();
        var g = this.af.q();
        var h = this.af.r();
        var i = this.af.o();
        var j = this.c1.top;
        var k = (this.c1.height - d);
        var l = false;
        for (var m = 0; m < this.bb.count; m++) {
            if (!this.ba._inner[m].a) {
                l = true;
            }
        }
        for (var n = 0; n < this.bb.count; n++) {
            if (this.ba == null || n >= this.ba.count) {
                break;
            }
            var o = void 0, p = void 0, q = void 0, r = void 0, s = void 0, t = void 0;
            var u = this.bb._inner[n];
            s = this.bk(u);
            t = this.bj(u);
            r = s + this.af.p() + this.af.q();
            q = t + h + i;
            var v = this.ba._inner[n].a;
            if (this.av) {
                o = this.ba._inner[n].c;
            }
            else {
                o = this.ba._inner[n].c - r / 2;
            }
            p = j + e;
            if (!v || !l) {
                this.di = Math.max(q, this.di);
                this.dl = Math.max(r, this.dl);
                this.dj = Math.max(t, this.dj);
                this.dk = Math.max(s, this.dk);
            }
            var w = new Rect(0, o, p, r, q);
            a.add(w);
            b.add(v);
            var x = r * Math.abs(Math.sin(c));
            this.ao = this.ao || x > k;
        }
        if (this.ad != null && this.ad.bz) {
            var y = -1;
            for (var z = 0; z < this.bb.count; z++) {
                var aa = this.bb._inner[z];
                y = Math.max(aa.ah, y);
            }
            if (y >= 0 && !isNaN_(y)) {
                for (var ab = 0; ab < this.bb.count; ab++) {
                    var ac = this.bb._inner[ab];
                    ac.ah = y;
                }
            }
        }
    };
    HorizontalAxisLabelPanelBase.prototype.dm = function (a) {
        var b = a * (Math.PI / 180);
        var c = Math.abs(this.dk * Math.sin(b)) + Math.abs(this.dj * Math.cos(b));
        c += this.af.r() + this.af.o();
        var d = this.bs();
        this.bh = (c) + (d) + this.ad.dz;
    };
    HorizontalAxisLabelPanelBase.prototype.dp = function (a) {
        this.c9.a2(a);
    };
    HorizontalAxisLabelPanelBase.prototype.dq = function (a, b) {
    };
    HorizontalAxisLabelPanelBase.prototype.dr = function () {
    };
    HorizontalAxisLabelPanelBase.prototype.get_au = function () {
        return true;
    };
    HorizontalAxisLabelPanelBase.prototype.cm = function (a, b) {
        var c = a.l;
        var d = a.m;
        var e = 0;
        var f = c / 2;
        var g = new TransformGroup();
        var h = AngleSimplifier.a(this.bl());
        var i = ((function () {
            var $ret = new RotateTransform();
            $ret.j = h;
            $ret.k = e;
            $ret.l = f;
            return $ret;
        })());
        var j = 0;
        var k = 0;
        if (h != 0 && h != 360) {
            if (h > 0 && h < 180) {
                j = -Math.sin(MathUtil.o(h)) * (c / 2);
            }
            else {
                i.k = d;
                k = -d;
                j = -Math.sin(MathUtil.o(h - 180)) * (c / 2);
            }
        }
        var l = ((function () {
            var $ret = new TranslateTransform();
            $ret.k = j;
            $ret.j = k;
            return $ret;
        })());
        g.j.add(i);
        g.j.add(l);
        a.j = g;
    };
    HorizontalAxisLabelPanelBase.prototype.dd = function () {
        return !this.aw && !this.av;
    };
    HorizontalAxisLabelPanelBase.prototype.da = function () {
        if (this.ad != null && this.ad.bi != null && this.ad.bi.e1) {
            return false;
        }
        return true;
    };
    HorizontalAxisLabelPanelBase.prototype.by = function (a, b, c) {
        var d = 0;
        var e = new List$1(Rect.$, 0);
        var f = this.dh() + this.c1.top;
        var g = this.dg();
        var h = f + g;
        if (a * 3 <= this.bd) {
            d = 3;
        }
        else if (a * 2 <= this.bd) {
            d = 2;
        }
        else {
            return {
                ret: d,
                p1: b
            };
        }
        var i = 0;
        for (var j = 0; j < b.count; j++) {
            var k = RectUtil.p(b._inner[j]);
            if (!c._inner[j]) {
                if (i % d == 0) {
                    k.y = f;
                }
                else if (i % d == d - 1) {
                    k.y = h - k.height;
                }
                else {
                    k.y = (f + (g / 2)) - k.height / 2;
                }
                i++;
            }
            e.add(k);
        }
        this.ao = this.an(e, c);
        if (!this.ao) {
            this.aw = true;
            b = e;
        }
        return {
            ret: d,
            p1: b
        };
    };
    HorizontalAxisLabelPanelBase.prototype.c0 = function () {
        var a = this.aj(this.ad.bf);
        var b = this.bs();
        var c = this.ah;
        var d = 0;
        if (a == 3) {
            d += this.c1.top;
            if (c == 1 || c == 5) {
                d += this.ad.dz;
            }
        }
        else {
            d = this.c1.bottom - b;
            if (c == 4 || c == 0) {
                d -= this.ad.dz;
            }
        }
        var e = this.bu();
        var f = 0;
        var g = this.ad.bf == null ? 1 : this.ad.bf.horizontalAlignment;
        if (g == 0) {
            f = this.c1.left;
        }
        else if (g == 2) {
            f = this.c1.right - e;
        }
        else {
            f = (this.c1.left + (this.c1.width / 2)) - (e / 2);
        }
        return new Rect(0, f, d, e, b);
    };
    HorizontalAxisLabelPanelBase.prototype.dh = function () {
        var a = 0;
        var b = this.aj(this.ad.bf);
        if (b == 3) {
            a += this.bs();
        }
        var c = this.ah;
        if (c == 1 || c == 5) {
            a += this.ad.dz;
        }
        return a;
    };
    HorizontalAxisLabelPanelBase.prototype.de = function () {
        var a = 0;
        var b = this.aj(this.ad.bf);
        if (b == 4) {
            a += this.bs();
        }
        var c = this.ah;
        if (c == 0 || c == 4) {
            a += this.ad.dz;
        }
        return a;
    };
    HorizontalAxisLabelPanelBase.prototype.dg = function () {
        var a = (this.bd - this.dh()) - this.de();
        if (a < 0) {
            a = 0;
        }
        return a;
    };
    HorizontalAxisLabelPanelBase.prototype.df = function () {
        var a = ((this.dg() - this.af.r()) - this.af.o());
        if (a < 0) {
            a = 0;
        }
        return a;
    };
    HorizontalAxisLabelPanelBase.prototype.b9 = function () {
        var e_41, _a;
        var a = this.af.au();
        this.ad.hi(a);
        if (this.ag != null && this.ag.visibility != 0) {
            return;
        }
        var b = this.ad.dz;
        if (b == 0) {
            return;
        }
        var c = this.a2();
        if (c == null) {
            return;
        }
        var d = this.c1.top;
        var e;
        var f = this.ah;
        if (f == 0 || f == 4) {
            d = this.c1.bottom;
            e = d - this.ad.dz;
        }
        else {
            e = d + this.ad.dz;
        }
        var g = this.af.b();
        try {
            for (var _b = __values(fromEnum(c)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                this.cs(a, h, d, e, this.c4, g);
            }
        }
        catch (e_41_1) {
            e_41 = { error: e_41_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_41)
                    throw e_41.error;
            }
        }
        if (!this.ab.contains(this.af.aw)) {
            this.ab.add(this.af.aw);
        }
    };
    HorizontalAxisLabelPanelBase.prototype.a6 = function (a) {
        var _this = this;
        if (this.ad.cu || this.ad.cw) {
            var b = this.af.p();
            var c = this.af.r();
            var d = this.af.q();
            var e = this.af.o();
            var f = Math.max(b, Math.max(c, Math.max(d, e)));
            var g_2 = new Thickness(0, f);
            if (this.av) {
                g_2 = new Thickness(0, Math.sqrt((f * f) / 2));
            }
            var h = this.a4(a);
            var i = new List$1(Thickness.$, 0);
            if (h.count < 1) {
                return a;
            }
            h.aa(function (j, k) {
                var l = _this.cy(j, a._inner[j], g_2);
                var m = _this.cy(k, a._inner[k], g_2);
                var n = l.left;
                var o = m.left;
                if (n < o) {
                    return -1;
                }
                if (n > o) {
                    return 1;
                }
                return 0;
            });
            for (var j = 0; j < h.count; j++) {
                var k = h._inner[j];
                var l = a._inner[k];
                var m = this.cy(k, a._inner[k], g_2);
                var n = this.ad.bi.ty.left;
                if (this.ad.cw) {
                    if (l.left < (this.ad.bi.ty.left - n)) {
                        l = new Rect(0, l.left + ((this.ad.bi.ty.left - n) - l.left), l.top, l.width, l.height);
                        a._inner[k] = l;
                    }
                }
            }
            var o = this.as(a, h, g_2);
            if (o && (this.ad.cu)) {
                for (var p = 0; p < h.count - 1; p++) {
                    var q = h._inner[p];
                    var r = h._inner[p + 1];
                    var s = a._inner[q];
                    var t = a._inner[r];
                    var u = this.cy(q, a._inner[q], g_2);
                    var v = this.cy(r, a._inner[r], g_2);
                    if (u.intersectsWith(v) || u.left > v.right) {
                        var w = new Rect(0, u.right + 1 + (t.left - v.left), t.top, t.width, t.height);
                        a._inner[r] = w;
                    }
                }
            }
            for (var x = h.count - 1; x >= 0; x--) {
                var y = h._inner[x];
                var z = a._inner[y];
                var aa = this.cy(y, a._inner[y], g_2);
                var ab = this.ad.bi.cu.a5;
                if (this.ad.cw) {
                    if (aa.right > this.ad.bi.ty.right + ab) {
                        z = new Rect(0, z.left - (aa.right - (this.ad.bi.ty.right + ab)), z.top, z.width, z.height);
                        a._inner[y] = z;
                    }
                }
            }
            if (this.ad.cu) {
                for (var ac = h.count - 1; ac >= 1; ac--) {
                    var ad = h._inner[ac];
                    var ae = h._inner[ac - 1];
                    var af = a._inner[ad];
                    var ag = a._inner[ae];
                    var ah = this.cy(ad, a._inner[ad], g_2);
                    var ai = this.cy(ae, a._inner[ae], g_2);
                    if (ah.intersectsWith(ai) || ah.left < ai.right) {
                        var aj = new Rect(0, ah.left - (ai.width + 1) + (ag.left - ai.left), ag.top, ag.width, ag.height);
                        a._inner[ae] = aj;
                    }
                }
            }
            return a;
        }
        else {
            return a;
        }
    };
    HorizontalAxisLabelPanelBase.$t = markType(HorizontalAxisLabelPanelBase, 'HorizontalAxisLabelPanelBase', AxisLabelPanelBase.$);
    return HorizontalAxisLabelPanelBase;
}(AxisLabelPanelBase));
export { HorizontalAxisLabelPanelBase };
/**
 * @hidden
 */
var HorizontalAxisLabelPanel = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(HorizontalAxisLabelPanel, _super);
    function HorizontalAxisLabelPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalAxisLabelPanel.prototype.ai = function () {
        return 1;
    };
    HorizontalAxisLabelPanel.prototype.ay = function (a) {
        return a == 5 || a == 4 || a == 1 || a == 0;
    };
    HorizontalAxisLabelPanel.$t = markType(HorizontalAxisLabelPanel, 'HorizontalAxisLabelPanel', HorizontalAxisLabelPanelBase.$);
    return HorizontalAxisLabelPanel;
}(HorizontalAxisLabelPanelBase));
export { HorizontalAxisLabelPanel };
/**
 * @hidden
 */
var NumericAxisBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(NumericAxisBase, _super);
    function NumericAxisBase() {
        var _this = _super.call(this) || this;
        _this.ks = 0;
        _this.lp = 0;
        _this.l3 = 0;
        _this.ls = 0;
        _this.lo = 0;
        _this.l2 = 0;
        _this.lr = 0;
        _this.ln = 0;
        _this.lq = 0;
        _this.k8 = false;
        _this.k9 = false;
        _this.ma = 0;
        _this.k0 = null;
        _this.lk = false;
        _this.ll = false;
        _this.ko = null;
        _this.kq = null;
        _this.lu = -1;
        _this.lt = -1;
        _this.kt = 0;
        _this.lh = false;
        _this.k4 = null;
        _this.k7 = false;
        _this.ma = 10;
        return _this;
    }
    NumericAxisBase.prototype.a4 = function () {
        return new NumericAxisBaseView(this);
    };
    NumericAxisBase.prototype.ag = function () {
        return [this.lx, this.lw];
    };
    NumericAxisBase.prototype.hs = function (a) {
        _super.prototype.hs.call(this, a);
        this.kx = a;
    };
    NumericAxisBase.prototype.d1 = function (a, b) {
        var c = a < this.lx ? this.lx : a;
        c = a > this.lw ? this.lw : c;
        return c;
    };
    NumericAxisBase.prototype.get_cj = function () {
        return true;
    };
    Object.defineProperty(NumericAxisBase.prototype, "ku", {
        get: function () {
            return EnumUtil.getEnumValue(AxisRangeBufferMode_$type, this.c(NumericAxisBase.ne));
        },
        set: function (a) {
            this.h(NumericAxisBase.ne, enumGetBox(AxisRangeBufferMode_$type, a));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "kv", {
        get: function () {
            return this.ks;
        },
        set: function (a) {
            this.ks = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lx", {
        get: function () {
            return this.lp;
        },
        set: function (a) {
            if (this.lx != a) {
                var b = this.lp;
                this.lp = a;
                this.l3 = Math.log(this.lx);
                this.h2("ActualMinimumValue", b, this.lx);
            }
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.prototype.f2 = function () {
        return this.l5;
    };
    Object.defineProperty(NumericAxisBase.prototype, "l0", {
        get: function () {
            return this.ls;
        },
        set: function (a) {
            if (this.l0 != a) {
                var b = this.ls;
                this.ls = a;
                this.h2("ActualVisibleMinimumValue", b, this.l0);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lw", {
        get: function () {
            return this.lo;
        },
        set: function (a) {
            if (this.lw != a) {
                var b = this.lo;
                this.lo = a;
                this.l2 = Math.log(this.lw);
                this.h2("ActualMaximumValue", b, this.lw);
            }
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.prototype.f1 = function () {
        return this.lw;
    };
    Object.defineProperty(NumericAxisBase.prototype, "lz", {
        get: function () {
            return this.lr;
        },
        set: function (a) {
            if (this.lz != a) {
                var b = this.lr;
                this.lr = a;
                this.h2("ActualVisibleMaximumValue", b, this.lz);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lv", {
        get: function () {
            return this.ln;
        },
        set: function (a) {
            if (this.lv != a) {
                var b = this.ln;
                this.ln = a;
                this.h2("ActualInterval", b, this.lv);
            }
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.prototype.ev = function () {
        return this.lv;
    };
    Object.defineProperty(NumericAxisBase.prototype, "ly", {
        get: function () {
            return this.lq;
        },
        set: function (a) {
            if (this.ly != a) {
                var b = this.lq;
                this.lq = a;
                this.h2("ActualMinorInterval", b, this.ly);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lb", {
        get: function () {
            return this.k8;
        },
        set: function (a) {
            if (this.lb != a) {
                var b = this.k8;
                if (b != a) {
                    this.k8 = a;
                    this.h2("ActualIsLogarithmic", b, this.lb);
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lc", {
        get: function () {
            return this.k9;
        },
        set: function (a) {
            this.k9 = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lj", {
        get: function () {
            return this.lb && this.lx > 0 && this.ma > 1;
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.prototype.h9 = function (a) {
        _super.prototype.h9.call(this, a);
        if (this.lj && this.bi != null) {
            var b = this.j8();
            var c = this.j7();
            var d = this.k1(this.kd, this.bi.tj, b, c);
            if (d == null) {
                return;
            }
            var _loop_4 = function (e) {
                var f = this_2.l9;
                var g = d.k._inner[e];
                var h = Math.min(g.d, g.c);
                var i = Math.max(g.d, g.c);
                var j = Math.floor(logBase(h, f));
                var k = Math.ceil(logBase(i, f));
                if (k - j < 2) {
                    if (typeCast(LogarithmicTickmarkValues.$, this_2.k4) !== null) {
                        this_2.k4 = new LinearTickmarkValues();
                    }
                }
                else {
                    this_2.k4 = this_2.k6 != null ? this_2.k6 : ((function () {
                        var $ret = new LogarithmicTickmarkValues();
                        $ret.x = f;
                        return $ret;
                    })());
                }
            };
            var this_2 = this;
            for (var e = 0; e < d.k.count; e++) {
                _loop_4(e);
            }
        }
    };
    NumericAxisBase.prototype.h1 = function (a) {
        _super.prototype.h1.call(this, a);
        this.l5 = a;
    };
    NumericAxisBase.prototype.h0 = function (a) {
        _super.prototype.h1.call(this, a);
        this.l4 = a;
    };
    NumericAxisBase.prototype.hw = function (a, b, c, d) {
        _super.prototype.hw.call(this, a, b, c, d);
        switch (b) {
            case NumericAxisBase.$$p[0]:
            case NumericAxisBase.$$p[1]:
                if (this.mb != null) {
                    this.ko = new BindingFormatter();
                    this.ko.j = this.mb;
                    this.ko.d = this.kn;
                }
                else {
                    this.ko = null;
                }
                break;
            case "AutoRangeBufferMode":
                this.kv = this.ku;
                this.mz();
                this.c1();
                this.h8(false);
                break;
            case NumericAxisBase.$$p[8]:
                this.c1();
                this.h8(false);
                break;
            case NumericAxisBase.$$p[7]:
                this.c1();
                this.h8(false);
                break;
            case NumericAxisBase.$$p[2]:
                this.lc = this.ld;
                this.c1();
                this.h8(false);
                break;
            case NumericAxisBase.$$p[5]:
                this.lk = true;
                this.lb = this.li;
                break;
            case Axis.$$p[4]:
            case Axis.$$p[3]:
            case NumericAxisBase.$$p[4]:
            case NumericAxisBase.$$p[9]:
                this.cq = true;
                this.h8(false);
                break;
            case NumericAxisBase.$$p[6]:
                this.lk = true;
                this.ma = this.l9;
                if (this.lb) {
                    this.c1();
                    this.m1();
                    this.h8(false);
                }
                break;
            case NumericAxisBase.$$p[10]:
                var e = new AxisRangeChangedEventArgs(0, this.lx, this.lx, this.lw, this.lw);
                this.h3(e);
                this.cq = true;
                this.h8(false);
                break;
            case Axis.$$p[13]:
                this.k0 = this.ky();
                this.cq = true;
                this.h8(false);
                break;
            case "TickmarkValues":
                this.m3();
                break;
            case "ActualIsLogarithmic":
                this.c1();
                this.m1();
                this.cq = true;
                this.m3();
                this.h8(false);
                break;
            case "ActualTickmarkValues":
                this.cq = true;
                this.h8(false);
                break;
            case "AbbreviateLargeNumbers":
                this.h8(false);
                break;
        }
    };
    NumericAxisBase.prototype.m1 = function () {
        var e_42, _a;
        try {
            for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a.mn(false);
            }
        }
        catch (e_42_1) {
            e_42 = { error: e_42_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_42)
                    throw e_42.error;
            }
        }
    };
    NumericAxisBase.prototype.kr = function () {
        var e_43, _a;
        var a = new AxisRange(Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY);
        var b = false;
        if (this.bi != null) {
            try {
                for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var c = _c.value;
                    var d = c.aq(this);
                    if (d != null) {
                        b = true;
                        a = new AxisRange(Math.min(a.c, d.c), Math.max(a.b, d.b));
                    }
                }
            }
            catch (e_43_1) {
                e_43 = { error: e_43_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_43)
                        throw e_43.error;
                }
            }
        }
        if (b) {
            if (this.lu >= 0) {
                a = new AxisRange(a.c - this.lu, a.b);
            }
            if (this.lt >= 0) {
                a = new AxisRange(a.c, a.b + this.lt);
            }
            this.kq = a;
            return a;
        }
        this.kq = null;
        return null;
    };
    NumericAxisBase.prototype.lm = function (a) {
        var e_44, _a;
        if (a == 1 || a == 2 || a == 3) {
            var b = this.kq;
            if (b == null) {
                b = this.kr();
            }
            if (b == null) {
                return false;
            }
            if (this.bi == null || this.bi.ty.isEmpty) {
                return false;
            }
            var c = -1;
            var d = -1;
            try {
                for (var _b = __values(fromEnum(this.db())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var e = _c.value;
                    var f = e.ap(b, this, new Rect(0, 0, 0, 1, 1));
                    if (f.c != b.c) {
                        if (a == 1 || a == 2) {
                            c = Math.max(c, b.c - f.c);
                        }
                    }
                    if (f.b != b.b) {
                        if (a == 1 || a == 3) {
                            d = Math.max(d, f.b - b.b);
                        }
                    }
                }
            }
            catch (e_44_1) {
                e_44 = { error: e_44_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_44)
                        throw e_44.error;
                }
            }
            if (c >= 0 || d >= 0) {
                this.lu = c;
                this.lt = d;
                return true;
            }
            return false;
        }
        return false;
    };
    NumericAxisBase.prototype.kw = function () {
        if (this.kv == 0) {
            if (this.bi != null) {
                if (this.cp) {
                    if (this.bi.bz == 2) {
                        return 1;
                    }
                    if (this.ci) {
                        if (this.bi.bz == 4) {
                            return 3;
                        }
                        if (this.bi.bz == 3) {
                            return 2;
                        }
                    }
                    else {
                        if (this.bi.bz == 4) {
                            return 2;
                        }
                        if (this.bi.bz == 3) {
                            return 3;
                        }
                    }
                }
                else {
                    if (this.bi.bx == 2) {
                        return 1;
                    }
                    if (this.ci) {
                        if (this.bi.bx == 4) {
                            return 3;
                        }
                        if (this.bi.bx == 3) {
                            return 2;
                        }
                    }
                    else {
                        if (this.bi.bx == 4) {
                            return 2;
                        }
                        if (this.bi.bx == 3) {
                            return 3;
                        }
                    }
                }
            }
            return 4;
        }
        else {
            return this.kv;
        }
    };
    NumericAxisBase.prototype.my = function (a, b, c, d, e, f, g) {
        var h = AutoRangeCalculator.a(a, b, c, d, e, f, g);
        f = h.p5;
        g = h.p6;
        return {
            p5: f,
            p6: g
        };
    };
    NumericAxisBase.prototype.c3 = function () {
        var a = this.lb && !isNaN_(this.l9) && !isInfinity(this.l9) && this.l9 > 1;
        var b;
        var c;
        var d = this.kw();
        if (d != this.kt) {
            this.kt = d;
            this.mz();
        }
        var e = false;
        if (!this.kd.isEmpty && d != 4) {
            if (this.lu == -1 && this.lt == -1) {
                e = true;
            }
        }
        var f = this.my(this, this.l5, this.l4, a, this.l9, b, c);
        b = f.p5;
        c = f.p6;
        if (b != this.lx || c != this.lw || this.lk) {
            if (d != 4 && (this.lu >= 0 || this.lt >= 0)) {
                this.mz();
                var g = this.my(this, this.l5, this.l4, a, this.l9, b, c);
                b = g.p5;
                c = g.p6;
            }
        }
        if (b != this.lx || c != this.lw || this.lk || e) {
            this.lk = false;
            var h = new AxisRangeChangedEventArgs(0, this.lx, b, this.lw, c);
            this.lx = b;
            this.lw = c;
            if (!this.kd.isEmpty && d != 4) {
                if (this.lm(d)) {
                    var i = this.my(this, this.l5, this.l4, a, this.l9, b, c);
                    b = i.p5;
                    c = i.p6;
                    h = new AxisRangeChangedEventArgs(0, h.oldMinimumValue, b, h.oldMaximumValue, c);
                    this.lx = b;
                    this.lw = c;
                }
            }
            this.h3(h);
            this.m2(h);
            this.h8(true);
            return true;
        }
        return false;
    };
    NumericAxisBase.prototype.mz = function () {
        this.lu = -1;
        this.lt = -1;
    };
    NumericAxisBase.prototype.m2 = function (a) {
    };
    NumericAxisBase.prototype.ct = function (a) {
        var b = _super.prototype.ct.call(this, a);
        if (b) {
            this.c1();
        }
        return b;
    };
    NumericAxisBase.prototype.b0 = function (a) {
        var b = _super.prototype.b0.call(this, a);
        if (b) {
            this.c1();
        }
        return b;
    };
    NumericAxisBase.prototype.kz = function (a) {
        return new NumericAxisRenderer(a);
    };
    NumericAxisBase.prototype.ky = function () {
        var _this = this;
        var a = ((function () {
            var $ret = new AxisLabelManager();
            $ret.a = _this;
            $ret.f = _this.dd;
            $ret.e = _this.dc;
            $ret.b = _this.aw;
            return $ret;
        })());
        if (this.az != null) {
            this.az.registerAxis(this);
        }
        var b = this.kz(a);
        b.u = function () {
            var c = _this.a5.a1();
            var d = _this.a5.a4();
            var e = _this.a5.a2();
            var f = _this.a5.a3();
            _this.il();
            _this.hi(c);
            _this.hi(d);
            _this.hi(e);
            _this.hi(f);
        };
        b.o = function (c, d) { return !d.isEmpty && !c.isEmpty; };
        b.d = function (c, d, e, f) { return _this.k1(c, d, e, f); };
        b.g = function (c, d) {
            _this.lh = d;
            var e = _this.fz(c);
            _this.lh = false;
            return e;
        };
        return b;
    };
    NumericAxisBase.prototype.k2 = function () {
        return new NumericAxisRenderingParameters();
    };
    NumericAxisBase.prototype.m0 = function () {
    };
    NumericAxisBase.prototype.k3 = function () {
        return null;
    };
    NumericAxisBase.prototype.k1 = function (a, b, c, d) {
        var e = this.k2();
        var f = this.a5.a1();
        var g = this.a5.a4();
        var h = this.a5.a2();
        var i = this.a5.a3();
        var j = this.a5.e();
        var k = this.a5.f();
        var l = this.a5.g();
        e.t = f;
        e.w = g;
        e.u = h;
        e.v = i;
        e.a = j;
        e.c = k;
        e.d = l;
        e.l = this.lw;
        e.m = this.lx;
        e.h = this.lf;
        e.f = this.k5;
        e.z = a;
        e.y = c;
        e.x = d;
        e.aa = b;
        e.o = this.ey();
        e.g = this.le();
        e.p = this.l1;
        e.q = this.l6;
        e.s = this.f0;
        if (this.f0 == null && (this.au != null || this.ai != null || this.kx.l())) {
            e.s = "Format";
        }
        e.j = this.cy;
        e.ab = this.la;
        return e;
    };
    NumericAxisBase.prototype.l8 = function (a) {
        var b = this.j8();
        var c = new ScalerParams(0, this.bi.tj, this.kd, this.ch, b);
        return this.em(a, c);
    };
    NumericAxisBase.prototype.le = function () {
        return !isNaN_(this.l1);
    };
    Object.defineProperty(NumericAxisBase.prototype, "lg", {
        get: function () {
            return !isNaN_(this.l5);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "lf", {
        get: function () {
            return !isNaN_(this.l4);
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.prototype.m3 = function () {
        if (this.k6 != null) {
            this.k5 = this.k6;
        }
        else if (this.lb) {
            this.k5 = new LogarithmicTickmarkValues();
            this.kx.bi();
        }
        else {
            this.k5 = new LinearTickmarkValues();
        }
    };
    Object.defineProperty(NumericAxisBase.prototype, "k6", {
        get: function () {
            return typeCast(TickmarkValues.$, this.c(NumericAxisBase.ng));
        },
        set: function (a) {
            this.h(NumericAxisBase.ng, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "k5", {
        get: function () {
            if (this.k4 == null) {
                this.m3();
            }
            return this.k4;
        },
        set: function (a) {
            var b = this.k4;
            var c = b != a;
            if (c) {
                this.k4 = a;
                this.h2("ActualTickmarkValues", b, a);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NumericAxisBase.prototype, "la", {
        get: function () {
            return this.k7;
        },
        set: function (a) {
            var b = this.la;
            if (a != b) {
                this.k7 = a;
                this.h2("AbbreviateLargeNumbers", b, this.la);
            }
        },
        enumerable: false,
        configurable: true
    });
    NumericAxisBase.$t = markType(NumericAxisBase, 'NumericAxisBase', Axis.$);
    NumericAxisBase.ne = DependencyProperty.i("AutoRangeBufferMode", AxisRangeBufferMode_$type, NumericAxisBase.$, new PropertyMetadata(2, enumGetBox(AxisRangeBufferMode_$type, 0), function (a, b) { return a.h2("AutoRangeBufferMode", b.oldValue, b.newValue); }));
    NumericAxisBase.ng = DependencyProperty.i("TickmarkValues", TickmarkValues.$, NumericAxisBase.$, new PropertyMetadata(1, function (a, b) { return a.h2("TickmarkValues", b.oldValue, b.newValue); }));
    NumericAxisBase.$$p = markDep(DependencyProperty, PropertyMetadata, NumericAxisBase, 'h2', ['AbbreviatedLabelFormat:mb:m4', [2, null], 'AbbreviatedLabelFormatSpecifiers:kn:m5', [Array_$type, null], 'FavorLabellingScaleEnd:ld:m6', [0, false], 'FormatAbbreviatedLabel:kp:m7', [Delegate_$type], 'Interval:l1:m8', [1, NaN], 'IsLogarithmic:li:m9', [0, false], 'LogarithmBase:l9:na', [1, 10], 'MaximumValue:l4:nb', [1, NaN], 'MinimumValue:l5:nc', [1, NaN], 'MinorInterval:l6:nd', [1, NaN], 'ReferenceValue:l7:nf', [1, 0]]);
    return NumericAxisBase;
}(Axis));
export { NumericAxisBase };
/**
 * @hidden
 */
var NumericScaler = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(NumericScaler, _super);
    function NumericScaler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.o = 0;
        _this.n = 0;
        _this.m = 0;
        return _this;
    }
    NumericScaler.prototype.y = function (a) {
        this.l = a;
    };
    NumericScaler.prototype.x = function (a) {
        this.k = a;
    };
    NumericScaler.prototype.w = function (a, b, c) {
        switch (a) {
            case NumericScaler.$$p[1]:
                this.o = this.l;
                this.z();
                break;
            case NumericScaler.$$p[0]:
                this.n = this.k;
                this.z();
                break;
        }
    };
    NumericScaler.prototype.z = function () {
        if (isNaN_(this.l) || isNaN_(this.k) || isInfinity(this.l) || isInfinity(this.k) || this.l < (-7.9228162514264338E+28) || this.k > (7.9228162514264338E+28)) {
            this.m = this.k - this.l;
        }
        else {
            this.m = this.k - this.l;
        }
    };
    NumericScaler.prototype.j = function (a, b, c, d) {
        var e = new List$1(Number_$type, 2, a.count);
        for (var f = b; f < c; f++) {
            e.add(this.q(a.item(f), d));
        }
        return e;
    };
    NumericScaler.prototype.v = function (a, b, c, d) {
        for (var e = b; e < c; e++) {
            a.item(e, this.p(a.item(e), d));
        }
    };
    NumericScaler.prototype.u = function (a, b, c, d, e) {
        for (var f = 0; f < b.count; f++) {
            var g = b.item(f);
            for (var h = c; h < d; h++) {
                a.item(h)[g] = this.p(a.item(h)[g], e);
            }
        }
    };
    NumericScaler.$t = markType(NumericScaler, 'NumericScaler', DependencyObject.$);
    NumericScaler.ac = new Rect(0, 0, 0, 1, 1);
    NumericScaler.$$p = markDep(DependencyProperty, PropertyMetadata, NumericScaler, 'w', ['ActualMaximumValue:k:aa', [1, NaN], 'ActualMinimumValue:l:ab', [1, NaN]]);
    return NumericScaler;
}(DependencyObject));
export { NumericScaler };
/**
 * @hidden
 */
var AxisRendererBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisRendererBase, _super);
    function AxisRendererBase(a) {
        var _this = _super.call(this) || this;
        _this.u = null;
        _this.o = null;
        _this.v = null;
        _this.m = null;
        _this.l = null;
        _this.k = null;
        _this.q = null;
        _this.n = null;
        _this.j = null;
        _this.e = null;
        _this.p = null;
        _this.h = null;
        _this.t = null;
        _this.b = null;
        _this.g = null;
        _this.d = null;
        _this.r = null;
        _this.a = null;
        _this.f = null;
        _this.i = null;
        _this.u = function () {
        };
        _this.o = function (b, c) { return false; };
        _this.v = function () {
        };
        _this.m = function (b, c) { return c; };
        _this.l = function (b, c, d, e) {
        };
        _this.k = function (b, c, d) {
        };
        _this.q = function (b, c) { return false; };
        _this.n = function (b, c) { return _this.q(b, c); };
        _this.j = function (b) {
        };
        _this.e = function (b) {
        };
        _this.p = function (b, c, d) { return false; };
        _this.h = function (b, c) { return new LabelPosition(c); };
        _this.t = function (b, c) { return c; };
        _this.g = function (b, c) { return null; };
        _this.r = function (b, c, d, e) { return c; };
        _this.a = function (b, c, d, e) { return c; };
        _this.b = a;
        _this.d = function (b, c, d, e) { return null; };
        return _this;
    }
    AxisRendererBase.prototype.c = function (a, b, c, d, e) {
        var e_45, _a;
        this.x(c, b);
        if (this.o(b, c)) {
            this.v();
            var f_1 = this.d(b, c, d, e);
            this.x(c, b);
            if (f_1 == null) {
                this.aa();
                return null;
            }
            if (f_1.k.count > 1 && !f_1.g) {
                this.ab(f_1);
            }
            var _loop_5 = function (g) {
                f_1.e = g;
                if (isNaN_(g.c) || isInfinity(g.c) || isNaN_(g.d) || isInfinity(g.d)) {
                    return "continue";
                }
                if (g.d == g.c) {
                    return "continue";
                }
                this_3.e(f_1);
                this_3.b.o(f_1.r);
                var h = 0;
                var i = 0;
                var j = false;
                var k = function (l) { return l; };
                if (this_3.f != null) {
                    k = this_3.i;
                }
                if (typeCast(CategoryAxisRenderingParameters.$, f_1) !== null) {
                    h = f_1.ab;
                    i = f_1.af;
                    j = f_1.ac;
                }
                f_1.f = this_3.s(f_1);
                f_1.f.s(((function () {
                    var $ret = new TickmarkValuesInitializationParameters();
                    $ret.n = f_1.e.d;
                    $ret.m = f_1.e.c;
                    $ret.g = f_1.m;
                    $ret.f = f_1.l;
                    $ret.k = f_1.e.b;
                    $ret.d = f_1.g;
                    $ret.l = f_1.p;
                    $ret.j = f_1.q;
                    $ret.h = f_1.o;
                    $ret.i = f_1.e.a;
                    $ret.p = f_1.e.e;
                    $ret.a = h;
                    $ret.q = i;
                    $ret.s = f_1.aa;
                    $ret.r = f_1.z;
                    $ret.e = j;
                    $ret.c = k;
                    return $ret;
                })()));
                this_3.y(f_1);
            };
            var this_3 = this;
            try {
                for (var _b = __values(fromEnum(f_1.k)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var g = _c.value;
                    _loop_5(g);
                }
            }
            catch (e_45_1) {
                e_45 = { error: e_45_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_45)
                        throw e_45.error;
                }
            }
            this.z();
            return f_1;
        }
        return null;
    };
    AxisRendererBase.prototype.aa = function () {
        this.b.q();
    };
    AxisRendererBase.prototype.ab = function (a) {
        var e_46, _a, e_47, _b;
        var b = -1.7976931348623157E+308;
        var c = -2147483648;
        var d = 0;
        var e = 0;
        var f = false;
        var g = function (h) { return h; };
        if (this.f != null) {
            g = this.i;
        }
        if (typeCast(CategoryAxisRenderingParameters.$, a) !== null) {
            d = a.ab;
            e = a.af;
            f = a.ac;
        }
        var _loop_6 = function (h) {
            a.e = h;
            a.f.s(((function () {
                var $ret = new TickmarkValuesInitializationParameters();
                $ret.n = h.d;
                $ret.m = h.c;
                $ret.g = a.m;
                $ret.f = a.l;
                $ret.k = h.b;
                $ret.d = a.g;
                $ret.l = a.p;
                $ret.i = h.a;
                $ret.p = h.e;
                $ret.h = a.o;
                $ret.j = a.q;
                $ret.a = d;
                $ret.q = e;
                $ret.s = a.aa;
                $ret.r = a.z;
                $ret.e = f;
                $ret.c = g;
                return $ret;
            })()));
            h.a = a.f.m;
            h.e = a.f.r;
            if (!isNaN_(a.f.m)) {
                b = Math.max(b, a.f.m);
                c = Math.max(c, a.f.r);
            }
        };
        try {
            for (var _c = __values(fromEnum(a.k)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var h = _d.value;
                _loop_6(h);
            }
        }
        catch (e_46_1) {
            e_46 = { error: e_46_1 };
        }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return))
                    _a.call(_c);
            }
            finally {
                if (e_46)
                    throw e_46.error;
            }
        }
        try {
            for (var _e = __values(fromEnum(a.k)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var i = _f.value;
                if (i.a == b) {
                    i.a = -1;
                    i.e = -1;
                }
                else {
                    i.a = b;
                    i.e = c;
                }
            }
        }
        catch (e_47_1) {
            e_47 = { error: e_47_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_47)
                    throw e_47.error;
            }
        }
    };
    AxisRendererBase.prototype.x = function (a, b) {
        this.u();
        this.b.n(a, b);
        this.b.t();
    };
    AxisRendererBase.prototype.z = function () {
        var e_48, _a;
        this.b.t();
        var a = false;
        if (this.b.d) {
            this.b.s(0);
        }
        else {
            var b = 0;
            try {
                for (var _b = __values(fromEnum(this.b.e)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var c = _c.value;
                    var d = typeCast(FrameworkElement.$, c);
                    if (d == null) {
                        d = this.b.u(b);
                        var e = d.al;
                        var f = c.toString();
                        var g = 0;
                        var h = 0;
                        if (e != null) {
                            g = e.length;
                        }
                        if (f != null) {
                            h = f.length;
                        }
                        if (g != h) {
                            a = true;
                        }
                        d.al = f;
                        b++;
                    }
                    else {
                        this.b.h(d);
                    }
                }
            }
            catch (e_48_1) {
                e_48 = { error: e_48_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_48)
                        throw e_48.error;
                }
            }
            if (a) {
                this.b.p();
            }
            this.b.g();
            this.b.s(b);
        }
    };
    AxisRendererBase.prototype.s = function (a) {
        return a.f;
    };
    AxisRendererBase.prototype.y = function (a) {
        var b = a.f.j();
        var c = a.f.k();
        this.b.r(this.m(a, a.f.m));
        this.j(a);
        for (var d = 0; d < b.length; d++) {
            var e = a.f.p + d;
            var f = b[d];
            var g = f;
            var h = 0;
            if (d < b.length - 1) {
                h = b[d + 1];
            }
            else {
                h = Number.POSITIVE_INFINITY;
            }
            g = this.r(a, g, e, a.f.m);
            h = this.r(a, h, e, a.f.m);
            var i = this.m(a, g);
            var j = this.m(a, h);
            if (this.q(a, i)) {
                if (e % 2 == 0 && this.n(a, j) && !isInfinity(j)) {
                    this.l(a, a.w, i, j);
                }
                a.b = a.c;
                this.k(a, a.u, i);
                a.b = null;
            }
            i = this.a(a, i, e, a.f.m);
            if (!isNaN_(i) && !isInfinity(i) && this.p(a, i, d == b.length - 1)) {
                var k = this.w(a, g, e, a.f.m);
                if (k != null) {
                    this.b.i(k, this.h(a, i));
                }
            }
        }
        if (a.j) {
            for (var l = 0; l < c.length; l++) {
                var m = c[l];
                var n = this.m(a, m);
                a.b = a.d;
                this.k(a, a.v, n);
                a.b = null;
            }
        }
    };
    AxisRendererBase.prototype.w = function (a, b, c, d) {
        return null;
    };
    AxisRendererBase.$t = markType(AxisRendererBase, 'AxisRendererBase');
    return AxisRendererBase;
}(Base));
export { AxisRendererBase };
/**
 * @hidden
 */
var NumericAxisRenderer = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(NumericAxisRenderer, _super);
    function NumericAxisRenderer(a) {
        var _this = _super.call(this, a) || this;
        _this.ac = null;
        _this.ad = false;
        return _this;
    }
    NumericAxisRenderer.prototype.w = function (a, b, c, d) {
        var e;
        if (a.s != null) {
            if (a.i() && a.ab) {
                return this.ae(b, this.g);
            }
            e = this.g(b, false);
        }
        else {
            b = Math.round(b * 1000000) / 1000000;
            if (a.i() && a.ab) {
                return this.ae(b, null);
            }
            e = MathUtil.s(b);
        }
        return e;
    };
    NumericAxisRenderer.prototype.ae = function (a, b) {
        if (this.ad) {
            return a.toString();
        }
        if (this.ac == null) {
            this.ac = NumberAbbreviatorFactory.a(this.b.a.bu);
            if (this.ac == null) {
                this.ad = true;
                return a.toString();
            }
        }
        return this.ac.abbreviate(a, b);
    };
    NumericAxisRenderer.$t = markType(NumericAxisRenderer, 'NumericAxisRenderer', AxisRendererBase.$);
    return NumericAxisRenderer;
}(AxisRendererBase));
export { NumericAxisRenderer };
/**
 * @hidden
 */
var VerticalAxisLabelPanel = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(VerticalAxisLabelPanel, _super);
    function VerticalAxisLabelPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.di = 0;
        _this.df = 0;
        _this.dh = 0;
        _this.dg = 0;
        return _this;
    }
    VerticalAxisLabelPanel.prototype.ae = function () {
        return new VerticalAxisLabelPanelView(this);
    };
    VerticalAxisLabelPanel.prototype.ch = function (a) {
        _super.prototype.ch.call(this, a);
        this.c9 = a;
    };
    VerticalAxisLabelPanel.prototype.b6 = function () {
        this.c9.a0();
    };
    VerticalAxisLabelPanel.prototype.bq = function () {
        return this.ad.bf != null ? this.ad.bf.angle : -90;
    };
    VerticalAxisLabelPanel.prototype.db = function () {
        var a = 0;
        var b = this.aj(this.ad.bf);
        if (b == 1) {
            a += this.bu();
        }
        var c = this.ah;
        if (c == 3 || c == 7) {
            a += this.ad.dz;
        }
        return a;
    };
    VerticalAxisLabelPanel.prototype.dd = function () {
        var a = 0;
        var b = this.aj(this.ad.bf);
        if (b == 2) {
            a += this.bu();
        }
        var c = this.ah;
        if (c == 2 || c == 6) {
            a += this.ad.dz;
        }
        return a;
    };
    VerticalAxisLabelPanel.prototype.de = function () {
        var a = (this.bd - this.db()) - this.dd();
        if (a < 0) {
            a = 0;
        }
        return a;
    };
    VerticalAxisLabelPanel.prototype.dc = function () {
        var a = ((this.de() - this.af.p()) - this.af.q());
        if (a < 0) {
            a = 0;
        }
        return a;
    };
    VerticalAxisLabelPanel.prototype.a5 = function () {
        var a = new List$1(Rect.$, 0);
        this.aw = false;
        this.av = false;
        if (this.ag != null && this.ag.k() && this.bl() % 360 != 0) {
            this.av = true;
        }
        this.di = -1.7976931348623157E+308;
        this.df = -1.7976931348623157E+308;
        this.dh = -1.7976931348623157E+308;
        this.dg = -1.7976931348623157E+308;
        var b = this.af.p();
        var c = this.af.r();
        var d = this.af.q();
        var e = this.af.o();
        var f = this.db();
        var g = false;
        if (!isNaN_(this.be)) {
            this.di = Math.max(this.be, this.di);
            this.dh = Math.max(this.bf, this.dh);
        }
        for (var h = 0; h < this.bb.count; h++) {
            var i = this.bb._inner[h];
            var j = this.ba._inner[h].a;
            var k = this.bj(i);
            var l = this.bk(i);
            var m = k + c + e;
            var n = l + b + d;
            var o = this.c1.left + f;
            var p = this.ba._inner[h].c - m / 2;
            if (j) {
                var q = this.be;
                if ((isNaN_(this.be) || n > this.be || this.ba._inner[h].b) && !g) {
                    if (this.ba._inner[h].b) {
                        g = true;
                    }
                    this.ba._inner[h].b = false;
                    this.be = n;
                    this.bf = l;
                }
                this.di = Math.max(this.be, this.di);
                this.df = Math.max(m, this.df);
                this.dh = Math.max(this.bf, this.dh);
                this.dg = Math.max(k, this.dg);
            }
            else {
                this.di = Math.max(n, this.di);
                this.df = Math.max(m, this.df);
                this.dh = Math.max(l, this.dh);
                this.dg = Math.max(k, this.dg);
            }
            var r = new Rect(0, o, p, n, m);
            a.add(r);
        }
        var s = 0;
        if (this.av) {
            s = this.bl() % 360;
            if (s < 0) {
                s += 360;
            }
        }
        var t = this.ad.b8();
        if (!t) {
            this.dj(s, b, d);
        }
        else {
            this.af.ac();
        }
        if (this.av) {
            for (var u = 0; u < a.count; u++) {
                var v = a._inner[u];
                v.y = this.ba._inner[u].c - this.df / 2;
                a._inner[u] = v;
            }
        }
        var w = false;
        if (!this.av && this.di <= this.bd) {
            w = true;
        }
        if (!w) {
            var x = this.c1.height;
            var y = this.de();
            var z = y;
            var aa = this.ba.count > 1 ? Math.abs(this.ba._inner[1].c - this.ba._inner[0].c) : x;
            var ab = Math.abs(Math.asin(aa / this.di) * (180 / Math.PI));
            var ac = (s >= ab && s <= 180 - ab) || (s - 180 >= ab && s - 180 <= 180 - ab);
            for (var ad = 0; ad < a.count; ad++) {
                if (this.av) {
                    var ae = s * (Math.PI / 180);
                    var af = this.bv(this.bb._inner[ad]);
                    z = Math.min(y / Math.abs(Math.cos(ae)), af);
                    if (ac) {
                        var ag = void 0;
                        if (s > 0 && s < 90) {
                            ag = (Math.PI / 180) * (90 - s);
                        }
                        else if (s > 270 && s < 360) {
                            ag = (Math.PI / 180) * (s - 270);
                        }
                        else {
                            ag = 0;
                        }
                        z = aa / Math.cos(ag);
                    }
                }
                var ah = a._inner[ad];
                ah.width = Math.min(ah.width, z);
                a._inner[ad] = ah;
                if (!(typeCast(TextBlock.$, this.bb._inner[ad]) !== null)) {
                    this.bb._inner[ad].width = z;
                }
                var ai = typeCast(TextBlock.$, this.bb._inner[ad]);
                if (ai != null) {
                    var aj = this.b1(ad, ai, z, b, d);
                    if (!Base.equalsStatic(ai.al, aj)) {
                        ai.al = aj;
                        this.bb._inner[ad].width = z;
                    }
                }
            }
            if (!t) {
                this.dj(s, b, d);
            }
        }
        if (this.da()) {
            this.dk(a);
        }
        return a;
    };
    VerticalAxisLabelPanel.prototype.dj = function (a, b, c) {
        var d = a * (Math.PI / 180);
        var e = Math.abs(this.dh * Math.cos(d)) + Math.abs(this.dg * Math.sin(d));
        var f = this.bu();
        var g = (e + b + c) + (f) + this.ad.dz;
        this.bh = Math.max(this.ad.es, g);
    };
    VerticalAxisLabelPanel.prototype.dk = function (a) {
        this.c9.a1(a, this.di);
    };
    VerticalAxisLabelPanel.prototype.cm = function (a, b) {
        var c = 0;
        var d = this.dg / 2;
        var e = new TransformGroup();
        var f = AngleSimplifier.a(this.bl());
        var g = ((function () {
            var $ret = new RotateTransform();
            $ret.j = f;
            $ret.k = c;
            $ret.l = d;
            return $ret;
        })());
        var h = 0;
        var i = 0;
        if (f != 0 && f != 360) {
            f -= 90;
            if (f > 0 && f < 180) {
                g.k = this.dh;
                h = -this.dh + this.dg / 2;
                h = h + Math.sin(MathUtil.o(f - 180)) * (this.dg / 2);
            }
            else {
                if (f >= 180) {
                    h = h - Math.cos(MathUtil.o(f)) * (this.dg / 2);
                }
                else {
                    h = h + Math.cos(MathUtil.o(f)) * (this.dg / 2);
                }
            }
        }
        var j = ((function () {
            var $ret = new TranslateTransform();
            $ret.j = h;
            $ret.k = i;
            return $ret;
        })());
        e.j.add(g);
        e.j.add(j);
        a.j = e;
    };
    VerticalAxisLabelPanel.prototype.da = function () {
        return !this.aw && !this.av;
    };
    VerticalAxisLabelPanel.prototype.c0 = function () {
        var a = this.aj(this.ad.bf);
        var b = this.bu();
        var c = this.ah;
        var d = 0;
        if (a == 1) {
            d += this.c1.left;
            if (c == 3 || c == 7) {
                d += this.ad.dz;
            }
        }
        else {
            d = this.c1.right - b;
            if (c == 6 || c == 2) {
                d -= this.ad.dz;
            }
        }
        var e = this.bs();
        var f = 0;
        var g = this.ad.bf == null ? 1 : this.ad.bf.verticalAlignment;
        if (g == 0) {
            f = this.c1.top;
        }
        else if (g == 2) {
            f = this.c1.bottom - e;
        }
        else {
            f = (this.c1.top + (this.c1.height / 2)) - (e / 2);
        }
        return new Rect(0, d, f, b, e);
    };
    VerticalAxisLabelPanel.prototype.aj = function (a) {
        if (a == null) {
            return this.ad.bi.aq(this.ad);
        }
        if (a.position == 0) {
            if (this.ad != null && this.ad.bi != null) {
                return this.ad.bi.aq(this.ad);
            }
            return 1;
        }
        return a.position;
    };
    VerticalAxisLabelPanel.prototype.ai = function () {
        return 2;
    };
    VerticalAxisLabelPanel.prototype.ay = function (a) {
        return a == 2 || a == 3 || a == 6 || a == 7;
    };
    VerticalAxisLabelPanel.prototype.b9 = function () {
        var e_49, _a;
        var a = this.af.au();
        this.ad.hi(a);
        if (this.ag != null && this.ag.visibility != 0) {
            return;
        }
        var b = this.ad.dz;
        if (b == 0) {
            return;
        }
        var c = this.a2();
        if (c == null) {
            return;
        }
        var d = this.c1.left;
        var e;
        var f = this.ah;
        if (f == 2 || f == 6) {
            d = this.c1.right;
            e = d - b;
        }
        else {
            e = d + b;
        }
        var g = this.af.b();
        try {
            for (var _b = __values(fromEnum(c)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var h = _c.value;
                this.cc(a, h, d, e, this.c4, g);
            }
        }
        catch (e_49_1) {
            e_49 = { error: e_49_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_49)
                    throw e_49.error;
            }
        }
        if (!this.ab.contains(this.af.aw)) {
            this.ab.add(this.af.aw);
        }
    };
    VerticalAxisLabelPanel.$t = markType(VerticalAxisLabelPanel, 'VerticalAxisLabelPanel', AxisLabelPanelBase.$);
    return VerticalAxisLabelPanel;
}(AxisLabelPanelBase));
export { VerticalAxisLabelPanel };
/**
 * @hidden
 */
export var IHasCategoryAxis_$type = /*@__PURE__*/ new Type(null, 'IHasCategoryAxis');
/**
 * @hidden
 */
export var IHasCategoryModePreference_$type = /*@__PURE__*/ new Type(null, 'IHasCategoryModePreference', null, [IHasCategoryAxis_$type]);
/**
 * @hidden
 */
var AutomaticSeriesManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AutomaticSeriesManager, _super);
    function AutomaticSeriesManager(a) {
        var _this = _super.call(this) || this;
        _this.g = new HashSet$1(AutomaticSeriesPurpose_$type, 0);
        _this.c = null;
        _this.f = false;
        _this.a = null;
        _this.a = new AutomaticSeriesRequestCollection();
        var b = _this.a;
        b.collectionChanged = delegateCombine(b.collectionChanged, runOn(_this, _this.i));
        var c = a.series;
        _this.c = c;
        c.collectionChanged = delegateCombine(c.collectionChanged, runOn(_this, _this.m));
        c.collectionResetting = delegateCombine(c.collectionResetting, runOn(_this, _this.n));
        return _this;
    }
    AutomaticSeriesManager.prototype.e = function (a) {
        return this.g.contains(a);
    };
    AutomaticSeriesManager.prototype.i = function (a, b) {
        this.j();
    };
    AutomaticSeriesManager.prototype.n = function (a, b) {
        this.j();
    };
    AutomaticSeriesManager.prototype.m = function (a, b) {
        this.j();
    };
    AutomaticSeriesManager.prototype.j = function () {
        if (this.f) {
            return;
        }
        this.f = true;
        try {
            this.k();
        }
        finally {
            this.f = false;
        }
    };
    AutomaticSeriesManager.prototype.k = function () {
        this.g.clear();
        var a = new Dictionary$2(Series.$, Number_$type, 0);
        var b = new Dictionary$2(Series.$, AutomaticSeriesRequest.$, 0);
        for (var c = 0; c < this.c.count; c++) {
            a.addItem(this.c._inner[c], c);
        }
        for (var d = 0; d < this.a.count; d++) {
            this.g.add_1(this.a._inner[d].a);
            b.addItem(this.a._inner[d].d, this.a._inner[d]);
        }
        var e = new List$1(Series.$, 0);
        var f = new List$1(AutomaticSeriesRequest.$, 0);
        var g = new List$1(AutomaticSeriesRequest.$, 0);
        for (var h = 0; h < this.a.count; h++) {
            if (!a.containsKey(this.a._inner[h].d)) {
                f.add(this.a._inner[h]);
            }
        }
        for (var i = 0; i < this.c.count; i++) {
            if (this.c._inner[i].dh && !b.containsKey(this.c._inner[i])) {
                e.add(this.c._inner[i]);
            }
            if (b.containsKey(this.c._inner[i]) && this.d(b.item(this.c._inner[i]), a, b)) {
                e.add(this.c._inner[i]);
                g.add(b.item(this.c._inner[i]));
                f.add(b.item(this.c._inner[i]));
            }
        }
        for (var j = e.count - 1; j >= 0; j--) {
            var k = e._inner[j];
            var l = a.item(k);
            this.c.removeAt(l);
        }
        a.clear();
        for (var m = 0; m < this.c.count; m++) {
            a.addItem(this.c._inner[m], m);
        }
        for (var n = 0; n < f.count; n++) {
            f._inner[n].d.dh = true;
            var o = this.h(f._inner[n], a);
            this.c.insert(o, f._inner[n].d);
            a.item(f._inner[n].d, o);
            for (var p = o; p < this.c.count; p++) {
                var q = this.c._inner[p];
                if (a.containsKey(q)) {
                    a.item(q, p);
                }
            }
        }
    };
    AutomaticSeriesManager.prototype.l = function (a) {
        for (var b = this.a.count - 1; b >= 0; b--) {
            if (this.a._inner[b].a == a) {
                this.a.removeAt(b);
            }
        }
    };
    AutomaticSeriesManager.prototype.h = function (a, b) {
        if (a.f) {
            return 0;
        }
        if (a.e) {
            return this.c.count;
        }
        if (a.c != null) {
            if (!b.containsKey(a.c)) {
                return this.c.count;
            }
            var c = b.item(a.c);
            return c - 1;
        }
        if (a.b != null) {
            if (!b.containsKey(a.b)) {
                return this.c.count;
            }
            var d = b.item(a.b);
            return d + 1;
        }
        return this.c.count;
    };
    AutomaticSeriesManager.prototype.d = function (a, b, c) {
        var d = b.item(a.d);
        if (a.f) {
            for (var e = d; e >= 0; e--) {
                if (!c.containsKey(this.c._inner[e])) {
                    return true;
                }
            }
        }
        if (a.e) {
            for (var f = d; f < this.c.count; f++) {
                if (!c.containsKey(this.c._inner[f])) {
                    return true;
                }
            }
        }
        if (a.c != null) {
            if (!b.containsKey(a.c)) {
                return false;
            }
            var g = b.item(a.c);
            if (d != g - 1) {
                return true;
            }
        }
        if (a.b != null) {
            if (!b.containsKey(a.b)) {
                return false;
            }
            var h = b.item(a.b);
            if (d != h + 1) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(AutomaticSeriesManager.prototype, "b", {
        get: function () {
            return this.a;
        },
        enumerable: false,
        configurable: true
    });
    AutomaticSeriesManager.$t = markType(AutomaticSeriesManager, 'AutomaticSeriesManager');
    return AutomaticSeriesManager;
}(Base));
export { AutomaticSeriesManager };
/**
 * @hidden
 */
var AutomaticSeriesRequest = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AutomaticSeriesRequest, _super);
    function AutomaticSeriesRequest() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = 0;
        _this.d = null;
        _this.b = null;
        _this.c = null;
        _this.e = false;
        _this.f = false;
        return _this;
    }
    AutomaticSeriesRequest.$t = markType(AutomaticSeriesRequest, 'AutomaticSeriesRequest');
    return AutomaticSeriesRequest;
}(Base));
export { AutomaticSeriesRequest };
/**
 * @hidden
 */
var AutomaticSeriesRequestCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AutomaticSeriesRequestCollection, _super);
    function AutomaticSeriesRequestCollection() {
        return _super.call(this, AutomaticSeriesRequest.$, 0) || this;
    }
    AutomaticSeriesRequestCollection.$t = markType(AutomaticSeriesRequestCollection, 'AutomaticSeriesRequestCollection', ObservableCollection$1.$.specialize(AutomaticSeriesRequest.$));
    return AutomaticSeriesRequestCollection;
}(ObservableCollection$1));
export { AutomaticSeriesRequestCollection };
/**
 * @hidden
 */
export var IDataChartToolbarProvider_$type = /*@__PURE__*/ new Type(null, 'IDataChartToolbarProvider');
/**
 * @hidden
 */
export var ISeriesViewerScrollbarManager_$type = /*@__PURE__*/ new Type(null, 'ISeriesViewerScrollbarManager');
/**
 * @hidden
 */
export var IHighlightingManager_$type = /*@__PURE__*/ new Type(null, 'IHighlightingManager');
/**
 * @hidden
 */
var HighlightingInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(HighlightingInfo, _super);
    function HighlightingInfo() {
        var _this = _super.call(this) || this;
        _this.i = 0;
        _this.h = 0;
        _this.g = 0;
        _this.a = 0;
        _this.f = 0;
        _this.e = false;
        _this.d = false;
        _this.c = false;
        _this.b = null;
        _this.a = HighlightingState.outward;
        _this.f = 0;
        _this.e = false;
        return _this;
    }
    HighlightingInfo.$t = markType(HighlightingInfo, 'HighlightingInfo');
    return HighlightingInfo;
}(Base));
export { HighlightingInfo };
/**
 * @hidden
 */
export var ISeriesInteractionManager_$type = /*@__PURE__*/ new Type(null, 'ISeriesInteractionManager');
/**
 * @hidden
 */
export var ISeriesViewerInteractionManager_$type = /*@__PURE__*/ new Type(null, 'ISeriesViewerInteractionManager');
/**
 * @hidden
 */
export var IDataChartVisualDataManager_$type = /*@__PURE__*/ new Type(null, 'IDataChartVisualDataManager');
/**
 * @hidden
 */
export var IAxisVisualDataManager_$type = /*@__PURE__*/ new Type(null, 'IAxisVisualDataManager');
/**
 * @hidden
 */
export var ISeriesVisualDataManager_$type = /*@__PURE__*/ new Type(null, 'ISeriesVisualDataManager');
/**
 * @hidden
 */
var XamDataChart = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XamDataChart, _super);
    function XamDataChart() {
        var _this = _super.call(this) || this;
        _this._xsr = null;
        _this.ub = null;
        _this.vc = 1;
        _this.vd = 1;
        _this.uv = false;
        _this.uz = false;
        _this.uy = false;
        _this.ve = 0;
        _this.vf = 0;
        _this.vw = NaN;
        _this.vx = NaN;
        _this.t6 = new AxisCollection();
        _this.axisRangeChanged = null;
        _this.uk = null;
        _this.un = false;
        _this.u9 = 0;
        _this.vb = 0;
        _this.va = 0;
        _this.u8 = 0;
        _this.vh = NaN;
        _this.vj = NaN;
        _this.vi = NaN;
        _this.vg = NaN;
        _this.ab = XamDataChart.$;
        _this.uy = true;
        var a = _this.axes;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.w3));
        var b = _this.axes;
        b.collectionResetting = delegateCombine(b.collectionResetting, runOn(_this, _this.w4));
        return _this;
    }
    Object.defineProperty(XamDataChart.prototype, "XSRP", {
        get: function () {
            if (this._xsr == null) {
                this._xsr = new SRProvider(this.cu.j.ae);
            }
            return this._xsr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "uc", {
        get: function () {
            var _this = this;
            if (this.ub == null) {
                this.ub = DVContainer.instance.createInstance(IDataChartVisualDataManager_$type, function () { return _this.XSRP.q; });
            }
            return this.ub;
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.staticInit = function () {
        XamDataChart.vt = -1.7976931348623157E+308;
        XamDataChart.vs = 1.7976931348623157E+308;
    };
    XamDataChart.v5 = function (a) {
        if (a.ce == null) {
            return -1;
        }
        if (!a.d1) {
            return -1;
        }
        var b = XamDataChartView.aw(a);
        if (b.count == 0) {
            return -1;
        }
        var c = -1;
        for (var d = 0; d < b.count; d++) {
            c = Math.max(c, b._inner[d].index);
        }
        var e = c + 1;
        if (a.dx) {
            e = a.hh();
            if (e == -1) {
                return -1;
            }
            var f = a.bg();
            e = f.index + e;
        }
        return e;
    };
    XamDataChart.prototype.od = function (a, b, c, d) {
        var e_50, _a, e_51, _b, e_52, _c;
        _super.prototype.od.call(this, a, b, c, d);
        switch (b) {
            case XamDataChart.$$p[23]:
                this.vo = this.v3;
                break;
            case XamDataChart.$$p[24]:
                this.vp = this.v4;
                break;
            case "ActualWindowScaleHorizontal":
            case "ActualWindowScaleVertical":
                if (!this.fg) {
                    this.pp(this.gp(), this.gq());
                }
                break;
            case XamDataChart.$$p[8]:
                this.cu.fr(d);
                {
                    try {
                        for (var _d = __values(fromEnum(this.axes)), _e = _d.next(); !_e.done; _e = _d.next()) {
                            var e = _e.value;
                            e.h7();
                        }
                    }
                    catch (e_50_1) {
                        e_50 = { error: e_50_1 };
                    }
                    finally {
                        try {
                            if (_e && !_e.done && (_a = _d.return))
                                _a.call(_d);
                        }
                        finally {
                            if (e_50)
                                throw e_50.error;
                        }
                    }
                }
                break;
            case XamDataChart.$$p[9]:
                this.uu = this.ut;
                break;
            case XamDataChart.$$p[22]:
                this.ux = this.u6;
                break;
            case XamDataChart.$$p[11]:
            case XamDataChart.$$p[13]:
                this.pl();
                break;
            case XamDataChart.$$p[0]:
            case XamDataChart.$$p[17]:
                if (c != d) {
                    try {
                        for (var _f = __values(fromEnum(this.axes)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var f = _g.value;
                            f.cq = true;
                            f.h7();
                        }
                    }
                    catch (e_51_1) {
                        e_51 = { error: e_51_1 };
                    }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return))
                                _b.call(_f);
                        }
                        finally {
                            if (e_51)
                                throw e_51.error;
                        }
                    }
                }
                break;
            case XamDataChart.$$p[7]:
            case XamDataChart.$$p[5]:
            case XamDataChart.$$p[6]:
                try {
                    for (var _h = __values(fromEnum(this.axes)), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var g = _j.value;
                        g.ij();
                    }
                }
                catch (e_52_1) {
                    e_52 = { error: e_52_1 };
                }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return))
                            _c.call(_h);
                    }
                    finally {
                        if (e_52)
                            throw e_52.error;
                    }
                }
                break;
            case XamDataChart.$$p[4]:
                this.w7();
                break;
        }
    };
    XamDataChart.prototype.ou = function () {
        _super.prototype.ou.call(this);
        if (this.t5 == 1 || this.t5 == 2) {
            this.xb();
        }
    };
    XamDataChart.prototype.m3 = function () {
        _super.prototype.m3.call(this);
        if (this.uo && this.t5 != 0) {
            if (!this.u5) {
                this.xb();
            }
        }
    };
    XamDataChart.prototype.mu = function (a, b) {
        _super.prototype.mu.call(this, a, b);
        if (this.uo && this.t5 == 2) {
            if (!a.isEmpty && !b.isEmpty) {
                if (Math.abs(a.width - b.width) > 1E-10) {
                    if (!this.u5) {
                        this.xb();
                    }
                }
            }
        }
    };
    XamDataChart.prototype.my = function () {
        _super.prototype.my.call(this);
        if (this.t8 == 1) {
            this.w7();
        }
    };
    XamDataChart.prototype.xc = function () {
        this.w7();
    };
    XamDataChart.prototype.w7 = function () {
        var e_53, _a, e_54, _b;
        var a = this.x7();
        this.un = false;
        if (!isNaN_(this.vz)) {
            this.vl = this.vz;
        }
        else {
            this.vl = a.left;
        }
        if (!isNaN_(this.v1)) {
            this.vn = this.v1;
        }
        else {
            this.vn = a.top;
        }
        if (!isNaN_(this.v0)) {
            this.vm = this.v0;
        }
        else {
            this.vm = a.right;
        }
        if (!isNaN_(this.vy)) {
            this.vk = this.vy;
        }
        else {
            this.vk = a.bottom;
        }
        this.tn = this.tl(this.ty);
        if (this.un) {
            this.un = false;
            try {
                for (var _c = __values(fromEnum(this.axes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var b = _d.value;
                    b.cq = true;
                    b.h7();
                }
            }
            catch (e_53_1) {
                e_53 = { error: e_53_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_53)
                        throw e_53.error;
                }
            }
            try {
                for (var _e = __values(fromEnum(this.series)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var c = _f.value;
                    c.mn(false);
                }
            }
            catch (e_54_1) {
                e_54 = { error: e_54_1 };
            }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return))
                        _b.call(_e);
                }
                finally {
                    if (e_54)
                        throw e_54.error;
                }
            }
        }
    };
    XamDataChart.prototype.x7 = function () {
        this.xe();
        switch (this.t8) {
            case 1:
                var a = this.x8();
                return a;
            default: return new Thickness(1, 0, 0, 0, 0);
        }
    };
    XamDataChart.prototype.xe = function () {
        this.bx = this.ue();
        this.bz = this.uh();
    };
    XamDataChart.prototype.uh = function () {
        var e_55, _a;
        var a = 1;
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                var c = b.bx();
                a = this.ug(a, c);
            }
        }
        catch (e_55_1) {
            e_55 = { error: e_55_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_55)
                    throw e_55.error;
            }
        }
        return a;
    };
    XamDataChart.prototype.ug = function (a, b) {
        switch (a) {
            case 2: return 2;
            case 4:
                if (b == 2 || b == 3) {
                    return 2;
                }
                return a;
            case 3:
                if (b == 2 || b == 4) {
                    return 2;
                }
                return a;
            case 1: return b;
        }
        return a;
    };
    XamDataChart.prototype.ue = function () {
        var e_56, _a;
        var a = 1;
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                var c = b.bw();
                a = this.ud(a, c);
            }
        }
        catch (e_56_1) {
            e_56 = { error: e_56_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_56)
                    throw e_56.error;
            }
        }
        return a;
    };
    XamDataChart.prototype.ud = function (a, b) {
        switch (a) {
            case 2: return 2;
            case 4:
                if (b == 2 || b == 3) {
                    return 2;
                }
                return a;
            case 3:
                if (b == 2 || b == 4) {
                    return 2;
                }
                return a;
            case 1: return b;
        }
        return a;
    };
    XamDataChart.prototype.x8 = function () {
        var a = new Thickness(1, 0, 0, 0, 0);
        for (var b = 0; b < this.series.count; b++) {
            var c = this.series._inner[b];
            var d = c.p8();
            a = new Thickness(1, Math.max(d.left, a.left), Math.max(d.top, a.top), Math.max(d.right, a.right), Math.max(d.bottom, a.bottom));
        }
        return a;
    };
    XamDataChart.prototype.x9 = function (a, b) {
        var c = new Thickness(1, 0, 0, 0, 0);
        for (var d = 0; d < this.series.count; d++) {
            var e = this.series._inner[d];
            var f = e.qa(a, b);
            c = new Thickness(1, Math.max(f.left, c.left), Math.max(f.top, c.top), Math.max(f.right, c.right), Math.max(f.bottom, c.bottom));
        }
        return c;
    };
    XamDataChart.prototype.get_d5 = function () {
        return this.t8 == 1;
    };
    XamDataChart.prototype.gp = function () {
        return this.vo;
    };
    XamDataChart.prototype.gq = function () {
        return this.vp;
    };
    XamDataChart.prototype.pd = function () {
        _super.prototype.pd.call(this);
        this.vo = this.tj.width;
        this.vp = this.tj.height;
    };
    Object.defineProperty(XamDataChart.prototype, "vo", {
        get: function () {
            return this.vc;
        },
        set: function (a) {
            var b = this.vc;
            this.vc = a;
            this.oi("ActualWindowScaleHorizontal", b, this.vc);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vp", {
        get: function () {
            return this.vd;
        },
        set: function (a) {
            var b = this.vd;
            this.vd = a;
            this.oi("ActualWindowScaleVertical", b, this.vd);
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.prototype.es = function () {
        return this.uu;
    };
    XamDataChart.prototype.et = function () {
        return this.ux;
    };
    Object.defineProperty(XamDataChart.prototype, "uo", {
        get: function () {
            return this.u0 || this.u3;
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.prototype.get_e1 = function () {
        return this.up;
    };
    Object.defineProperty(XamDataChart.prototype, "up", {
        get: function () {
            return this.u4 || (this.e0 && this.t5 != 0);
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.prototype.get_e0 = function () {
        return this.u3;
    };
    XamDataChart.prototype.get_ez = function () {
        return this.u0;
    };
    XamDataChart.prototype.xb = function () {
        this.uv = false;
        this.uz = true;
        this.uy = true;
        for (var a = 0; a < this.axes.count; a++) {
            this.axes._inner[a].cq = true;
            this.axes._inner[a].h7();
        }
    };
    XamDataChart.prototype.xa = function () {
        this.uv = false;
        this.uy = true;
        for (var a = 0; a < this.axes.count; a++) {
            this.axes._inner[a].cq = true;
            this.axes._inner[a].h7();
        }
    };
    XamDataChart.prototype.w9 = function (a, b, c, d) {
        if (a.ad == null) {
            return;
        }
        if (a.ad.cq || a.ad.kd.isEmpty) {
            return;
        }
        var e = false;
        for (var f = 0; f < this.axes.count; f++) {
            var g = this.axes._inner[f].aw.bh;
            this.axes._inner[f].aw.ca();
            if (this.axes._inner[f].aw.bh != g) {
                e = true;
            }
        }
        if (e) {
            return;
        }
        if (isNaN_(this.vw)) {
            this.vw = this.cu.a4;
            this.vx = this.cu.a5;
        }
        var h = false;
        var i = false;
        var j = 0;
        if (a.au) {
            var k = this.uy;
            if (this.u3 && this.uy) {
                j = this.v2(a, b, c, d);
                this.uy = false;
                if (a.bl() != j) {
                    if (j == 0 && a.ad.b4) {
                        if (k) {
                            this.uz = true;
                            a.ad.ia();
                            h = true;
                            i = true;
                        }
                    }
                    else {
                        if ((j > a.bl()) || k) {
                            this.uz = true;
                            a.ad.ig(j);
                            h = true;
                            i = true;
                        }
                    }
                }
            }
        }
        this.ds = h;
        if (a.bl() != 0 || j != 0 || h) {
            var l = a.bl();
            var m = c.left + c.width / 2;
            var n = d.left + d.width / 2;
            if (a.av) {
                m = c.left;
                n = d.left;
            }
            if (l == 0) {
                m = m - a.c3.width / 2;
                n = n - a.c3.width / 2;
            }
            var o = a.cz(new Rect(0, m, c.top, a.c3.width, a.c3.height), l);
            var p = a.cz(new Rect(0, n, d.top, a.c3.width, a.c3.height), l);
            c = o;
            d = p;
        }
        var q = false;
        if (this.uz) {
            this.uz = false;
            q = true;
        }
        this.uv = true;
        var r = 0;
        var s = 0;
        var t = 0;
        var u = c.left + t;
        var v = d.right + t;
        var w = 0;
        w = this.ty.right + this.cu.a5;
        if (u < 0) {
            r = -u;
            r += this.vq;
        }
        if (v > w) {
            s = v - w;
            s += this.vq;
        }
        if (q) {
            if (u > 0) {
                r = -u;
                r += this.vq;
            }
            if (v < w) {
                s = -(w - v);
                s += this.vq;
            }
        }
        var x = false;
        var y = false;
        if (r != 0 || s != 0) {
            x = true;
            this.ve = this.ve + r;
            this.vf = this.vf + s;
            if (this.ve > this.vr) {
                this.ve = this.vr;
                y = true;
            }
            if (this.vf > this.vr) {
                this.vf = this.vr;
                y = true;
            }
            if (this.ve < 0) {
                this.ve = 0;
                y = true;
            }
            if (this.vf < 0) {
                this.vf = 0;
                y = true;
            }
        }
        else {
            if (this.ds) {
                this.w6();
            }
            return;
        }
        this.ff = true;
        this.gz = this.vw + this.ve;
        this.g4 = this.vx + this.vf;
        this.ff = false;
        this.ex = x;
        if (y) {
            if (q && (this.ex || this.ds)) {
                this.w6();
            }
            return;
        }
        if (this.ex || this.ds) {
            this.w6();
        }
    };
    XamDataChart.prototype.v2 = function (a, b, c, d) {
        var e = this.vu(-1, a, b, c, d);
        var f = a.bl();
        if (e < f) {
            var g = c.left + c.width / 2;
            var h = d.left + d.width / 2;
            if (a.av) {
                g = c.left;
                h = d.left;
            }
            var i = a.cz(new Rect(0, g, c.top, a.c3.width, a.c3.height), e);
            var j = a.cz(new Rect(0, h, d.top, a.c3.width, a.c3.height), e);
            if (e == 0) {
                i = new Rect(0, g - a.c3.width / 2, c.top, a.c3.width, a.c3.height);
                j = new Rect(0, h - a.c3.width / 2, d.top, a.c3.width, a.c3.height);
            }
            var k = a.cz(new Rect(0, g, c.top, a.c3.width, a.c3.height), f);
            var l = a.cz(new Rect(0, h, d.top, a.c3.width, a.c3.height), f);
            var m = j.right - l.right;
            var n = 0;
            var o = 0;
            o = this.ty.right + this.cu.a5;
            var p = i.left + n;
            var q = j.right + n;
            var r = 0;
            var s = 0;
            if (p < 0) {
                r = -p;
                r += this.vq;
            }
            if (q > o) {
                s = q - o;
                s += this.vq;
            }
            var t = false;
            if (this.uz || this.uy) {
                t = true;
            }
            if (t) {
                if (p > 0) {
                    r = -p;
                    r += this.vq;
                }
                if (q < o) {
                    s = -(o - q);
                    s += this.vq;
                }
            }
            var u = false;
            var v = false;
            var w = 0;
            var x = 0;
            if (r != 0 || s != 0) {
                v = true;
                w = this.ve + r;
                x = this.vf + s;
                if (w > this.vr) {
                    w = this.vr;
                    u = true;
                }
                if (x > this.vr) {
                    x = this.vr;
                    u = true;
                }
                if (w < 0) {
                    w = 0;
                    u = true;
                }
                if (x < 0) {
                    x = 0;
                    u = true;
                }
            }
            var y = this.cu.a4;
            var z = this.cu.a5;
            var aa = new Thickness(1, this.vw + w, 0, this.vx + x, 0);
            var ab = (aa.left - y) + (aa.right - z);
            var ac = a.ad.j7().width;
            var ad = ac - ab;
            var ae = ad / ac;
            var af = a.bn() * ae;
            var ag = this.vu(af, a, b, c, d);
            if (ag == e) {
                return e;
            }
            else {
                return f;
            }
        }
        return e;
    };
    XamDataChart.prototype.vu = function (a, b, c, d, e) {
        var f = b.c3;
        var g = b.bn();
        if (a < 0) {
        }
        if (a > 0) {
            g = a;
        }
        if (f.width < g) {
            return 0;
        }
        var h = 45;
        var i = new Rect(0, 0, f.top, f.width, f.height);
        var j = new Rect(0, g, f.top, f.width, f.height);
        var k = b.ac(i, h);
        var l = b.ac(j, h);
        var m = true;
        for (var n = 0; n < k.length; n++) {
            if (PolygonUtil.a(l, k[n])) {
                m = false;
                break;
            }
        }
        if (!m) {
            h = 90;
        }
        return h;
    };
    XamDataChart.prototype.w6 = function () {
        for (var a = 0; a < this.axes.count; a++) {
            this.axes._inner[a].cq = true;
            this.axes._inner[a].h8(false);
        }
        this.l5(true, false, false);
        this.uv = false;
        for (var b = 0; b < this.axes.count; b++) {
            this.axes._inner[b].cq = true;
            this.axes._inner[b].h8(false);
        }
        this.l5(true, false, false);
    };
    Object.defineProperty(XamDataChart.prototype, "axes", {
        get: function () {
            return this.t6;
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.prototype.w3 = function (a, b) {
        var e_57, _a, e_58, _b, e_59, _c;
        if (b.oldItems != null) {
            try {
                for (var _d = __values(fromEn(b.oldItems)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var c = _e.value;
                    if (c != null) {
                        c.bo = null;
                        c.bi = null;
                        this.oy(c);
                        this.cu.dw(c);
                        c.rangeChanged = delegateRemove(c.rangeChanged, runOn(this, this.w5));
                        this.cu.dx(c);
                        if (c.de != null) {
                            try {
                                for (var _f = (e_58 = void 0, __values(fromEnum(c.db()))), _g = _f.next(); !_g.done; _g = _f.next()) {
                                    var d = _g.value;
                                    d.mn(false);
                                }
                            }
                            catch (e_58_1) {
                                e_58 = { error: e_58_1 };
                            }
                            finally {
                                try {
                                    if (_g && !_g.done && (_b = _f.return))
                                        _b.call(_f);
                                }
                                finally {
                                    if (e_58)
                                        throw e_58.error;
                                }
                            }
                        }
                    }
                }
            }
            catch (e_57_1) {
                e_57 = { error: e_57_1 };
            }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return))
                        _a.call(_d);
                }
                finally {
                    if (e_57)
                        throw e_57.error;
                }
            }
            if (this.axes.count == 0) {
                this.o3();
            }
        }
        if (b.newItems != null) {
            try {
                for (var _h = __values(fromEn(b.newItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var e = _j.value;
                    if (e != null) {
                        this.pg(e);
                        e.bo = this.actualSyncLink;
                        e.bi = this;
                        e.a5.az();
                        this.cu.bo(e);
                        e.rangeChanged = delegateCombine(e.rangeChanged, runOn(this, this.w5));
                        this.cu.bl(e);
                    }
                }
            }
            catch (e_59_1) {
                e_59 = { error: e_59_1 };
            }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return))
                        _c.call(_h);
                }
                finally {
                    if (e_59)
                        throw e_59.error;
                }
            }
        }
        this.mr();
    };
    XamDataChart.prototype.w4 = function (a, b) {
        var e_60, _a, e_61, _b, e_62, _c, e_63, _d;
        var c = new List$1(Series.$, 0);
        try {
            for (var _e = __values(fromEnum(this.axes)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var d = _f.value;
                if (d.de != null) {
                    try {
                        for (var _g = (e_61 = void 0, __values(fromEnum(d.db()))), _h = _g.next(); !_h.done; _h = _g.next()) {
                            var e = _h.value;
                            if (!c.contains(e)) {
                                c.add(e);
                            }
                        }
                    }
                    catch (e_61_1) {
                        e_61 = { error: e_61_1 };
                    }
                    finally {
                        try {
                            if (_h && !_h.done && (_b = _g.return))
                                _b.call(_g);
                        }
                        finally {
                            if (e_61)
                                throw e_61.error;
                        }
                    }
                }
                d.bo = null;
                d.bi = null;
                this.oy(d);
                this.cu.dw(d);
                d.rangeChanged = delegateRemove(d.rangeChanged, runOn(this, this.w5));
                this.cu.dx(d);
                this.o3();
            }
        }
        catch (e_60_1) {
            e_60 = { error: e_60_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return))
                    _a.call(_e);
            }
            finally {
                if (e_60)
                    throw e_60.error;
            }
        }
        try {
            for (var _j = __values(fromEnum(this.series)), _k = _j.next(); !_k.done; _k = _j.next()) {
                var f = _k.value;
                if (!c.contains(f)) {
                    c.add(f);
                }
            }
        }
        catch (e_62_1) {
            e_62 = { error: e_62_1 };
        }
        finally {
            try {
                if (_k && !_k.done && (_c = _j.return))
                    _c.call(_j);
            }
            finally {
                if (e_62)
                    throw e_62.error;
            }
        }
        try {
            for (var _l = __values(fromEnum(c)), _m = _l.next(); !_m.done; _m = _l.next()) {
                var g = _m.value;
                g.mn(false);
            }
        }
        catch (e_63_1) {
            e_63 = { error: e_63_1 };
        }
        finally {
            try {
                if (_m && !_m.done && (_d = _l.return))
                    _d.call(_l);
            }
            finally {
                if (e_63)
                    throw e_63.error;
            }
        }
    };
    XamDataChart.prototype.w5 = function (a, b) {
        var e_64, _a, e_65, _b, e_66, _c;
        var c = typeCast(Axis.$, a);
        if (c == null) {
            return;
        }
        this.mr();
        if (this.axisRangeChanged != null) {
            this.axisRangeChanged(this, new ChartAxisRangeChangedEventArgs(this, c, b.oldMinimumValue, b.minimumValue, b.oldMaximumValue, b.maximumValue));
        }
        if (c.aj != null) {
            c.aj.h4();
        }
        c.h4();
        var d = this.dt;
        if (typeCast(CategoryAxisBase.$, c) !== null) {
            d = true;
        }
        try {
            for (var _d = __values(fromEnum(c.db())), _e = _d.next(); !_e.done; _e = _d.next()) {
                var e = _e.value;
                e.e3 = true;
                this.mr();
                e.mn(d);
            }
        }
        catch (e_64_1) {
            e_64 = { error: e_64_1 };
        }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return))
                    _a.call(_d);
            }
            finally {
                if (e_64)
                    throw e_64.error;
            }
        }
        if (c.bi != null) {
            try {
                for (var _f = __values(fromEnum(c.bi.series)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var f = _g.value;
                    XamDataChart.w8(c, d, f);
                }
            }
            catch (e_65_1) {
                e_65 = { error: e_65_1 };
            }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return))
                        _b.call(_f);
                }
                finally {
                    if (e_65)
                        throw e_65.error;
                }
            }
        }
        try {
            for (var _h = __values(fromEnum(this.axes)), _j = _h.next(); !_j.done; _j = _h.next()) {
                var g = _j.value;
                if (g != c && g.aj != null && g.aj == c) {
                    g.h4();
                }
            }
        }
        catch (e_66_1) {
            e_66 = { error: e_66_1 };
        }
        finally {
            try {
                if (_j && !_j.done && (_c = _h.return))
                    _c.call(_h);
            }
            finally {
                if (e_66)
                    throw e_66.error;
            }
        }
    };
    XamDataChart.w8 = function (a, b, c) {
    };
    XamDataChart.prototype.pn = function (a, b) {
        var e_67, _a;
        _super.prototype.pn.call(this, a, b);
        if (this.axes == null) {
            return;
        }
        try {
            for (var _b = __values(fromEnum(this.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.bo = this.actualSyncLink;
                c.bi = this;
            }
        }
        catch (e_67_1) {
            e_67 = { error: e_67_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_67)
                    throw e_67.error;
            }
        }
    };
    XamDataChart.prototype.getFontInfo = function () {
        this.uk = this.uj.fo;
        return this.uk;
    };
    XamDataChart.prototype.xd = function () {
        var e_68, _a, e_69, _b;
        this.cu.ee();
        try {
            for (var _c = __values(fromEnum(this.axes)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var a = _d.value;
                a.h8(false);
            }
        }
        catch (e_68_1) {
            e_68 = { error: e_68_1 };
        }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return))
                    _a.call(_c);
            }
            finally {
                if (e_68)
                    throw e_68.error;
            }
        }
        try {
            for (var _e = __values(fromEnum(this.series)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var b = _f.value;
                b.b1.bj();
                b.mn(false);
            }
        }
        catch (e_69_1) {
            e_69 = { error: e_69_1 };
        }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return))
                    _b.call(_e);
            }
            finally {
                if (e_69)
                    throw e_69.error;
            }
        }
    };
    XamDataChart.prototype.getFontBrush = function () {
        return this.uj.fw;
    };
    XamDataChart.prototype.l0 = function () {
        _super.prototype.l0.call(this);
        var a = new List$1(Axis.$, 0);
        for (var b = 0; b < this.axes.count; b++) {
            a.add(this.axes._inner[b]);
        }
        for (var c = 0; c < a.count; c++) {
            this.axes.remove(a._inner[c]);
            if (typeCast(CategoryAxisBase.$, a._inner[c]) !== null) {
                var d = a._inner[c];
                this.o0(d.name, true);
                d.itemsSource = null;
            }
            a._inner[c].hx(null, null);
        }
    };
    XamDataChart.prototype.so = function () {
        return this.uj.fs;
    };
    XamDataChart.prototype.e8 = function () {
        return true;
    };
    XamDataChart.prototype.ph = function () {
        var e_70, _a;
        _super.prototype.ph.call(this);
        if (!this.ev) {
            return;
        }
        try {
            for (var _b = __values(fromEnum(this.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                this.pg(a);
            }
        }
        catch (e_70_1) {
            e_70 = { error: e_70_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_70)
                    throw e_70.error;
            }
        }
    };
    XamDataChart.prototype.d4 = function () {
        if (this.uw) {
            return true;
        }
        return this.us();
    };
    XamDataChart.prototype.us = function () {
        for (var a = 0; a < this.series.count; a++) {
            if (this.series._inner[a].ed || this.series._inner[a].d9) {
                return true;
            }
        }
        for (var b = 0; b < this.axes.count; b++) {
            if (this.axes._inner[b].b9 || this.axes._inner[b].cm) {
                return true;
            }
        }
        return false;
    };
    XamDataChart.prototype.ct = function () {
        return new XamDataChartView(this);
    };
    XamDataChart.prototype.n1 = function (a) {
        _super.prototype.n1.call(this, a);
        this.uj = a;
    };
    XamDataChart.prototype.ov = function () {
        for (var a = 0; a < this.t6.count; a++) {
            this.t6._inner[a].cq = true;
            this.t6._inner[a].h8(false);
        }
        _super.prototype.ov.call(this);
    };
    Object.defineProperty(XamDataChart.prototype, "vl", {
        get: function () {
            return this.u9;
        },
        set: function (a) {
            var b = this.u9;
            this.u9 = a;
            if (this.u9 != b) {
                this.un = true;
                this.oi(XamDataChart.v8, b, this.u9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vn", {
        get: function () {
            return this.vb;
        },
        set: function (a) {
            var b = this.vb;
            this.vb = a;
            if (this.vb != b) {
                this.un = true;
                this.oi(XamDataChart.wa, b, this.vb);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vm", {
        get: function () {
            return this.va;
        },
        set: function (a) {
            var b = this.va;
            this.va = a;
            if (this.va != b) {
                this.un = true;
                this.oi(XamDataChart.v9, b, this.va);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vk", {
        get: function () {
            return this.u8;
        },
        set: function (a) {
            var b = this.u8;
            this.u8 = a;
            if (this.u8 != b) {
                this.un = true;
                this.oi(XamDataChart.v7, b, this.u8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vz", {
        get: function () {
            return this.vh;
        },
        set: function (a) {
            this.vh = a;
            this.w7();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "v1", {
        get: function () {
            return this.vj;
        },
        set: function (a) {
            this.vj = a;
            this.w7();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "v0", {
        get: function () {
            return this.vi;
        },
        set: function (a) {
            this.vi = a;
            this.w7();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(XamDataChart.prototype, "vy", {
        get: function () {
            return this.vg;
        },
        set: function (a) {
            this.vg = a;
            this.w7();
        },
        enumerable: false,
        configurable: true
    });
    XamDataChart.prototype.tl = function (a) {
        var b = _super.prototype.tl.call(this, a);
        if (a.isEmpty) {
            return Rect.empty;
        }
        if (this.vl == 0 && this.vn == 0 && this.vm == 0 && this.vk == 0) {
            return Rect.empty;
        }
        if (this.vl + this.vm >= a.width || this.vn + this.vk >= a.height) {
            return Rect.empty;
        }
        var c = new Rect(0, a.left + this.vl, a.top + this.vn, a.width - this.vl - this.vm, a.height - this.vn - this.vk);
        return c;
    };
    XamDataChart.prototype.tr = function () {
        var a = this.ty;
        var b = this.tz;
        var c = this.tn;
        if (c.isEmpty || a.isEmpty) {
            return a;
        }
        if (c.containsRect(a)) {
            return a;
        }
        if (a.containsRect(c)) {
            return c;
        }
        return a;
    };
    XamDataChart.prototype.v6 = function () {
        return this.uc.exportVisualData(this);
    };
    XamDataChart.prototype.wl = function () {
        var cvd_ = this.v6();
        cvd_.scaleByViewport();
        return (cvd_.serialize());
    };
    XamDataChart.prototype.oa = function () {
        _super.prototype.oa.call(this);
        for (var a = 0; a < this.axes.count; a++) {
            var b = this.axes._inner[a];
            var c = 50;
            if (!isNaN_(b.aw.bh)) {
                c = b.aw.bh;
            }
            b.d3 = c;
        }
    };
    XamDataChart.prototype.ox = function () {
        _super.prototype.ox.call(this);
        for (var a = 0; a < this.axes.count; a++) {
            var b = this.axes._inner[a];
            b.d3 = NaN;
            b.cq = true;
            b.h8(false);
        }
    };
    XamDataChart.prototype.u7 = function (a) {
        var e_71, _a;
        var b = new List$1(Axis.$, 0);
        try {
            for (var _b = __values(fromEnum(this.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                var d = c.ao(a);
                if (d != null) {
                    b.add(d);
                }
            }
        }
        catch (e_71_1) {
            e_71 = { error: e_71_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_71)
                    throw e_71.error;
            }
        }
        return b;
    };
    XamDataChart.$t = markType(XamDataChart, 'XamDataChart', SeriesViewer.$);
    XamDataChart.vt = 0;
    XamDataChart.vs = 0;
    XamDataChart.v8 = "ActualPlotAreaMarginLeft";
    XamDataChart.wa = "ActualPlotAreaMarginTop";
    XamDataChart.v9 = "ActualPlotAreaMarginRight";
    XamDataChart.v7 = "ActualPlotAreaMarginBottom";
    XamDataChart.$$p = markDep(DependencyProperty, PropertyMetadata, XamDataChart, 'oi', ['AlignsGridLinesToPixels:uq:xf', [0, true], 'AutoExpandMarginExtraPadding:vq:xg', [1, DeviceUtils.g(2)], 'AutoExpandMarginMaximumValue:vr:xh', [1, 60], 'AutoMarginAndAngleUpdateMode:t5:xi', [AutoMarginsAndAngleUpdateMode_$type, enumGetBox(AutoMarginsAndAngleUpdateMode_$type, 0)], 'ComputedPlotAreaMarginMode:t8:xj', [ComputedPlotAreaMarginMode_$type, enumGetBox(ComputedPlotAreaMarginMode_$type, 0)], 'DefaultAxisMajorStroke:x4:xk', [Brush.$, null], 'DefaultAxisMinorStroke:x5:xl', [Brush.$, null], 'DefaultAxisStroke:x6:xm', [Brush.$, null], 'GridMode:ua:xn', [GridMode_$type, enumGetBox(GridMode_$type, 2)], 'HorizontalZoomable:ut:xo', [0, false], 'InitialCloseGridlinesThreshold:vv:xp', [1, NaN], 'IsHorizontalZoomEnabled:uu:xq', [0, false], 'IsSquare:uw:xr', [0, false], 'IsVerticalZoomEnabled:ux:xs', [0, false], 'SeriesPlotAreaMarginHorizontalMode:uf:xt', [SeriesPlotAreaMarginHorizontalMode_$type, enumGetBox(SeriesPlotAreaMarginHorizontalMode_$type, 0)], 'SeriesPlotAreaMarginVerticalMode:ui:xu', [SeriesPlotAreaMarginVerticalMode_$type, enumGetBox(SeriesPlotAreaMarginVerticalMode_$type, 0)], 'ShouldAutoExpandMarginForInitialLabels:u0:xv', [0, false], 'ShouldClipGridlines:u1:xw', [0, true], 'ShouldClipInitialCloseGridlines:u2:xx', [0, true], 'ShouldConsiderAutoRotationForInitialLabels:u3:xy', [0, false], 'ShouldSuppressAxisLabelTruncation:u4:xz', [0, false], 'SuppressAutoMarginAndAngleRecalculation:u5:x0', [0, false], 'VerticalZoomable:u6:x1', [0, false], 'WindowScaleHorizontal:v3:x2', [1, NaN], 'WindowScaleVertical:v4:x3', [1, NaN]]);
    return XamDataChart;
}(SeriesViewer));
export { XamDataChart };
/**
 * @hidden
 */
var LabelPanelArranger = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(LabelPanelArranger, _super);
    function LabelPanelArranger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LabelPanelArranger.e = function (a, b) {
        var e_72, _a;
        try {
            for (var _b = __values(fromEnum(a)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                var d = c.ad;
                var e = d.aj;
                e = LabelPanelArranger.a(c, d, e);
                var f = LabelPanelArranger.b(c);
                var g = 0;
                var h = 0;
                var i = 0;
                if (d.b8()) {
                    c.af.ac();
                    i = c.bh;
                }
                else {
                    i = c.bi(b);
                }
                g = i;
                h = i;
                if (c.ad.az != null && c.ad.az.visibility != 0) {
                    h = 0;
                    g = 0;
                }
                if (c.aq()) {
                    switch (f) {
                        case 0:
                            b.y = Math.max(0, b.top + h);
                            b.height = Math.max(0, b.height - h);
                            d.az.c = 0;
                            break;
                        case 4:
                            if (e != null && (c.bg - b.top < h && typeCast(HorizontalAxisLabelPanel.$, c) !== null)) {
                                d.az.c = 5;
                            }
                            else {
                                d.az.c = 4;
                            }
                            break;
                        case 5:
                            if (e != null && (b.bottom - c.bg < h && typeCast(HorizontalAxisLabelPanel.$, c) !== null)) {
                                if (d.az != null) {
                                    d.az.c = 4;
                                }
                            }
                            else {
                                if (d.az != null) {
                                    d.az.c = 5;
                                }
                            }
                            break;
                        case 1:
                        default:
                            if (d.az != null) {
                                d.az.c = 1;
                            }
                            b.height = Math.max(0, b.height - h);
                            break;
                    }
                }
                if (typeCast(VerticalAxisLabelPanel.$, c) !== null) {
                    switch (f) {
                        case 3:
                            b.width = Math.max(0, b.width - g);
                            d.az.c = 3;
                            break;
                        case 6:
                            if (e != null && c.bg - b.left < g) {
                                d.az.c = 7;
                            }
                            else {
                                d.az.c = 6;
                            }
                            break;
                        case 7:
                            if (e != null && b.right - c.bg < g) {
                                d.az.c = 6;
                            }
                            else {
                                d.az.c = 7;
                            }
                            break;
                        case 2:
                        default:
                            if (d.az != null) {
                                d.az.c = 2;
                            }
                            b.x = Math.max(0, b.left + g);
                            b.width = Math.max(0, b.width - g);
                            break;
                    }
                }
                if (c.ad.b9) {
                    if (d.az != null) {
                        d.az.c = f;
                    }
                }
            }
        }
        catch (e_72_1) {
            e_72 = { error: e_72_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_72)
                    throw e_72.error;
            }
        }
        return b;
    };
    LabelPanelArranger.a = function (a, b, c) {
        return b.ak();
    };
    LabelPanelArranger.b = function (a) {
        if (a == null) {
            return 1;
        }
        else {
            var b = a.ad;
            if (b != null && b.az != null) {
                var c = b.az.c;
                if (!a.ay(c)) {
                    return a.ai();
                }
                return c;
            }
            else {
                return a.ai();
            }
        }
    };
    LabelPanelArranger.c = function (a, b, c, d) {
        var e = a.ad;
        var f = e.aj;
        f = LabelPanelArranger.a(a, e, f);
        var g = LabelPanelArranger.b(a);
        var h;
        var i = a.bi(c);
        var j = Math.max(0, i);
        var k = Math.max(0, i);
        if (a.ad != null && a.ad.az != null && a.ad.az.visibility == 1) {
            return;
        }
        switch (g) {
            case 3:
                b.g = b.g - k;
                b.d = b.d - k;
                h = new Rect(0, b.g, c.top, k, c.height);
                d(a, h);
                break;
            case 2:
                h = new Rect(0, b.f, c.top, k, c.height);
                d(a, h);
                b.f = b.f + k;
                b.c = b.c + k;
                break;
            case 7:
                if (f != null) {
                    h = new Rect(0, b.f + a.bg, c.top, k, c.height);
                }
                else {
                    b.d = b.d - k;
                    h = new Rect(0, b.d, c.top, k, c.height);
                }
                d(a, h);
                break;
            case 6:
                if (f != null) {
                    h = new Rect(0, b.f + a.bg - k, c.top, k, c.height);
                }
                else {
                    h = new Rect(0, b.c, c.top, k, c.height);
                    b.c = b.c + k;
                }
                d(a, h);
                break;
            case 1:
                b.a = b.a - j;
                b.b = b.b - j;
                h = new Rect(0, c.left, b.a, c.width, j);
                d(a, h);
                break;
            case 0:
                h = new Rect(0, c.left, b.h, c.width, j);
                d(a, h);
                b.h = b.h + j;
                b.e = b.e + j;
                break;
            case 5:
                if (f != null) {
                    h = new Rect(0, c.left, b.h + a.bg, c.width, j);
                }
                else {
                    b.b = b.b - j;
                    h = new Rect(0, c.left, b.b, c.width, j);
                }
                d(a, h);
                break;
            case 4:
                if (f != null) {
                    h = new Rect(0, c.left, b.h + a.bg - j, c.width, j);
                }
                else {
                    h = new Rect(0, c.left, b.e, c.width, j);
                    b.e = b.e + j;
                }
                d(a, h);
                break;
        }
        if (a.ad.b9) {
            h = new Rect(0, c.left, c.top, c.width, c.height);
            d(a, h);
        }
    };
    LabelPanelArranger.d = function (a, b, c, d) {
        var e_73, _a, e_74, _b, e_75, _c;
        var e = new List$1(AxisLabelPanelBase.$, 0);
        var f = new List$1(AxisLabelPanelBase.$, 0);
        try {
            for (var _d = __values(fromEnum(a)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var g = _e.value;
                var h = LabelPanelArranger.b(g);
                switch (h) {
                    case 1:
                    case 2:
                    case 0:
                    case 3:
                        f.add(g);
                        break;
                    case 5:
                    case 6:
                    case 4:
                    case 7:
                        e.add(g);
                        break;
                }
            }
        }
        catch (e_73_1) {
            e_73 = { error: e_73_1 };
        }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return))
                    _a.call(_d);
            }
            finally {
                if (e_73)
                    throw e_73.error;
            }
        }
        try {
            for (var _f = __values(fromEnum(f)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var i = _g.value;
                LabelPanelArranger.c(i, b, c, d);
            }
        }
        catch (e_74_1) {
            e_74 = { error: e_74_1 };
        }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return))
                    _b.call(_f);
            }
            finally {
                if (e_74)
                    throw e_74.error;
            }
        }
        try {
            for (var _h = __values(fromEnum(e)), _j = _h.next(); !_j.done; _j = _h.next()) {
                var j = _j.value;
                LabelPanelArranger.c(j, b, c, d);
            }
        }
        catch (e_75_1) {
            e_75 = { error: e_75_1 };
        }
        finally {
            try {
                if (_j && !_j.done && (_c = _h.return))
                    _c.call(_h);
            }
            finally {
                if (e_75)
                    throw e_75.error;
            }
        }
    };
    LabelPanelArranger.$t = markType(LabelPanelArranger, 'LabelPanelArranger');
    return LabelPanelArranger;
}(Base));
export { LabelPanelArranger };
/**
 * @hidden
 */
var ChartContentManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ChartContentManager, _super);
    function ChartContentManager(a) {
        var _this = _super.call(this) || this;
        _this.l = null;
        _this.r = new Dictionary$2(ChartContentType_$type, Dictionary$2.$.specialize(DependencyObject.$, ContentInfo.$), 0);
        _this.t = new List$1(Series.$, 0);
        _this.m = false;
        _this.v = null;
        _this.q = false;
        _this.o = false;
        _this.n = false;
        _this.p = false;
        _this.p = true;
        _this.o = true;
        _this.n = true;
        _this.r.addItem(0, new Dictionary$2(DependencyObject.$, ContentInfo.$, 0));
        _this.r.addItem(1, new Dictionary$2(DependencyObject.$, ContentInfo.$, 0));
        _this.r.addItem(2, new Dictionary$2(DependencyObject.$, ContentInfo.$, 0));
        _this.l = a;
        return _this;
    }
    Object.defineProperty(ChartContentManager.prototype, "u", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            this.t = a;
        },
        enumerable: false,
        configurable: true
    });
    ChartContentManager.prototype.k = function (a, b, c) {
        var d = this.j(a, b);
        d.a = c;
        return d;
    };
    ChartContentManager.prototype.ad = function (a, b) {
        var c = this.r.item(a);
        if (c.containsKey(b)) {
            c.removeItem(b);
        }
        var d = typeCast(Series.$, b);
        if (d != null && this.u.contains(d)) {
            this.u.remove(d);
        }
    };
    ChartContentManager.prototype.aa = function (a) {
        var b = this.v;
        this.v = a;
        if (this.m && b == null && this.v != null) {
            this.v.setTimeout(runOn(this, this.w), 0);
        }
    };
    ChartContentManager.prototype.z = function () {
        if (!this.m) {
            this.m = true;
            if (this.v != null) {
                this.v.setTimeout(runOn(this, this.w), 0);
            }
            else {
            }
        }
    };
    ChartContentManager.prototype.ac = function (a, b, c, d) {
        var e = c;
        if (!e.c) {
            e.b = d;
        }
        else {
            if (!d) {
                e.b = false;
            }
        }
        if (!e.c) {
            e.c = true;
            this.z();
        }
    };
    ChartContentManager.prototype.j = function (a, b) {
        var c = this.r.item(a);
        var d = null;
        if (!((function () { var e = c.tryGetValue(b, d); d = e.p1; return e.ret; })())) {
            d = new ContentInfo();
            d.h = b;
            c.addItem(b, d);
            var e = typeCast(Series.$, b);
            if (e != null && !this.u.contains(e)) {
                if (e.dx) {
                    var f = e.bg();
                    var g = this.u.indexOf(f) + 1;
                    g += e.hl();
                    if (this.u.count <= g || f.hq() == 0 || g == -1) {
                        this.u.add(e);
                    }
                    else {
                        this.u.insert(g, e);
                    }
                }
                else {
                    this.u.add(e);
                }
            }
        }
        return d;
    };
    ChartContentManager.prototype.y = function () {
        this.w();
    };
    ChartContentManager.prototype.w = function () {
        var e_76, _a;
        if (this.l == null || this.r == null) {
            return;
        }
        if (!this.m) {
            return;
        }
        this.m = false;
        if (this.l != null) {
            this.l.lp();
        }
        try {
            for (var _b = __values(fromEnum(this.s())), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a.f();
            }
        }
        catch (e_76_1) {
            e_76 = { error: e_76_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_76)
                    throw e_76.error;
            }
        }
        if (!this.m) {
            this.l.oj();
        }
    };
    ChartContentManager.prototype._s = function () {
        var a, _a, _b, b, e_77_1, c, _c, _d, d, _e, _f, e, _g, _h, f, e_78_1, _j, _k, g, e_79_1;
        var e_77, _l, e_80, _m, e_81, _o, e_78, _p, e_79, _q;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    a = null;
                    a = this.r.item(1);
                    _r.label = 1;
                case 1:
                    _r.trys.push([1, 6, 7, 8]);
                    _a = __values(fromEnum(a.values)), _b = _a.next();
                    _r.label = 2;
                case 2:
                    if (!!_b.done)
                        return [3 /*break*/, 5];
                    b = _b.value;
                    return [4 /*yield*/, b];
                case 3:
                    _r.sent();
                    _r.label = 4;
                case 4:
                    _b = _a.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_77_1 = _r.sent();
                    e_77 = { error: e_77_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (_b && !_b.done && (_l = _a.return))
                            _l.call(_a);
                    }
                    finally {
                        if (e_77)
                            throw e_77.error;
                    }
                    return [7 /*endfinally*/];
                case 8:
                    a = this.r.item(0);
                    c = new List$1(ContentInfo.$, 0);
                    try {
                        for (_c = __values(fromEnum(this.u)), _d = _c.next(); !_d.done; _d = _c.next()) {
                            d = _d.value;
                            if (!d.dd) {
                                c.add(a.item(d));
                            }
                        }
                    }
                    catch (e_80_1) {
                        e_80 = { error: e_80_1 };
                    }
                    finally {
                        try {
                            if (_d && !_d.done && (_m = _c.return))
                                _m.call(_c);
                        }
                        finally {
                            if (e_80)
                                throw e_80.error;
                        }
                    }
                    try {
                        for (_e = __values(fromEnum(this.u)), _f = _e.next(); !_f.done; _f = _e.next()) {
                            e = _f.value;
                            if (e.dd) {
                                c.add(a.item(e));
                            }
                        }
                    }
                    catch (e_81_1) {
                        e_81 = { error: e_81_1 };
                    }
                    finally {
                        try {
                            if (_f && !_f.done && (_o = _e.return))
                                _o.call(_e);
                        }
                        finally {
                            if (e_81)
                                throw e_81.error;
                        }
                    }
                    _r.label = 9;
                case 9:
                    _r.trys.push([9, 14, 15, 16]);
                    _g = __values(fromEnum(c)), _h = _g.next();
                    _r.label = 10;
                case 10:
                    if (!!_h.done)
                        return [3 /*break*/, 13];
                    f = _h.value;
                    return [4 /*yield*/, f];
                case 11:
                    _r.sent();
                    _r.label = 12;
                case 12:
                    _h = _g.next();
                    return [3 /*break*/, 10];
                case 13: return [3 /*break*/, 16];
                case 14:
                    e_78_1 = _r.sent();
                    e_78 = { error: e_78_1 };
                    return [3 /*break*/, 16];
                case 15:
                    try {
                        if (_h && !_h.done && (_p = _g.return))
                            _p.call(_g);
                    }
                    finally {
                        if (e_78)
                            throw e_78.error;
                    }
                    return [7 /*endfinally*/];
                case 16:
                    a = this.r.item(2);
                    _r.label = 17;
                case 17:
                    _r.trys.push([17, 22, 23, 24]);
                    _j = __values(fromEnum(a.values)), _k = _j.next();
                    _r.label = 18;
                case 18:
                    if (!!_k.done)
                        return [3 /*break*/, 21];
                    g = _k.value;
                    return [4 /*yield*/, g];
                case 19:
                    _r.sent();
                    _r.label = 20;
                case 20:
                    _k = _j.next();
                    return [3 /*break*/, 18];
                case 21: return [3 /*break*/, 24];
                case 22:
                    e_79_1 = _r.sent();
                    e_79 = { error: e_79_1 };
                    return [3 /*break*/, 24];
                case 23:
                    try {
                        if (_k && !_k.done && (_q = _j.return))
                            _q.call(_j);
                    }
                    finally {
                        if (e_79)
                            throw e_79.error;
                    }
                    return [7 /*endfinally*/];
                case 24: return [2 /*return*/];
            }
        });
    };
    ChartContentManager.prototype.s = function () {
        var _this = this;
        return toEnum(function () { return _this._s(); });
    };
    ChartContentManager.prototype.x = function (a) {
        var e_82, _a, e_83, _b, e_84, _c;
        try {
            for (var _d = __values(fromEnum(this.r.item(1).values)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var b = _e.value;
                b.h.ht(a);
            }
        }
        catch (e_82_1) {
            e_82 = { error: e_82_1 };
        }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return))
                    _a.call(_d);
            }
            finally {
                if (e_82)
                    throw e_82.error;
            }
        }
        try {
            for (var _f = __values(fromEnum(this.r.item(1).values)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var c = _g.value;
                c.f();
            }
        }
        catch (e_83_1) {
            e_83 = { error: e_83_1 };
        }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return))
                    _b.call(_f);
            }
            finally {
                if (e_83)
                    throw e_83.error;
            }
        }
        try {
            for (var _h = __values(fromEnum(this.r.item(1).values)), _j = _h.next(); !_j.done; _j = _h.next()) {
                var d = _j.value;
                d.h.ii();
            }
        }
        catch (e_84_1) {
            e_84 = { error: e_84_1 };
        }
        finally {
            try {
                if (_j && !_j.done && (_c = _h.return))
                    _c.call(_h);
            }
            finally {
                if (e_84)
                    throw e_84.error;
            }
        }
    };
    ChartContentManager.prototype.ae = function (a, b, c, d) {
        c.i = d;
    };
    ChartContentManager.prototype.ab = function (a, b) {
        if (!b.e) {
            b.e = true;
            this.z();
        }
    };
    ChartContentManager.$t = markType(ChartContentManager, 'ChartContentManager', DependencyObject.$);
    return ChartContentManager;
}(DependencyObject));
export { ChartContentManager };
/**
 * @hidden
 */
var ContentInfo = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ContentInfo, _super);
    function ContentInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.h = null;
        _this.a = null;
        _this.b = false;
        _this.c = false;
        _this.i = null;
        _this.e = false;
        return _this;
    }
    Object.defineProperty(ContentInfo.prototype, "d", {
        get: function () {
            if (this.i.isEmpty) {
                return false;
            }
            if (this.i.width == 0 && this.i.height == 0) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ContentInfo.prototype.g = function () {
        if (this.e && typeCast(Axis.$, this.h) !== null) {
            this.e = false;
            var a = this.c;
            this.c = true;
            var b = this.h.c2(true);
            if (!b) {
                this.c = a;
            }
        }
    };
    ContentInfo.prototype.f = function () {
        this.g();
        if (typeCast(Axis.$, this.h) !== null) {
            var a = typeCast(Axis.$, this.h);
            if (a.aj != null) {
                var b = a.aj;
                if (b.a6 != null && b.a6.e) {
                    b.a6.g();
                }
            }
        }
        if (this.c) {
            this.c = false;
            this.a(this.b);
            this.b = false;
        }
    };
    ContentInfo.$t = markType(ContentInfo, 'ContentInfo');
    return ContentInfo;
}(Base));
export { ContentInfo };
/**
 * @hidden
 */
var Series = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(Series, _super);
    function Series() {
        var _this = _super.call(this) || this;
        _this.b1 = null;
        _this.ht = 0;
        _this.py = null;
        _this.dh = false;
        _this.hd = null;
        _this.cn = null;
        _this.a8 = null;
        _this.a6 = null;
        _this.cf = null;
        _this.nf = null;
        _this.ff = new Dictionary$2(String_$type, String_$type, 0);
        _this.fe = new Dictionary$2(String_$type, FastReflectionHelper.$, 0);
        _this.propertyChanged = null;
        _this.propertyUpdated = null;
        _this.renderRequested = null;
        _this.e4 = false;
        _this.b0 = null;
        _this.at = null;
        _this.ct = true;
        _this.ew = false;
        _this.ex = false;
        _this.cu = false;
        _this.cz = false;
        _this.b8 = null;
        _this.cd = null;
        _this.fk = null;
        _this.be = null;
        _this.cm = null;
        _this.ha = null;
        _this.nc = null;
        _this.a1 = null;
        _this.b7 = 0;
        _this.b6 = 0;
        _this.c1 = false;
        _this.cs = false;
        _this.fn = DeviceUtils.g(1);
        _this.fr = NaN;
        _this.fo = NaN;
        _this.fp = NaN;
        _this.fq = NaN;
        _this.pa = null;
        _this.pb = null;
        _this.f4 = DeviceUtils.g(2);
        _this.bk = 1;
        _this.fm = 0.2;
        _this.cr = false;
        _this.b2 = 1;
        _this.bs = 1;
        _this.hw = null;
        _this.bh = new SeriesComponentsForView();
        _this.cv = false;
        _this.h7 = null;
        _this.hc = null;
        _this._coercionMethods = null;
        _this.cq = false;
        _this.bo = 0;
        _this.bn = 0;
        _this.cp = null;
        _this.pm = { $type: Point_$type, x: NaN, y: NaN };
        _this.fs = NaN;
        _this.ft = NaN;
        _this.a5 = null;
        DVContainer.instance.registerIfLoaded("AnnotationFactoryManager");
        DVContainer.instance.registerIfLoaded("InteractivityFactoryManager");
        DVContainer.instance.registerIfLoaded("VisualDataFactoryManager");
        _this.ht = Series.hf++;
        _this.e3 = true;
        _this.py = Rect.empty;
        _this.b1 = _this.by();
        _this.b1.bu = Rect.empty;
        _this.l4(_this.b1);
        _this.b1.n = true;
        _this.b1.as();
        _this.b1.n = false;
        _this.ab = Series.$;
        _this.cm = function (a, b) {
            if (_this.ce == null || !_this.ce.d9) {
                _this.nb(b.oldRect, b.newRect);
            }
        };
        _this.be = function (a, b) { return _this.l9(a, b.propertyName, b.oldValue, b.newValue); };
        _this.ha = function (a, b) {
            if (_this.ce != null) {
                _this.e3 = true;
                _this.ce.ms();
            }
            _this.k5(b.action, b.position, b.count, b.propertyName);
        };
        _this.propertyUpdated = delegateCombine(_this.propertyUpdated, function (a, b) { return _this.l9(a, b.propertyName, b.oldValue, b.newValue); });
        _this.nf = new Canvas();
        _this.cf = new DoubleAnimator(0, 1, _this.hr);
        var a = _this.cf;
        a.propertyChanged = delegateCombine(a.propertyChanged, runOn(_this, _this.ku));
        _this.g(Series.oz, ((function () {
            var $ret = new Binding(1, "Visibility");
            $ret.d = _this;
            return $ret;
        })()));
        _this.bp = _this.bq();
        _this.b3 = _this.b4();
        return _this;
    }
    Series.prototype.get_dataLegendKey = function () {
        if (!stringIsNullOrEmpty(this.name)) {
            return this.name;
        }
        return "Index___" + this.index.toString();
    };
    Object.defineProperty(Series.prototype, "dataLegendKey", {
        get: function () {
            return this.get_dataLegendKey();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "he", {
        get: function () {
            return this.hd;
        },
        set: function (a) {
            this.hd = a;
            this.cf.u(this.hd);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.provideRenderer = function (a) {
        this.he = a;
    };
    Series.prototype.jw = function () {
        return this.a7.a$r(this);
    };
    Series.prototype.m5 = function (a) {
    };
    Series.prototype.m4 = function (a) {
    };
    Series.prototype.m6 = function (a) {
    };
    Series.prototype.ku = function (a, b) {
        this.g5 = this.cf.o;
    };
    Object.defineProperty(Series.prototype, "co", {
        get: function () {
            if (this.cn == null) {
                this.cn = new SRProvider(this.he);
            }
            if (this.cn.l == null) {
                if (this.he != null) {
                    this.cn.l = this.he;
                }
                else if (this.ce != null && this.ce.cu != null && this.ce.cu.j != null && this.ce.cu.j.ae != null) {
                    this.cn.l = this.ce.cu.j.ae;
                }
            }
            return this.cn;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "a9", {
        get: function () {
            var _this = this;
            if (this.a8 == null) {
                this.a8 = DVContainer.instance.createInstance(ISeriesVisualDataManager_$type, function () { return _this.co.q; });
            }
            return this.a8;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "fg", {
        get: function () {
            return this.a7.a$h;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "a7", {
        get: function () {
            var _this = this;
            if (this.a6 == null) {
                this.a6 = DVContainer.instance.createInstance(ISeriesInteractionManager_$type, function () { return _this.co.n; });
                if (this.toolTip != null) {
                    this.a6.a$aj(this, this.toolTip);
                }
            }
            return this.a6;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "d2", {
        get: function () {
            return DVContainer.instance.checkLoaded("InteractivityFactoryManager");
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.l4 = function (a) {
    };
    Series.prototype.l2 = function () {
        this.kv(this.a2, this.a2);
        if (this.cl == null && this.b9 != null && this.itemsSource != null) {
            this.cl = this.b9.getFastItemsSource(this.itemsSource);
        }
        this.b1.av();
    };
    Series.prototype.l3 = function () {
        this.k1();
        if (this.cl != null && this.b9 != null && this.itemsSource != null) {
            this.cl = this.b9.releaseFastItemsSource(this.itemsSource);
        }
        this.b1.aw();
    };
    Series.prototype.bz = function () {
        return this.by();
    };
    Series.prototype.by = function () {
        return new SeriesView(this);
    };
    Series.prototype.fa = function () {
        return false;
    };
    Series.prototype.h1 = function (a, b) {
        return null;
    };
    Series.prototype.onLegendItemOver = function (a) {
    };
    Series.prototype.onLegendItemPointerUp = function (a) {
    };
    Series.prototype.onLegendItemPointerDown = function (a) {
    };
    Series.prototype.onLegendItemEnter = function (a) {
        if (this.d0 && this.d2 && this.ce != null && (this.ce.bb == 0 || this.ce.bb == 2) && this.bl != 1) {
            this.a7.a$v(this, a, { $type: Point_$type, x: NaN, y: NaN }, false, true, false, a == null, this == this.ce.bo, false);
        }
    };
    Series.prototype.onLegendItemLeave = function (a) {
        if (this.d0 && this.d2 && this.ce != null && (this.ce.bb == 0 || this.ce.bb == 2) && this.bl != 1) {
            this.a7.a$v(this, a, { $type: Point_$type, x: NaN, y: NaN }, false, true, true, a == null, this == this.ce.bo, false);
        }
    };
    Series.prototype.jv = function (a) {
        if (!this.ff.containsKey(a)) {
            var b = a.substr(0, 1).toUpperCase() + a.substr(1);
            this.ff.addItem(a, b);
        }
        return this.ff.item(a);
    };
    Series.prototype.h2 = function (a, b, c) {
        var d = null;
        if (!this.fe.containsKey(b)) {
            d = new FastReflectionHelper(false, c);
            this.fe.addItem(b, d);
        }
        else {
            d = this.fe.item(b);
        }
        d.propertyName = c;
        var e = d.getPropertyValue(a);
        if (this.expectFunctions) {
            var func_ = e;
            var item_ = a;
            if ((typeof func_ === 'function')) {
                e = func_.apply(item_);
            }
        }
        return e;
    };
    Series.prototype.f9 = function (a) {
        return this.hi(a);
    };
    Series.prototype.hk = function (a) {
        return -1;
    };
    Series.prototype.get_ec = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ec", {
        get: function () {
            return this.get_ec();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.as = function () {
        return null;
    };
    Series.prototype.hi = function (a) {
        return -1;
    };
    Series.prototype.p8 = function () {
        var a = 1;
        var b = 1;
        if (this.ce != null) {
            a = this.ce.bx;
            b = this.ce.bz;
        }
        return this.p9(a, b);
    };
    Series.prototype.qa = function (a, b) {
        return this.p9(a, b);
    };
    Series.prototype.p9 = function (a, b) {
        return new Thickness(1, 0, 0, 0, 0);
    };
    Series.prototype.bw = function () {
        return 1;
    };
    Series.prototype.bx = function () {
        return 1;
    };
    Series.prototype.hy = function (a) {
        return null;
    };
    Series.prototype.h3 = function (a, b) {
        return a.hy(b);
    };
    Series.prototype.az = function (a, b, c, d) {
        return a.ax(b, c, d);
    };
    Series.prototype.a0 = function (a, b, c, d) {
        return a.ay(b, c, d);
    };
    Series.prototype.hh = function () {
        return -1;
    };
    Series.prototype.hl = function () {
        return -1;
    };
    Series.prototype.hq = function () {
        return -1;
    };
    Object.defineProperty(Series.prototype, "container", {
        get: function () {
            return this.ce;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "hasSubItems", {
        get: function () {
            return this.c4();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.c4 = function () {
        return false;
    };
    Series.prototype.forSubItems = function (a) {
        this.le(a);
    };
    Series.prototype.le = function (a) {
    };
    Series.prototype.lf = function (a) {
    };
    Series.prototype.ju = function () {
        return null;
    };
    Series.prototype.pf = function () {
        return this.o9;
    };
    Series.prototype.pg = function () {
        return this.pe;
    };
    Series.prototype.resolveLegendIndex = function () {
        return this.index;
    };
    Series.prototype.bg = function () {
        return null;
    };
    Series.prototype.get_dd = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dd", {
        get: function () {
            return this.get_dd();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_da = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "da", {
        get: function () {
            return this.get_da();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_c9 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "c9", {
        get: function () {
            return this.get_c9();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dc = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dc", {
        get: function () {
            return this.get_dc();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_db = function () {
        return true;
    };
    Object.defineProperty(Series.prototype, "db", {
        get: function () {
            return this.get_db();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_de = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "de", {
        get: function () {
            return this.get_de();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_isVertical = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "isVertical", {
        get: function () {
            return this.get_isVertical();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dx = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dx", {
        get: function () {
            return this.get_dx();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dg = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dg", {
        get: function () {
            return this.get_dg();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_df = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "df", {
        get: function () {
            return this.get_df();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_c7 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "c7", {
        get: function () {
            return this.get_c7();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_em = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "em", {
        get: function () {
            return this.get_em();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d4 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d4", {
        get: function () {
            return this.get_d4();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d3 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d3", {
        get: function () {
            return this.get_d3();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ej = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ej", {
        get: function () {
            return this.get_ej();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dk = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dk", {
        get: function () {
            return this.get_dk();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_di = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "di", {
        get: function () {
            return this.get_di();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_en = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "en", {
        get: function () {
            return this.get_en();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_eb = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "eb", {
        get: function () {
            return this.get_eb();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ea = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ea", {
        get: function () {
            return this.get_ea();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d8 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d8", {
        get: function () {
            return this.get_d8();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d7 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d7", {
        get: function () {
            return this.get_d7();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_el = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "el", {
        get: function () {
            return this.get_el();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ek = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ek", {
        get: function () {
            return this.get_ek();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_eh = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "eh", {
        get: function () {
            return this.get_eh();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d9 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d9", {
        get: function () {
            return this.get_d9();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ef = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ef", {
        get: function () {
            return this.get_ef();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ed = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ed", {
        get: function () {
            return this.get_ed();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_isStacked = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "isStacked", {
        get: function () {
            return this.get_isStacked();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ds = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ds", {
        get: function () {
            return this.get_ds();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_ee = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "ee", {
        get: function () {
            return this.get_ee();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dj = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dj", {
        get: function () {
            return this.get_dj();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dy = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dy", {
        get: function () {
            return this.get_dy();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_eg = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "eg", {
        get: function () {
            return this.get_eg();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_isValueOverlay = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "isValueOverlay", {
        get: function () {
            return this.get_isValueOverlay();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.bf = function () {
        return null;
    };
    Series.prototype.get_c5 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "c5", {
        get: function () {
            return this.get_c5();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dv = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dv", {
        get: function () {
            return this.get_dv();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_du = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "du", {
        get: function () {
            return this.get_du();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dt = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dt", {
        get: function () {
            return this.get_dt();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dw = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dw", {
        get: function () {
            return this.get_dw();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dm = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dm", {
        get: function () {
            return this.get_dm();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dn = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "dn", {
        get: function () {
            return this.get_dn();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.f7 = function (a, b, c, d, e) {
        return Number.POSITIVE_INFINITY;
    };
    Series.prototype.f8 = function (a, b, c, d, e, f, g) {
        return this.a7.a$j(this, a, b, c, d, e, f, g);
    };
    Series.prototype.get_fc = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "fc", {
        get: function () {
            return this.get_fc();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.gp = function (a, b, c, d, e, f, g, h) {
        return this.a7.a$m(this, a, b, c, d, e, f, g, h);
    };
    Series.prototype.gd = function (a, b, c, d, e, f, g, h) {
        return this.a7.a$l(this, a, b, c, d, e, f, g, h);
    };
    Series.prototype.hp = function (a, b, c, d, e) {
        return this.a7.a$o(this, a, b, c, d, e);
    };
    Series.prototype.gc = function (a) {
        return (a ? 10 : 3);
    };
    Series.prototype.ah = function (a) {
        return null;
    };
    Series.prototype.ai = function (a) {
        return null;
    };
    Series.prototype.ey = function (a, b) {
        return this.a7.a$d(this, a, b);
    };
    Series.prototype.aj = function (a, b, c, d, e, f) {
        return this.a7.a$a(this, a, b, c, d, e, f);
    };
    Series.prototype.e0 = function (a, b, c) {
        return this.a7.a$e(this, a, b, c);
    };
    Series.prototype.e1 = function (a, b) {
        return this.a7.a$f(this, a, b);
    };
    Series.prototype.hn = function (a, b, c, d, e) {
        return this.a7.a$n(this, a, b, c, d, e);
    };
    Series.prototype.gb = function (a, b) {
        return this.a7.a$k(this, a, b);
    };
    Series.prototype.ho = function (a, b) {
        return -1;
    };
    Series.prototype.hm = function (a, b) {
        return -1;
    };
    Series.prototype.gn = function (a, b, c) {
        return NaN;
    };
    Series.prototype.ps = function (a, b, c) {
        return { $type: Point_$type, x: NaN, y: NaN };
    };
    Series.prototype.p3 = function (a) {
        return Rect.empty;
    };
    Series.prototype.ak = function (a) {
        var b = this.p3(a);
        if (!b.isEmpty) {
            var c = new Array(1);
            c[0] = b;
            return c;
        }
        return null;
    };
    Series.prototype.p4 = function (a) {
        return this.p3(this.px(a));
    };
    Series.prototype.al = function (a) {
        return this.ak(this.px(a));
    };
    Series.prototype.p5 = function (a) {
        return Rect.empty;
    };
    Series.prototype.p6 = function (a) {
        return this.p5(this.px(a));
    };
    Series.prototype.e2 = function (a, b) {
        return this.a7.a$g(this, a, b);
    };
    Series.prototype.pu = function (a, b, c, d, e, f, g, h, i) {
        return this.a7.a$al(this, a, b, c, d, e, f, g, h, i);
    };
    Series.prototype.gj = function (a, b, c) {
        return this.gn(a, b, c);
    };
    Series.prototype.po = function (a, b, c) {
        return this.ps(a, b, c);
    };
    Series.prototype.gl = function (a, b, c) {
        return this.gn(a, b, c);
    };
    Series.prototype.pq = function (a, b, c) {
        return this.ps(a, b, c);
    };
    Series.prototype.pt = function (a, b, c) {
        var d = this.px(a);
        return this.ps(d, b, c);
    };
    Series.prototype.go = function (a, b, c) {
        var d = this.px(a);
        return this.gn(d, b, c);
    };
    Series.prototype.pp = function (a, b, c) {
        var d = this.px(a);
        return this.po(d, b, c);
    };
    Series.prototype.gk = function (a, b, c) {
        var d = this.px(a);
        return this.gj(d, b, c);
    };
    Series.prototype.pr = function (a, b, c) {
        var d = this.px(a);
        return this.pq(d, b, c);
    };
    Series.prototype.gm = function (a, b, c) {
        var d = this.px(a);
        return this.gl(d, b, c);
    };
    Series.prototype.hj = function (a) {
        var b = this.px(a);
        return this.hi(b);
    };
    Series.prototype.ge = function () {
        return 0;
    };
    Series.prototype.ga = function (a) {
        var b = this.px(a);
        return this.f9(b);
    };
    Series.prototype.hz = function (a) {
        var b = this.px(a);
        return this.hy(b);
    };
    Series.prototype.c2 = function (a, b, c, d) {
        return false;
    };
    Series.prototype.gt = function (a) {
        var b = this.i4();
        if (b == null) {
            return NaN;
        }
        if (a.content == null) {
            return NaN;
        }
        if (a.content.item == null) {
            return NaN;
        }
        return FastItemColumn.i(this.h1(a.content.item, b));
    };
    Series.prototype.i4 = function () {
        return null;
    };
    Series.prototype.gq = function (a, b) {
        return NaN;
    };
    Series.prototype.am = function (a) {
        return [NaN, NaN];
    };
    Series.prototype.pv = function (a) {
        return { $type: Point_$type, x: NaN, y: NaN };
    };
    Series.prototype.pw = function (a) {
        return { $type: Point_$type, x: NaN, y: NaN };
    };
    Series.prototype.raisePropertyChanged = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        if (this.propertyUpdated != null) {
            this.propertyUpdated(this, new PropertyUpdatedEventArgs(a, b, c));
        }
    };
    Series.prototype.get_hasMarkers = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "hasMarkers", {
        get: function () {
            return this.get_hasMarkers();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.li = function () {
    };
    Series.prototype.lj = function () {
        this.li();
    };
    Series.prototype.pc = function () {
        return null;
    };
    Series.prototype.pd = function () {
        return null;
    };
    Series.prototype.nj = function () {
        return null;
    };
    Series.prototype.f6 = function () {
        return NaN;
    };
    Series.prototype.px = function (a) {
        var b = this.ce != null ? this.ce.tm : this.b1.bu;
        var c = this.b1.bv;
        var d = { $type: Point_$type, x: c.left + c.width * (a.x - b.left) / b.width, y: c.top + c.height * (a.y - b.top) / b.height };
        return d;
    };
    Series.prototype.pn = function (a) {
        var b = this.ce != null ? this.ce.tm : this.b1.bu;
        var c = this.b1.bv;
        var d = b.left + (a.x - c.left) / c.width * b.width;
        var e = b.top + (a.y - c.top) / c.height * b.height;
        return { $type: Point_$type, x: d, y: e };
    };
    Series.prototype.h4 = function (a, b) {
        var c = this.b1.c(a);
        var d = c != null ? c.item : null;
        if (d == null) {
            var e = this.px(b);
            d = this.hy(e);
        }
        return d;
    };
    Series.prototype.eq = function (a) {
        return false;
    };
    Series.prototype.aq = function (a) {
        return new AxisRange(NaN, NaN);
    };
    Series.prototype.ar = function (a) {
        return new AxisRange(NaN, NaN);
    };
    Series.prototype.ap = function (a, b, c) {
        this.lb();
        if (!this.isVertical) {
            if (this.fz == 0 && this.f2 == 0) {
                return a;
            }
            var d = new ScalerParams(0, c, this.ce.ty, b.ch, this.getEffectiveViewport());
            d.b = this.gg();
            var e = b.ej(a.c, d);
            var f = b.ej(a.b, d);
            if (b.ch) {
                f += this.fz;
                e -= this.f2;
            }
            else {
                f -= this.f2;
                e += this.fz;
            }
            var g = b.em(e, d);
            var h = b.em(f, d);
            return new AxisRange(g, h);
        }
        else {
            if (this.f0 == 0 && this.f1 == 0) {
                return a;
            }
            var i = new ScalerParams(0, c, this.ce.ty, b.ch, this.getEffectiveViewport());
            i.b = this.gg();
            var j = b.ej(a.c, i);
            var k = b.ej(a.b, i);
            if (!b.ch) {
                k += this.f1;
                j -= this.f0;
            }
            else {
                k -= this.f0;
                j += this.f1;
            }
            var l = b.em(j, i);
            var m = b.em(k, i);
            return new AxisRange(l, m);
        }
    };
    Series.prototype.lb = function () {
        if (isNaN_(this.f2)) {
            var a = this.qa(1, 1);
            this.f2 = a.top;
            if (isNaN_(this.f2)) {
                this.f2 = 0;
            }
        }
        if (isNaN_(this.fz)) {
            var b = this.qa(1, 1);
            this.fz = b.bottom;
            if (isNaN_(this.fz)) {
                this.fz = 0;
            }
        }
        if (isNaN_(this.f0)) {
            var c = this.qa(1, 1);
            this.f0 = c.left;
            if (isNaN_(this.f0)) {
                this.f0 = 0;
            }
        }
        if (isNaN_(this.f1)) {
            var d = this.qa(1, 1);
            this.f1 = d.right;
            if (isNaN_(this.f1)) {
                this.f1 = 0;
            }
        }
    };
    Series.prototype.mn = function (a) {
        this.ew = false;
        if (this.ce != null) {
            this.ce.ar.ac(0, this, this.at, a);
            if (this.renderRequested != null) {
                var b = new RenderRequestedEventArgs();
                b.animate = a;
                this.renderRequested(this, b);
                a = b.animate;
            }
        }
    };
    Series.prototype.k8 = function (a) {
        this.mo(a);
        this.ew = false;
    };
    Series.prototype.mo = function (a) {
        if (this.e6 && !this.eu()) {
            this.e5 = false;
        }
    };
    Series.prototype.ky = function () {
        if (this.e4 && !this.e6) {
            this.cf.r = truncate(Math.max(this.gr(), this.gs()));
            this.k3();
        }
    };
    Series.prototype.k3 = function () {
    };
    Series.prototype.mp = function (a, b) {
        if (this.b0 == null) {
            this.b0 = this.by();
            this.b0.q = true;
            if (this.ce != null) {
                this.ce.am.o(this.b0);
                this.b0.a = this.ce.am;
            }
            this.b0.as();
        }
        this.b0.bu = a;
    };
    Series.prototype.mm = function (a, b, c, d, e) {
        this.a7.a$t(this, a, b, d, e);
    };
    Series.prototype.getEffectiveViewport1 = function (a) {
        if (this.ce == null) {
            return Rect.empty;
        }
        if (a.p) {
            return this.ce.tn;
        }
        if (a.q) {
            if (this.ce.tn.isEmpty) {
                return this.ce.tn;
            }
            var b = this.ce.ts(a.bu, this.ce.ty, this.ce.tn);
            return b;
        }
        return this.ce.tn;
    };
    Series.prototype.getMainContentViewport = function () {
        return this.pz(this.b1);
    };
    Series.prototype.pz = function (a) {
        if (this.ce == null || this.ce.tm.isEmpty) {
            return a.bu;
        }
        if (a.p) {
            return a.bu;
        }
        if (a.q) {
            if (this.ce.tn.isEmpty) {
                return a.bu;
            }
            if (this.ce.tm.equals1(this.ce.ty)) {
                return a.bu;
            }
            var b = this.ce.ts(a.bu, this.ce.ty, this.ce.tn);
            var c = this.ce.tq(a.bu, b, this.ce.tj);
            return c;
        }
        return this.ce.tm;
    };
    Series.prototype.p2 = function (a) {
        if (!this.p7.equals1(a)) {
            return Rect.empty;
        }
        return this.getEffectiveViewport();
    };
    Series.prototype.p1 = function (a) {
        if (this.ce == null || this.ce.tn.isEmpty) {
            return Rect.empty;
        }
        var b = this.ce.tn;
        var c = a.bu;
        var d = (b.left - c.left) / c.width;
        var e = (b.top - c.top) / c.height;
        var f = (b.right - c.left) / c.width;
        var g = (b.bottom - c.top) / c.height;
        return new Rect(0, d, e, f - d, g - e);
    };
    Series.prototype.getEffectiveViewport = function () {
        return this.getEffectiveViewport1(this.b1);
    };
    Series.prototype.mh = function () {
        this.mi(null);
    };
    Series.prototype.get_c3 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "c3", {
        get: function () {
            return this.get_c3();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_c6 = function () {
        return this.bl == 2 || this.bl == 4;
    };
    Object.defineProperty(Series.prototype, "c6", {
        get: function () {
            return this.get_c6();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.mi = function (a) {
        if (this.d2) {
            this.a7.a$ae(this, a);
        }
    };
    Series.prototype.mj = function (a) {
        if (this.d2) {
            this.a7.a$af(this, a, this.ce);
        }
    };
    Series.prototype.getViewInfo = function (a, b) {
        a = this.b1.bu;
        b = this.b1.bv;
        return {
            p0: a,
            p1: b
        };
    };
    Series.prototype.fd = function (a, b, c) {
        if (a.width == 0 || a.height == 0) {
            return false;
        }
        if (this.dx) {
            return true;
        }
        return this._visibility == 0;
    };
    Series.prototype.k2 = function (a, b) {
        if (a) {
            this.e3 = true;
        }
    };
    Series.prototype.cx = function () {
        return this.cy(this.b1);
    };
    Series.prototype.cy = function (a) {
        var b = a.bu;
        var c = a.bv;
        if (!this.fd(b, c, a)) {
            this.k2(true, a);
            return true;
        }
        return false;
    };
    Series.prototype.l5 = function (a, b) {
        this.b1.bu = b;
        this.na(a, b);
        if (this.ce != null) {
            this.ce.ar.ae(0, this, this.at, b);
            if (a.isEmpty || a.width == 0 || a.height == 0) {
                this.ce.ml();
            }
        }
    };
    Series.prototype.nb = function (a, b) {
    };
    Series.prototype.na = function (a, b) {
    };
    Object.defineProperty(Series.prototype, "e3", {
        get: function () {
            return this.ct;
        },
        set: function (a) {
            this.ct = a;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.ld = function (a) {
        a.k9();
    };
    Series.prototype.lv = function () {
        this.ex = false;
        this.e3 = true;
        if (this.ce != null) {
            this.ce.ms();
        }
    };
    Series.prototype.lp = function () {
        this.m1();
        this.l6();
    };
    Series.prototype.lu = function () {
        this.ex = false;
        this.e3 = true;
        if (this.ce != null) {
            this.ce.mr();
        }
    };
    Series.prototype.get_d1 = function () {
        return true;
    };
    Object.defineProperty(Series.prototype, "d1", {
        get: function () {
            return this.get_d1();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_isUsableInLegend = function () {
        return true;
    };
    Object.defineProperty(Series.prototype, "isUsableInLegend", {
        get: function () {
            return this.get_isUsableInLegend();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.l0 = function () {
        this.b1.ao();
    };
    Series.prototype.lw = function () {
        this.l6();
    };
    Series.prototype.l6 = function () {
        this.b1.az();
        this.l8(false);
        this.m2();
    };
    Series.prototype.l7 = function () {
        this.b1.az();
        this.l8(true);
    };
    Series.prototype.ep = function () {
        return false;
    };
    Series.prototype.l8 = function (a) {
        if (this.at == null || this.at.c) {
            return;
        }
        var b = this.b1.bu;
        var c = this.b1.bv;
        var d = this.fd(b, c, this.b1);
        var e = this.ce != null && this.ce.eo && this.b0 != null && this.fd(this.b0.bu, this.b0.bv, this.b0);
        if (d) {
            if (a) {
                this.ew = !this.ep();
                this.k8(false);
            }
            else {
                this.mn(false);
                this.ew = !this.ep();
            }
        }
        if (e) {
            if (!this.e3) {
                this.lu();
                this.ex = true;
            }
        }
    };
    Object.defineProperty(Series.prototype, "e5", {
        get: function () {
            return this.cu;
        },
        set: function (a) {
            this.cu = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "e6", {
        get: function () {
            if (this.e5 == false) {
                return false;
            }
            return this.gs() > 0;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.v = function () {
        _super.prototype.v.call(this);
        this.raisePropertyChanged("Opacity", this._opacity, this._opacity);
    };
    Series.prototype.w = function (a, b) {
        _super.prototype.w.call(this, a, b);
        this.raisePropertyChanged("Visibility", enumGetBox(Visibility_$type, a), enumGetBox(Visibility_$type, b));
    };
    Series.prototype.lz = function () {
    };
    Series.prototype.l9 = function (a, b, c, d) {
        switch (b) {
            case "SyncLink":
                if (typeCast(SyncLink.$, c) !== null) {
                    var e = c;
                    e.propertyUpdated = delegateRemove(e.propertyUpdated, this.be);
                    this.mg(typeCast(IFastItemsSourceProvider_$type, c));
                }
                if (typeCast(SyncLink.$, d) !== null) {
                    var f = d;
                    f.propertyUpdated = delegateCombine(f.propertyUpdated, this.be);
                    this.mf(typeCast(IFastItemsSourceProvider_$type, d));
                }
                if (this.index == -1) {
                    this.index = XamDataChart.v5(this);
                }
                break;
            case Series.$$p[26]:
                this.bt = this.bv();
                this.m0();
                this.k9();
                this.l6();
                break;
            case SeriesViewer.$$p[1]:
            case SeriesViewer.$$p[15]:
            case SeriesViewer.$$p[14]:
            case SeriesViewer.$$p[16]:
                this.k9();
                break;
            case "HighlightingMode":
                this.bl = this.bm();
                break;
            case "SeriesViewer":
                if (typeCast(SeriesViewer.$, c) !== null) {
                    this.he = null;
                    var g = c;
                    g.windowRectChanged = delegateRemove(g.windowRectChanged, this.cm);
                    var h = c.series;
                    h.collectionChanged = delegateRemove(h.collectionChanged, this.fk);
                    var i = c;
                    i.propertyUpdated = delegateRemove(i.propertyUpdated, this.be);
                    c.ar.ad(0, this);
                    this.mi(c);
                    this.b1.ak(c);
                }
                if (typeCast(SeriesViewer.$, d) !== null) {
                    this.he = d.cu.j.ae;
                    var j = d;
                    j.windowRectChanged = delegateCombine(j.windowRectChanged, this.cm);
                    var k = d.series;
                    k.collectionChanged = delegateCombine(k.collectionChanged, this.fk);
                    var l = d;
                    l.propertyUpdated = delegateCombine(l.propertyUpdated, this.be);
                    this.at = d.ar.k(0, this, runOn(this, this.k8));
                    this.b1.ag(d);
                    this.bl = this.bm();
                    this.my();
                    if (this.ej) {
                        this.fx = this.gz();
                    }
                    this.la();
                    this.ht = this.ce.hx();
                }
                if (this.ce == null) {
                    this.externalObject._ensureTooltipDestroyed();
                    this.cf.w();
                }
                if (this.index != -1) {
                    this.m1();
                }
                if (this.index == -1 || d == null) {
                    this.index = XamDataChart.v5(this);
                }
                this.a2 = this.a3();
                this.kw(typeCast(SeriesViewer.$, c), typeCast(SeriesViewer.$, d));
                break;
            case Series.$$p[36]:
                if (this.b1 != null) {
                    this.b1.ay();
                }
                break;
            case "HitTestMode":
                this.bp = this.bq();
                break;
            case "ActualHitTestMode":
                if (this.ce != null) {
                    this.ce.ot();
                }
                break;
            case "LegendItemBadgeTemplate":
            case "LegendItemTemplate":
            case Series.$$p[19]:
            case Series.$$p[18]:
                this.m1();
                this.l6();
                break;
            case Series.$$p[23]:
                this.mz();
                break;
            case Series.$$p[5]:
            case Series.$$p[9]:
            case Series.$$p[27]:
            case Series.$$p[10]:
            case Series.$$p[11]:
                this.k9();
                this.l6();
                break;
            case "Index":
                if (typeGetValue(c) != typeGetValue(d)) {
                    this.lz();
                    this.bt = this.bv();
                    this.m0();
                    this.mz();
                    this.k9();
                    this.l6();
                }
                break;
            case "RadiusX":
            case "RadiusY":
            case "RoundedCornersLocation":
                this.l6();
                break;
            case Series.$$p[8]:
                this.my();
                this.l6();
                break;
            case Series.$$p[22]:
            case Series.$$p[21]:
            case Series.$$p[24]:
                this.l6();
                break;
            case Series.$$p[16]:
                this.l0();
                this.l6();
                break;
            case Series.$$p[44]:
            case Series.$$p[30]:
            case Series.$$p[29]:
            case Series.$$p[31]:
            case Series.$$p[32]:
                this.l6();
                break;
            case Series.$$p[35]:
                this.m0();
                if (this.ba == 1) {
                    this.m2();
                }
                break;
            case Series.$$p[2]:
            case Series.$$p[3]:
                this.l6();
                break;
            case Series.$$p[1]:
            case Series.$$p[6]:
            case Series.$$p[7]:
                this.pa = this.o5;
                this.pb = this.o8;
                this.f4 = this.fy;
                this.o7 = this.o8;
                this.o6 = this.o5;
                this.l6();
                this.b1.bj();
                if (this.toolTip != null && this.a6 != null) {
                    this.a7.a$aj(this, this.toolTip);
                }
                break;
            case "Visibility":
                this.b1.bk();
                break;
            case "ItemsSource":
                if (this.b9 != null) {
                    this.mf(this.b9);
                }
                break;
            case Series.$$p[12]:
                if (c != d && d != null) {
                    this.e5 = true;
                }
                this.lv();
                if (typeCast(IFastItemsSource_$type, c) != null) {
                    var m = c;
                    m.event = delegateRemove(m.event, this.ha);
                }
                if (typeCast(IFastItemsSource_$type, d) != null) {
                    var n = d;
                    n.event = delegateCombine(n.event, this.ha);
                }
                break;
            case "Legend":
                if (d != null) {
                    if (a == this) {
                        d.seriesOwner = this;
                    }
                    else if (typeCast(XamDataChart.$, a) !== null) {
                        d.chartOwner = a;
                    }
                }
                this.a2 = this.a3();
                break;
            case "ActualLegend":
                this.c8 = this.a2 == null ? false : this.a2.isFinancial;
                this.kv(typeCast(IChartLegend_$type, c), typeCast(IChartLegend_$type, d));
                break;
            case "LegendItem":
                this.kx(typeCast(Control.$, c), typeCast(Control.$, d));
                break;
            case Series.$$p[20]:
                this.b1.at();
                break;
            case Series.$$p[37]:
                if (this.a6 != null) {
                    this.a7.a$aj(this, this.toolTip);
                }
                break;
            case "CrosshairPoint":
                if (this.ce != null) {
                    this.m8(this.ce.ta);
                }
                if (this.ce != null) {
                    if (!this.cz) {
                        this.ce.ol(this, this.hy(this.ce.ta));
                    }
                }
                break;
            case Series.$$p[28]:
                this.fx = this.gz();
                break;
            case "ActualResolution":
                this.mn(false);
                this.lu();
                break;
            case Series.$$p[48]:
                this.f2 = this.g9;
                if (this.ce != null) {
                    this.ce.mf();
                }
                break;
            case Series.$$p[45]:
                this.fz = this.g6;
                if (this.ce != null) {
                    this.ce.mf();
                }
                break;
            case Series.$$p[38]:
            case Series.$$p[39]:
                this.cf.w();
                this.cf.r = this.hr;
                this.cf.b = this.cg;
                this.mn(false);
                break;
            case "DiscreteLegendItemTemplate":
                this.mn(false);
                break;
            case "VisibilityProxy":
                if (c != d) {
                    this.mn(false);
                }
                this.lu();
                this.b1.bk();
                break;
            case Series.$$p[17]:
                this.bl = this.bm();
                this.mn(false);
                break;
            case Series.$$p[13]:
                this.fv = isNaN_(this.gu) ? 0.2 : this.gu;
                break;
            case Series.$$p[34]:
                this.la();
                break;
            case "FinalValue":
                this.m7();
                break;
            case Series.$$p[49]:
                this.b3 = this.b4();
                break;
        }
    };
    Series.prototype.m0 = function () {
        var a = this.bt;
        var b = this.g4;
        if (isNaN_(b)) {
            b = DeviceUtils.g(2);
        }
        if (a == 2) {
            b = 1;
        }
        if (this.fy != b) {
            this.fy = b;
        }
        this.f4 = this.fy;
    };
    Series.prototype.m8 = function (a) {
        if (this.ce != null && this.ce.ei && this.bl != 1 && this.ce.ef) {
            if (isNaN_(a.x) || isNaN_(a.y)) {
                this.a7.a$v(this, null, a, false, false, false, false, this.ce.bo == this, true);
            }
            else {
                this.a7.a$v(this, this.hy(a), a, false, false, false, false, this.ce.bo == this, false);
            }
        }
    };
    Series.prototype.la = function () {
        if (this.ce != null && (this.externalObject.owner)) {
            var sv_ = this.ce;
            this.externalObject.owner._ensureDefaultTooltip(this.externalObject);
            ;
        }
    };
    Series.prototype.get_d0 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d0", {
        get: function () {
            return this.get_d0();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.k7 = function (a) {
        a.cz = true;
    };
    Object.defineProperty(Series.prototype, "b9", {
        get: function () {
            return this.b8;
        },
        set: function (a) {
            if (this.b9 != a) {
                var b = this.b9;
                this.b8 = a;
                this.raisePropertyChanged("SyncLink", b, this.b9);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ce", {
        get: function () {
            return this.cd;
        },
        set: function (a) {
            if (this.ce != a) {
                var b = this.ce;
                this.cd = a;
                this.raisePropertyChanged("SeriesViewer", b, this.cd);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "cc", {
        get: function () {
            return typeCast(XamDataChart.$, this.ce);
        },
        set: function (a) {
            this.ce = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "itemsSource", {
        get: function () {
            return this.c(Series.n4);
        },
        set: function (a) {
            this.h(Series.n4, a);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.k5 = function (a, b, c, d) {
        if (this.ce != null) {
            this.ce.om();
        }
    };
    Object.defineProperty(Series.prototype, "legend", {
        get: function () {
            return this.c(Series.oa);
        },
        set: function (a) {
            this.h(Series.oa, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ne", {
        get: function () {
            if (this.nc == null && this.a2 != null) {
                this.nc = this.nd();
            }
            return this.nc;
        },
        set: function (a) {
            if (this.ne != a) {
                var b = this.ne;
                this.nc = a;
                this.raisePropertyChanged("LegendItem", b, this.nc);
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.h5 = function () {
        return this.nd();
    };
    Series.prototype.nd = function () {
        var _this = this;
        var a = typeCast(ContentControl.$, this.nc);
        var b = this.legendItemTemplate;
        if (b == null) {
            b = this.b1.bl(this.b7);
        }
        if (b != null) {
            if (a == null) {
                a = new ContentControl();
            }
            a.content = ((function () {
                var $ret = new DataContext();
                $ret.series = _this;
                $ret.item = null;
                return $ret;
            })());
            a.ah = b;
        }
        else {
            a = null;
        }
        return a;
    };
    Object.defineProperty(Series.prototype, "a2", {
        get: function () {
            return this.a1;
        },
        set: function (a) {
            if (this.a2 != a) {
                var b = this.a1;
                this.a1 = a;
                this.raisePropertyChanged("ActualLegend", b, this.a1);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "legendItemBadgeTemplate", {
        get: function () {
            return this.c(Series.n7);
        },
        set: function (a) {
            this.h(Series.n7, a);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.ni = function () {
        return this.legendItemBadgeTemplate;
    };
    Object.defineProperty(Series.prototype, "legendItemTemplate", {
        get: function () {
            return this.c(Series.n8);
        },
        set: function (a) {
            this.h(Series.n8, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "nh", {
        get: function () {
            return this.c(Series.nw);
        },
        set: function (a) {
            this.h(Series.nw, a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "index", {
        get: function () {
            return typeGetValue(this.c(Series.nz));
        },
        set: function (a) {
            this.h(Series.nz, a);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.m9 = function () {
        this.m1();
    };
    Series.prototype.k9 = function () {
        this.m1();
    };
    Series.prototype.m1 = function () {
        this.lu();
        if (this.index < 0) {
            return;
        }
        if (this.o9 != null) {
            this.b1.a7();
            this.b1.ah();
        }
        else {
            this.o5 = this.ce == null ? null : this.ce.sq(this.index);
        }
        if (this.bt == 2) {
            this.b1.a8();
            this.o8 = this.o5;
        }
        else {
            if (this.pe != null) {
                this.b1.a8();
                this.b1.ai();
            }
            else {
                this.o8 = this.ce == null ? null : this.ce.sw(this.index);
            }
        }
        if ((this.ef || this.dy) && this.eb) {
            this.o5 = this.o8;
        }
        else if ((this.ef || this.dy) && this.df) {
            this.o8 = this.o5;
        }
        else if ((this.ef || this.dy) && this.d3) {
            this.o8 = this.o5;
        }
        else if (this.el && this.legendItemBadgeShape == 2) {
            this.o5 = this.o8;
        }
    };
    Series.prototype.cw = function () {
        return this.cf.f();
    };
    Series.prototype.mw = function () {
        this.cf.v();
    };
    Object.defineProperty(Series.prototype, "fx", {
        get: function () {
            if (!this.cs) {
                this.cs = true;
                this.fn = this.gz();
            }
            return this.fn;
        },
        set: function (a) {
            var b = this.fn;
            this.fn = a;
            if (b != this.fn) {
                this.raisePropertyChanged("ActualResolution", b, this.fn);
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.gz = function () {
        if (!isNaN_(this.gy)) {
            return this.gy;
        }
        return DeviceUtils.g(1);
    };
    Object.defineProperty(Series.prototype, "f2", {
        get: function () {
            return this.fr;
        },
        set: function (a) {
            this.fr = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "fz", {
        get: function () {
            return this.fo;
        },
        set: function (a) {
            this.fo = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "f0", {
        get: function () {
            return this.fp;
        },
        set: function (a) {
            this.fp = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "f1", {
        get: function () {
            return this.fq;
        },
        set: function (a) {
            this.fq = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "bl", {
        get: function () {
            return this.bk;
        },
        set: function (a) {
            var b = this.bk;
            this.bk = a;
            if (b != this.bk) {
                this.raisePropertyChanged("ActualHighlightingMode", enumGetBox(SeriesHighlightingMode_$type, b), enumGetBox(SeriesHighlightingMode_$type, this.bk));
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.bm = function () {
        if (!this.d0) {
            return 1;
        }
        if (this.ce != null) {
            if (this.ce.bv != 1 && this.ce.bv != 0 && !this.dl) {
                return this.ce.bv;
            }
        }
        if (this.dz) {
            return 2;
        }
        return 1;
    };
    Series.prototype.ei = function (a) {
        switch (a) {
            case 2:
            case 4: return true;
        }
        return false;
    };
    Object.defineProperty(Series.prototype, "fv", {
        get: function () {
            return this.fm;
        },
        set: function (a) {
            var b = this.fm;
            this.fm = a;
            if (b != this.fm) {
                this.raisePropertyChanged("ActualHighlightingFadeOpacity", b, this.fm);
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_dr = function () {
        return true;
    };
    Object.defineProperty(Series.prototype, "dr", {
        get: function () {
            return this.get_dr();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.my = function () {
        var a = (typeCast(XamDataChart.$, this.ce));
        if (a != null) {
            this.fu = isNaN_(this.f3) ? a.uj.fp : this.f3;
        }
    };
    Series.prototype.mz = function () {
        this.fw = isNaN_(this.gv) ? this.g0() : this.gv;
    };
    Series.prototype.g0 = function () {
        return 1;
    };
    Object.defineProperty(Series.prototype, "dp", {
        get: function () {
            return this.cr;
        },
        set: function (a) {
            this.cr = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "b3", {
        get: function () {
            return this.b2;
        },
        set: function (a) {
            this.b2 = a;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.b4 = function () {
        if (this.b5 == 0) {
            return 1;
        }
        return this.b5;
    };
    Object.defineProperty(Series.prototype, "bt", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            this.bs = a;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.bv = function () {
        if (this.bu == 0) {
            return 1;
        }
        return this.bu;
    };
    Series.prototype.av = function (a) {
        var _this = this;
        return ((function () {
            var $ret = new DataContext();
            $ret.series = _this;
            $ret.item = a;
            return $ret;
        })());
    };
    Series.prototype.ca = function () {
        return 1;
    };
    Series.prototype.ml = function () {
        this.b1.a3();
    };
    Series.prototype.mq = function () {
        this.e5 = true;
        this.mn(true);
    };
    Series.prototype.mk = function () {
        this.kz();
    };
    Series.prototype.kz = function () {
    };
    Series.prototype.lk = function () {
    };
    Series._fi = function (a, b, c) {
        var d;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    d = b;
                    _a.label = 1;
                case 1:
                    if (!(d < c))
                        return [3 /*break*/, 4];
                    return [4 /*yield*/, a(d)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    d++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    Series.fi = function (a, b, c) {
        return toEnum(function () { return Series._fi(a, b, c); });
    };
    Series.fh = function (a, b) {
        return Series.fi(a, 0, b);
    };
    Series.prototype.bi = function () {
        return this.bh;
    };
    Series.prototype.mr = function (a) {
        this.m3(a);
    };
    Series.prototype.gr = function () {
        return this.hr;
    };
    Series.prototype.gs = function () {
        return this.hs;
    };
    Series.prototype.get_e7 = function () {
        return this.cv;
    };
    Series.prototype.set_e7 = function (a) {
        this.cv = a;
    };
    Object.defineProperty(Series.prototype, "e7", {
        get: function () {
            return this.get_e7();
        },
        set: function (a) {
            this.set_e7(a);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "es", {
        get: function () {
            return this.e7;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.k0 = function () {
        this.a7.a$s();
    };
    Series.prototype.ax = function (a, b, c) {
        return null;
    };
    Series.prototype.ay = function (a, b, c) {
        return null;
    };
    Series.prototype.l1 = function (a, b, c, d) {
        this.a7.a$y(this, a, b, c, d);
    };
    Series.prototype.mv = function (a) {
        this.a7.a$ai(this, a);
    };
    Series.prototype.kw = function (a, b) {
        if (this.a2 != null && this.ne != null) {
            if (b == null && this.a2.containsChild(this.ne)) {
                this.a2.removeChild(this.ne);
            }
            if (b != null && !this.a2.containsChild(this.ne) && this.qb != 1) {
                this.a2.addChildInOrder(this.ne, this);
            }
        }
    };
    Series.prototype.k1 = function () {
        if (this.a2 == null || this.ne == null) {
            return;
        }
        this.a2.removeChild(this.ne);
    };
    Series.prototype.kv = function (a, b) {
        if (this.ne != null) {
            if (a != null && a.containsChild(this.ne)) {
                a.removeChild(this.ne);
            }
            if (this.ce != null && b != null && !b.containsChild(this.ne) && this.qb != 1) {
                b.addChildInOrder(this.ne, this);
            }
        }
    };
    Series.prototype.kx = function (a, b) {
        if (this.a2 != null) {
            if (a != null && this.a2.containsChild(a)) {
                this.a2.removeChild(a);
            }
            if (this.ce != null && b != null && this.qb != 1) {
                this.a2.addChildInOrder(b, this);
            }
        }
    };
    Series.prototype.mg = function (a) {
        this.cl = a.releaseFastItemsSource(this.itemsSource);
    };
    Series.prototype.mf = function (a) {
        this.cl = a.getFastItemsSource(this.itemsSource);
    };
    Series.prototype.a3 = function () {
        if (this.legend != null) {
            return this.legend;
        }
        if (this.ce != null && this.ce.legend != null) {
            return this.ce.legend;
        }
        return null;
    };
    Series.prototype.eu = function () {
        return false;
    };
    Series.prototype.er = function (a) {
        return (a && this.gr() > 0) || this.cw() || (this.e6 && this.eu() && this.gs() > 0);
    };
    Series.prototype.k6 = function (a) {
        if (a != null) {
            a.b0(this);
        }
    };
    Series.prototype.me = function (a) {
        if (a != null) {
            a.ct(this);
        }
    };
    Series.prototype.bj = function () {
        return this.b1.g();
    };
    Series.prototype.m3 = function (a) {
        this.b1.a9(a);
    };
    Series.prototype.mu = function (a, b) {
        this.a7.a$ah(this, a, b);
    };
    Series.prototype.get_e9 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "e9", {
        get: function () {
            return this.get_e9();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.ma = function (a, b) {
        this.b1.ar(a, b);
    };
    Series.prototype.mc = function (a) {
        this.l5(this.p7, a);
    };
    Series.prototype.lh = function (a) {
        if (this.cl != null) {
            this.cl.handleCollectionChanged(a);
        }
    };
    Series.prototype.ls = function (a, b, c) {
        this.lh(new NotifyCollectionChangedEventArgs(2, 2, c, b, a));
    };
    Series.prototype.lo = function () {
        this.lh(new NotifyCollectionChangedEventArgs(0, 4));
    };
    Series.prototype.lq = function (a, b) {
        this.lh(new NotifyCollectionChangedEventArgs(1, 0, b, a));
    };
    Series.prototype.lr = function (a, b) {
        this.lh(new NotifyCollectionChangedEventArgs(1, 1, b, a));
    };
    Series.prototype.mx = function () {
        this.mn(false);
    };
    Series.prototype.ez = function (a, b) {
        return false;
    };
    Series.prototype.get_coercionMethods = function () {
        return this._coercionMethods;
    };
    Series.prototype.set_coercionMethods = function (a) {
        this._coercionMethods = a;
    };
    Object.defineProperty(Series.prototype, "coercionMethods", {
        get: function () {
            return this.get_coercionMethods();
        },
        set: function (a) {
            this.set_coercionMethods(a);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_expectFunctions = function () {
        return this.cq;
    };
    Series.prototype.set_expectFunctions = function (a) {
        var b = this.cq;
        this.cq = a;
        if (b != this.cq) {
            this.raisePropertyChanged("ExpectFunctions", b, this.cq);
        }
    };
    Object.defineProperty(Series.prototype, "expectFunctions", {
        get: function () {
            return this.get_expectFunctions();
        },
        set: function (a) {
            this.set_expectFunctions(a);
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.au = function (a, b) {
        return null;
    };
    Object.defineProperty(Series.prototype, "br", {
        get: function () {
            return this.bo;
        },
        set: function (a) {
            var b = this.bo;
            this.bo = a;
            if (b != this.bo) {
                this.raisePropertyChanged("HitTestMode", enumGetBox(SeriesHitTestMode_$type, b), enumGetBox(SeriesHitTestMode_$type, this.bo));
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.bq = function () {
        return this.br == 0 ? 2 : this.br;
    };
    Object.defineProperty(Series.prototype, "bp", {
        get: function () {
            return this.bn;
        },
        set: function (a) {
            var b = this.bn;
            this.bn = a;
            if (b != this.bn) {
                this.raisePropertyChanged("ActualHitTestMode", enumGetBox(SeriesHitTestMode_$type, b), enumGetBox(SeriesHitTestMode_$type, this.bn));
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.ci = function (a) {
        if (a == null) {
            return this.cl.registerColumn(null, null, false);
        }
        var b = null;
        var c = SeriesViewer.cg(a, this.coercionMethods);
        b = c.a;
        return this.cl.registerColumn(a, b, this.expectFunctions);
    };
    Series.prototype.cj = function (a) {
        if (a == null) {
            return this.cl.registerColumnInt(null, null, false);
        }
        var b = null;
        var c = SeriesViewer.cg(a, this.coercionMethods);
        b = c.a;
        return this.cl.registerColumnInt(a, b, this.expectFunctions);
    };
    Series.prototype.ck = function (a) {
        if (a == null) {
            return this.cl.registerColumnObject(null, null, false);
        }
        var b = null;
        var c = SeriesViewer.cg(a, this.coercionMethods);
        b = c.a;
        return this.cl.registerColumnObject(a, b, this.expectFunctions);
    };
    Object.defineProperty(Series.prototype, "p7", {
        get: function () {
            return this.b1 != null ? this.b1.bu : Rect.empty;
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d6 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d6", {
        get: function () {
            return this.get_d6();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.get_d5 = function () {
        return false;
    };
    Object.defineProperty(Series.prototype, "d5", {
        get: function () {
            return this.get_d5();
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.mt = function (a) {
    };
    Series.prototype.ms = function (a, b) {
    };
    Series.prototype.k4 = function (a, b) {
        this.a9.copyVisualData(a, b);
    };
    Series.prototype.hx = function () {
        var a = this.a9.exportVisualData(this, this.p7);
        this.lc(a);
        this.b1.al(a);
        return a;
    };
    Series.prototype.lc = function (a) {
    };
    Series.prototype.lm = function (a) {
        if (this.pm.x != a.x || this.pm.y != a.y) {
            this.pm = a;
            this.ly(a);
        }
    };
    Series.prototype.ly = function (a) {
    };
    Series.prototype.ln = function () {
    };
    Series.prototype.lt = function () {
    };
    Series.prototype.ao = function (a) {
        return null;
    };
    Series.prototype.ag = function () {
        return null;
    };
    Series.prototype.gg = function () {
        return NaN;
    };
    Series.gh = function (a, b) {
        if (a == null || a.count == 0) {
            return NaN;
        }
        if (b != null && b.i$b != null) {
            if (b.i$b.count != a.count) {
                return NaN;
            }
            for (var c = 0; c < a.count; c++) {
                if (!isNaN_(a.item(b.i$b._inner[c])) && a.item(b.i$b._inner[c]) != 0) {
                    return a.item(b.i$b._inner[c]);
                }
            }
        }
        for (var d = 0; d < a.count; d++) {
            if (!isNaN_(a.item(d)) && a.item(d) != 0) {
                return a.item(d);
            }
        }
        return NaN;
    };
    Series.gi = function (a, b) {
        if (a == null || a.count == 0) {
            return NaN;
        }
        if (b != null && b.i$b != null) {
            if (b.i$b.count != a.count) {
                return NaN;
            }
            for (var c = 0; c < a.count; c++) {
                if (!isNaN_(a.item(b.i$b._inner[c])) && a.item(b.i$b._inner[c]) != 0) {
                    return a.item(b.i$b._inner[c]);
                }
            }
        }
        for (var d = 0; d < a.count; d++) {
            if (!isNaN_(a.item(d)) && a.item(d) != 0) {
                return a.item(d);
            }
        }
        return NaN;
    };
    Series.prototype.lx = function () {
    };
    Object.defineProperty(Series.prototype, "f5", {
        get: function () {
            return this.fs;
        },
        set: function (a) {
            var b = this.f5;
            if (a != b) {
                this.fs = a;
                this.raisePropertyChanged("FinalValue", b, this.f5);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "gx", {
        get: function () {
            return this.ft;
        },
        set: function (a) {
            var b = this.gx;
            if (a != b) {
                this.ft = a;
                this.raisePropertyChanged("PercentChange", b, this.gx);
            }
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.m7 = function () {
        var a = this.gg();
        this.gx = (this.f5 - a) / a * 100;
    };
    Series.prototype.h0 = function (a) {
        return null;
    };
    Object.defineProperty(Series.prototype, "im", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.bz) ? this.co.bz : "Open";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ia", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.bw) ? this.co.bw : "Close";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ib", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.bx) ? this.co.bx : "High";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ik", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.by) ? this.co.by : "Low";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "it", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.b0) ? this.co.b0 : "Volume";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "is", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.b9) ? this.co.b9 : "Value";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Series.prototype, "ip", {
        get: function () {
            return !stringIsNullOrWhiteSpace(this.co.m) ? this.co.m : "Radius";
        },
        enumerable: false,
        configurable: true
    });
    Series.prototype.m2 = function () {
        this.ng = this.ni();
        this.b1.bj();
    };
    Series.prototype.an = function () {
        var a = this.legendItemBadgeShape;
        if (a == 0) {
            a = this.bc();
        }
        var b = 0;
        if (a == 3) {
            if (this.dv || this.en) {
                b = 6;
            }
            else if (this.dt) {
                b = 7;
            }
            else {
                b = 5;
            }
        }
        else if (a == 4) {
            if (this.hasMarkers && !this.du) {
                b = 8;
            }
            else {
                b = 0;
            }
        }
        else if (a == 2) {
            if (this.hasMarkers && !this.dd) {
                b = 1;
            }
            else {
                b = 2;
            }
        }
        else if (a == 1) {
            b = 0;
        }
        else if (a == 5) {
            b = 3;
        }
        else if (a == 6) {
            b = 4;
        }
        else if (a == 7) {
            b = 9;
        }
        return b;
    };
    Series.prototype.bb = function (a) {
        return a;
    };
    Series.prototype.bc = function () {
        if (this.df || this.di || this.dk || this.ea || this.eh || this.dv || this.dt || this.du || this.el || this.en) {
            return this.bb(3);
        }
        else if (this.d4 || this.ej || this.eb || this.d3 || this.isValueOverlay) {
            return this.bb(2);
        }
        else if (this.dd || this.d8 || this.d7) {
            return this.bb(1);
        }
        else if (this.c5) {
            return this.bb(4);
        }
        return this.bb(1);
    };
    Series.prototype.getDataLegendBadge = function () {
        var a = this.ni();
        if (a == null) {
            a = LegendTemplates.af(this);
        }
        return a;
    };
    Series.prototype.getDataLegendBadgeContext = function () {
        var _this = this;
        if (this.a5 == null) {
            this.a5 = ((function () {
                var $ret = new DataContext();
                $ret.series = _this;
                $ret.item = null;
                return $ret;
            })());
        }
        return this.a5;
    };
    Series.prototype.getDataLegendBadgeShapeAndMarker = function () {
        var a = this.an();
        if (a == 8) {
            return this.i2();
        }
        else if (a == 1) {
            if (this.ba == 0) {
                return "Line";
            }
            return "LineWith" + this.i2();
        }
        else if (a == 3) {
            return "Bar";
        }
        else if (a == 4) {
            return "Column";
        }
        else if (a == 9) {
            return "None";
        }
        else if (a == 0) {
            return "Circle";
        }
        else if (a == 2) {
            return "Line";
        }
        else if (a == 5) {
            return "Square";
        }
        else if (a == 6) {
            if (this.ba == 0) {
                return "Square";
            }
            else {
                return "TwoColumns";
            }
        }
        else if (a == 7) {
            if (this.ba == 0) {
                return "Square";
            }
            else {
                return "TwoBars";
            }
        }
        return EnumUtil.getName(ActualLegendItemBadgeShape_$type, a);
    };
    Series.prototype.i2 = function () {
        return null;
    };
    Series.prototype.i3 = function (a, b) {
        if (b == a.ce.pv) {
            return "Circle";
        }
        else if (b == a.ce.pw) {
            return "Diamond";
        }
        else if (b == a.ce.px) {
            return "Hexagon";
        }
        else if (b == a.ce.py) {
            return "Hexagram";
        }
        else if (b == a.ce.pz) {
            return "Pentagon";
        }
        else if (b == a.ce.p0) {
            return "Pentagram";
        }
        else if (b == a.ce.p1) {
            return "Pyramid";
        }
        else if (b == a.ce.p2) {
            return "Square";
        }
        else if (b == a.ce.p3) {
            return "Tetragram";
        }
        else if (b == a.ce.p4) {
            return "Triangle";
        }
        else if (b != null) {
            return "Custom";
        }
        else {
            return "None";
        }
    };
    Series.prototype.getDataLegendSeriesTitle = function () {
        return this.title == null ? null : this.title.toString();
    };
    Series.prototype.gf = function (a, b) {
        return FastItemColumn.i(this.h1(a, b));
    };
    Series.prototype.getDataLegendSeriesContextAt = function (a, b) {
        var c = new DataLegendSeriesValueInfo();
        c.l = this.gn({ $type: Point_$type, x: a, y: b }, false, false);
        c.a = 0;
        c.p = "Value";
        c.q = "Value";
        c.r = "";
        var d = new DataLegendSeriesContext();
        d.f = ((function () {
            var $ret = new List$1(DataLegendSeriesValueInfo.$, 0);
            $ret.add(c);
            return $ret;
        })());
        d.b = this.aw();
        return d;
    };
    Series.prototype.aw = function () {
        if (this.dy) {
            return 9;
        }
        if (this.ee) {
            return 1;
        }
        if (this.eg) {
            return 8;
        }
        if (this.ef) {
            return 6;
        }
        if (this.d9) {
            return 4;
        }
        if (this.ed) {
            return 5;
        }
        if (this.isStacked || this.dx) {
            return 7;
        }
        if (this.dw) {
            return 0;
        }
        if (this.ds) {
            if (this.dv) {
                return 2;
            }
            return 3;
        }
        return 0;
    };
    Series.prototype.getDataLegendAxisLabelFromCursorPosition = function (a, b) {
        if (this.dj || this.ds || this.ed) {
            var c = { $type: Point_$type, x: a, y: b };
            var d = this.as();
            if (d != null) {
                if (!d.co()) {
                    return null;
                }
                if (d.cn) {
                    var e = this.hk(c);
                    if (e < 0) {
                        return null;
                    }
                    var f = d;
                    var g = f.i$d(e);
                    var h = this.fl(g);
                    return h;
                }
                else {
                    if (d.ck) {
                        var i = this.f9(c);
                        if (i < 0) {
                            i = 0;
                        }
                        var j = d;
                        var k = j.getDateTime(i);
                        return k;
                    }
                    else {
                        var l = this.hi(c);
                        if (l < 0) {
                            return null;
                        }
                        var m = d.kr;
                        if (m == null || m.count == 0) {
                            return null;
                        }
                        if (l >= m.count) {
                            l = m.count - 1;
                        }
                        var n = d.gd(l);
                        return n;
                    }
                }
            }
        }
        return null;
    };
    Series.prototype.ll = function (message_) {
        console.log('Series >> ' + message_);
        ;
    };
    Series.prototype.fl = function (ticks_) {
        var a = (new Date(ticks_));
        return a;
    };
    Series.$t = markType(Series, 'Series', Control.$, [INotifyPropertyChanged_$type, IProvidesViewport_$type, ILegendSeries_$type, ILegendSeriesInternal_$type, ILegendOwner_$type, ILegendTemplateProvider_$type, IDataLegendSeries_$type]);
    Series.hf = 0;
    Series.oz = DependencyProperty.i("VisibilityProxy", Visibility_$type, Series.$, new PropertyMetadata(2, enumGetBox(Visibility_$type, 0), function (a, b) { return a.raisePropertyChanged("VisibilityProxy", b.oldValue, b.newValue); }));
    Series.n4 = DependencyProperty.i("ItemsSource", IEnumerable_$type, Series.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(Series.$, a);
        if (c.b9 != null) {
            c.b9.releaseFastItemsSource(b.oldValue);
        }
        a.raisePropertyChanged("ItemsSource", b.oldValue, b.newValue);
    }));
    Series.oa = DependencyProperty.i("Legend", IChartLegend_$type, Series.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(Series.$, a);
        c.raisePropertyChanged("Legend", b.oldValue, b.newValue);
    }));
    Series.n7 = DependencyProperty.i("LegendItemBadgeTemplate", DataTemplate.$, Series.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(Series.$, a);
        c.raisePropertyChanged("LegendItemBadgeTemplate", b.oldValue, b.newValue);
        if (c.ne != null) {
            c.ne = c.nd();
        }
    }));
    Series.n8 = DependencyProperty.i("LegendItemTemplate", DataTemplate.$, Series.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(Series.$, a);
        c.raisePropertyChanged("LegendItemTemplate", b.oldValue, b.newValue);
        if (c.ne != null) {
            c.ne = c.nd();
        }
    }));
    Series.nw = DependencyProperty.i("DiscreteLegendItemTemplate", DataTemplate.$, Series.$, new PropertyMetadata(2, null, function (a, b) {
        var c = typeCast(Series.$, a);
        c.raisePropertyChanged("DiscreteLegendItemTemplate", b.oldValue, b.newValue);
    }));
    Series.nz = DependencyProperty.i("Index", Number_$type, Series.$, new PropertyMetadata(2, -1, function (a, b) {
        var c = typeCast(Series.$, a);
        c.raisePropertyChanged("Index", b.oldValue, b.newValue);
        if (c.ne != null) {
            c.ne = c.nd();
        }
    }));
    Series.$$p = markDep(DependencyProperty, PropertyMetadata, Series, 'raisePropertyChanged', ['ActualAreaFillOpacity:fu:nk', [1, 1], 'ActualBrush:o5:nl', [Brush.$], 'ActualLegendItemBadgeBrush:o6:nm', [Brush.$], 'ActualLegendItemBadgeOutline:o7:nn', [Brush.$], 'ActualLegendItemBadgeTemplate:ng:no', [DataTemplate.$], 'ActualMarkerFillOpacity:fw:np', [1, 1], 'ActualOutline:o8:nq', [Brush.$], 'ActualThickness:fy:nr', [1, DeviceUtils.g(2)], 'AreaFillOpacity:f3:ns', [1, NaN], 'Brush:o9:nt', [Brush.$, null], 'DashArray:pi:nu', [DoubleCollection.$], 'DashCap:pj:nv', [PenLineCap_$type, enumGetBox(PenLineCap_$type, 0)], 'FastItemsSource:cl:nx', [IFastItemsSource_$type], 'HighlightingFadeOpacity:gu:ny', [1, NaN], 'IsActualLegendFinancial:c8:n0', [0, false], 'IsComponentHighlightingModeIgnored:dl:n1', [0, false], 'IsDropShadowEnabled:dq:n2', [0, false], 'IsHighlightingEnabled:dz:n3', [0, false], 'LegendItemBadgeMode:ba:n5', [LegendItemBadgeMode_$type, enumGetBox(LegendItemBadgeMode_$type, 0)], 'LegendItemBadgeShape::n6', [LegendItemBadgeShape_$type, enumGetBox(LegendItemBadgeShape_$type, 0)], 'LegendItemVisibility:qb:n9', [Visibility_$type, enumGetBox(Visibility_$type, 0)], 'LineCap:pk:ob', [PenLineCap_$type, enumGetBox(PenLineCap_$type, 0)], 'LineJoin:pl:oc', [PenLineJoin_$type, enumGetBox(PenLineJoin_$type, 0)], 'MarkerFillOpacity:gv:od', [1, NaN], 'MiterLimit:gw:oe', [1, 10], 'MouseOverEnabled:eo:of', [0, true], 'OutlineMode:bu:og', [SeriesOutlineMode_$type, enumGetBox(SeriesOutlineMode_$type, 0)], 'Outline:pe:oh', [Brush.$, null], 'Resolution:gy:oi', [1, NaN], 'ShadowBlur:g1:oj', [1, NaN], 'ShadowColor:ph:ok', [Color.$], 'ShadowOffsetX:g2:ol', [1, NaN], 'ShadowOffsetY:g3:om', [1, NaN], 'ShouldHideAutoCallouts:et:on', [0, false], 'ShowDefaultTooltip:ev:oo', [0, false], 'Thickness:g4:op', [1, DeviceUtils.g(2)], 'Title::oq', [4, "Series Title"], 'ToolTip::or', [4, null], 'TransitionDuration:hr:os', [1, 0], 'TransitionEasingFunction:cg:ot', [Delegate_$type, null], 'TransitionInDuration:hs:ou', [1, 1000], 'TransitionInEasingFunction:ch:ov', [Delegate_$type, null], 'TransitionInSpeedType:cb:ow', [TransitionInSpeedType_$type, enumGetBox(TransitionInSpeedType_$type, 0)], 'TransitionProgress:g5:ox', [1, 0], 'UseSingleShadow:fb:oy', [0, true], 'VisibleRangeMarginBottom:g6:o0', [1, NaN], 'VisibleRangeMarginLeft:g7:o1', [1, NaN], 'VisibleRangeMarginRight:g8:o2', [1, NaN], 'VisibleRangeMarginTop:g9:o3', [1, NaN], 'VisibleRangeMode:b5:o4', [SeriesVisibleRangeMode_$type, enumGetBox(SeriesVisibleRangeMode_$type, 0)]]);
    return Series;
}(Control));
export { Series };
/**
 * @hidden
 */
var MarkerSeries = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(MarkerSeries, _super);
    function MarkerSeries() {
        var _this = _super.call(this) || this;
        _this.qg = 1;
        _this.qc = 1;
        _this.q6 = null;
        return _this;
    }
    MarkerSeries.prototype.p9 = function (a, b) {
        if (this.ed || this.d9) {
            return new Thickness(1, 0, 0, 0, 0);
        }
        if (this.ql != 1 && this.ql != 13) {
            var c = this.qk.cq();
            var d = (c.width / 2) + (this.qq / 2);
            var e = (c.height / 2) + (this.qq / 2);
            var f = e;
            var g = e;
            var h = d;
            var i = d;
            if (a == 2 || a == 4) {
                h = 0;
            }
            if (a == 2 || a == 3) {
                i = 0;
            }
            if (b == 2 || b == 3) {
                f = 0;
            }
            if (b == 2 || b == 4) {
                g = 0;
            }
            return new Thickness(1, h, f, i, g);
        }
        return new Thickness(1, 0, 0, 0, 0);
    };
    MarkerSeries.prototype.l4 = function (a) {
        _super.prototype.l4.call(this, a);
        this.qk = a;
    };
    MarkerSeries.prototype.get_hasMarkers = function () {
        return true;
    };
    MarkerSeries.prototype.pc = function () {
        return this.rl;
    };
    MarkerSeries.prototype.pd = function () {
        return this.rm;
    };
    MarkerSeries.prototype.nj = function () {
        return this.q6;
    };
    MarkerSeries.prototype.i2 = function () {
        return this.i3(this, this.q6);
    };
    Object.defineProperty(MarkerSeries.prototype, "qh", {
        get: function () {
            return this.qg;
        },
        set: function (a) {
            this.qg = a;
        },
        enumerable: false,
        configurable: true
    });
    MarkerSeries.prototype.qj = function () {
        if (this.qi == 0) {
            return 1;
        }
        return this.qi;
    };
    MarkerSeries.prototype.m5 = function (a) {
        _super.prototype.m5.call(this, a);
        this.qi = a;
    };
    Object.defineProperty(MarkerSeries.prototype, "qd", {
        get: function () {
            return this.qc;
        },
        set: function (a) {
            this.qc = a;
        },
        enumerable: false,
        configurable: true
    });
    MarkerSeries.prototype.qf = function () {
        if (this.qe == 0) {
            return 1;
        }
        return this.qe;
    };
    MarkerSeries.prototype.m4 = function (a) {
        _super.prototype.m4.call(this, a);
        this.qe = a;
    };
    MarkerSeries.prototype.m6 = function (a) {
        _super.prototype.m6.call(this, a);
        this.qq = a;
    };
    MarkerSeries.prototype.f6 = function () {
        return this.qq;
    };
    Object.defineProperty(MarkerSeries, "q8", {
        get: function () {
            if (MarkerSeries.q4 == null) {
                MarkerSeries.q4 = new DataTemplate();
            }
            return MarkerSeries.q4;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MarkerSeries.prototype, "rn", {
        get: function () {
            return this.c(MarkerSeries.rc);
        },
        set: function (a) {
            this.h(MarkerSeries.rc, a);
        },
        enumerable: false,
        configurable: true
    });
    MarkerSeries.prototype.qn = function () {
        return this.q6 != null && ((this.ql != 1 && this.ql != 0) || this.q7 != null);
    };
    MarkerSeries.prototype.lz = function () {
        _super.prototype.lz.call(this);
        this.qh = this.qj();
        this.qd = this.qf();
    };
    MarkerSeries.prototype.l9 = function (a, b, c, d) {
        _super.prototype.l9.call(this, a, b, c, d);
        switch (b) {
            case "MarkerBrush":
            case MarkerSeries.$$p[9]:
            case MarkerSeries.$$p[5]:
            case MarkerSeries.$$p[7]:
            case MarkerSeries.$$p[8]:
                this.m1();
                this.l6();
                break;
            case MarkerSeries.$$p[4]:
                this.qh = this.qj();
                this.m1();
                this.l6();
                break;
            case MarkerSeries.$$p[3]:
                this.qd = this.qf();
                this.m1();
                this.l6();
                break;
            case MarkerSeries.$$p[2]:
                this.q6 = d;
                if (c == MarkerSeries.q8 || d == MarkerSeries.q8 || (c == null || d != null)) {
                    this.qk.cg();
                    var e = typeCast(MarkerSeriesView.$, this.b0);
                    if (e != null) {
                        e.cg();
                    }
                    this.mn(false);
                }
                if (this.ce != null) {
                    this.ce.mc();
                }
                this.b1.bj();
                if (this.toolTip != null && this.d2) {
                    this.a7.a$aj(this, this.toolTip);
                }
                this.lu();
                break;
            case MarkerSeries.$$p[10]:
                this.qk.cn(this.qp);
                this.mn(false);
                break;
            case MarkerSeries.$$p[0]:
            case MarkerSeries.$$p[1]:
                if (this.c5) {
                    this.o6 = this.pc();
                    this.o7 = this.pd();
                }
                break;
        }
    };
    MarkerSeries.qu = function (a) {
        switch (a) {
            case 3:
            case 13: return SeriesViewer.$$p[2];
            case 4: return SeriesViewer.$$p[37];
            case 5: return SeriesViewer.$$p[27];
            case 6: return SeriesViewer.$$p[31];
            case 7: return SeriesViewer.$$p[5];
            case 8: return SeriesViewer.$$p[19];
            case 9: return SeriesViewer.$$p[7];
            case 10: return SeriesViewer.$$p[34];
            case 11: return SeriesViewer.$$p[20];
            case 12: return SeriesViewer.$$p[8];
            case 0:
            case 1:
            default: return null;
        }
    };
    MarkerSeries.qm = function (a, b) {
        var c = 1;
        var d = 0;
        if (a != null && a.ce != null) {
            d = a.ce.be;
        }
        if (a == null || a.ce == null) {
            c = 1;
            return c;
        }
        if (b != 2 && b != 0) {
            c = b;
        }
        else {
            if (d == 4) {
                c = 3;
            }
            else if (d == 5) {
                c = 4;
            }
            else if (d == 9) {
                c = 8;
            }
            else if (d == 11) {
                c = 10;
            }
            else if (d == 8) {
                c = 7;
            }
            else if (d == 7) {
                c = 6;
            }
            else if (d == 10) {
                c = 9;
            }
            else if (d == 12) {
                c = 11;
            }
            else if (d == 6) {
                c = 5;
            }
            else if (d == 13) {
                c = 12;
            }
            else if (d == 1) {
                c = 1;
            }
            else if (d == 0) {
                if (a.d5) {
                    c = 1;
                }
                else {
                    c = 3;
                }
            }
            else if (d == 3 || d == 2) {
                if (d == 2) {
                    if (a.d5) {
                        c = 1;
                        return c;
                    }
                }
                if (a.index < 0) {
                    c = 1;
                }
                else {
                    var e = [3, 4, 8, 10, 7, 6, 9, 11, 5, 12];
                    c = e[a.index % e.length];
                }
            }
        }
        return c;
    };
    MarkerSeries.prototype.m1 = function () {
        _super.prototype.m1.call(this);
        if (this.index < 0) {
            return;
        }
        if (this.qk.b2()) {
            this.qk.ce();
            this.qk.b8();
        }
        else {
            var a = MarkerSeries.qm(this, this.ql);
            var b = MarkerSeries.qu(a);
            if (b == null) {
                this.q5 = MarkerSeries.q8;
            }
            else {
                this.qk.cb(b);
            }
        }
        if (this.rn != null && this.ql != 13) {
            this.qk.cc();
            this.qk.b9();
        }
        else {
            if (this.ql == 13) {
                this.rl = this.b1.bq();
            }
            else {
                if (this.qd != 2) {
                    if (this.ce != null) {
                        var c = this.ce.su(this.index);
                        if (!isNaN_(this.fw) && this.fw != 1) {
                            c = BrushUtil.p(c, this.fw);
                        }
                        this.rl = c;
                    }
                    else {
                        this.rl = null;
                    }
                }
            }
        }
        if (this.ro != null) {
            this.qk.cd();
            this.qk.ca();
        }
        else {
            if (this.ql == 13) {
                this.rm = this.b1.bq();
            }
            else {
                if (this.qh == 2) {
                    this.rm = this.rl;
                }
                else {
                    this.rm = this.ce == null ? null : this.ce.sv(this.index);
                }
            }
        }
        if (this.qd == 2 && this.rn == null && this.ql != 13) {
            if (this.rm != null) {
                var d = this.rm;
                if (!isNaN_(this.fw) && this.fw != 1) {
                    d = BrushUtil.p(d, this.fw);
                }
                this.rl = d;
            }
            else {
                this.rl = null;
            }
        }
    };
    MarkerSeries.prototype.lc = function (a) {
        _super.prototype.lc.call(this, a);
        this.a9.exportMarkerVisualData(this, a);
    };
    MarkerSeries.prototype.qo = function (a, b) {
        if (this.hasMarkers && this.qn()) {
            var c = this.p6(a);
            if (c.isEmpty) {
                return false;
            }
            var d = RectUtil.r(c, this.gc(b));
            if (d.containsPoint(a)) {
                return true;
            }
        }
        return false;
    };
    MarkerSeries.prototype.au = function (a, b) {
        var c = this.qk.by(a);
        var d = null;
        if (c != null) {
            d = c.content;
        }
        return d;
    };
    MarkerSeries.$t = markType(MarkerSeries, 'MarkerSeries', Series.$);
    MarkerSeries.q4 = null;
    MarkerSeries.rc = DependencyProperty.i("MarkerBrush", Brush.$, MarkerSeries.$, new PropertyMetadata(1, function (a, b) {
        var c = (typeCast(MarkerSeries.$, a));
        c.raisePropertyChanged("MarkerBrush", b.oldValue, b.newValue);
    }));
    MarkerSeries.$$p = markDep(DependencyProperty, PropertyMetadata, MarkerSeries, 'raisePropertyChanged', ['ActualMarkerBrush:rl:q9', [Brush.$], 'ActualMarkerOutline:rm:ra', [Brush.$], 'ActualMarkerTemplate:q5:rb', [DataTemplate.$, null], 'MarkerFillMode:qe:rd', [MarkerFillMode_$type, enumGetBox(MarkerFillMode_$type, 0)], 'MarkerOutlineMode:qi:re', [MarkerOutlineMode_$type, enumGetBox(MarkerOutlineMode_$type, 0)], 'MarkerOutline:ro:rf', [Brush.$], 'MarkerStyle:rp:rg', [Style.$], 'MarkerTemplate:q7:rh', [DataTemplate.$, null], 'MarkerThickness:qq:ri', [1, DeviceUtils.g(2)], 'MarkerType:ql:rj', [MarkerType_$type, enumGetBox(MarkerType_$type, 1)], 'UseLightweightMarkers:qp:rk', [0, false]]);
    return MarkerSeries;
}(Series));
export { MarkerSeries };
/**
 * @hidden
 */
var SyncLink = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SyncLink, _super);
    function SyncLink() {
        var _this = _super.call(this) || this;
        _this.ak = null;
        _this.ah = new Dictionary$2(IEnumerable_$type, FastItemsSourceReference.$, 0);
        _this.av = null;
        _this.ad = null;
        _this.propertyChanged = null;
        _this.propertyUpdated = null;
        _this.propertyUpdated = delegateCombine(_this.propertyUpdated, function (a, b) { return _this.aq(a, b.propertyName, b.oldValue, b.newValue); });
        _this.ad = new ChartCollection();
        var a = _this.ad;
        a.collectionChanged = delegateCombine(a.collectionChanged, runOn(_this, _this.am));
        _this.av = new Rect(0, 0, 0, 1, 1);
        return _this;
    }
    SyncLink.prototype.aq = function (a, b, c, d) {
    };
    SyncLink.prototype.releaseFastItemsSource = function (a) {
        var _this = this;
        if (a != null) {
            var b_1 = null;
            if (((function () { var c = _this.ah.tryGetValue(a, b_1); b_1 = c.p1; return c.ret; })())) {
                --b_1.b;
                if (b_1.b == 0) {
                    this.ah.removeItem(a);
                }
            }
        }
        return null;
    };
    SyncLink.af = function (a) {
        return ((function () {
            var $ret = new FastItemsSource();
            $ret.e = a;
            return $ret;
        })());
    };
    SyncLink.prototype.getFastItemsSource = function (a) {
        var _this = this;
        if (SyncLink.aj == null) {
            SyncLink.aj = SyncLink.af;
        }
        var b = null;
        if (a != null) {
            var c_1 = null;
            if (!((function () { var d = _this.ah.tryGetValue(a, c_1); c_1 = d.p1; return d.ret; })())) {
                b = SyncLink.aj(a);
                c_1 = new FastItemsSourceReference(b);
                this.ah.addItem(a, c_1);
            }
            c_1.b++;
            b = c_1.a;
        }
        return b;
    };
    SyncLink.prototype.ag = function (a) {
        var _this = this;
        var b = null;
        if (a != null) {
            var c_2 = null;
            if (!((function () { var d = _this.ah.tryGetValue(a, c_2); c_2 = d.p1; return d.ret; })())) {
                return null;
            }
            b = c_2.a;
        }
        return b;
    };
    SyncLink.prototype.aw = function (a, b, c) {
        return this.ax(a, b, c, false);
    };
    SyncLink.prototype.ax = function (a, b, c, d) {
        if (!c.isEmpty) {
            c = new Rect(0, c.left, c.top, c.width, c.height);
            var e = a.gj;
            var f = a.gi;
            if (b == a) {
                if (!d) {
                    if (!b.es()) {
                        c.x = b.tz.x;
                        c.width = b.tz.width;
                    }
                    if (!b.et()) {
                        c.y = b.tz.y;
                        c.height = b.tz.height;
                    }
                }
            }
            else {
                var g = SyncManager.a(b);
                if (g == null || !g.synchronizeHorizontally) {
                    c.x = b.tz.x;
                    c.width = b.tz.width;
                }
                if (g == null || !g.synchronizeVertically) {
                    c.y = b.tz.y;
                    c.height = b.tz.height;
                }
            }
            var h = 0.5 * (c.left + c.right);
            var i = 0.5 * (c.top + c.bottom);
            var j = c.width;
            var k = c.height;
            var l = MathUtil.d(c.width, e, 1);
            var m = MathUtil.d(c.height, f, 1);
            var n = false;
            if (a.fh() && !a.ty.isEmpty) {
                var o = a.ty;
                var p = o.width / o.height;
                var q = l * o.width;
                var r = m * o.height;
                var s = q / r;
                if (s != p) {
                    if (r * p > q) {
                        q = r * p;
                        l = q / o.width;
                    }
                    else {
                        r = q / p;
                        m = r / o.height;
                    }
                }
            }
            else if (a.d4()) {
                var t = false;
                var u = false;
                if (Math.abs(l - a.tj.width) > e) {
                    t = true;
                }
                if (Math.abs(m - a.tj.height) > f) {
                    u = true;
                }
                var v = a.mg(l, m, t, u);
                l = v.p0;
                m = v.p1;
                l = MathUtil.d(l, e, 1);
                m = MathUtil.d(m, f, 1);
            }
            else if (b.fc) {
                var w = 1.7976931348623157E+308;
                var x = -1.7976931348623157E+308;
                var y = 1.7976931348623157E+308;
                var z = -1.7976931348623157E+308;
                var aa = c.left;
                var ab = c.right;
                var ac = c.top;
                var ad = c.bottom;
                var ae = c.width;
                var af = c.height;
                if (b.cd == 1) {
                    if (aa < 0) {
                        aa = 0;
                        ab = aa + ae;
                    }
                    if (ab > 1) {
                        ab = 1;
                        aa = ab - ae;
                    }
                    if (ac < 0) {
                        ac = 0;
                        ad = ac + af;
                    }
                    if (ad > 1) {
                        ad = 1;
                        ac = ad - af;
                    }
                }
                var ag = new Rect(0, aa, ac, ab - aa, ad - ac);
                var ah = [w, x];
                var ai = [y, z];
                for (var aj = 0; aj < b.series.count; aj++) {
                    var ak = b.series._inner[aj];
                    if (ak.dd) {
                        continue;
                    }
                    {
                        var al = ak;
                        if (al.isVertical) {
                            if (c.height < 1) {
                                ai = this.ac(al, b, ag, ai);
                                y = ai[0];
                                z = ai[1];
                            }
                        }
                        else {
                            if (c.width < 1) {
                                ah = this.ab(al, b, ag, ah);
                                w = ah[0];
                                x = ah[1];
                            }
                        }
                    }
                }
                var am = (w == 1.7976931348623157E+308 || x == -1.7976931348623157E+308 || isNaN_(w) || isNaN_(x));
                var an = (y == 1.7976931348623157E+308 || z == -1.7976931348623157E+308 || isNaN_(y) || isNaN_(z));
                if (!am || !an) {
                    if (am) {
                        c = new Rect(0, y, c.top, z - y, c.height);
                    }
                    else if (an) {
                        c = new Rect(0, c.left, w, c.width, x - w);
                    }
                    else {
                        c = new Rect(0, y, w, z - y, x - w);
                    }
                    l = c.width;
                    m = c.height;
                    n = true;
                }
            }
            var ao = l != j;
            var ap = m != k;
            var aq = ao && !n ? h - 0.5 * l : c.left;
            var ar = ap && !n ? i - 0.5 * m : c.top;
            var as = ao && !n ? h + 0.5 * l : c.right;
            var at = ap && !n ? i + 0.5 * m : c.bottom;
            if (b.cd == 1) {
                if (aq < 0) {
                    aq = 0;
                    as = aq + l;
                }
                if (as > 1) {
                    as = 1;
                    aq = as - l;
                }
                if (ar < 0) {
                    ar = 0;
                    at = ar + m;
                }
                if (at > 1) {
                    at = 1;
                    ar = at - m;
                }
            }
            c = new Rect(0, aq, ar, as - aq, at - ar);
        }
        return c;
    };
    SyncLink.prototype.ab = function (a, b, c, d) {
        var e = a.ag();
        var f = d[0];
        var g = d[1];
        var h = null;
        for (var i = 0; i < e.length; i++) {
            if (e[i].cp) {
                h = e[i];
            }
        }
        if (h != null) {
            var j = new Rect(0, 0, 0, 1, 1);
            var k = new ScalerParams(0, j, j, h.ch, b.ts(j, b.ty, b.tn));
            k.b = a.gg();
            var l = a.ar(c);
            var m = l == null || l.c == 1.7976931348623157E+308 || isNaN_(l.c);
            if (m) {
                return d;
            }
            var n = h.ej(l.c, k);
            var o = h.ej(l.b, k);
            if (h.ch) {
                var p = n;
                n = o;
                o = p;
            }
            g = Math.max(g, n);
            f = Math.min(f, o);
            if (a.b3 == 2) {
                if (h.cj) {
                    var q = h;
                    var r = q.l7;
                    r = h.d1(r, k);
                    var s = h.ej(r, k);
                    g = Math.max(g, s);
                    f = Math.min(f, s);
                }
            }
        }
        d[0] = f;
        d[1] = g;
        return d;
    };
    SyncLink.prototype.ac = function (a, b, c, d) {
        var e = a.ag();
        var f = d[0];
        var g = d[1];
        var h = null;
        for (var i = 0; i < e.length; i++) {
            if (!e[i].cp) {
                h = e[i];
            }
        }
        if (h != null) {
            var j = new Rect(0, 0, 0, 1, 1);
            var k = new ScalerParams(0, j, j, h.ch, b.ts(j, b.ty, b.tn));
            k.b = a.gg();
            var l = a.ar(c);
            var m = l == null || l.c == 1.7976931348623157E+308 || isNaN_(l.c);
            if (m) {
                return d;
            }
            var n = h.ej(l.c, k);
            var o = h.ej(l.b, k);
            if (h.ch) {
                var p = n;
                n = o;
                o = p;
            }
            g = Math.max(g, o);
            f = Math.min(f, n);
            if (a.b3 == 2) {
                if (h.cj) {
                    var q = h;
                    var r = q.l7;
                    r = h.d1(r, k);
                    var s = h.ej(r, k);
                    g = Math.max(g, s);
                    f = Math.min(f, s);
                }
            }
        }
        d[0] = f;
        d[1] = g;
        return d;
    };
    Object.defineProperty(SyncLink.prototype, "ai", {
        get: function () {
            return this.ad;
        },
        enumerable: false,
        configurable: true
    });
    SyncLink.prototype.al = function (a) {
        this.ad.add(a);
    };
    SyncLink.prototype.as = function (a) {
        this.ad.remove(a);
    };
    SyncLink.prototype.ao = function () {
        var e_85, _a;
        try {
            for (var _b = __values(fromEnum(this.ad)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                if (a.tz.isEmpty) {
                    a.tz = this.aw(null, a, this.av);
                }
            }
        }
        catch (e_85_1) {
            e_85 = { error: e_85_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_85)
                    throw e_85.error;
            }
        }
    };
    SyncLink.prototype.am = function (a, b) {
        var e_86, _a;
        if (b.newItems != null) {
            try {
                for (var _b = __values(fromEn(b.newItems)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var c = _c.value;
                    if (c.tz.isEmpty) {
                        c.tz = this.aw(null, c, this.av);
                    }
                }
            }
            catch (e_86_1) {
                e_86 = { error: e_86_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_86)
                        throw e_86.error;
                }
            }
        }
    };
    SyncLink.prototype.an = function (a, b) {
        var e_87, _a;
        try {
            for (var _b = __values(fromEnum(this.ai)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                if (c == a) {
                    c.ta = { $type: Point_$type, x: b.x, y: b.y };
                }
                else {
                    var d = { $type: Point_$type, x: b.x, y: b.y };
                    var e = SyncManager.a(c);
                    if (e == null || !e.synchronizeHorizontally) {
                        d.x = NaN;
                    }
                    if (e == null || !e.synchronizeVertically) {
                        d.y = NaN;
                    }
                    c.ta = d;
                }
            }
        }
        catch (e_87_1) {
            e_87 = { error: e_87_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_87)
                    throw e_87.error;
            }
        }
    };
    SyncLink.prototype.ap = function (a, b) {
        var e_88, _a;
        try {
            for (var _b = __values(fromEnum(this.ai)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var c = _c.value;
                c.tt = this.aw(a, c, b);
            }
        }
        catch (e_88_1) {
            e_88 = { error: e_88_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_88)
                    throw e_88.error;
            }
        }
    };
    SyncLink.prototype.at = function (a, b) {
        this.au(a, b, false);
    };
    SyncLink.prototype.au = function (a, b, c) {
        var e_89, _a;
        var d = b.isEmpty || isNaN_(b.x) || isNaN_(b.y) || isNaN_(b.width) || isNaN_(b.height);
        if (!d && !a.d2) {
            try {
                for (var _b = __values(fromEnum(this.ai)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var e = _c.value;
                    e.d2 = true;
                    e.tz = this.ax(a, e, b, c);
                    e.d2 = false;
                }
            }
            catch (e_89_1) {
                e_89 = { error: e_89_1 };
            }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return))
                        _a.call(_b);
                }
                finally {
                    if (e_89)
                        throw e_89.error;
                }
            }
        }
    };
    SyncLink.prototype.ar = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        if (this.propertyUpdated != null) {
            this.propertyUpdated(this, new PropertyUpdatedEventArgs(a, b, c));
        }
    };
    SyncLink.$t = markType(SyncLink, 'SyncLink', FrameworkElement.$, [INotifyPropertyChanged_$type, IFastItemsSourceProvider_$type]);
    SyncLink.aj = null;
    return SyncLink;
}(FrameworkElement));
export { SyncLink };
/**
 * @hidden
 */
var SyncLinkManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SyncLinkManager, _super);
    function SyncLinkManager() {
        var _this = _super.call(this) || this;
        _this.d = null;
        _this.d = new Dictionary$2(String_$type, SyncLink.$, 0);
        return _this;
    }
    SyncLinkManager.instance = function () {
        if (SyncLinkManager.b == null) {
            SyncLinkManager.b = new SyncLinkManager();
        }
        return SyncLinkManager.b;
    };
    Object.defineProperty(SyncLinkManager.prototype, "e", {
        get: function () {
            return this.d.count;
        },
        enumerable: false,
        configurable: true
    });
    SyncLinkManager.prototype.getLink = function (a) {
        var _this = this;
        var b;
        if (((function () { var c = _this.d.tryGetValue(a, b); b = c.p1; return c.ret; })())) {
            return b;
        }
        b = new SyncLink();
        b.ak = a;
        this.d.addItem(a, b);
        return b;
    };
    SyncLinkManager.prototype.releaseLink = function (a) {
        if (a.ai.count == 0 && a.ak != null && this.d.containsKey(a.ak)) {
            this.d.removeItem(a.ak);
        }
    };
    SyncLinkManager.$t = markType(SyncLinkManager, 'SyncLinkManager');
    SyncLinkManager.b = null;
    return SyncLinkManager;
}(Base));
export { SyncLinkManager };
/**
 * @hidden
 */
var SyncManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SyncManager, _super);
    function SyncManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncManager.e = function (a) {
        var b = SyncManager.a(a);
        if (b == null) {
            return;
        }
        if (!a.en) {
            return;
        }
        if (a.syncChannel != b.syncChannel) {
            return;
        }
        SyncManager.b(a, a.syncChannel, null);
    };
    SyncManager.c = function (a) {
        var b = SyncManager.a(a);
        if (b == null) {
            return;
        }
        if (a.en && a.syncChannel == b.syncChannel) {
            return;
        }
        var c = null;
        if (a.en) {
            c = a.syncChannel;
        }
        SyncManager.b(a, c, b.syncChannel);
    };
    SyncManager.b = function (a, b, c) {
        if (a != null) {
            if (stringIsNullOrEmpty(c)) {
                var d = a.actualSyncLink;
                a.actualSyncLink = null;
                a.actualSyncLink = new SyncLink();
                if (d != null) {
                    SyncLinkManager.instance().releaseLink(d);
                }
                a.syncChannel = null;
            }
            else {
                if (!stringIsNullOrEmpty(b)) {
                    var e = a.actualSyncLink;
                    a.actualSyncLink = null;
                    if (e != null) {
                        SyncLinkManager.instance().releaseLink(e);
                    }
                }
                a.actualSyncLink = SyncLinkManager.instance().getLink(c);
                a.syncChannel = c;
            }
        }
    };
    SyncManager.d = function (a, b) {
        a.syncSettings = b;
    };
    SyncManager.a = function (a) {
        return a.syncSettings;
    };
    SyncManager.$t = markType(SyncManager, 'SyncManager');
    return SyncManager;
}(Base));
export { SyncManager };
/**
 * @hidden
 */
var ChartCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ChartCollection, _super);
    function ChartCollection() {
        var _this = _super.call(this, SeriesViewer.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    ChartCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    ChartCollection.$t = markType(ChartCollection, 'ChartCollection', ObservableCollection$1.$.specialize(SeriesViewer.$));
    return ChartCollection;
}(ObservableCollection$1));
export { ChartCollection };
/**
 * @hidden
 */
var SeriesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesCollection, _super);
    function SeriesCollection() {
        var _this = _super.call(this, Series.$, 0) || this;
        _this.collectionResetting = null;
        return _this;
    }
    SeriesCollection.prototype.p = function () {
        if (this.collectionResetting != null) {
            this.collectionResetting(this, null);
        }
        _super.prototype.p.call(this);
    };
    SeriesCollection.$t = markType(SeriesCollection, 'SeriesCollection', ObservableCollection$1.$.specialize(Series.$));
    return SeriesCollection;
}(ObservableCollection$1));
export { SeriesCollection };
/**
 * @hidden
 */
var PlotAreaMouseEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(PlotAreaMouseEventArgs, _super);
    function PlotAreaMouseEventArgs(a, b, c) {
        var _this = _super.call(this) || this;
        _this._chartPosition = null;
        _this._plotAreaPosition = null;
        _this._isDuringManipulation = false;
        _this._viewer = null;
        _this.viewer = a;
        _this.chartPosition = b;
        _this.plotAreaPosition = c;
        return _this;
    }
    Object.defineProperty(PlotAreaMouseEventArgs.prototype, "chartPosition", {
        get: function () {
            return this._chartPosition;
        },
        set: function (a) {
            this._chartPosition = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseEventArgs.prototype, "plotAreaPosition", {
        get: function () {
            return this._plotAreaPosition;
        },
        set: function (a) {
            this._plotAreaPosition = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseEventArgs.prototype, "isDuringManipulation", {
        get: function () {
            return this._isDuringManipulation;
        },
        set: function (a) {
            this._isDuringManipulation = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseEventArgs.prototype, "viewer", {
        get: function () {
            return this._viewer;
        },
        set: function (a) {
            this._viewer = a;
        },
        enumerable: false,
        configurable: true
    });
    PlotAreaMouseEventArgs.$t = markType(PlotAreaMouseEventArgs, 'PlotAreaMouseEventArgs', EventArgs.$);
    return PlotAreaMouseEventArgs;
}(EventArgs));
export { PlotAreaMouseEventArgs };
/**
 * @hidden
 */
var PlotAreaMouseButtonEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(PlotAreaMouseButtonEventArgs, _super);
    function PlotAreaMouseButtonEventArgs(a, b, c) {
        var _this = _super.call(this) || this;
        _this._chartPosition = null;
        _this._plotAreaPosition = null;
        _this._manipulationOccurred = false;
        _this._viewer = null;
        _this.viewer = a;
        _this.chartPosition = b;
        _this.plotAreaPosition = c;
        return _this;
    }
    Object.defineProperty(PlotAreaMouseButtonEventArgs.prototype, "chartPosition", {
        get: function () {
            return this._chartPosition;
        },
        set: function (a) {
            this._chartPosition = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseButtonEventArgs.prototype, "plotAreaPosition", {
        get: function () {
            return this._plotAreaPosition;
        },
        set: function (a) {
            this._plotAreaPosition = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseButtonEventArgs.prototype, "manipulationOccurred", {
        get: function () {
            return this._manipulationOccurred;
        },
        set: function (a) {
            this._manipulationOccurred = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlotAreaMouseButtonEventArgs.prototype, "viewer", {
        get: function () {
            return this._viewer;
        },
        set: function (a) {
            this._viewer = a;
        },
        enumerable: false,
        configurable: true
    });
    PlotAreaMouseButtonEventArgs.$t = markType(PlotAreaMouseButtonEventArgs, 'PlotAreaMouseButtonEventArgs', EventArgs.$);
    return PlotAreaMouseButtonEventArgs;
}(EventArgs));
export { PlotAreaMouseButtonEventArgs };
/**
 * @hidden
 */
var ChartCursorEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ChartCursorEventArgs, _super);
    function ChartCursorEventArgs(a, b, c) {
        var _this = _super.call(this) || this;
        _this._item = null;
        _this._series = null;
        _this._seriesViewer = null;
        _this.seriesViewer = a;
        _this.series = b;
        _this.item = c;
        return _this;
    }
    ChartCursorEventArgs.prototype.toString = function () {
        return this.seriesViewer.name + ", " + this.series.name + ", " + (this.item != null ? this.item.toString() : "");
    };
    Object.defineProperty(ChartCursorEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartCursorEventArgs.prototype, "series", {
        get: function () {
            return this._series;
        },
        set: function (a) {
            this._series = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartCursorEventArgs.prototype, "seriesViewer", {
        get: function () {
            return this._seriesViewer;
        },
        set: function (a) {
            this._seriesViewer = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartCursorEventArgs.prototype, "chart", {
        get: function () {
            return typeCast(XamDataChart.$, this.seriesViewer);
        },
        enumerable: false,
        configurable: true
    });
    ChartCursorEventArgs.$t = markType(ChartCursorEventArgs, 'ChartCursorEventArgs', EventArgs.$);
    return ChartCursorEventArgs;
}(EventArgs));
export { ChartCursorEventArgs };
/**
 * @hidden
 */
var DataChartMouseButtonEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(DataChartMouseButtonEventArgs, _super);
    function DataChartMouseButtonEventArgs(a, b, c, d) {
        var _this = _super.call(this) || this;
        _this.g = null;
        _this._item = null;
        _this._series = null;
        _this._chart = null;
        _this.chart = a;
        _this.series = b;
        _this.item = c;
        _this.g = d;
        return _this;
    }
    DataChartMouseButtonEventArgs.prototype.toString = function () {
        return this.chart.name + ", " + this.series.name + ", " + (this.item != null ? this.item.toString() : "") + ", " + this.getPosition(null).toString();
    };
    Object.defineProperty(DataChartMouseButtonEventArgs.prototype, "handled", {
        get: function () {
            return this.g.handled;
        },
        set: function (a) {
            this.g.handled = a;
        },
        enumerable: false,
        configurable: true
    });
    DataChartMouseButtonEventArgs.prototype.getPosition = function (a) {
        return this.g.getPosition(a);
    };
    Object.defineProperty(DataChartMouseButtonEventArgs.prototype, "originalSource", {
        get: function () {
            return this.g.originalSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataChartMouseButtonEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataChartMouseButtonEventArgs.prototype, "series", {
        get: function () {
            return this._series;
        },
        set: function (a) {
            this._series = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataChartMouseButtonEventArgs.prototype, "chart", {
        get: function () {
            return this._chart;
        },
        set: function (a) {
            this._chart = a;
        },
        enumerable: false,
        configurable: true
    });
    DataChartMouseButtonEventArgs.$t = markType(DataChartMouseButtonEventArgs, 'DataChartMouseButtonEventArgs', EventArgs.$);
    return DataChartMouseButtonEventArgs;
}(EventArgs));
export { DataChartMouseButtonEventArgs };
/**
 * @hidden
 */
var ChartMouseEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ChartMouseEventArgs, _super);
    function ChartMouseEventArgs(a, b, c, d) {
        var _this = _super.call(this) || this;
        _this.f = null;
        _this._item = null;
        _this._series = null;
        _this._chart = null;
        _this.chart = a;
        _this.series = b;
        _this.item = c;
        _this.f = d;
        return _this;
    }
    ChartMouseEventArgs.prototype.toString = function () {
        return this.chart.name + ", " + this.series.name + ", " + (this.item != null ? this.item.toString() : "") + ", " + this.getPosition(null).toString();
    };
    ChartMouseEventArgs.prototype.getPosition = function (a) {
        return this.f.getPosition(a);
    };
    Object.defineProperty(ChartMouseEventArgs.prototype, "originalSource", {
        get: function () {
            return this.f.originalSource;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartMouseEventArgs.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartMouseEventArgs.prototype, "series", {
        get: function () {
            return this._series;
        },
        set: function (a) {
            this._series = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartMouseEventArgs.prototype, "chart", {
        get: function () {
            return this._chart;
        },
        set: function (a) {
            this._chart = a;
        },
        enumerable: false,
        configurable: true
    });
    ChartMouseEventArgs.$t = markType(ChartMouseEventArgs, 'ChartMouseEventArgs', EventArgs.$);
    return ChartMouseEventArgs;
}(EventArgs));
export { ChartMouseEventArgs };
/**
 * @hidden
 */
var AxisComponentsForView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisComponentsForView, _super);
    function AxisComponentsForView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.a = null;
        return _this;
    }
    AxisComponentsForView.$t = markType(AxisComponentsForView, 'AxisComponentsForView');
    return AxisComponentsForView;
}(Base));
export { AxisComponentsForView };
/**
 * @hidden
 */
var AxisLabelPanelBaseView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisLabelPanelBaseView, _super);
    function AxisLabelPanelBaseView(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.aw = null;
        _this.e = null;
        _this.av = Rect.empty;
        _this.c = null;
        _this.h = 0;
        _this.i = NaN;
        _this.a = a;
        return _this;
    }
    AxisLabelPanelBaseView.prototype.aa = function (a, b, c, d, e, f) {
        var g = typeCast(FrameworkElement.$, a);
        if (g != null) {
            g._visibility = 0;
            if (b.width == 0 && b.height == 0) {
                g._visibility = 1;
            }
            var h = b.height - (d + f);
            var i = b.width - (c + e);
            g.n = b.left + c;
            g.o = b.top + d;
            if (i < 0) {
                i = 0;
            }
            if (h < 0) {
                h = 0;
            }
            g.l = h;
            g.m = i;
            if (g.j != null) {
                var j = g.j;
                var k = j.j._inner[0];
                k.k = k.k + g.n;
                k.l = k.l + g.o;
            }
        }
    };
    AxisLabelPanelBaseView.prototype.z = function (a, b, c, d, e, f, g, h) {
        var i = Math.max(e, Math.max(f, Math.max(g, h)));
        var j = new Thickness(0, i);
        if (this.a.av) {
            j = new Thickness(0, Math.sqrt((i * i) / 2));
        }
        var k = c.d;
        if (isNaN_(k.left) || isNaN_(k.top) || isNaN_(k.right) || isNaN_(k.bottom)) {
            k = j;
        }
        if (k.left > j.left || k.top > j.top || k.right > j.right || k.bottom > j.bottom) {
            k = j;
        }
        var l = new Rect(0, d.left - k.left, d.top - k.top, d.width + k.left + k.right, d.height + k.top + k.bottom);
        var m = a.j;
        a.j = null;
        this.aa(a, l, e, f, g, h);
        a.j = m;
        a.width = a.m;
        a.height = a.l;
    };
    AxisLabelPanelBaseView.prototype.ae = function (a) {
        var b = a;
        b.j = null;
    };
    AxisLabelPanelBaseView.prototype.ah = function (a) {
    };
    AxisLabelPanelBaseView.prototype.ai = function (a, b) {
    };
    AxisLabelPanelBaseView.prototype.aj = function (a, b) {
        var c = typeCast(FrameworkElement.$, a);
        var d = 0;
        var e = 0;
        var f = new TransformGroup();
        var g = ((function () {
            var $ret = new RotateTransform();
            $ret.j = b;
            $ret.k = d;
            $ret.l = e;
            return $ret;
        })());
        f.j.add(g);
        c.j = f;
    };
    AxisLabelPanelBaseView.prototype.ar = function (a, b, c, d, e, f, g, h, i) {
        var j = Math.max(e, Math.max(f, Math.max(g, h)));
        var k = new Thickness(0, j);
        if (this.a.av) {
            k = new Thickness(0, Math.sqrt((j * j) / 2));
        }
        var l = c.d;
        if (isNaN_(l.left) || isNaN_(l.top) || isNaN_(l.right) || isNaN_(l.bottom)) {
            l = k;
        }
        if (l.left > k.left || l.top > k.top || l.right > k.right || l.bottom > k.bottom) {
            l = k;
        }
        var m = b.j;
        var n = new TransformGroup();
        var o = a.n + l.left;
        var p = a.o + l.top;
        n.j.add(m);
        a.j = n;
    };
    AxisLabelPanelBaseView.prototype.ad = function (a) {
        a.j = null;
    };
    AxisLabelPanelBaseView.prototype.x = function (a, b, c, d) {
        var e = a.al.length;
        var f = a.al;
        var g = a.al;
        while ((this.m(a) + c + d) > b && e > 0) {
            e--;
            f = f.substr(0, e) + "\u2026";
            a.al = f;
        }
        a.al = g;
        return f;
    };
    AxisLabelPanelBaseView.prototype.af = function () {
        var e_90, _a;
        if (this.e == null) {
            return;
        }
        var a = this.g();
        try {
            for (var _b = __values(fromEnum(a)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                var c = typeCast(FrameworkElement.$, b);
                if (c != null) {
                    this.a.cg(c);
                }
                this.a.b7(b);
            }
        }
        catch (e_90_1) {
            e_90 = { error: e_90_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_90)
                    throw e_90.error;
            }
        }
    };
    AxisLabelPanelBaseView.prototype.g = function () {
        var a = this.a.a1();
        var b = this.a.a0();
        if (!this.a.ad.c7) {
            return a;
        }
        else {
            return b;
        }
    };
    AxisLabelPanelBaseView.prototype.l = function (a) {
        if (this.a.ad != null && this.a.ad.bz) {
            return this.ax(a).height;
        }
        else {
            return this.h;
        }
    };
    AxisLabelPanelBaseView.prototype.n = function (a) {
        return this.l(a) + this.r() + this.o();
    };
    AxisLabelPanelBaseView.prototype.an = function () {
        this.aw = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            $ret.ab = false;
            return $ret;
        })());
    };
    AxisLabelPanelBaseView.prototype.m = function (a) {
        if (this.a.ad != null && this.a.ad.bz) {
            return this.ax(a).width;
        }
        else {
            var b = a;
            if (b != null && b.al != null) {
                return this.e.f(b);
            }
            return 0;
        }
    };
    AxisLabelPanelBaseView.prototype.w = function (a) {
        var b = a;
        if (b != null && b.al != null) {
            return this.m(a) + this.p() + this.q();
        }
        return 0;
    };
    AxisLabelPanelBaseView.prototype.ax = function (a) {
        var b = a;
        if (b != null && b.al != null) {
            b.ag = true;
            var c = this.e.ah(b, this.h, true);
            return new Size(1, c.c, c.b);
        }
        return new Size(1, 0, 0);
    };
    AxisLabelPanelBaseView.prototype.ac = function () {
        this.a.bh = this.a.ad.ep();
    };
    AxisLabelPanelBaseView.prototype.ak = function () {
        this.ag();
        this.a.c8(new Size(1, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY));
    };
    AxisLabelPanelBaseView.prototype.f = function () {
        return this.e;
    };
    AxisLabelPanelBaseView.prototype.al = function (a) {
        this.e = a;
    };
    AxisLabelPanelBaseView.prototype.y = function () {
        if (this.a.c1.isEmpty) {
            return;
        }
        var a = this.a.bd;
        this.a.c6(new Size(1, this.a.c1.width, this.a.c1.height));
        if (this.a.bd != a) {
            this.a.ad.bg.md();
            this.am();
        }
    };
    AxisLabelPanelBaseView.prototype.am = function () {
    };
    AxisLabelPanelBaseView.prototype.ap = function (a) {
        this.e.x(a);
    };
    AxisLabelPanelBaseView.prototype.ao = function () {
        var e_91, _a, e_92, _b;
        if (this.e == null) {
            return;
        }
        if (this.e.d) {
            if (this.a.ad.bi != null && this.a.ad.bi.gf != 1) {
                this.e.aa();
                this.e.ab(this.a.ad.bi.gf, this.a.ad.bi.gf);
            }
            this.ag();
            this.av = this.a.c1;
            var a = this.a.ad.bg.getFontBrush();
            if (this.a.ag != null && this.a.ag.textColor != null) {
                a = this.a.ag.textColor;
            }
            if (this.a.j != null) {
                this.e.aa();
                this.e.k(this.a.j);
            }
            var b = false;
            try {
                for (var _c = __values(fromEnum(this.g())), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var c = _d.value;
                    var d = typeCast(TextBlock.$, c);
                    if (d != null) {
                        if (d.s != 0) {
                            b = true;
                            continue;
                        }
                        d.ao = a;
                        if (d.j != null) {
                            this.e.aa();
                            this.e.k(d.j);
                        }
                        this.ap(d);
                        if (d.j != null) {
                            this.e.z();
                        }
                    }
                }
            }
            catch (e_91_1) {
                e_91 = { error: e_91_1 };
            }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return))
                        _a.call(_c);
                }
                finally {
                    if (e_91)
                        throw e_91.error;
                }
            }
            if (b) {
                try {
                    for (var _e = __values(fromEnum(this.a.ab)), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var e = _f.value;
                        var f = typeCast(Rectangle.$, e);
                        if (f != null) {
                            if (f.s == 0) {
                                continue;
                            }
                            if (f.j != null) {
                                this.e.aa();
                                this.e.k(f.j);
                            }
                            this.e.w(f);
                            if (f.j != null) {
                                this.e.z();
                            }
                        }
                        var g = typeCast(TextBlock.$, e);
                        if (g != null) {
                            if (g.s == 0) {
                                continue;
                            }
                            if (g.j != null) {
                                this.e.aa();
                                this.e.k(g.j);
                            }
                            if (g.ao == null) {
                                g.ao = a;
                            }
                            this.e.x(g);
                            if (g.j != null) {
                                this.e.z();
                            }
                        }
                    }
                }
                catch (e_92_1) {
                    e_92 = { error: e_92_1 };
                }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return))
                            _b.call(_e);
                    }
                    finally {
                        if (e_92)
                            throw e_92.error;
                    }
                }
            }
            if (this.a.j != null) {
                this.e.z();
            }
            this.aq();
            a = this.at();
            this.e.ad(this.d());
            var h = this.a.ad.is;
            if (h != null) {
                h.ao = a;
                if (h.j != null) {
                    this.e.aa();
                    this.e.k(h.j);
                }
                this.e.x(h);
                if (h.j != null) {
                    this.e.z();
                }
            }
            if (this.a.ad.bi != null && this.a.ad.bi.gf != 1) {
                this.e.z();
            }
        }
    };
    AxisLabelPanelBaseView.prototype.d = function () {
        var a = this.a.ad.bi.getFontInfo();
        if (this.a.ad.bf != null && this.a.ad.bf.textStyle != null) {
            a = this.a.ad.bf.h(this.a.ad.bi.cu.j.ae);
        }
        else {
            var b = this.a.ad.bi.cx();
            if (b != null) {
                a = b;
            }
        }
        return a;
    };
    AxisLabelPanelBaseView.prototype.at = function () {
        var a = this.a.ad.bg.getFontBrush();
        if (this.a.ad.bf != null && this.a.ad.bf.textColor != null) {
            a = this.a.ad.bf.textColor;
        }
        else {
            var b = this.a.ad.bi.sr();
            if (b != null) {
                a = b;
            }
        }
        return a;
    };
    AxisLabelPanelBaseView.prototype.ag = function () {
        if (this.e == null) {
            return;
        }
        var a = this.a.ad.bi.getFontInfo();
        if (this.a.ag != null && this.a.ag.j) {
            a = this.a.ag.h(this.a.ad.bi.cu.j.ae);
        }
        if (this.c != a) {
            this.c = a;
            this.as();
        }
        this.e.ad(a);
    };
    AxisLabelPanelBaseView.prototype.as = function () {
        if (this.a.ad != null && this.a.ad.bi != null) {
            if (this.a.ag == null || this.a.ag.textStyle == null) {
                this.h = this.a.ad.bi.cu.a9;
                return;
            }
            if (this.h == 0) {
                this.h = this.a.ad.bi.cu.a9;
            }
            var a = this.h;
            var b = this.a.ad.bi.getFontInfo();
            if (this.a.ag != null && this.a.ag.textStyle != null) {
                b = this.a.ag.h(this.a.ad.bi.cu.j.ae);
            }
            var c = FontUtil.getCurrentFontHeight(this.a.ad.bi.cu.j.ae, b);
            this.h = c;
            if (a != this.h) {
                this.a.ad.bi.md();
            }
        }
    };
    AxisLabelPanelBaseView.prototype.j = function () {
        if (this.a.ad.g6 == null) {
            return 0;
        }
        if (this.a.ad.bf != null && this.a.ad.bf.visibility == 1) {
            return 0;
        }
        if (!isNaN_(this.i)) {
            return this.i;
        }
        var a = this.d();
        if (this.a.ad.bi == null) {
            return this.h;
        }
        this.i = FontUtil.getCurrentFontHeight(this.a.ad.bi.cu.j.ae, a);
        return this.i;
    };
    AxisLabelPanelBaseView.prototype.k = function () {
        if (this.a.ad.bf != null && this.a.ad.bf.visibility == 1) {
            return 0;
        }
        if (this.e == null) {
            return 0;
        }
        var a = this.a.ad.is;
        if (a != null && a.al != null) {
            this.e.ad(this.d());
            var b = this.e.f(a);
            this.ag();
            return b;
        }
        return 0;
    };
    AxisLabelPanelBaseView.prototype.aq = function () {
        if (this.a.ab.count == 0) {
            return;
        }
        if (this.a.ad.j0 == null) {
            this.aw._stroke = this.a.ad.bg.so();
        }
        else {
            this.aw._stroke = this.a.ad.j0;
        }
        this.aw.ad = this.a.ad.fi;
        this.e.t(this.aw);
    };
    AxisLabelPanelBaseView.prototype.ab = function (a) {
    };
    AxisLabelPanelBaseView.prototype.ay = function () {
        return this.a.ad.bi.t1();
    };
    AxisLabelPanelBaseView.prototype.v = function () {
        if (this.a.ad.bf != null && !isNaN_(this.a.ad.bf.topMargin)) {
            return Math.max(0, this.a.ad.bf.topMargin);
        }
        else {
            return this.ay().top;
        }
    };
    AxisLabelPanelBaseView.prototype.s = function () {
        if (this.a.ad.bf != null && !isNaN_(this.a.ad.bf.bottomMargin)) {
            return Math.max(0, this.a.ad.bf.bottomMargin);
        }
        else {
            return this.ay().bottom;
        }
    };
    AxisLabelPanelBaseView.prototype.t = function () {
        if (this.a.ad.bf != null && !isNaN_(this.a.ad.bf.leftMargin)) {
            return Math.max(0, this.a.ad.bf.leftMargin);
        }
        else {
            return this.ay().left;
        }
    };
    AxisLabelPanelBaseView.prototype.u = function () {
        if (this.a.ad.bf != null && !isNaN_(this.a.ad.bf.rightMargin)) {
            return Math.max(0, this.a.ad.bf.rightMargin);
        }
        else {
            return this.ay().right;
        }
    };
    AxisLabelPanelBaseView.prototype.au = function () {
        return this.aw.an.d;
    };
    AxisLabelPanelBaseView.prototype.b = function () {
        var _this = this;
        var a = ((function () {
            var $ret = new PathRenderingInfo();
            $ret.e = _this.a.ad.j0;
            $ret.c = _this.a.ad.fi;
            return $ret;
        })());
        if (this.a.ad != null && typeCast(XamDataChart.$, this.a.ad.bg) !== null) {
            var b = this.a.ad.bg;
            if (b.uq && b.cl != 2 && b.cl != 1) {
                a.a = true;
            }
        }
        return a;
    };
    AxisLabelPanelBaseView.prototype.r = function () {
        if (this.a.ag == null) {
            return 0;
        }
        return Math.max(0, this.a.ag.topMargin);
    };
    AxisLabelPanelBaseView.prototype.p = function () {
        if (this.a.ag == null) {
            return 0;
        }
        return Math.max(0, this.a.ag.leftMargin);
    };
    AxisLabelPanelBaseView.prototype.q = function () {
        if (this.a.ag == null) {
            return 0;
        }
        return Math.max(0, this.a.ag.rightMargin);
    };
    AxisLabelPanelBaseView.prototype.o = function () {
        if (this.a.ag == null) {
            return 0;
        }
        return Math.max(0, this.a.ag.bottomMargin);
    };
    AxisLabelPanelBaseView.$t = markType(AxisLabelPanelBaseView, 'AxisLabelPanelBaseView');
    return AxisLabelPanelBaseView;
}(Base));
export { AxisLabelPanelBaseView };
/**
 * @hidden
 */
var AxisView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(AxisView, _super);
    function AxisView(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.ba = null;
        _this.bb = null;
        _this.bd = null;
        _this.bc = null;
        _this.b = new AxisComponentsFromView();
        _this.h = null;
        _this.k = null;
        _this.j = null;
        _this._isDirty = false;
        _this.be = null;
        _this.a8 = Rect.empty;
        _this.a = a;
        _this.be = new Rectangle();
        return _this;
    }
    AxisView.prototype.aj = function () {
        this.ba = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            return $ret;
        })());
        this.bd = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            $ret.ab = false;
            $ret.stroke = null;
            return $ret;
        })());
        this.bb = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            $ret.ab = false;
            return $ret;
        })());
        this.bc = ((function () {
            var $ret = new Path();
            $ret.an = new GeometryGroup();
            $ret.ab = false;
            return $ret;
        })());
        this.a.j0 = AxisDefaults.j;
        this.a.fh = AxisDefaults.d;
        this.a.fi = AxisDefaults.e;
        this.a.er = AxisDefaults.b;
        this.a.eu = AxisDefaults.c;
        this.a.fg = AxisDefaults.a;
    };
    AxisView.prototype.al = function (a) {
    };
    AxisView.prototype.a0 = function () {
        var a = new TextBlock();
        return a;
    };
    AxisView.prototype.at = function (a) {
        a._visibility = 0;
        a.s = 0;
        if (a.x == null) {
            this.a.aw.ab.add(a);
        }
    };
    AxisView.prototype.av = function (a) {
        a._visibility = 1;
    };
    AxisView.prototype.au = function (a) {
        if (this.a.aw.ab.contains(a)) {
            this.a.aw.ab.remove(a);
        }
    };
    AxisView.prototype.bf = function () {
        var a = new Rectangle();
        return a;
    };
    AxisView.prototype.s = function (a) {
        if (a.x == null) {
            this.d.ab.add(a);
        }
        a._visibility = 0;
    };
    AxisView.prototype.u = function (a) {
        a._visibility = 1;
    };
    AxisView.prototype.t = function (a) {
        if (this.a.aw.ab.contains(a)) {
            this.a.aw.ab.remove(a);
        }
    };
    AxisView.prototype.am = function () {
    };
    AxisView.prototype.o = function () {
        return true;
    };
    Object.defineProperty(AxisView.prototype, "index", {
        get: function () {
            if (this.a.bi != null && this.a.bi.ek) {
                return this.a.bi.series.count + 1;
            }
            var a = typeCast(XamDataChart.$, this.a.bg);
            var b = 0;
            if (a == null) {
                return 0;
            }
            if (a != null && a.ua == 1) {
                var c = 0;
                for (var d = 0; d < this.a.bi.series.count; d++) {
                    if (this.a.bi.series._inner[d].isStacked) {
                        c += this.a.bi.series._inner[d].hq();
                    }
                    else {
                        c++;
                    }
                }
                b = c;
            }
            return b + a.axes.indexOf(this.a);
        },
        enumerable: false,
        configurable: true
    });
    AxisView.prototype.ag = function () {
        this.d.cf();
        this.d.b3();
    };
    AxisView.prototype.ae = function () {
        this.d.ca();
    };
    AxisView.prototype.aa = function () {
        if (this.d != null) {
            this.d.ab.clear();
        }
        this.ac(this.ba.an.d);
        this.ac(this.bd.an.d);
        this.ac(this.bb.an.d);
        this.ac(this.bc.an.d);
        this.ah();
    };
    AxisView.prototype.ay = function (a) {
        this.ba._visibility = a;
        this.bb._visibility = a;
        this.bd._visibility = a;
        this.bc._visibility = a;
    };
    AxisView.prototype.aq = function () {
    };
    AxisView.prototype.z = function (a) {
        this.a.cq = true;
        if (this.a.bi != null) {
            this.a.bi.md();
        }
        this.a.h7();
    };
    AxisView.prototype.c = function () {
        this.b.a = this.ba;
        this.b.b = this.bb;
        this.b.c = this.bc;
        this.b.d = this.bd;
        return this.b;
    };
    AxisView.prototype.ac = function (a) {
        if (a != null) {
            a.clear();
        }
    };
    AxisView.prototype.a1 = function () {
        return this.ba.an.d;
    };
    AxisView.prototype.e = function () {
        var _this = this;
        var a = ((function () {
            var $ret = new PathRenderingInfo();
            $ret.e = _this.a.jz;
            $ret.c = _this.a.fg;
            $ret.f = _this.a.j3;
            return $ret;
        })());
        if (typeCast(XamDataChart.$, this.a.bg) !== null) {
            var b = this.a.bg;
            if (b.uq && b.cl != 2 && b.cl != 1) {
                a.a = true;
            }
        }
        return a;
    };
    AxisView.prototype.a4 = function () {
        return this.bd.an.d;
    };
    AxisView.prototype.a2 = function () {
        return this.bb.an.d;
    };
    AxisView.prototype.f = function () {
        var _this = this;
        var a = ((function () {
            var $ret = new PathRenderingInfo();
            $ret.e = _this.a.jw;
            $ret.c = _this.a.er;
            $ret.f = _this.a.j1;
            return $ret;
        })());
        if (typeCast(XamDataChart.$, this.a.bg) !== null) {
            var b = this.a.bg;
            if (b.uq && b.cl != 2 && b.cl != 1) {
                a.a = true;
            }
        }
        return a;
    };
    AxisView.prototype.a3 = function () {
        return this.bc.an.d;
    };
    AxisView.prototype.g = function () {
        var _this = this;
        var a = ((function () {
            var $ret = new PathRenderingInfo();
            $ret.e = _this.a.jx;
            $ret.c = _this.a.eu;
            $ret.f = _this.a.j2;
            return $ret;
        })());
        if (typeCast(XamDataChart.$, this.a.bg) !== null) {
            var b = this.a.bg;
            if (b.uq && b.cl != 2 && b.cl != 1) {
                a.a = true;
            }
        }
        return a;
    };
    Object.defineProperty(AxisView.prototype, "d", {
        get: function () {
            return this.a.aq().a;
        },
        enumerable: false,
        configurable: true
    });
    AxisView.prototype.aw = function (a, b, c) {
        this.d.ad = a;
        this.d.c5 = b;
        this.d.c4 = c;
        this.ah();
    };
    AxisView.prototype.ab = function () {
        this.d.ab.clear();
        this.ah();
    };
    AxisView.prototype.as = function (a) {
        this.d.bw = a;
        this.ah();
    };
    AxisView.prototype.ax = function (a, b) {
        this.d.a9 = a;
        this.d.ba = b;
        this.d.ar = false;
    };
    AxisView.prototype.ar = function (a) {
        this.d.bg = a;
    };
    AxisView.prototype.y = function () {
    };
    AxisView.prototype.r = function (a) {
        return null;
    };
    AxisView.prototype.n = function () {
        return false;
    };
    AxisView.prototype.l = function () {
        return false;
    };
    AxisView.prototype.q = function (dataItem_) {
        if (this.a.au != null) {
            return this.a.au(dataItem_);
        }
        if (this.a.ai != null) {
            return this.a.ai.i(dataItem_);
        }
        return null;
    };
    AxisView.prototype.p = function (dataItem_) {
        if (this.n() && this.l()) {
            return this.q(dataItem_);
        }
        else {
            if (this.a.au != null) {
                return this.a.au(dataItem_);
            }
            if (this.a.ai != null) {
                return this.a.ai.i(dataItem_);
            }
        }
        var label_ = this.a.f0;
        var a = typeof dataItem_ === 'number' && typeof label_ === 'string';
        var labelValue_ = null;
        if (this.h != null) {
            labelValue_ = this.h.getPropertyValue(dataItem_);
            if ((labelValue_ === undefined)) {
                labelValue_ = label_;
            }
        }
        else {
            labelValue_ = a ? stringFormat(label_, dataItem_) : (typeof dataItem_[label_] != 'undefined') ? dataItem_[label_] : label_;
            ;
        }
        if (this.a.expectFunctions) {
            if ((typeof (labelValue_) == 'function')) {
                labelValue_ = labelValue_();
            }
        }
        return labelValue_;
    };
    AxisView.prototype.ai = function (a, b) {
        this.j = a;
        this.k = b;
    };
    Object.defineProperty(AxisView.prototype, "isDirty", {
        get: function () {
            return this._isDirty;
        },
        set: function (a) {
            this._isDirty = a;
        },
        enumerable: false,
        configurable: true
    });
    AxisView.prototype.ah = function () {
        if (this.a.bg == null || this.j == null) {
            return;
        }
        if (!this.isDirty) {
            this.isDirty = true;
            this.a.bg.al.r(this.j, this.k);
        }
    };
    AxisView.prototype.undirty = function (a) {
        this.isDirty = false;
        this.ao(a);
    };
    AxisView.prototype.ao = function (a) {
        if (this.j == null) {
            return;
        }
        if (this.j.d) {
            if (this.a.bi != null && this.a.bi.gf != 1) {
                this.j.aa();
                this.j.ab(this.a.bi.gf, this.a.bi.gf);
            }
            var b = this.a.bg.to();
            if (a) {
                if (!this.j.e) {
                    this.j.l(b.left, b.top, b.width, b.height);
                }
            }
            if (a) {
                if (this.a.bi.s0 != null && !this.a.kd.isEmpty) {
                    this.be.o = this.a.kd.top;
                    this.be.n = this.a.kd.left;
                    this.be.width = this.a.kd.width;
                    this.be.height = this.a.kd.height;
                    this.be._fill = this.a.bi.s0;
                    this.j.w(this.be);
                }
            }
            this.j.aa();
            this.j.af(this.a.kd);
            this.ap();
            this.j.z();
            if (this.a.bi != null && this.a.bi.gf != 1) {
                this.j.z();
            }
        }
        if (this.k.d) {
            if (this.a.bi != null && this.a.bi.gf != 1) {
                this.k.aa();
                this.k.ab(this.a.bi.gf, this.a.bi.gf);
            }
            var c = this.a8;
            var d = this.a.bg.to();
            if (!c.isEmpty && a) {
                if (!this.k.e) {
                    this.k.l(d.left, d.top, d.width, d.height);
                }
            }
            if (this.a.bi != null && this.a.bi.gf != 1) {
                this.k.z();
            }
        }
    };
    AxisView.prototype.postRender = function () {
        this.d.ck();
    };
    AxisView.prototype.ap = function () {
        if (this.j.d) {
            this.ba._stroke = this.a.jv;
            this.bd._fill = this.a.jy;
            this.bc._stroke = this.a.ju;
            this.bb._stroke = this.a.jt;
            this.bc.ad = this.a.eu;
            this.bb.ad = this.a.er;
            this.ba.ad = this.a.fg;
            this.bc.ai = this.a.j2;
            this.bb.ai = this.a.j1;
            this.ba.ai = this.a.j3;
            this.a8 = this.a.kd;
            this.j.t(this.ba);
            this.j.t(this.bd);
            this.j.t(this.bb);
            this.j.t(this.bc);
        }
    };
    AxisView.prototype.af = function () {
        this.ah();
    };
    AxisView.prototype.ad = function (a) {
        if (a != null) {
            a.al.u(this);
            a.cu.cq();
        }
    };
    AxisView.prototype.x = function (a) {
        if (a != null) {
            a.al.o(this);
            this.ah();
        }
    };
    AxisView.prototype.i = function () {
        if (this.a.bi == null || this.a.bi.cu.j.ae == null) {
            return null;
        }
        return FontUtil.getFont(this.a.bi.cu.j.ae);
    };
    AxisView.prototype.m = function () {
        return this.j == null;
    };
    AxisView.prototype.an = function () {
        if (this.a.b9 || this.a.cm) {
            return;
        }
        if (this.a.g6 == null) {
            this.a.is = null;
            this.a.cq = true;
            this.a.h7();
            return;
        }
        if (this.a.is == null) {
            var a = new TextBlock();
            a.al = this.a.g6;
            a.dataContext = this.a.bf;
            this.a.is = a;
        }
        else {
            this.a.is.al = this.a.g6;
            this.a.is.dataContext = this.a.bf;
        }
        this.a.cq = true;
        this.a.h7();
    };
    AxisView.prototype.w = function () {
        var a;
        var b = new AxisLabelSettings();
        if (this.a.b9) {
            a = "ui-angular-axis-labels";
            b.margin = 0;
        }
        else if (this.a.cp) {
            a = "ui-vertical-axis-labels";
            b.location = 2;
            b.leftMargin = 5;
            b.rightMargin = 5;
            b.topMargin = 2;
            b.bottomMargin = 2;
        }
        else if (this.a.a2 == 3) {
            a = "ui-radial-axis-labels";
            b.location = 5;
        }
        else {
            a = "ui-horizontal-axis-labels";
            b.location = 1;
            b.leftMargin = 2;
            b.rightMargin = 2;
            b.topMargin = 5;
            b.bottomMargin = 5;
        }
        this.v(b, a);
    };
    AxisView.prototype.az = function () {
        if (this.a.bi == null) {
            return;
        }
        var a = this.a.bi.uj;
        var b = a.fv;
        var c = a.fu;
        if (this.a.jz == null) {
            if (b == null) {
                this.a.jz = a.fs;
            }
            else if (b.color.l != 0) {
                this.a.jz = b;
            }
        }
        if (this.a.jw == null) {
            if (c == null) {
                this.a.jw = a.fs;
            }
            else if (c.color.l != 0) {
                this.a.jw = c;
            }
        }
    };
    AxisView.prototype.v = function (a, b) {
        this.a.fl.startCSSQuery();
        var c = this.a.fl.getCssDefaultPropertyValue(b, "margin-top");
        var d = this.a.fl.getCssDefaultPropertyValue(b, "margin-right");
        var e = this.a.fl.getCssDefaultPropertyValue(b, "margin-bottom");
        var f = this.a.fl.getCssDefaultPropertyValue(b, "margin-left");
        var g = this.a.fl.getCssDefaultPropertyValue(b, "text-align");
        var h = this.a.fl.getCssDefaultPropertyValue(b, "vertical-align");
        var i = this.a.fl.getCssDefaultPropertyValue(b, "color");
        var j = FontUtil.getFontForClass(this.a.fl, b);
        this.a.fl.endCSSQuery();
        if (c != null) {
            a.topMargin = parseFloat(c);
        }
        if (d != null) {
            a.rightMargin = parseFloat(d);
        }
        if (e != null) {
            a.bottomMargin = parseFloat(e);
        }
        if (f != null) {
            a.leftMargin = parseFloat(f);
        }
        if (i != null) {
            if (a.textColor == null) {
                a.textColor = new Brush();
            }
            a.textColor._fill = i;
        }
        if (j != null) {
            a.g = j;
        }
        if (g != null) {
            switch (g) {
                case "right":
                    a.horizontalAlignment = 2;
                    break;
                case "left":
                    a.horizontalAlignment = 0;
                    break;
                default:
                    a.horizontalAlignment = 1;
                    break;
            }
        }
        if (h != null) {
            switch (h) {
                case "top":
                    a.verticalAlignment = 0;
                    break;
                case "bottom":
                    a.verticalAlignment = 2;
                    break;
                default:
                    a.verticalAlignment = 1;
                    break;
            }
        }
        this.a.az = a;
    };
    AxisView.prototype.preRender = function () {
        if (this.a.bi != null) {
            this.a.bi.l2();
        }
    };
    AxisView.prototype.isValid = function () {
        return this.a != null && !this.a.kd.isEmpty;
    };
    AxisView.prototype.a5 = function (a) {
        return { $type: Point_$type, x: a.n, y: a.o };
    };
    AxisView.prototype.a6 = function () {
        return { $type: Point_$type, x: this.a.aw.c1.left, y: this.a.aw.c1.top };
    };
    AxisView.prototype.a9 = function () {
        var a = this.a.aw.c1;
        return a;
    };
    AxisView.prototype.a7 = function (a) {
        return { $type: Point_$type, x: a.n, y: a.o };
    };
    AxisView.prototype.bg = function (a) {
        var b = this.a.aw.af.t();
        var c = this.a.aw.af.v();
        var d = this.a.aw.af.u();
        var e = this.a.aw.af.s();
        return new Thickness(1, b, c, d, e);
    };
    AxisView.prototype.ak = function () {
        if (FastReflectionHelper.needsHelper(this.a.f0)) {
            this.h = new FastReflectionHelper(true, this.a.f0);
        }
        else {
            this.h = null;
        }
    };
    AxisView.$t = markType(AxisView, 'AxisView', Base.$, [ISchedulableRender_$type]);
    return AxisView;
}(Base));
export { AxisView };
/**
 * @hidden
 */
var CategoryAxisBaseView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CategoryAxisBaseView, _super);
    function CategoryAxisBaseView(a) {
        var _this = _super.call(this, a) || this;
        _this.bh = null;
        _this.bh = a;
        return _this;
    }
    CategoryAxisBaseView.prototype.r = function (a) {
        var b = 0;
        if (this.bh.categoryMode == 0) {
            b = truncate(Math.round(a));
        }
        else {
            b = truncate(Math.floor(a));
        }
        if (b < 0 || b > this.a.lg - 1) {
            return null;
        }
        var c = this.a.kr.item(b);
        var d = this.p(c);
        if (d == null) {
            return null;
        }
        return d.toString();
    };
    CategoryAxisBaseView.prototype.bi = function (a) {
        var b = 0;
        var c = false;
        for (var d = 0; d < a.count; d++) {
            var e = typeCast(FrameworkElement.$, a._inner[d]);
            if (e == null) {
                e = this.a.br.item(d);
                var f = a._inner[d] == null ? "" : a._inner[d].toString();
                var g = e.al;
                var h = 0;
                var i = 0;
                if (g != null) {
                    h = g.length;
                }
                if (f != null) {
                    i = f.length;
                }
                if (h != i) {
                    c = true;
                }
                e.al = f;
                b++;
            }
            else {
                this.d.ab.add(e);
            }
        }
        if (c) {
            this.a.cq = true;
        }
        this.a.hf();
        return b;
    };
    CategoryAxisBaseView.$t = markType(CategoryAxisBaseView, 'CategoryAxisBaseView', AxisView.$);
    return CategoryAxisBaseView;
}(AxisView));
export { CategoryAxisBaseView };
/**
 * @hidden
 */
var HorizontalAxisLabelPanelBaseView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(HorizontalAxisLabelPanelBaseView, _super);
    function HorizontalAxisLabelPanelBaseView(a) {
        var _this = _super.call(this, a) || this;
        _this.az = null;
        _this.az = a;
        return _this;
    }
    HorizontalAxisLabelPanelBaseView.prototype.a1 = function () {
    };
    HorizontalAxisLabelPanelBaseView.prototype.a0 = function () {
        return false;
    };
    HorizontalAxisLabelPanelBaseView.prototype.a2 = function (a) {
        var b = this.a.bs();
        var c, d;
        c = this.az.dh();
        d = this.az.de();
        var e = this.a.ag != null ? this.a.ag.verticalAlignment : 1;
        var f = this.a.bd;
        var g = a.count;
        var h = this.a.c1;
        var i = this.az.dg();
        var j = i / 2;
        for (var k = 0; k < g; k++) {
            var l = a._inner[k];
            var m = l.height / 2;
            switch (e) {
                case 0:
                    l.y = h.top + c;
                    break;
                case 1:
                case 3:
                    l.y = (h.top + c + j) - m;
                    break;
                case 2:
                    l.y = (h.bottom - d) - l.height;
                    break;
            }
        }
    };
    HorizontalAxisLabelPanelBaseView.$t = markType(HorizontalAxisLabelPanelBaseView, 'HorizontalAxisLabelPanelBaseView', AxisLabelPanelBaseView.$);
    return HorizontalAxisLabelPanelBaseView;
}(AxisLabelPanelBaseView));
export { HorizontalAxisLabelPanelBaseView };
/**
 * @hidden
 */
var NumericAxisBaseView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(NumericAxisBaseView, _super);
    function NumericAxisBaseView(a) {
        var _this = _super.call(this, a) || this;
        _this.bh = null;
        _this.bh = a;
        return _this;
    }
    NumericAxisBaseView.prototype.bi = function () {
    };
    NumericAxisBaseView.prototype.n = function () {
        return this.bh.lh;
    };
    NumericAxisBaseView.prototype.l = function () {
        if (this.bh.kp != null) {
            return true;
        }
        if (this.bh.ko != null) {
            return true;
        }
        return false;
    };
    NumericAxisBaseView.prototype.q = function (dataItem_) {
        if (this.bh.kp != null) {
            return this.bh.kp(dataItem_);
        }
        if (this.bh.ko != null) {
            return this.bh.ko.i(dataItem_);
        }
        return null;
    };
    NumericAxisBaseView.prototype.r = function (a) {
        var b = this.bh.k0.d(this.bh.kd, this.bh.bi.tj, this.bh.j8(), this.bh.j7());
        return this.bh.k0.w(b, a, -1, NaN);
    };
    NumericAxisBaseView.$t = markType(NumericAxisBaseView, 'NumericAxisBaseView', AxisView.$);
    return NumericAxisBaseView;
}(AxisView));
export { NumericAxisBaseView };
/**
 * @hidden
 */
var VerticalAxisLabelPanelView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(VerticalAxisLabelPanelView, _super);
    function VerticalAxisLabelPanelView(a) {
        var _this = _super.call(this, a) || this;
        _this.az = null;
        _this.az = a;
        return _this;
    }
    VerticalAxisLabelPanelView.prototype.a0 = function () {
    };
    VerticalAxisLabelPanelView.prototype.d = function () {
        var a = this.a.ad.bi.getFontInfo();
        if (this.a.ad.bf != null && this.a.ad.bf.textStyle != null) {
            a = this.a.ad.bf.h(this.a.ad.bi.cu.j.ae);
        }
        else {
            var b = this.a.ad.bi.cy();
            if (b != null) {
                a = b;
            }
        }
        return a;
    };
    VerticalAxisLabelPanelView.prototype.ay = function () {
        return this.a.ad.bi.t2();
    };
    VerticalAxisLabelPanelView.prototype.at = function () {
        var a = this.a.ad.bg.getFontBrush();
        if (this.a.ad.bf != null && this.a.ad.bf.textColor != null) {
            a = this.a.ad.bf.textColor;
        }
        else {
            var b = this.a.ad.bi.ss();
            if (b != null) {
                a = b;
            }
        }
        return a;
    };
    VerticalAxisLabelPanelView.prototype.a1 = function (a, b) {
        var c, d;
        c = this.az.db();
        d = this.az.dd();
        var e = this.a.ag != null ? this.a.ag.horizontalAlignment : 1;
        var f = this.a.bd;
        var g = this.az.de();
        var h = g / 2;
        var i = this.a.c1;
        for (var j = 0; j < a.count; j++) {
            var k = a._inner[j];
            var l = k.width / 2;
            switch (e) {
                case 0:
                    k.x = i.left + c;
                    break;
                case 1:
                case 3:
                    k.x = (i.left + c + h) - l;
                    break;
                case 2:
                    k.x = (i.right - d) - k.width;
                    break;
            }
        }
    };
    VerticalAxisLabelPanelView.$t = markType(VerticalAxisLabelPanelView, 'VerticalAxisLabelPanelView', AxisLabelPanelBaseView.$);
    return VerticalAxisLabelPanelView;
}(AxisLabelPanelBaseView));
export { VerticalAxisLabelPanelView };
/**
 * @hidden
 */
var XamDataChartView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XamDataChartView, _super);
    function XamDataChartView(a) {
        var _this = _super.call(this, a) || this;
        _this.fn = null;
        _this.fw = null;
        _this.fs = null;
        _this.ft = null;
        _this.fv = null;
        _this.fu = null;
        _this.fp = 0;
        _this.fq = 0;
        _this.fo = null;
        _this.fn = a;
        return _this;
    }
    XamDataChartView.prototype.fr = function (a) {
        this.p.al.s();
    };
    XamDataChartView.prototype.ds = function () {
        _super.prototype.ds.call(this);
        if (this.b.count == 0 && this.y != null) {
            if (this.p.gf != 1) {
                this.y.aa();
                this.y.ab(this.p.gf, this.p.gf);
            }
            if (!this.y.e) {
                this.y.l(0, 0, this.a8, this.a7);
            }
            if (this.p.gf != 1) {
                this.y.z();
            }
        }
    };
    XamDataChartView.prototype.d4 = function () {
        var e_93, _a;
        var a, b;
        var c = 1, d = 0;
        var e = false;
        var f = this.j.e();
        var g;
        var h = this.j.a7(c, g, a, b, d, e);
        c = h.p0;
        g = h.p1;
        a = h.p2;
        b = h.p3;
        d = h.p4;
        e = h.p5;
        if (isNaN_(this.p.hd)) {
            this.p.hd = g[0];
        }
        if (isNaN_(this.p.g4)) {
            this.p.g4 = g[1];
        }
        if (isNaN_(this.p.gm)) {
            this.p.gm = g[2];
        }
        if (isNaN_(this.p.gz)) {
            this.p.gz = g[3];
        }
        this.fn.x6 = f.i;
        this.fn.x4 = AxisDefaults.h;
        this.fn.x5 = AxisDefaults.i;
        this.fn.uq = e;
        this.fv = a;
        this.fu = b;
        this.fn.ag = f.a;
        this.fn.aj = f.f;
        this.fn.ah = f.b != null ? f.b : new BrushCollection();
        this.fn.ai = f.c != null ? f.c : new BrushCollection();
        if (this.fn.ah.count == 0) {
            for (var i = 0; i < f.a.count; i++) {
                this.fn.ah.add(f.a.item(i));
            }
        }
        if (f.c.count == 0) {
            for (var j = 0; j < f.f.count; j++) {
                this.fn.ai.add(f.f.item(j));
            }
        }
        this.ft = f.j;
        this.fw = f.k;
        this.fo = f.h;
        this.fs = f.i;
        this.fp = c;
        try {
            for (var _b = __values(fromEnum(this.fn.series)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var k = _c.value;
                k.my();
            }
        }
        catch (e_93_1) {
            e_93 = { error: e_93_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_93)
                    throw e_93.error;
            }
        }
        this.fq = d;
    };
    XamDataChartView.prototype.d1 = function () {
        this.fe.ad = Defaults.j;
        this.fd.ad = Defaults.j;
        this.fe._stroke = this.p.s6 != null ? this.p.s6 : this.ft;
        this.fd._stroke = this.p.sx != null ? this.p.sx : this.ft;
        _super.prototype.d1.call(this);
    };
    XamDataChartView.$t = markType(XamDataChartView, 'XamDataChartView', SeriesViewerView.$);
    return XamDataChartView;
}(SeriesViewerView));
export { XamDataChartView };
/**
 * @hidden
 */
var SeriesView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesView, _super);
    function SeriesView(a) {
        var _this = _super.call(this) || this;
        _this.e = null;
        _this.s = false;
        _this.h = null;
        _this.d = null;
        _this._isDirty = false;
        _this.bw = null;
        _this.bn = null;
        _this.v = 0;
        _this.br = Rect.empty;
        _this.bm = new Brush();
        _this.f = new SeriesComponentsFromView();
        _this.k = null;
        _this.l = null;
        _this.bs = null;
        _this.bt = null;
        _this.m = false;
        _this.a = null;
        _this.r = false;
        _this.n = false;
        _this.p = false;
        _this.ad = null;
        _this.v = NaN;
        _this.r = true;
        _this.e = a;
        _this.q = false;
        _this.bw = new Rectangle();
        _this.s = false;
        return _this;
    }
    SeriesView.prototype.getDefaultTooltipTemplate = function () {
        return this.e.a7.a$q(this.e);
    };
    SeriesView.prototype.ap = function () {
        if (this.e.d2) {
            this.e.a7.a$u(this.e);
        }
    };
    SeriesView.prototype.j = function () {
        return new DOMExecutionContext(this.e.ce.cu.j.ae);
    };
    Object.defineProperty(SeriesView.prototype, "i", {
        get: function () {
            if (this.h == null) {
                this.h = this.j();
            }
            return this.h;
        },
        enumerable: false,
        configurable: true
    });
    SeriesView.prototype.as = function () {
        if (!this.q) {
            this.e.f3 = 0.8;
            this.e.b7 = 0;
            this.e.b6 = 1;
            this.d = new DataContext();
            this.d.series = this.e;
            this.e.ch = EasingFunctions.cubicEase;
            this.af();
        }
    };
    SeriesView.prototype.getEffectiveViewport = function () {
        return this.e.getEffectiveViewport1(this);
    };
    SeriesView.prototype.az = function () {
        this.aq();
    };
    SeriesView.prototype.aj = function () {
    };
    SeriesView.prototype.getMainContentViewport = function () {
        return this.e.getMainContentViewport();
    };
    Object.defineProperty(SeriesView.prototype, "w", {
        get: function () {
            if (this.e.ce != null) {
                return this.e.ce.cu.j.ae;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesView.prototype, "isDirty", {
        get: function () {
            return this._isDirty;
        },
        set: function (a) {
            this._isDirty = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesView.prototype.get_index = function () {
        if (this.e == null || this.e.ce == null) {
            return 0;
        }
        if (this.e.ce.ek) {
            if (this.e.dy) {
                return this.e.ce.series.indexOf(this.e);
            }
            else {
                var a = this.e.ce.series.indexOf(this.e);
                if (a >= 0) {
                    return a;
                }
                for (var b = 0; b < this.e.ce.series.count; b++) {
                    if (this.e.ce.series._inner[b].dy) {
                        var c = this.e.ce.series._inner[b].bf();
                        if (c == this.e) {
                            return b;
                        }
                    }
                }
                return a;
            }
        }
        var d = typeCast(XamDataChart.$, this.e.cc);
        var e = 0;
        if (d != null) {
            if (d.ua == 2 || d.ua == 0) {
                e = d.axes.count;
            }
        }
        var f = 0;
        for (var g = 0; g < this.e.ce.series.count; g++) {
            if (this.e.ce.series._inner[g] == this.e) {
                break;
            }
            if (this.e.ce.series._inner[g].isStacked) {
                f += this.e.ce.series._inner[g].hq();
            }
            else {
                f++;
            }
        }
        return e + f;
    };
    Object.defineProperty(SeriesView.prototype, "index", {
        get: function () {
            return this.get_index();
        },
        enumerable: false,
        configurable: true
    });
    SeriesView.prototype.aq = function () {
        if (this.e.ce == null) {
            return;
        }
        if (!this.isDirty) {
            this.isDirty = true;
            this.a.r(this.k, this.l);
        }
    };
    SeriesView.prototype.undirty = function (a) {
        this.isDirty = false;
        this.a4(a);
    };
    SeriesView.prototype.au = function () {
        this.aq();
    };
    SeriesView.prototype.bq = function () {
        if (this.bn == null) {
            this.bn = ((function () {
                var $ret = new Brush();
                $ret.color = Color.u(0, 0, 0, 0);
                return $ret;
            })());
        }
        return this.bn;
    };
    SeriesView.prototype.u = function () {
        if (!isNaN_(this.v)) {
            return this.v;
        }
        if (this.e.ce != null) {
            return this.e.ce.gf;
        }
        else {
            return 1;
        }
    };
    SeriesView.prototype.a4 = function (a) {
        if (this.k == null) {
            return;
        }
        if (this.br.isEmpty) {
            this.br = this.bu;
        }
        var b = this.br;
        var c = this.e.ce.to();
        var d = c.left;
        var e = c.top;
        var f = c.width;
        var g = c.height;
        var h = this.u();
        if (this.p) {
            d = this.bu.left;
            e = this.bu.top;
            f = this.bu.width;
            g = this.bu.height;
        }
        if (this.k.d) {
            if (h != 1) {
                this.k.aa();
                this.k.ab(h, h);
            }
            if (a) {
                if (!this.k.e) {
                    this.k.l(d, e, f, g);
                }
            }
            if (a) {
                if (this.e.ce.s0 != null && !this.bu.isEmpty) {
                    this.bw.o = this.bu.top;
                    this.bw.n = this.bu.left;
                    this.bw.width = this.bu.width;
                    this.bw.height = this.bu.height;
                    this.bw._fill = this.e.ce.s0;
                    this.k.w(this.bw);
                }
            }
            if (h != 1) {
                this.k.z();
            }
        }
        if (this.l != null && this.r) {
            if (this.l.d) {
                if (this.e.ce != null && h != 1) {
                    this.l.aa();
                    this.l.ab(h, h);
                }
                if (!b.isEmpty && a) {
                    if (!this.l.e) {
                        this.l.l(b.left, b.top, b.width, b.height);
                    }
                }
                this.ba(true);
                this.a6(this.l, true);
                this.a5(this.l, true);
                if (h != 1) {
                    this.l.z();
                }
            }
        }
        if (this.k.d && this.r) {
            if (h != 1) {
                this.k.aa();
                this.k.ab(h, h);
            }
            this.k.aa();
            if (!this.q && Rect.l_op_Inequality(this.e.py, null) && !this.e.py.isEmpty && (this.e.py.width != 1 || this.e.py.height != 1)) {
                this.k.af(new Rect(0, this.bu.left + this.bu.width * this.e.py.left, this.bu.top + this.bu.height * this.e.py.top, this.bu.width * this.e.py.width, this.bu.height * this.e.py.height));
            }
            else {
                this.k.af(this.bu);
            }
            this.ba(false);
            this.k.ae(this.e._opacity);
            if (this.e.dq && this.e.dr && !this.q) {
                if (this.e.fb) {
                    this.k.p(this.e.ph.colorString, 0, this.e.g2, this.e.g3);
                    var i = this.e.ce.cu.j.x;
                    var j = this.e.ce.cu.j.ak;
                    if (h != 1) {
                        i.aa();
                        i.ab(h, h);
                    }
                    if (!i.e) {
                        i.l(c.left, c.top, c.width, c.height);
                    }
                    this.a6(i, false);
                    this.a5(i, false);
                    this.k.n(j.getNativeElement(), 1, 0, 0, c.width, c.height);
                    if (h != 1) {
                        i.z();
                    }
                }
                else {
                    this.k.p(this.e.ph.colorString, this.e.g1, this.e.g2, this.e.g3);
                    this.a6(this.k, false);
                    this.a5(this.k, false);
                }
                this.k.m();
            }
            else {
                this.a6(this.k, false);
                this.a5(this.k, false);
            }
            this.k.ae(1);
            this.k.z();
            if (h != 1) {
                this.k.z();
            }
        }
    };
    SeriesView.prototype.bd = function (a, b, c) {
        if (c) {
            this.bf(a, b);
        }
        else {
            this.be(a, b);
        }
    };
    SeriesView.prototype.bg = function (a, b, c) {
        if (c) {
            this.bi(a, b);
        }
        else {
            this.bh(a, b);
        }
    };
    SeriesView.prototype.aa = function (a, b) {
        if (b) {
            return this.ab(a);
        }
        else {
            return this.ac(a);
        }
    };
    SeriesView.prototype.ab = function (a) {
        return null;
    };
    SeriesView.prototype.ac = function (a) {
        return null;
    };
    SeriesView.prototype.be = function (a, b) {
    };
    SeriesView.prototype.bh = function (a, b) {
    };
    SeriesView.prototype.bf = function (a, b) {
    };
    SeriesView.prototype.bi = function (a, b) {
    };
    SeriesView.prototype.ba = function (a) {
        if (a) {
            this.bc();
        }
        else {
            this.bb();
        }
    };
    SeriesView.prototype.bb = function () {
    };
    SeriesView.prototype.bc = function () {
    };
    SeriesView.prototype.bp = function (a) {
        return this.bo();
    };
    SeriesView.prototype.bo = function () {
        var a = this.e.ht;
        var num_ = (a + 1) * 1000;
        var b = ((num_ & 0x3F) << 2);
        num_ = (num_ >> 6);
        var c = ((num_ & 0x3F) << 2);
        num_ = (num_ >> 6);
        var d = ((num_ & 0x3F) << 2);
        this.bm._fill = "rgb(" + b + "," + c + "," + d + ")";
        return this.bm;
    };
    SeriesView.prototype.a6 = function (a, b) {
        this.br = this.bu;
    };
    SeriesView.prototype.a5 = function (a, b) {
    };
    SeriesView.prototype.ax = function () {
    };
    SeriesView.prototype.am = function () {
    };
    SeriesView.prototype.an = function () {
    };
    SeriesView.prototype.g = function () {
        return this.f;
    };
    SeriesView.prototype.a9 = function (a) {
    };
    SeriesView.prototype.t = function () {
        return true;
    };
    SeriesView.prototype.aw = function () {
    };
    SeriesView.prototype.av = function () {
    };
    SeriesView.prototype.a7 = function () {
        this.e.o5 = null;
    };
    SeriesView.prototype.ah = function () {
        this.e.o5 = this.e.o9;
    };
    SeriesView.prototype.a8 = function () {
        this.e.o8 = null;
    };
    SeriesView.prototype.ai = function () {
        this.e.o8 = this.e.pe;
    };
    SeriesView.prototype.c = function (a) {
        if (typeCast(DataContext.$, a) !== null) {
            return a;
        }
        return null;
    };
    SeriesView.prototype.ar = function (a, b) {
        this.k = a;
        this.l = b;
    };
    Object.defineProperty(SeriesView.prototype, "bu", {
        get: function () {
            return this.bs;
        },
        set: function (a) {
            this.bs = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesView.prototype.get_bv = function () {
        if (this.p) {
            return this.bt;
        }
        else if (this.q) {
            return XamDataChart.tv;
        }
        else {
            return this.e.ce != null ? this.e.ce.tj : Rect.empty;
        }
    };
    Object.defineProperty(SeriesView.prototype, "bv", {
        get: function () {
            return this.get_bv();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SeriesView.prototype, "q", {
        get: function () {
            return this.m;
        },
        set: function (a) {
            this.m = a;
        },
        enumerable: false,
        configurable: true
    });
    SeriesView.prototype.ak = function (a) {
        if (a != null) {
            this.a.u(this);
            if (this.e.b0 != null) {
                this.e.b0.a.u(this.e.b0);
            }
        }
    };
    SeriesView.prototype.ag = function (a) {
        var e_94, _a;
        if (a != null) {
            if (this.e.e9) {
                this.k = this.e.ce.cu.z;
                a.cu.a.o(this);
                this.a = a.cu.a;
            }
            else {
                this.k = this.e.ce.cu.y;
                a.al.o(this);
                this.a = a.al;
            }
            if (this.e.b0 != null) {
                a.am.o(this.e.b0);
                this.e.b0.a = a.am;
                this.e.b0.aq();
            }
            if (this.e.d2) {
                try {
                    for (var _b = __values(fromEnum(this.e.a7.a$h.keys)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var b = _c.value;
                        a.ak.o(this.e.a7.a$h.item(b));
                        this.e.a7.a$h.item(b).a = a.ak;
                        this.e.a7.a$h.item(b).aq();
                    }
                }
                catch (e_94_1) {
                    e_94 = { error: e_94_1 };
                }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return))
                            _a.call(_b);
                    }
                    finally {
                        if (e_94)
                            throw e_94.error;
                    }
                }
            }
            this.aq();
        }
    };
    SeriesView.prototype.postRender = function () {
        this.a0();
    };
    SeriesView.prototype.a0 = function () {
    };
    SeriesView.prototype.b = function (a) {
        return null;
    };
    SeriesView.prototype.a2 = function (a) {
        this.e.b0.k = a.a;
    };
    SeriesView.prototype.al = function (a) {
    };
    SeriesView.prototype.bj = function () {
        if (this.n) {
            return;
        }
        if (this.e.ce != null) {
            var a = (this.e.legend != null) ? this.e.legend : this.e.ce.legend;
            if (a != null && this.e.ne != null && a.containsChild(this.e.ne)) {
                a.removeChild(this.e.ne);
                var b = this.e.h5();
                b.content.actualItemBrush = this.e.o5;
                b.content.outline = this.e.o8;
                b.content.thickness = this.e.fy;
                a.addChildInOrder(this.e.ne, this.e);
            }
        }
    };
    SeriesView.prototype.at = function () {
        this.e.kv(this.e.a2, this.e.a2);
    };
    SeriesView.prototype.ay = function () {
        this.bj();
    };
    SeriesView.prototype.getViewInfo = function (a, b) {
        a = this.bu;
        b = this.bv;
        return {
            p0: a,
            p1: b
        };
    };
    SeriesView.prototype.o = function () {
        return this.k != null;
    };
    SeriesView.prototype.bk = function () {
        this.r = this.e._visibility == 0;
        this.aq();
    };
    SeriesView.prototype.a3 = function () {
        this.e.a7.a$ag(this.e);
    };
    SeriesView.prototype.af = function () {
        var a = new Color();
        a.colorString = "rgba(95,95,95,0.5)";
        this.e.ph = a;
        this.e.g1 = 5;
        this.e.g2 = 5;
        this.e.g3 = 5;
    };
    SeriesView.prototype.ao = function () {
    };
    SeriesView.prototype.preRender = function () {
        if (this.e.ce != null && !this.q) {
            this.e.ce.l2();
        }
    };
    SeriesView.prototype.isValid = function () {
        return true;
    };
    SeriesView.prototype.a1 = function (a) {
        this.k = a.a;
    };
    SeriesView.prototype.bl = function (type_) {
        var legendTemplates_ = TypeRegistrar.get("LegendTemplates");
        var a = (legendTemplates_.resolveLegendItemTemplate(type_));
        return a;
    };
    SeriesView.$t = markType(SeriesView, 'SeriesView', Base.$, [ISchedulableRender_$type, IProvidesViewport_$type]);
    return SeriesView;
}(Base));
export { SeriesView };
/**
 * @hidden
 */
var MarkerSeriesView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(MarkerSeriesView, _super);
    function MarkerSeriesView(a) {
        var _this = _super.call(this, a) || this;
        _this.b1 = null;
        _this.b5 = 1;
        _this.b7 = Defaults.ab;
        _this.b6 = 3;
        _this.b4 = null;
        _this.b3 = false;
        _this.bx = new Marker();
        _this.co = null;
        _this.bx = new Marker();
        _this.bx.content = new DataContext();
        _this.b1 = a;
        return _this;
    }
    MarkerSeriesView.prototype.as = function () {
        _super.prototype.as.call(this);
        this.b4 = new List$1(Marker.$, 0);
        this.co = ((function () {
            var $ret = new DataTemplate();
            $ret.render = MarkerTemplates.c;
            $ret.measure = MarkerTemplates.b;
            return $ret;
        })());
    };
    MarkerSeriesView.prototype.cg = function () {
        var e_95, _a;
        try {
            for (var _b = __values(fromEnum(this.b4)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var a = _c.value;
                a.ah = this.b1.q6;
            }
        }
        catch (e_95_1) {
            e_95 = { error: e_95_1 };
        }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return))
                    _a.call(_b);
            }
            finally {
                if (e_95)
                    throw e_95.error;
            }
        }
        this.aq();
    };
    MarkerSeriesView.prototype.cq = function () {
        if (this.k == null) {
            return new Size(1, 0, 0);
        }
        var a = new DataTemplatePassInfo();
        a.isHitTestRender = false;
        a.context = this.k.h();
        a.viewportTop = this.bu.top;
        a.viewportLeft = this.bu.left;
        a.viewportWidth = this.bu.width;
        a.viewportHeight = this.bu.height;
        a.passID = "TestMeasure";
        var b = new DataTemplateRenderInfo();
        b.isHitTestRender = false;
        b.passInfo = a;
        var c = new DataTemplateMeasureInfo();
        c.passInfo = a;
        var d = this.k.h();
        c.context = d;
        b.context = d;
        var e = 0;
        var f = 0;
        if (this.b1.q6 != null && this.b1.q6.passStarting != null) {
            this.b1.q6.passStarting(a);
        }
        var g = this.b1.q6;
        if (this.b4.count > 0) {
            var h = this.b4._inner[0];
            c.data = h.content;
            c.width = h.width;
            c.height = h.height;
            c.renderOffsetX = 0;
            c.renderOffsetY = 0;
            c.renderContext = this.k;
            g = h.ah;
        }
        var i = 0;
        var j = 0;
        if (g != null && g.measure != null) {
            g.measure(c);
            i = c.width;
            j = c.height;
        }
        if (this.b1.q6 != null && this.b1.q6.passCompleted != null) {
            this.b1.q6.passCompleted(a);
        }
        return new Size(1, i, j);
    };
    MarkerSeriesView.prototype.cn = function (a) {
    };
    MarkerSeriesView.prototype.b0 = function () {
        var _this = this;
        var a = new Marker();
        a.content = ((function () {
            var $ret = new DataContext();
            $ret.series = _this.e;
            return $ret;
        })());
        a.ah = this.b1.q6;
        this.b4.add(a);
        return a;
    };
    MarkerSeriesView.prototype.cj = function (a) {
        a._visibility = 0;
    };
    MarkerSeriesView.prototype.cl = function (a) {
        a._visibility = 1;
    };
    MarkerSeriesView.prototype.ck = function (a) {
        this.b4.remove(a);
    };
    MarkerSeriesView.prototype.b2 = function () {
        return this.b1.q7 != null;
    };
    MarkerSeriesView.prototype.ce = function () {
        this.b1.q5 = null;
    };
    MarkerSeriesView.prototype.b8 = function () {
        this.b1.q5 = this.b1.q7;
    };
    MarkerSeriesView.prototype.cp = function (a) {
        var b = a.n;
        var c = a.o;
        var d = a.m;
        var e = a.l;
        return new Rect(0, b - d / 2, c - d / 2, d, e);
    };
    MarkerSeriesView.prototype.cb = function (a) {
        switch (a) {
            case SeriesViewer.$$p[2]:
                this.b1.q5 = this.b1.ce.pv;
                break;
            case SeriesViewer.$$p[37]:
                this.b1.q5 = this.b1.ce.p4;
                break;
            case SeriesViewer.$$p[27]:
                this.b1.q5 = this.b1.ce.p1;
                break;
            case SeriesViewer.$$p[31]:
                this.b1.q5 = this.b1.ce.p2;
                break;
            case SeriesViewer.$$p[5]:
                this.b1.q5 = this.b1.ce.pw;
                break;
            case SeriesViewer.$$p[19]:
                this.b1.q5 = this.b1.ce.pz;
                break;
            case SeriesViewer.$$p[7]:
                this.b1.q5 = this.b1.ce.px;
                break;
            case SeriesViewer.$$p[34]:
                this.b1.q5 = this.b1.ce.p3;
                break;
            case SeriesViewer.$$p[20]:
                this.b1.q5 = this.b1.ce.p0;
                break;
            case SeriesViewer.$$p[8]:
                this.b1.q5 = this.b1.ce.py;
                break;
        }
    };
    MarkerSeriesView.prototype.cc = function () {
        this.b1.rl = null;
    };
    MarkerSeriesView.prototype.b9 = function () {
        if (!isNaN_(this.e.fw) && this.e.fw != 1) {
            var a = BrushUtil.p(this.b1.rn, this.e.fw);
            this.b1.rl = a;
        }
        else {
            this.b1.rl = this.b1.rn;
        }
    };
    MarkerSeriesView.prototype.cd = function () {
        this.b1.rm = null;
    };
    MarkerSeriesView.prototype.ca = function () {
        this.b1.rm = this.b1.ro;
    };
    MarkerSeriesView.prototype.cm = function () {
        this.aq();
    };
    MarkerSeriesView.prototype.bh = function (a, b) {
        _super.prototype.bh.call(this, a, b);
        if (!this.b3) {
            var c = a;
            var d = c.content;
            if (d != null) {
                d.actualItemBrush = this.b1.rl;
                if (d.itemBrush != null) {
                    d.actualItemBrush = d.itemBrush;
                }
                d.outline = this.b1.rm;
                d.thickness = this.b1.qq;
            }
        }
    };
    MarkerSeriesView.prototype.bi = function (a, b) {
        _super.prototype.bi.call(this, a, b);
        var c = a;
        this.bx._visibility = c._visibility;
        this.bx.ah = c.ah;
        this.bx.width = c.width;
        this.bx.height = c.height;
        this.bx.m = c.m;
        this.bx.l = c.l;
        this.bx.n = c.n;
        this.bx.o = c.o;
        var d = this.bp(b);
        var e = this.bx.content;
        var f = c.content;
        e.item = f.item;
        e.series = f.series;
        e.thickness = f.thickness;
        if (e != null) {
            e.actualItemBrush = d;
            e.outline = d;
            e.thickness = this.b5 + this.b6;
        }
    };
    MarkerSeriesView.prototype.b = function (a) {
        if (a >= 0 && a < this.b4.count) {
            return this.b4._inner[a].content;
        }
        return _super.prototype.b.call(this, a);
    };
    MarkerSeriesView.prototype.a5 = function (a, b) {
        _super.prototype.a5.call(this, a, b);
        if (a.d) {
            var c = new DataTemplatePassInfo();
            c.isHitTestRender = b;
            c.context = a.h();
            c.viewportTop = this.bu.top;
            c.viewportLeft = this.bu.left;
            c.viewportWidth = this.bu.width;
            c.viewportHeight = this.bu.height;
            c.passID = "Markers";
            var d = new DataTemplateRenderInfo();
            d.isHitTestRender = b;
            d.passInfo = c;
            var e = new DataTemplateMeasureInfo();
            e.passInfo = c;
            var f = false;
            var g = a.h();
            e.context = g;
            d.context = g;
            var h = 0;
            var i = 0;
            if (this.b1.q6 != null && this.b1.q6.passStarting != null) {
                this.b1.q6.passStarting(c);
            }
            for (var j = 0; j < this.b4.count; j++) {
                var k = this.b4._inner[j];
                if (k._visibility == 1) {
                    continue;
                }
                this.bg(k, j, b);
                if (b) {
                    k = this.bx;
                }
                if (!f) {
                    e.data = k.content;
                    e.width = k.width;
                    e.height = k.height;
                    e.renderOffsetX = 0;
                    e.renderOffsetY = 0;
                    e.renderContext = a;
                    var l = k.ah;
                    if (l.measure != null) {
                        e.data = k.content;
                        l.measure(e);
                        f = e.isConstant;
                        if (f) {
                            h = e.width;
                            i = e.height;
                        }
                    }
                    d.availableWidth = e.width;
                    d.availableHeight = e.height;
                    d.renderOffsetX = e.renderOffsetX;
                    d.renderOffsetY = e.renderOffsetY;
                    d.renderContext = a;
                }
                else {
                    d.availableWidth = h;
                    d.availableHeight = i;
                }
                if (!isNaN_(k.width) && !isInfinity(k.width)) {
                    d.availableWidth = k.width;
                }
                if (!isNaN_(k.height) && !isInfinity(k.height)) {
                    d.availableHeight = k.height;
                }
                a.q(d, k);
                k.m = d.availableWidth;
                k.l = d.availableHeight;
                k.ai = d.renderOffsetX;
                k.aj = d.renderOffsetY;
            }
            if (this.b1.q6 != null && this.b1.q6.passCompleted != null) {
                this.b1.q6.passCompleted(c);
            }
        }
    };
    MarkerSeriesView.prototype.ch = function (a) {
        a.create = runOn(this, this.b0);
        a.destroy = runOn(this, this.ck);
        a.activate = runOn(this, this.cj);
        a.disactivate = runOn(this, this.cl);
    };
    MarkerSeriesView.prototype.ci = function (a) {
        a.create = runOn(this, this.b0);
        a.destroy = runOn(this, this.ck);
        a.activate = runOn(this, this.cj);
        a.disactivate = runOn(this, this.cl);
    };
    MarkerSeriesView.prototype.by = function (a) {
        var b = this.bz(a, 0);
        if (b == null) {
            b = this.bz(a, 3);
        }
        return b;
    };
    MarkerSeriesView.prototype.bz = function (a, b) {
        var c;
        var d;
        var e;
        var f;
        for (var g = this.b4.count - 1; g >= 0; g--) {
            var h = this.b4._inner[g];
            if (h._visibility == 1 || h._opacity == 0) {
                continue;
            }
            c = (h.m / 2) + b;
            d = (h.l / 2) + b;
            e = h.ai;
            f = h.aj;
            if ((h.n + e) - c <= a.x && (h.n + e) + c >= a.x && (h.o + f) - d <= a.y && (h.o + f) + d >= a.y) {
                return h;
            }
        }
        return null;
    };
    MarkerSeriesView.$t = markType(MarkerSeriesView, 'MarkerSeriesView', SeriesView.$);
    return MarkerSeriesView;
}(SeriesView));
export { MarkerSeriesView };
/**
 * @hidden
 */
var ChartAxisRangeChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ChartAxisRangeChangedEventArgs, _super);
    function ChartAxisRangeChangedEventArgs(a, b, c, d, e, f) {
        var _this = _super.call(this) || this;
        _this._chart = null;
        _this._axis = null;
        _this._oldMinimumValue = 0;
        _this._minimumValue = 0;
        _this._oldMaximumValue = 0;
        _this._maximumValue = 0;
        _this.chart = a;
        _this.axis = b;
        _this.oldMinimumValue = c;
        _this.minimumValue = d;
        _this.oldMaximumValue = e;
        _this.maximumValue = f;
        return _this;
    }
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "chart", {
        get: function () {
            return this._chart;
        },
        set: function (a) {
            this._chart = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "axis", {
        get: function () {
            return this._axis;
        },
        set: function (a) {
            this._axis = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "oldMinimumValue", {
        get: function () {
            return this._oldMinimumValue;
        },
        set: function (a) {
            this._oldMinimumValue = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "minimumValue", {
        get: function () {
            return this._minimumValue;
        },
        set: function (a) {
            this._minimumValue = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "oldMaximumValue", {
        get: function () {
            return this._oldMaximumValue;
        },
        set: function (a) {
            this._oldMaximumValue = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChartAxisRangeChangedEventArgs.prototype, "maximumValue", {
        get: function () {
            return this._maximumValue;
        },
        set: function (a) {
            this._maximumValue = a;
        },
        enumerable: false,
        configurable: true
    });
    ChartAxisRangeChangedEventArgs.$t = markType(ChartAxisRangeChangedEventArgs, 'ChartAxisRangeChangedEventArgs', EventArgs.$);
    return ChartAxisRangeChangedEventArgs;
}(EventArgs));
export { ChartAxisRangeChangedEventArgs };
(function (v) { callStaticConstructors(); })(true);
